/* eslint-disable */
/* istanbul ignore file */
import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
import { ClientError } from 'graphql-request/dist/types';
import useSWR, { SWRConfiguration as SWRConfigInterface, Key as SWRKeyInterface } from 'swr';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  JSON: { input: unknown; output: unknown };
  Upload: { input: unknown; output: unknown };
};

export type Account = {
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  amountOverdue?: Maybe<Scalars['Float']['output']>;
  city: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCodOnly: Scalars['Boolean']['output'];
  isNetTermsLimited: Scalars['Boolean']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isOnBrandCreditHold: Scalars['Boolean']['output'];
  isOnCreditHold: Scalars['Boolean']['output'];
  isOnMarketplace?: Maybe<Scalars['Boolean']['output']>;
  isRetailerRestricted: Scalars['Boolean']['output'];
  isRetailerRestrictedForBrand: Scalars['Boolean']['output'];
  lastCreditRating: CreditRatingTrustLevels;
  lastCreditRatingDate?: Maybe<Scalars['String']['output']>;
  lastOrderDate?: Maybe<Scalars['DateTime']['output']>;
  lastOrderNumber?: Maybe<Scalars['String']['output']>;
  lastOrderRepFirstName?: Maybe<Scalars['String']['output']>;
  lastOrderRepLastName?: Maybe<Scalars['String']['output']>;
  licenseExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licensedLocationId: Scalars['String']['output'];
  lifetimeOrderGMV?: Maybe<Scalars['Float']['output']>;
  nabisGMVRating?: Maybe<Scalars['Int']['output']>;
  nabisNotes?: Maybe<Scalars['String']['output']>;
  nabisTrustedRating?: Maybe<CreditRatingTrustLevels>;
  name: Scalars['String']['output'];
  netTerms?: Maybe<Scalars['Int']['output']>;
  nextOrderDate?: Maybe<Scalars['DateTime']['output']>;
  nextOrderNumber?: Maybe<Scalars['String']['output']>;
  numberOfOrders?: Maybe<Scalars['Int']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  pendingOrders?: Maybe<Scalars['Int']['output']>;
  retailerExcludedFromMarketplace: Scalars['Boolean']['output'];
  retailerGroupId?: Maybe<Scalars['ID']['output']>;
  retailerGroupName?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status?: Maybe<UserLicensedLocationStatusesEnum>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zip: Scalars['String']['output'];
};

export type AccountActivity = {
  author: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  secondaryNotes?: Maybe<Scalars['String']['output']>;
  type: AccountActivityTypeEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountActivityInput = {
  licensedLocationId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
};

export type AccountActivityPin = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  rowId: Scalars['ID']['output'];
  table: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

/** Values for the AccountActivityTypeEnum enum */
export enum AccountActivityTypeEnum {
  Email = 'EMAIL',
  Note = 'NOTE',
  Order = 'ORDER',
  PhoneCall = 'PHONE_CALL',
  Task = 'TASK',
}

export type AccountFilters = {
  amountOverdue?: Maybe<Array<Scalars['String']['output']>>;
  cityState?: Maybe<Array<Scalars['String']['output']>>;
  hasOverdueBalance?: Maybe<Array<Scalars['String']['output']>>;
  hasUpcomingOrders?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Array<Scalars['ID']['output']>>;
  isNew?: Maybe<Array<Scalars['String']['output']>>;
  isOnMarketplace?: Maybe<Array<Scalars['String']['output']>>;
  lastOrderDate?: Maybe<Array<Scalars['String']['output']>>;
  lastOrderNumber?: Maybe<Array<Scalars['String']['output']>>;
  licenseNumber?: Maybe<Array<Scalars['String']['output']>>;
  lifetimeOrderGMV?: Maybe<Array<Scalars['String']['output']>>;
  nabisGMVRating?: Maybe<Array<Scalars['String']['output']>>;
  nabisTrustedRating?: Maybe<Array<CreditRatingTrustLevels>>;
  name?: Maybe<Array<Scalars['String']['output']>>;
  numberOfOrders?: Maybe<Array<Scalars['String']['output']>>;
  paymentTerms?: Maybe<Array<Scalars['String']['output']>>;
  restrictionStatus?: Maybe<Array<RestrictionStatus>>;
  retailerGroups?: Maybe<Array<Scalars['String']['output']>>;
  salesRep?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type AccountFiltersInput = {
  amountOverdue?: InputMaybe<Array<Scalars['String']['input']>>;
  cityState?: InputMaybe<Array<Scalars['String']['input']>>;
  hasOverdueBalance?: InputMaybe<Array<Scalars['String']['input']>>;
  hasUpcomingOrders?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNew?: InputMaybe<Array<Scalars['String']['input']>>;
  isOnMarketplace?: InputMaybe<Array<Scalars['String']['input']>>;
  lastOrderDate?: InputMaybe<Array<Scalars['String']['input']>>;
  lastOrderNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  lifetimeOrderGMV?: InputMaybe<Array<Scalars['String']['input']>>;
  nabisGMVRating?: InputMaybe<Array<Scalars['String']['input']>>;
  nabisTrustedRating?: InputMaybe<Array<CreditRatingTrustLevels>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfOrders?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictionStatus?: InputMaybe<Array<RestrictionStatus>>;
  retailerGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRep?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AccountOrderChange = {
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editReasons?: Maybe<Array<Maybe<OrderEditReasons>>>;
  id: Scalars['ID']['output'];
  issueReason?: Maybe<OrderIssueReasons>;
  order: Order;
  submitter?: Maybe<User>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type AccountTask = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountTaskInput = {
  includeCompleted: Scalars['Boolean']['input'];
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Values for the AccountType enum */
export enum AccountType {
  OrderAppliedCreditMemo = 'ORDER_APPLIED_CREDIT_MEMO',
  OrderAppliedDiscounts = 'ORDER_APPLIED_DISCOUNTS',
  OrderAppliedExternalCollected = 'ORDER_APPLIED_EXTERNAL_COLLECTED',
  OrderAppliedExternalWriteOff = 'ORDER_APPLIED_EXTERNAL_WRITE_OFF',
  OrderAppliedNabisCreditMemo = 'ORDER_APPLIED_NABIS_CREDIT_MEMO',
  OrderAppliedNabisWriteOff = 'ORDER_APPLIED_NABIS_WRITE_OFF',
  OrderAppliedPayments = 'ORDER_APPLIED_PAYMENTS',
  PreRemittedCreditMemo = 'PRE_REMITTED_CREDIT_MEMO',
  PreRemittedDiscounts = 'PRE_REMITTED_DISCOUNTS',
  PreRemittedExternalCollected = 'PRE_REMITTED_EXTERNAL_COLLECTED',
  PreRemittedExternalWriteOff = 'PRE_REMITTED_EXTERNAL_WRITE_OFF',
  PreRemittedNabisCreditMemo = 'PRE_REMITTED_NABIS_CREDIT_MEMO',
  PreRemittedNabisKept = 'PRE_REMITTED_NABIS_KEPT',
  PreRemittedNabisWriteOff = 'PRE_REMITTED_NABIS_WRITE_OFF',
  PreRemittedToBrand = 'PRE_REMITTED_TO_BRAND',
  RemittanceReport = 'REMITTANCE_REPORT',
  RemittedCreditMemo = 'REMITTED_CREDIT_MEMO',
  RemittedDiscounts = 'REMITTED_DISCOUNTS',
  RemittedExternalCollected = 'REMITTED_EXTERNAL_COLLECTED',
  RemittedExternalWriteOff = 'REMITTED_EXTERNAL_WRITE_OFF',
  RemittedNabisCreditMemo = 'REMITTED_NABIS_CREDIT_MEMO',
  RemittedNabisKept = 'REMITTED_NABIS_KEPT',
  RemittedNabisWriteOff = 'REMITTED_NABIS_WRITE_OFF',
  RemittedToBrand = 'REMITTED_TO_BRAND',
  RemittedUnallocatedNabisReceived = 'REMITTED_UNALLOCATED_NABIS_RECEIVED',
  UnallocatedNabisReceived = 'UNALLOCATED_NABIS_RECEIVED',
  UncategorizedCreditMemo = 'UNCATEGORIZED_CREDIT_MEMO',
  UncategorizedDiscounts = 'UNCATEGORIZED_DISCOUNTS',
  UncategorizedExternalCollected = 'UNCATEGORIZED_EXTERNAL_COLLECTED',
  UncategorizedExternalWriteOff = 'UNCATEGORIZED_EXTERNAL_WRITE_OFF',
  UncategorizedNabisCreditMemo = 'UNCATEGORIZED_NABIS_CREDIT_MEMO',
  UncategorizedNabisWriteOff = 'UNCATEGORIZED_NABIS_WRITE_OFF',
  UncategorizedPayments = 'UNCATEGORIZED_PAYMENTS',
}

export type AccountingInfo = {
  creditMemo: Scalars['Float']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  discountedSubtotal?: Maybe<Scalars['Float']['output']>;
  lineItemDiscounts?: Maybe<Scalars['Float']['output']>;
  mustPayPreviousBalance?: Maybe<Scalars['Boolean']['output']>;
  netOffTotal?: Maybe<Scalars['Float']['output']>;
  orderDiscount?: Maybe<Scalars['Float']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalBalance?: Maybe<Scalars['Float']['output']>;
  totalExciseTax?: Maybe<Scalars['Float']['output']>;
};

export type AccountingOrder = {
  ACHACRetailerUnconfirmed: Scalars['Float']['output'];
  ACHAmountCollectedRetailer: Scalars['Float']['output'];
  ACHAmountPaidBrand: Scalars['Float']['output'];
  accountingNotes?: Maybe<Scalars['String']['output']>;
  action: OrderActionEnum;
  adminNotes?: Maybe<Scalars['String']['output']>;
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  basePricing?: Maybe<BaseOrgPricing>;
  brandFeesCollection: BrandFeesCollection;
  calculateMoneyValues: CalculateMoneyValues;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creditMemo: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  discount: Scalars['Float']['output'];
  disputeStatus: OrderDisputeStatus;
  distroFees?: Maybe<Scalars['Float']['output']>;
  dueToBrand?: Maybe<Scalars['Float']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  exciseTax: Scalars['Float']['output'];
  exciseTaxCollected?: Maybe<Scalars['Float']['output']>;
  extraFees?: Maybe<Scalars['Float']['output']>;
  factorStatus: OrderFactorStatusEnum;
  gmv: Scalars['Float']['output'];
  gmvCollected: Scalars['Float']['output'];
  hasMultiAQBInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasMultiBQBInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasMultiC1QBInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasMultiC2QBInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasMultiCQBInvoice?: Maybe<Scalars['Boolean']['output']>;
  hasMultiQBInvoices?: Maybe<Scalars['Boolean']['output']>;
  hasSingleQBInvoice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  irn?: Maybe<Scalars['String']['output']>;
  isAfterQuickbooksDeploy?: Maybe<Scalars['Boolean']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isSampleDemo?: Maybe<Scalars['Boolean']['output']>;
  issueReason?: Maybe<OrderIssueReasons>;
  lastDispute?: Maybe<OrderIssue>;
  lastNonpayment?: Maybe<OrderIssue>;
  lastPaymentTermOrderChange?: Maybe<AccountOrderChange>;
  licensedLocation?: Maybe<LicensedLocation>;
  licensedLocationId?: Maybe<Scalars['ID']['output']>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  mustPayPreviousBalance?: Maybe<Scalars['Boolean']['output']>;
  nabisDiscount?: Maybe<Scalars['Float']['output']>;
  nabisManifestNotes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  netGmv: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  orderFees?: Maybe<Array<OrderFee>>;
  orderFiles: Array<OrderFile>;
  orgLicenseNum?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  packingListS3FileLink?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  parentOrder?: Maybe<ParentOrder>;
  parentOrderId?: Maybe<Scalars['ID']['output']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  paymentSentAt?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus: OrderPaymentStatusEnum;
  paymentTermsRequestStatus?: Maybe<PaymentTermsRequestStatusEnum>;
  postDiscountFees?: Maybe<Scalars['Boolean']['output']>;
  priceDifference: Scalars['Float']['output'];
  pricingFee?: Maybe<Scalars['Float']['output']>;
  pricingPercentage?: Maybe<Scalars['Float']['output']>;
  processingAt?: Maybe<Scalars['DateTime']['output']>;
  referrer: OrderReferrer;
  remittedAt?: Maybe<Scalars['DateTime']['output']>;
  site: Site;
  siteLicenseNum?: Maybe<Scalars['String']['output']>;
  status: OrderStatusEnum;
  surcharge: Scalars['Float']['output'];
  wholesaleGmv: Scalars['Float']['output'];
  willAutoRegenerateInvoices: Scalars['Boolean']['output'];
  writeOffReasons?: Maybe<Array<WriteOffReason>>;
};

export type AccountingPageInfo = {
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  numItemsPerPage?: Maybe<Scalars['Int']['output']>;
  orderBy: Array<OrderBy>;
  page?: Maybe<Scalars['Int']['output']>;
};

export type AddItemsToCartPayload = {
  acceptedSkus?: Maybe<Array<Scalars['ID']['output']>>;
  cart?: Maybe<Cart>;
  rejectedSkus?: Maybe<Array<Scalars['ID']['output']>>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Values for the AdjustmentType enum */
export enum AdjustmentType {
  Deduction = 'DEDUCTION',
}

export type AdminCreditSettingsCsvInput = {
  licensedLocationName?: InputMaybe<Scalars['String']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  retailerRestrictionFilters?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCreditSettingsRow = {
  brandCodOnlyRestrictions: Array<BrandRestrictedOrgName>;
  brandRetailerCreditHolds: Array<BrandRestrictedOrgName>;
  creditHoldId?: Maybe<Scalars['ID']['output']>;
  creditTier?: Maybe<Scalars['String']['output']>;
  enterpriseNabisRetailerCreditHoldId?: Maybe<Scalars['ID']['output']>;
  enterpriseNabisRetailerOrderingRestrictionId?: Maybe<Scalars['ID']['output']>;
  licensedLocationId: Scalars['ID']['output'];
  licensedLocationName: Scalars['String']['output'];
  nabisRetailerOrderingRestrictionId?: Maybe<Scalars['ID']['output']>;
  retailerOrganizationId: Scalars['ID']['output'];
  totalAmount: Scalars['Float']['output'];
  totalAmountCollected: Scalars['Float']['output'];
  totalAmountDue: Scalars['Float']['output'];
  totalAmountExciseTaxOutstanding: Scalars['Float']['output'];
  totalAmountNotYetDue: Scalars['Float']['output'];
  totalAmountOutstanding: Scalars['Float']['output'];
  totalAmountOverdue: Scalars['Float']['output'];
  totalAmountRequiredForDelivery: Scalars['Float']['output'];
  totalCountOutstanding: Scalars['Int']['output'];
  totalCountOverdue: Scalars['Int']['output'];
};

export type AllAccountsAddRemoveRetailerGroupPayload = {
  affectedRows: Scalars['Int']['output'];
};

export type AllAccountsInput = {
  filters?: InputMaybe<AccountFiltersInput>;
  organizationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type AllAccountsPayload = {
  filters: AccountFilters;
  pageInfo: PageInfo;
  results?: Maybe<Array<Account>>;
};

export type AllAdminAccountingOrdersPayload = {
  nextOrders?: Maybe<Array<Maybe<NextOrder>>>;
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<AccountingOrder>>;
};

export type AllAdminOrdersPayload = {
  nextOrders?: Maybe<Array<Maybe<NextOrder>>>;
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Order>>;
};

export type AllDraftsPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<SimplifiedDraft>>;
};

export type AllEmailTemplatesPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Maybe<EmailTemplate>>>;
};

export type AllFactoringInvoicesPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<FactorInvoice>>;
};

export type AllInvoicesPayload = {
  nextOrders?: Maybe<Array<Maybe<NextOrder>>>;
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Invoice>>;
};

export type AllLicensedLocationProposalsPayload = {
  results?: Maybe<Array<LicensedLocationProposal>>;
};

export type AllLicensedLocationSimplified = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCodOnly: Scalars['Boolean']['output'];
  isNetTermsLimited: Scalars['Boolean']['output'];
  licensedLocationOrg?: Maybe<Array<Maybe<LicensedLocationOrganizationFragment>>>;
  licenses?: Maybe<Array<License>>;
  nabisMaxTerms?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noExciseTax: Scalars['Boolean']['output'];
  specialRequirementsForLocation?: Maybe<Array<SpecialRequirementsForLocation>>;
  state?: Maybe<Scalars['String']['output']>;
  trustLevelInEffect: CreditRatingTrustLevels;
  warehouse: Warehouse;
  warehouseId: Scalars['ID']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type AllLicensedLocationSimplifiedLicensesArgs = {
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllLicensedLocationSimplifiedPayload = {
  pageInfo: PageInfo;
  results: Array<AllLicensedLocationSimplified>;
};

export type AllLicensedLocationsPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<LicensedLocation>>;
};

export type AllLicensesPayload = {
  organizationLicenses: Array<License>;
};

export type AllOrdersPayload = {
  nextOrders?: Maybe<Array<Maybe<NextOrder>>>;
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Order>>;
};

export type AllOrdersRetailerPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<OrderRetailer>>;
};

export type AllRetailerInvoicesPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Maybe<RetailerInvoice>>>;
};

export type AllSettledErrorReason = {
  message: Scalars['String']['output'];
};

export type AllStagingAreasInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AllStagingAreasWithPaginationInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageInfo: PageInfoInput;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AppConstant = {
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  numDaysForOrderEditLockdown: Scalars['Int']['output'];
  timeOfDayForOrderEditLockdown: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type AppSetting = {
  ACHEnabled: Scalars['Boolean']['output'];
  canCreateOrder: Scalars['Boolean']['output'];
  maintenanceSetting: MaintenanceSettingEnum;
};

export type Applications = {
  amount: Scalars['Float']['output'];
  appliedAt: Scalars['DateTime']['output'];
  brandOrgName?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['Int']['output'];
  invoiceTypeName: Scalars['String']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
};

export type AppliedDiscountInput = {
  discountType: RetailerDiscountType;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatDiscount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  minBrandOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>;
  promotionsDiscount: Scalars['Float']['input'];
  skuIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  tierId?: InputMaybe<Scalars['ID']['input']>;
};

export type AppliedToBrandTransactions = {
  amount: Scalars['Float']['output'];
  appliedAt: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['Int']['output'];
  invoiceTotal: Scalars['Float']['output'];
  invoiceTypeName: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
};

export type ArTotalSums = {
  oustandingAr: Scalars['Float']['output'];
  overdueAr: Scalars['Float']['output'];
  t3mCollectedAr: Scalars['Float']['output'];
};

export type ArchiveLicensePayload = {
  changedLicense: License;
};

/** Values for the AromaEnum enum */
export enum AromaEnum {
  Ammonia = 'AMMONIA',
  ApplePear = 'APPLE_PEAR',
  Banana = 'BANANA',
  Berry = 'BERRY',
  Cheese = 'CHEESE',
  Chemical = 'CHEMICAL',
  Chocolate = 'CHOCOLATE',
  Citrus = 'CITRUS',
  Coffee = 'COFFEE',
  CommonChemical = 'COMMON_CHEMICAL',
  Creamy = 'CREAMY',
  Diesel = 'DIESEL',
  Dough = 'DOUGH',
  DriedFruit = 'DRIED_FRUIT',
  Earthy = 'EARTHY',
  Floral = 'FLORAL',
  Fruit = 'FRUIT',
  Gas = 'GAS',
  Glue = 'GLUE',
  GrainCereal = 'GRAIN_CEREAL',
  Grape = 'GRAPE',
  Grassy = 'GRASSY',
  Greens = 'GREENS',
  Herb = 'HERB',
  Heritage = 'HERITAGE',
  Kush = 'KUSH',
  Melon = 'MELON',
  Menthol = 'MENTHOL',
  Natural = 'NATURAL',
  Nutty = 'NUTTY',
  Orange = 'ORANGE',
  Petroleum = 'PETROLEUM',
  Resinous = 'RESINOUS',
  Rubber = 'RUBBER',
  Savory = 'SAVORY',
  Skunk = 'SKUNK',
  Spice = 'SPICE',
  StoneFruit = 'STONE_FRUIT',
  Sugary = 'SUGARY',
  Sweet = 'SWEET',
  Tea = 'TEA',
  Tropical = 'TROPICAL',
  UnknownBenchmark = 'UNKNOWN_BENCHMARK',
  VegetalEarthen = 'VEGETAL_EARTHEN',
  Woody = 'WOODY',
}

export type AsyncOrderPayload = {
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  firstShipmentId?: Maybe<Scalars['String']['output']>;
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  isEditableByBrand?: Maybe<Scalars['Boolean']['output']>;
  orderId: Scalars['String']['output'];
  packingListS3FileLink?: Maybe<Scalars['String']['output']>;
  qrcodeS3FileLink?: Maybe<Scalars['String']['output']>;
};

export type AsyncTask = {
  body?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AsyncTaskWithOrder = {
  asyncTask: AsyncTask;
  order?: Maybe<AsyncTaskedOrder>;
};

export type AsyncTaskWithOrderResult = {
  error?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
  task: AsyncTaskWithOrder;
};

export type AsyncTaskedOrder = {
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
};

export type Attachment = {
  category: AttachmentCategory;
  dataUrl?: InputMaybe<Scalars['String']['input']>;
  downloadLink?: InputMaybe<Scalars['String']['input']>;
  gDriveFileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  send: Scalars['Boolean']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  viewLink?: InputMaybe<Scalars['String']['input']>;
};

/** Values for the AttachmentCategory enum */
export enum AttachmentCategory {
  Additional = 'ADDITIONAL',
  Coa = 'COA',
  Paperwork = 'PAPERWORK',
}

export type AvailableEmail = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type AvailableInventory = {
  key: Scalars['String']['output'];
  values: Values;
  warehouseId: Scalars['ID']['output'];
};

export type BsaForm8300Submission = {
  BSAForm8300SubmissionDaily: BsaForm8300SubmissionDaily;
  BSAForm8300SubmissionDailyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  groupingDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  s3IndividualFileLink: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BsaForm8300SubmissionDaily = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  groupingDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  s3ZipFileLink: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BackfillMppbStats = {
  failedCount: Scalars['Int']['output'];
  failedOrderIds: Array<Scalars['String']['output']>;
  ordersPerPage: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  skippedOrderIds: Array<Scalars['String']['output']>;
  successCount: Scalars['Int']['output'];
  time: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type BankAccountInfo = {
  accountType: BankAccountInfoAccountTypeEnum;
  achEnabled: Scalars['Boolean']['output'];
  approvalStatus: BankAccountInfoApprovalStatusTypeEnum;
  autoPay: Scalars['Boolean']['output'];
  bankAccountSuffix: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bankRoutingSuffix: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDefaultBank: Scalars['Boolean']['output'];
  namedOwner: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  ownerType: BankAccountInfoOwnerTypeEnum;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  validationAttempts?: Maybe<Scalars['Int']['output']>;
};

/** Values for the BankAccountInfoAccountTypeEnum enum */
export enum BankAccountInfoAccountTypeEnum {
  Checking = 'CHECKING',
  Savings = 'SAVINGS',
}

/** Values for the BankAccountInfoApprovalStatusTypeEnum enum */
export enum BankAccountInfoApprovalStatusTypeEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

/** Values for the BankAccountInfoOwnerTypeEnum enum */
export enum BankAccountInfoOwnerTypeEnum {
  Brand = 'BRAND',
  Retailer = 'RETAILER',
}

export type BankAccountInfosPayload = {
  bankAccountInfos: Array<BankAccountInfo>;
};

export type BankingInvoice = {
  ACHACRetailerUnconfirmed: Scalars['Float']['output'];
  ACHAmountCollectedRetailer: Scalars['Float']['output'];
  ACHAmountPaidBrand: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  dueToBrand: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus: OrderPaymentStatusEnum;
  remittedAt?: Maybe<Scalars['DateTime']['output']>;
  totalBalance: Scalars['Float']['output'];
};

export type BaseOrgPricing = {
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  pricingFee?: Maybe<Scalars['Float']['output']>;
  pricingPercentage?: Maybe<Scalars['Float']['output']>;
};

export type Batch = {
  aromas: Array<AromaEnum>;
  cbdPercentage?: Maybe<Scalars['Float']['output']>;
  cbdWeight?: Maybe<Scalars['Float']['output']>;
  coaS3FileLink?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customTags: Array<CustomTag>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<License>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  manufacturingDate: Scalars['DateTime']['output'];
  organization: Organization;
  otherCannabinoidPercentage?: Maybe<Scalars['Float']['output']>;
  otherCannabinoidWeight?: Maybe<Scalars['Float']['output']>;
  skuBatches: Array<SkuBatch>;
  skus: Array<Sku>;
  thcAPercentage?: Maybe<Scalars['Float']['output']>;
  thcAWeight?: Maybe<Scalars['Float']['output']>;
  thcPercentage?: Maybe<Scalars['Float']['output']>;
  thcWeight?: Maybe<Scalars['Float']['output']>;
};

export type BatchCoaLink = {
  brandName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BatchInfo = {
  pageInfo: PageInfo;
  results: Array<Batch>;
};

export type BccLicense = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  adultUse: Scalars['String']['output'];
  businessDBA?: Maybe<Scalars['String']['output']>;
  businessName: Scalars['String']['output'];
  businessOwner?: Maybe<Scalars['String']['output']>;
  businessStructure?: Maybe<Scalars['String']['output']>;
  category: LicenseCategoryEnum;
  email?: Maybe<Scalars['String']['output']>;
  expiryDate: Scalars['String']['output'];
  issuedDate: Scalars['String']['output'];
  licenseNumber: Scalars['String']['output'];
  licenseStatus: Scalars['String']['output'];
  licenseType: Scalars['String']['output'];
  medicinal: Scalars['String']['output'];
  microActivityCultivator?: Maybe<Scalars['String']['output']>;
  microActivityDistributor?: Maybe<Scalars['String']['output']>;
  microActivityDistributorTransportOnly?: Maybe<Scalars['String']['output']>;
  microActivityLevel1Manufacturer?: Maybe<Scalars['String']['output']>;
  microActivityRetailer?: Maybe<Scalars['String']['output']>;
  microActivityRetailerNonStorefront?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  premiseCity?: Maybe<Scalars['String']['output']>;
  premiseCounty?: Maybe<Scalars['String']['output']>;
  premiseState?: Maybe<Scalars['String']['output']>;
  premiseZip?: Maybe<Scalars['String']['output']>;
  type: LicenseTypeEnum;
  website?: Maybe<Scalars['String']['output']>;
};

export type BrandCodOnlyRetailersThatCanNotBeOverriden = {
  codOnlyRetailersThatCanNotBeOverriden: Array<RestrictionInformationRetailer>;
  decodedSelectedBrandOrganizationId: Scalars['String']['output'];
};

export type BrandCreditSettingsRow = {
  brandRetailerCreditHoldId?: Maybe<Scalars['ID']['output']>;
  brandRetailerOrderingRestrictionCodOnlyId?: Maybe<Scalars['ID']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  creditTier?: Maybe<Scalars['String']['output']>;
  hasNabisMaxCodOnlyRestriction: Scalars['Boolean']['output'];
  hasNabisMaxCreditHold: Scalars['Boolean']['output'];
  hasNabisStandardCodOnlyRestriction: Scalars['Boolean']['output'];
  hasNabisStandardCreditHold: Scalars['Boolean']['output'];
  licensedLocationId: Scalars['ID']['output'];
  licensedLocationName: Scalars['String']['output'];
  retailerOrganizationId: Scalars['ID']['output'];
  totalAmountOutstanding: Scalars['Float']['output'];
};

export type BrandFeesCollection = {
  collectionStatus?: Maybe<BrandFeesCollectionCollectionStatusEnum>;
  collectionStatusUpdatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  notes: Scalars['String']['output'];
  submitterId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/** Values for the BrandFeesCollectionCollectionStatusEnum enum */
export enum BrandFeesCollectionCollectionStatusEnum {
  Collected = 'COLLECTED',
  Eligible = 'ELIGIBLE',
  NotOverdue = 'NOT_OVERDUE',
  PartiallyCollected = 'PARTIALLY_COLLECTED',
}

export type BrandRestrictedOrgName = {
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BrandRetailerCreditHold = {
  createdAt: Scalars['String']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type BrandRetailerCreditLimit = {
  brandOrganizationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  retailerOrganizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById: Scalars['ID']['output'];
};

export type BrandRetailerCreditLimitInput = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type BrandRetailerOrderingRestriction = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  maxTerms?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type BrandRetailerOrderingRestrictionInput = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type BrandRetailerOutstandingBalanceResponse = {
  brandOrganizationId: Scalars['ID']['output'];
  data?: Maybe<OutstandingBalanceResponse>;
  licensedLocationId: Scalars['ID']['output'];
};

export type BrandRetailerRestriction = {
  brandId: Scalars['ID']['output'];
  brandOrganizationName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  retailerId: Scalars['ID']['output'];
  retailerOrganizationName: Scalars['String']['output'];
};

export type BrandRetailerRestrictionResponse = {
  pageInfo: PageInfo;
  results: Array<BrandRetailerRestriction>;
};

export type BrandRetailerRestrictionWhitelist = {
  brandId: Scalars['ID']['output'];
  brandOrganizationName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BrandRetailerRestrictionWhitelistResponse = {
  results: Array<BrandRetailerRestrictionWhitelist>;
};

export type BulkImportCsvUploadResponse = {
  columns: Scalars['JSON']['output'];
  filePath: Scalars['String']['output'];
};

export type BulkImportFileMappingInput = {
  config: Scalars['JSON']['input'];
  fileType: GuzzleFileType;
  organizationId: Scalars['ID']['input'];
};

export type BulkImportFileMappingResponse = {
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileType: GuzzleFileType;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BulkImportJobInput = {
  organizationId: Scalars['ID']['input'];
};

export type BulkImportJobResponse = {
  createdAt: Scalars['DateTime']['output'];
  guzzleFileMappingId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ingestErrors: Scalars['JSON']['output'];
  ingestStats: Scalars['JSON']['output'];
  organizationId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  transformErrors: Scalars['JSON']['output'];
  transformStats: Scalars['JSON']['output'];
  transformedFilePath?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadFilePath: Scalars['String']['output'];
};

export type BulkRequestFactorInvoiceInput = {
  changedInvoices: Array<RequestFactorInvoiceInput>;
  userSignature: Scalars['String']['input'];
};

export type BulkUpdateCustomRateProposalInput = {
  changedInvoices: Array<RequestFactorInvoiceInput>;
  userSignature: Scalars['String']['input'];
};

export type BulkUpdateFactorInvoiceInput = {
  changedInvoices?: InputMaybe<Array<InputMaybe<UpdateFactorInvoiceInput>>>;
};

export type BulkUpdateOrder = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  stagingAreaId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<OrderStatusEnum>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkUpdateOrderDates = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  number: Scalars['Int']['input'];
};

export type BulkUpdateOrderDatesPayload = {
  orders: Array<BulkUpdateOrderDates>;
};

export type BulkUpdateOrderDatesResponse = {
  changedOrders?: Maybe<Array<Order>>;
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type BulkUpdateOrdersInput = {
  orders: Array<BulkUpdateOrder>;
};

export type BulkUpdateOrdersPayload = {
  changedOrders: Array<Order>;
};

export type BulkUpdatePricingInput = {
  orders?: InputMaybe<Scalars['JSON']['input']>;
  pricingPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CcpaDeletionResult = {
  deletionAmount: Scalars['Int']['output'];
  recordAmount: Scalars['Int']['output'];
};

export type CcpaUser = {
  dateOfBirth: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  idType: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  occupation: Scalars['String']['output'];
};

/** Values for the CSVFileTypes enum */
export enum CsvFileTypes {
  Account = 'ACCOUNT',
  BrandCreditSettings = 'BRAND_CREDIT_SETTINGS',
  BrandCsv = 'BRAND_CSV',
  CreditBrandCsv = 'CREDIT_BRAND_CSV',
  DetailedBrandCsv = 'DETAILED_BRAND_CSV',
  Inventory = 'INVENTORY',
  RetailerDetailedOrders = 'RETAILER_DETAILED_ORDERS',
  SalesRules = 'SALES_RULES',
}

export type CalculateMoneyValues = {
  discountedSubtotal: Scalars['Float']['output'];
  lineItemDiscounts: Scalars['Float']['output'];
  netOffTotal?: Maybe<Scalars['Float']['output']>;
  orderDiscount: Scalars['Float']['output'];
  subtotal: Scalars['Float']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalBalance: Scalars['Float']['output'];
  totalExciseTax: Scalars['Float']['output'];
  wholesaleSubtotal: Scalars['Float']['output'];
};

export type Cart = {
  address: CartAddress;
  brandItems: Array<CartBrandItem>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryPreferences?: Maybe<Array<Scalars['String']['output']>>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  legalInformation?: Maybe<CartLegalInformation>;
  license?: Maybe<License>;
  notes?: Maybe<Scalars['String']['output']>;
  poc: CartPoc;
  promoCodes?: Maybe<Array<CartPromoCode>>;
  siteLicenseNum?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type CartAddress = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CartAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CartBrandItem = {
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']['output']>;
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  items: Array<CartItem>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  paymentMethod: PaymentMethodEnum;
  requestedDaysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  retailerManifestNotes?: Maybe<Scalars['String']['output']>;
  retailerNotes?: Maybe<Scalars['String']['output']>;
};

export type CartBrandItemItemsArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type CartBrandItemOrganizationArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type CartBrandItemInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  daysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<CartItemInput>>>;
  organizationId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  requestedDaysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  retailerManifestNotes?: InputMaybe<Scalars['String']['input']>;
  retailerNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CartItem = {
  includeDisplaySample?: Maybe<Scalars['Boolean']['output']>;
  isSample: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  sku?: Maybe<Sku>;
  skuBatchId?: Maybe<Scalars['ID']['output']>;
  skuId: Scalars['ID']['output'];
};

export type CartItemSkuArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type CartItemInput = {
  includeDisplaySample?: InputMaybe<Scalars['Boolean']['input']>;
  isSample: Scalars['Boolean']['input'];
  quantity: Scalars['Int']['input'];
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
  skuId: Scalars['ID']['input'];
};

export type CartLegalInformation = {
  sellerPermitLink?: Maybe<Scalars['String']['output']>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  w9Link?: Maybe<Scalars['String']['output']>;
};

export type CartLegalInformationInput = {
  sellerPermitLink?: InputMaybe<Scalars['String']['input']>;
  taxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  w9Link?: InputMaybe<Scalars['String']['input']>;
};

export type CartPoc = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CartPocInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CartPromoCode = {
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type CartPromoCodeInput = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type Changelog = {
  action: ChangelogAction;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  new?: Maybe<Scalars['JSON']['output']>;
  old?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['ID']['output'];
  table: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Values for the ChangelogAction enum */
export enum ChangelogAction {
  Create = 'CREATE',
  Destroy = 'DESTROY',
  Update = 'UPDATE',
}

export type CheckConfirmationIdPayload = {
  licensedLocationConfirmationUser?: Maybe<LicensedLocationConfirmationUser>;
  paymentPickupConfirmation?: Maybe<PaymentPickupConfirmation>;
};

export type CheckForDuplicateRetailerGroupsOldPayload = {
  duplicateRetailerGroups: Array<RetailerGroup>;
  hasDuplicates: Scalars['Boolean']['output'];
};

export type CheckForDuplicateRetailerGroupsPayload = {
  duplicateRetailerGroupLicensedLocations?: Maybe<Array<RetailerGroupLicensedLocation>>;
  hasDuplicates: Scalars['Boolean']['output'];
};

export type CheckForExistingOrderFilesByTypePayload = {
  existingOrderFiles?: Maybe<Array<OrderFile>>;
  isCurrentUploadAllowed: Scalars['Boolean']['output'];
};

export type CoaLink = {
  coaS3FileLink?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type CoaPayload = {
  coaLinks: Array<CoaLink>;
  orderId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
};

export type ColdStorageInfo = {
  isColdStorage: Scalars['Boolean']['output'];
  skuId: Scalars['ID']['output'];
};

export type CompleteBatchFileUploadInput = {
  fileKey: Scalars['String']['input'];
  isMultipart: Scalars['Boolean']['input'];
  parts?: InputMaybe<Array<UploadPart>>;
  s3Link?: InputMaybe<Scalars['String']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmDeliveryInput = {
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  ownerFirstName?: InputMaybe<Scalars['String']['input']>;
  retailerConfirmLinkId: Scalars['ID']['input'];
  retailerNotes?: InputMaybe<Scalars['String']['input']>;
  sellerPermitLink?: InputMaybe<Scalars['String']['input']>;
  tin?: InputMaybe<Scalars['String']['input']>;
  w9Link?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmDeliveryPayload = {
  success: Scalars['Boolean']['output'];
};

/** Values for the ConfirmationTrailEnum enum */
export enum ConfirmationTrailEnum {
  EmailFailure = 'EMAIL_FAILURE',
  EmailSuccess = 'EMAIL_SUCCESS',
  PhoneFailure = 'PHONE_FAILURE',
  PhoneSuccess = 'PHONE_SUCCESS',
  SmsSuccess = 'SMS_SUCCESS',
  VoicemailSuccess = 'VOICEMAIL_SUCCESS',
}

export type ContainerType = {
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CountAndTotalDue = {
  count: Scalars['Int']['output'];
  exciseTaxDue?: Maybe<Scalars['Float']['output']>;
  totalDue: Scalars['Float']['output'];
};

export type CountAndTotalDueForOverdueInvoicesPayload = {
  outstandingForAllBrands: CountAndTotalDue;
  outstandingForBrand: CountAndTotalDue;
  overdueForAllBrands: CountAndTotalDue;
  overdueForBrand: CountAndTotalDue;
};

export type CountEwbPrePayableOrdersInput = {
  licensedLocationId: Scalars['ID']['input'];
};

export type CountOverdueInvoicesPayload = {
  outstanding: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
};

export type CreateAccountActivityInput = {
  licensedLocationId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  secondaryNotes?: InputMaybe<Scalars['String']['input']>;
  type: AccountActivityTypeEnum;
};

export type CreateAccountActivityPinInput = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  rowId: Scalars['ID']['input'];
  type: AccountActivityTypeEnum;
};

export type CreateAccountTaskInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateAndArchiveOrderRestrictionsForMppbInput = {
  archivedOrderRestrictionIds: Array<Scalars['ID']['input']>;
  createOrderRestrictions: Array<CreateMppbOrderRestrictionAssociation>;
  orderId: Scalars['ID']['input'];
  updateOrderRestrictions: Array<CreateMppbOrderRestrictionAssociation>;
};

export type CreateAndArchiveOrderRestrictionsForMppbResponse = {
  success: Scalars['Boolean']['output'];
};

export type CreateBankAccountInfoInput = {
  accountType: BankAccountInfoAccountTypeEnum;
  autoPay: Scalars['Boolean']['input'];
  bankAccountId: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  bankRoutingId: Scalars['String']['input'];
  createValidationMicroTransactions: Scalars['Boolean']['input'];
  namedOwner: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ownerType: BankAccountInfoOwnerTypeEnum;
};

export type CreateBatchInput = {
  aromas: Array<AromaEnum>;
  cbdPercentage?: InputMaybe<Scalars['Float']['input']>;
  cbdWeight?: InputMaybe<Scalars['Float']['input']>;
  coaS3FileLink?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  customTagIds: Array<Scalars['ID']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  manufacturingDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['ID']['input'];
  otherCannabinoidPercentage?: InputMaybe<Scalars['Float']['input']>;
  otherCannabinoidWeight?: InputMaybe<Scalars['Float']['input']>;
  thcAPercentage?: InputMaybe<Scalars['Float']['input']>;
  thcAWeight?: InputMaybe<Scalars['Float']['input']>;
  thcPercentage?: InputMaybe<Scalars['Float']['input']>;
  thcWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateBrandRetailerCreditHoldResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<BrandRetailerCreditHold>;
};

export type CreateBrandRetailerCreditLimitResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<BrandRetailerCreditLimit>;
};

export type CreateBrandRetailerOrderingRestrictionResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<BrandRetailerOrderingRestriction>;
};

export type CreateBrandsSaleRelationshipInput = {
  brandOrgIds: Array<Scalars['ID']['input']>;
  salesOrgId: Scalars['ID']['input'];
};

export type CreateBulkImportCsvUploadInput = {
  file: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateBulkImportFileMappingInput = {
  config: Scalars['JSON']['input'];
  fileType: GuzzleFileType;
  organizationId: Scalars['ID']['input'];
};

export type CreateBulkImportJobInput = {
  guzzleFileMappingId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  uploadFilePath: Scalars['String']['input'];
};

export type CreateDraftInput = {
  body: Scalars['JSON']['input'];
  organizationId: Scalars['ID']['input'];
  source?: InputMaybe<DraftSourceEnum>;
  type?: InputMaybe<DraftTypeEnum>;
};

export type CreateDraftPayload = {
  createdDraft: Draft;
};

export type CreateDriverConfirmationPayload = {
  createdPaymentPickups: Array<PaymentPickupConfirmation>;
  orders: Array<DriverOrder>;
};

export type CreateDriverInput = {
  driversLicense: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  onfleetWorkerId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateDriverMultiPaymentPickupConfirmationPayload = {
  createdPaymentPickups: Array<PaymentPickupConfirmation>;
};

export type CreateDriverMultiPaymentPickupConfirmationsInput = {
  form8300Email?: InputMaybe<Scalars['String']['input']>;
  form8300SelectedUser?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickups: Array<DriverMultiPaymentPickupConfirmationElement>;
};

export type CreateDriverPayload = {
  changedDriver: Driver;
};

export type CreateEwbMicroTransactionsInput = {
  bankAccountInfoId: Scalars['ID']['input'];
};

export type CreateEwbTransactionsInput = {
  bankAccountInfoId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  requestedExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  retailerPayAll?: InputMaybe<RetailerPayAllEnum>;
  totalNotes?: InputMaybe<Scalars['String']['input']>;
  transactionOrders: Array<EwbTransactionOrderData>;
  transactionType: EwbTransactionTypeEnum;
};

export type CreateEmailTemplateInput = {
  bcc: Array<InputMaybe<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  cc: Array<InputMaybe<Scalars['String']['input']>>;
  from: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  to: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateEmailTemplatePayload = {
  bcc: Array<Maybe<Scalars['String']['output']>>;
  body: Scalars['String']['output'];
  cc: Array<Maybe<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  to: Array<Maybe<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateEnterpriseNabisRetailerCreditHoldResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<EnterpriseNabisRetailerCreditHold>;
};

export type CreateEnterpriseNabisRetailerOrderingRestrictionResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<EnterpriseNabisRetailerOrderingRestriction>;
};

export type CreateExternalPaymentConfirmationInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  orderId: Scalars['ID']['input'];
};

export type CreateExternalPaymentConfirmationPayload = {
  amount?: Maybe<Scalars['Float']['output']>;
  orderId: Scalars['ID']['output'];
};

export type CreateForm8300UrlWithoutPayment = {
  email: Scalars['String']['input'];
  licensedLocationId: Scalars['ID']['input'];
};

export type CreateHomeListElementInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  inventoryClass?: InputMaybe<InventoryClassEnum>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  marketplacePage: MarketplacePageType;
  name?: InputMaybe<Scalars['String']['input']>;
  retailerGroupId?: InputMaybe<Scalars['ID']['input']>;
  skuIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  type: HomeListElementType;
};

export type CreateHoursInput = {
  enabled: Scalars['Boolean']['input'];
  hours?: InputMaybe<Array<InputMaybe<Array<Scalars['DateTime']['input']>>>>;
  licensedLocationId: Scalars['ID']['input'];
};

export type CreateInventorySnapshotInput = {
  organizationIds: Array<Scalars['ID']['input']>;
};

export type CreateLicenseInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  category: LicenseCategoryEnum;
  city: Scalars['String']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  issuanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName: Scalars['String']['input'];
  licenseNumber: Scalars['String']['input'];
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  nickname: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  state: Scalars['String']['input'];
  type: LicenseTypeEnum;
  zip: Scalars['String']['input'];
};

export type CreateLicensePayload = {
  changedLicense: License;
};

export type CreateLicensedLocationInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingAddressZip?: InputMaybe<Scalars['String']['input']>;
  centralizedPurchasingNotes?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  collect1PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  collect1PocEmail?: InputMaybe<Scalars['String']['input']>;
  collect1PocFirstName?: InputMaybe<Scalars['String']['input']>;
  collect1PocLastName?: InputMaybe<Scalars['String']['input']>;
  collect1PocNumber?: InputMaybe<Scalars['String']['input']>;
  collect1PocTitle?: InputMaybe<Scalars['String']['input']>;
  collect1PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  collect2PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  collect2PocEmail?: InputMaybe<Scalars['String']['input']>;
  collect2PocFirstName?: InputMaybe<Scalars['String']['input']>;
  collect2PocLastName?: InputMaybe<Scalars['String']['input']>;
  collect2PocNumber?: InputMaybe<Scalars['String']['input']>;
  collect2PocTitle?: InputMaybe<Scalars['String']['input']>;
  collect2PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  collectionNotes?: InputMaybe<Scalars['String']['input']>;
  delivery1PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  delivery1PocEmail?: InputMaybe<Scalars['String']['input']>;
  delivery1PocFirstName?: InputMaybe<Scalars['String']['input']>;
  delivery1PocLastName?: InputMaybe<Scalars['String']['input']>;
  delivery1PocNumber?: InputMaybe<Scalars['String']['input']>;
  delivery1PocTitle?: InputMaybe<Scalars['String']['input']>;
  delivery1PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  delivery2PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  delivery2PocEmail?: InputMaybe<Scalars['String']['input']>;
  delivery2PocFirstName?: InputMaybe<Scalars['String']['input']>;
  delivery2PocLastName?: InputMaybe<Scalars['String']['input']>;
  delivery2PocNumber?: InputMaybe<Scalars['String']['input']>;
  delivery2PocTitle?: InputMaybe<Scalars['String']['input']>;
  delivery2PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  deliveryByApptOnly?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  form8300ComplianceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  hoursBusiness?: InputMaybe<Scalars['String']['input']>;
  hoursDelivery?: InputMaybe<Scalars['String']['input']>;
  isBillingAddressSameAsDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isDropAndGo?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  licensedLocationProposalId?: InputMaybe<Scalars['ID']['input']>;
  licenses: Array<CreateLicenseInput>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locationNotes?: InputMaybe<Scalars['String']['input']>;
  nabisNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  newSpecialRequirementsForLocation?: InputMaybe<NewSpecialRequirementsForLocation>;
  noExciseTax?: InputMaybe<Scalars['Boolean']['input']>;
  payByCheck?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  printCoas?: InputMaybe<Scalars['Boolean']['input']>;
  qualitativeRating: Scalars['Float']['input'];
  reason: Scalars['String']['input'];
  retailerPricingGroupId?: InputMaybe<Scalars['ID']['input']>;
  retailerPricingGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  schedulingSoftwareLink?: InputMaybe<Scalars['String']['input']>;
  schedulingSoftwareRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sellerPermitLink?: InputMaybe<Scalars['String']['input']>;
  siteCategory: SiteCategoryEnum;
  specialProtocol?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  taxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  trustLevelNabis: CreditRatingTrustLevels;
  w9Link?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreateLicensedLocationProposalInput = {
  body: Scalars['JSON']['input'];
  creatorId: Scalars['String']['input'];
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLineItemInput = {
  additionalDiscount: Scalars['Float']['input'];
  appliedDiscounts: Array<AppliedDiscountInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  destinationSkuBatchId?: InputMaybe<Scalars['String']['input']>;
  discount: Scalars['Float']['input'];
  includeDisplaySample?: InputMaybe<Scalars['Boolean']['input']>;
  isExciseTaxable: Scalars['Boolean']['input'];
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemManifestNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overrideQuantityPerUnitOfMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  oversold?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerUnit: Scalars['Float']['input'];
  promotionsDiscount: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  sampleType?: InputMaybe<LineItemSampleType>;
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
  standardPricePerUnit: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLineItemPayload = {
  changedLineItem: LineItem;
};

export type CreateMppbOrderInput = {
  amount: Scalars['Float']['input'];
  isPartialRequired?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber: Scalars['Int']['input'];
};

export type CreateMppbOrderRestrictionAssociation = {
  amountToCollect: Scalars['Float']['input'];
  isPartialRequired?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
};

export type CreateMarketplaceParentOrderInput = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  legalInformation?: InputMaybe<CartLegalInformationInput>;
  orders: Array<CreateOrderInput>;
  organizationId: Scalars['ID']['input'];
};

export type CreateMarketplaceParentOrderPayload = {
  changedParentOrder?: Maybe<ParentOrder>;
  oversoldSkus?: Maybe<Array<OversoldSkuPayload>>;
};

export type CreateMetrcTransferInput = {
  destinationLicensedLocationId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  originLicensedLocationId: Scalars['ID']['input'];
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  shouldCreateTemplateOnMetrc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateNabisRetailerCreditHoldResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<NabisCreditHold>;
};

export type CreateNabisRetailerOrderingRestrictionResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<NabisRetailerOrderingRestriction>;
};

export type CreateOnboardingInviteInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOnboardingInvitePayload = {
  changedInvite?: Maybe<OnboardingInvite>;
};

export type CreateOrderContactPayload = {
  orderContacts: Array<OrderContact>;
};

export type CreateOrderInput = {
  action: OrderActionEnum;
  additionalDiscount: Scalars['Float']['input'];
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  appliedDiscounts: Array<AppliedDiscountInput>;
  asnInventoryStatus?: InputMaybe<OrderAsnInventoryStatusEnum>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  brandManifestNotes?: InputMaybe<Scalars['String']['input']>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creditMemo: Scalars['Float']['input'];
  creditMemoPayload?: InputMaybe<Array<CreditMemoPayload>>;
  date: Scalars['DateTime']['input'];
  daysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  exciseTax?: InputMaybe<Scalars['Float']['input']>;
  exciseTaxCollected?: InputMaybe<Scalars['Float']['input']>;
  expectedDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalPaymentDesired?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentMin?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentNotes?: InputMaybe<Scalars['String']['input']>;
  gmv: Scalars['Float']['input'];
  gmvCollected?: InputMaybe<Scalars['Float']['input']>;
  infoplus?: InputMaybe<Scalars['Int']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<OrderIssueReasons>;
  licensedLocationId: Scalars['ID']['input'];
  lineItems: Array<CreateLineItemInput>;
  manufacturerOrgId?: InputMaybe<Scalars['ID']['input']>;
  mppbOrders?: InputMaybe<Array<CreateMppbOrderInput>>;
  mustPayExternalBalance?: InputMaybe<Scalars['Boolean']['input']>;
  mustPayPreviousBalance?: InputMaybe<Scalars['Boolean']['input']>;
  nabisManifestNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderInventoryStatus?: InputMaybe<OrderOrderInventoryStatusEnum>;
  orgLicenseNum?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  parentOrderId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentStatus: OrderPaymentStatusEnum;
  pickupDropoffWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  promotionsDiscount: Scalars['Float']['input'];
  referrer?: InputMaybe<OrderReferrer>;
  reorderEmailDate?: InputMaybe<Scalars['DateTime']['input']>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
  requestedDaysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  retailerManifestNotes?: InputMaybe<Scalars['String']['input']>;
  retailerNotes?: InputMaybe<Scalars['String']['input']>;
  secondaryInfoplus?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<UpsertSiteInput>;
  siteLicenseNum?: InputMaybe<Scalars['String']['input']>;
  status: OrderStatusEnum;
  surcharge?: InputMaybe<Scalars['Float']['input']>;
  timeWindow?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrderPayload = {
  changedOrder?: Maybe<Order>;
  oversoldSkus?: Maybe<Array<OversoldSkuPayload>>;
};

export type CreateOrganizationInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  alias: Scalars['String']['input'];
  bannerImageS3Link?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  doingBusinessAs: Scalars['String']['input'];
  licenses: Array<CreateLicenseInput>;
  logoS3Link?: InputMaybe<Scalars['String']['input']>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  singleHubWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  state: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreateOrganizationInviteInput = {
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  senderId: Scalars['ID']['input'];
};

export type CreateOrganizationInvitePayload = {
  changedOrganizationInvite: OrganizationInvite;
};

export type CreateOrganizationPayload = {
  changedOrganization: Organization;
};

export type CreateOrganizationUserInput = {
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateOrganizationUserPayload = {
  changedOrganizationUser: OrganizationUser;
};

export type CreateRetailerGroupPayload = {
  duplicateRetailerGroupLicensedLocations?: Maybe<Array<RetailerGroupLicensedLocation>>;
  hasDuplicates: Scalars['Boolean']['output'];
  retailerGroup?: Maybe<RetailerGroup>;
};

export type CreateRoleInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type CreateRolePayload = {
  changedRole: Role;
};

export type CreateSalesOrderInput = {
  action: OrderActionEnum;
  creatorId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
  licensedLocationId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDropoffWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  referrer: Scalars['String']['input'];
  salesOrgId: Scalars['ID']['input'];
  site: UpsertSiteInput;
  siteLicenseNum: Scalars['String']['input'];
  status?: InputMaybe<OrderStatusEnum>;
  subOrders: Array<SubOrders>;
  timeWindow?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type CreateSalesOrgRelationshipInput = {
  organizationId: Scalars['ID']['input'];
  salesOrgIds: Array<Scalars['ID']['input']>;
};

export type CreateSiteInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  licenses?: InputMaybe<Array<InputMaybe<CreateLicenseInput>>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  pocEmail?: InputMaybe<Scalars['String']['input']>;
  pocName?: InputMaybe<Scalars['String']['input']>;
  pocPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  siteCategory: SiteCategoryEnum;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSitePayload = {
  changedSite: Site;
};

export type CreateSkuDetailsInput = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  cannabinoidDosageA?: InputMaybe<Scalars['String']['input']>;
  cannabinoidDosageB?: InputMaybe<Scalars['String']['input']>;
  cannabinoidTypeA?: InputMaybe<Scalars['String']['input']>;
  cannabinoidTypeB?: InputMaybe<Scalars['String']['input']>;
  containerType?: InputMaybe<Scalars['String']['input']>;
  eachUnitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isColdStorage?: InputMaybe<Scalars['Boolean']['input']>;
  productLine?: InputMaybe<Scalars['String']['input']>;
  thcPotencyMeasurementType?: InputMaybe<Scalars['String']['input']>;
  thcPotencyPerUnit?: InputMaybe<Scalars['String']['input']>;
  unitsPerEach?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSkuDetailsPayload = {
  changedSkuDetails: SkuDetailsPayload;
};

export type CreateSkuInput = {
  code: Scalars['String']['input'];
  customTagIds: Array<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  inventoryCategory: InventoryCategoryEnum;
  inventoryCategoryTags?: InputMaybe<Array<InventoryCategoryTagEnum>>;
  inventoryClass: InventoryClassEnum;
  inventoryType: InventoryTypeEnum;
  inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isColdStorage?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySampleAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  janeProductId?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  marketplaceName?: InputMaybe<Scalars['String']['input']>;
  maxMarketplaceInventory?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  netVolume?: InputMaybe<Scalars['Float']['input']>;
  netVolumeUnitOfMeasure?: InputMaybe<VolumeUnitOfMeasureEnum>;
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  netWeightUnitOfMeasure?: InputMaybe<WeightUnitOfMeasureEnum>;
  nonSampleSkuId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  parentSkuId?: InputMaybe<Scalars['ID']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  productImageS3Link?: InputMaybe<Scalars['String']['input']>;
  productImageS3LinkCopy?: InputMaybe<Scalars['String']['input']>;
  quantityPerUnitOfMeasure: Scalars['Int']['input'];
  secondaryImageS3Links?: InputMaybe<Array<Scalars['String']['input']>>;
  secondaryImageS3LinksCopy?: InputMaybe<Array<Scalars['String']['input']>>;
  strainId?: InputMaybe<Scalars['ID']['input']>;
  strainType: StrainTypeEnum;
  tags: Array<InventoryTagEnum>;
  unit: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnitOfMeasure?: InputMaybe<WeightUnitOfMeasureEnum>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateSkuPayload = {
  changedSku: Sku;
};

export type CreateStrainReturn = {
  strain?: Maybe<Strain>;
};

export type CreateUserFromOnboardingInviteInput = {
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
  user?: InputMaybe<CreateUserInput>;
};

export type CreateUserInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserLicensedLocationRelationship = {
  description?: InputMaybe<Scalars['String']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<UserLicensedLocationStatusesEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateUserPayload = {
  changedUser: User;
  token: Scalars['String']['output'];
};

export type CreateVehicleInput = {
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVehiclePayload = {
  changedVehicle: Vehicle;
};

export type CreditHolds = {
  canNotBeOverriden: Array<RetailersOnCreditHoldThatCanNotBeOverriden>;
  retailersOnCreditHold: Array<RestrictionInformationRetailer>;
};

export type CreditMemo = {
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  creditMemoTypeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById: Scalars['ID']['output'];
};

export type CreditMemoPayload = {
  creditMemoAmount?: InputMaybe<Scalars['Float']['input']>;
  creditMemoId?: InputMaybe<Scalars['ID']['input']>;
  creditMemoNote?: InputMaybe<Scalars['String']['input']>;
  creditMemoTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreditMemoType = {
  id: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

/** Values for the CreditRatingTrustLevels enum */
export enum CreditRatingTrustLevels {
  Excellent = 'EXCELLENT',
  Fair = 'FAIR',
  Good = 'GOOD',
  NotApplicable = 'NOT_APPLICABLE',
  Poor = 'POOR',
  Weak = 'WEAK',
}

export type CurrentTotalFactorBalances = {
  availableCredit: Scalars['Float']['output'];
  totalAdvanceAmount: Scalars['Float']['output'];
  totalReserveAmount: Scalars['Float']['output'];
};

export type CustomTag = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
  urlSlug: Scalars['String']['output'];
};

/** Values for the CustomTagTypeEnum enum */
export enum CustomTagTypeEnum {
  Batch = 'BATCH',
  Sku = 'SKU',
}

export type DashboardAccounts = {
  active: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DashboardData = {
  totalDelivered: Scalars['Int']['output'];
  totalExciseTaxCollected: Scalars['Float']['output'];
  totalGMVCollected: Scalars['Float']['output'];
  totalInTransit: Scalars['Int']['output'];
  totalScheduled: Scalars['Int']['output'];
  totalUnscheduled: Scalars['Int']['output'];
};

export type DashboardDeliveries = {
  bySellers: Scalars['Int']['output'];
  cod: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  lastSellerAmount?: Maybe<Scalars['Float']['output']>;
  lastSellerName?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['Int']['output'];
};

export type DashboardMaxPaymentStatus = {
  GMV?: Maybe<Scalars['Float']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
};

export type DashboardPayload = {
  accounts: DashboardAccounts;
  deliveries: DashboardDeliveries;
  maxPaymentStatus: DashboardMaxPaymentStatus;
  sales: DashboardSales;
};

export type DashboardSales = {
  cashOnHand: Scalars['Float']['output'];
  thisMonth: Scalars['Float']['output'];
  thisYear: Scalars['Float']['output'];
};

export type DataTableData = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DateRule = {
  createdAt: Scalars['DateTime']['output'];
  dayOfYear: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  maxDeliveryShipments?: Maybe<Scalars['Int']['output']>;
  maxNumIncomingUnits?: Maybe<Scalars['Int']['output']>;
  maxPackingShipments?: Maybe<Scalars['Int']['output']>;
  monthDay: Scalars['String']['output'];
  superOrderThreshold: Scalars['Float']['output'];
  uniqueRetailersCap?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['ID']['output'];
};

export type DateRuleRow = {
  dateRuleId: Scalars['ID']['output'];
  dayOfYear: Scalars['Int']['output'];
  formattedDate: Scalars['String']['output'];
  maxDeliveryShipments?: Maybe<Scalars['Int']['output']>;
  maxNumIncomingUnits?: Maybe<Scalars['Int']['output']>;
  maxPackingShipments?: Maybe<Scalars['Int']['output']>;
  monthDay: Scalars['String']['output'];
  numDeliveryShipments: Scalars['Int']['output'];
  numIncomingUnits: Scalars['Int']['output'];
  numPackingShipments: Scalars['Int']['output'];
  superOrderThreshold: Scalars['Float']['output'];
  uniqueRetailersCap: Scalars['Boolean']['output'];
};

export type DateRulesPayload = {
  pageInfo: PageInfo;
  results: Array<DateRuleRow>;
};

export type DebugLineItemInput = {
  quantity: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

/** Values for the DefaultSpecialPricingTypeEnum enum */
export enum DefaultSpecialPricingTypeEnum {
  External = 'EXTERNAL',
  Outtake = 'OUTTAKE',
  Sample = 'SAMPLE',
  SampleOnSameDayLocationAsNormalOrder = 'SAMPLE_ON_SAME_DAY_LOCATION_AS_NORMAL_ORDER',
}

export type DeleteAccountTaskInput = {
  id: Scalars['ID']['input'];
};

export type DeleteBankAccountInfoInput = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteBrandRetailerCreditHoldResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBrandRetailerCreditLimitResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteBrandRetailerOrderingRestrictionResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteDraftInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDraftPayload = {
  deletedDraft: Draft;
};

export type DeleteDriverInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDriverPayload = {
  changedDriver: Driver;
};

export type DeleteEwbTransactionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteEwbTransactionPayload = {
  ACHACRetailerUnconfirmed?: Maybe<Scalars['Float']['output']>;
  ACHAmountCollectedRetailer?: Maybe<Scalars['Float']['output']>;
  ACHAmountPaidBrand?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
};

export type DeleteEnterpriseNabisRetailerCreditHoldResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteEnterpriseNabisRetailerOrderingRestrictionResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteIdPayload = {
  id: Scalars['ID']['output'];
};

export type DeleteLicensePayload = {
  changedLicense: License;
};

export type DeleteLicensedLocationContactInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLicensedLocationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLineItemInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLineItemPayload = {
  changedLineItem: LineItem;
};

export type DeleteNabisRetailerCreditHoldResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNabisRetailerOrderingRestrictionResponse = {
  reason?: Maybe<AllSettledErrorReason>;
  status: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOnboardingInviteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOnboardingInvitePayload = {
  changedInvite?: Maybe<OnboardingInvite>;
};

export type DeleteOrderFeeInput = {
  feeName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};

export type DeleteOrderFeePayload = {
  deletedOrderFee?: Maybe<DeleteIdPayload>;
};

export type DeleteOrderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrderPayload = {
  changedOrder: Order;
};

export type DeleteOrganizationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationInviteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationInvitePayload = {
  changedOrganizationInvite: OrganizationInvite;
};

export type DeleteOrganizationPayload = {
  changedOrganization: Organization;
};

export type DeleteOrganizationUserInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteOrganizationUserPayload = {
  changedOrganizationUser: OrganizationUser;
};

export type DeleteQuickbooksInvoiceInput = {
  invoiceTypesToDelete: Array<InvoiceGenerationEnum>;
  orderId: Scalars['ID']['input'];
};

export type DeleteQuickbooksInvoicePayload = {
  orderId: Scalars['ID']['output'];
};

export type DeleteRoleInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRolePayload = {
  changedRole: Role;
};

export type DeleteSalesOrgRelationshipInput = {
  organizationId: Scalars['ID']['input'];
  salesOrgId: Scalars['ID']['input'];
};

export type DeleteSiteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSitePayload = {
  changedSite: Site;
};

export type DeleteSkuInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSkuPayload = {
  changedSku: Sku;
};

export type DeleteUserInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserLicensedLocationRelationshipInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserPayload = {
  changedUser: User;
};

export type DeleteVehicleInput = {
  id: Scalars['ID']['input'];
};

export type DeleteVehiclePayload = {
  changedVehicle: Vehicle;
};

export type DiscountTierInput = {
  discountType: RetailerDiscountType;
  flatDiscount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  minBrandOrderAmount: Scalars['Float']['input'];
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type DownloadProformaInput = {
  action: OrderActionEnum;
  additionalDiscount?: InputMaybe<Scalars['Float']['input']>;
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  brandManifestNotes?: InputMaybe<Scalars['String']['input']>;
  creatorEmail?: InputMaybe<Scalars['String']['input']>;
  creatorName?: InputMaybe<Scalars['String']['input']>;
  creatorPhone?: InputMaybe<Scalars['String']['input']>;
  creditMemo: Scalars['Float']['input'];
  creditMemoPayload?: InputMaybe<Array<CreditMemoPayload>>;
  date: Scalars['DateTime']['input'];
  daysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountedSubtotal?: InputMaybe<Scalars['Float']['input']>;
  exciseTax?: InputMaybe<Scalars['Float']['input']>;
  exciseTaxCollected?: InputMaybe<Scalars['Float']['input']>;
  gmv: Scalars['Float']['input'];
  gmvCollected?: InputMaybe<Scalars['Float']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  lineItems?: InputMaybe<Scalars['JSON']['input']>;
  mustPayPreviousBalance?: InputMaybe<Scalars['Boolean']['input']>;
  nabisManifestNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  netOffTotal?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orgLicenseNum?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['JSON']['input']>;
  organizationId: Scalars['ID']['input'];
  retailerManifestNotes?: InputMaybe<Scalars['String']['input']>;
  retailerNotes?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['JSON']['input']>;
  siteLicenseNum?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatusEnum>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  surcharge?: InputMaybe<Scalars['Float']['input']>;
  timeWindow?: InputMaybe<Scalars['String']['input']>;
  totalBalance?: InputMaybe<Scalars['Float']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type Draft = {
  body?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  organization: Organization;
  source: DraftSourceEnum;
  type: DraftTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
};

/** Values for the DraftSourceEnum enum */
export enum DraftSourceEnum {
  Brand = 'BRAND',
  Marketplace = 'MARKETPLACE',
  Sales = 'SALES',
}

/** Values for the DraftTypeEnum enum */
export enum DraftTypeEnum {
  Cart = 'CART',
  Order = 'ORDER',
}

export type Driver = {
  driversLicense: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  onfleetWorkerId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Values for the DriverAppOpenInvoicesSection enum */
export enum DriverAppOpenInvoicesSection {
  OpenInvoices = 'OPEN_INVOICES',
  OverdueInvoices = 'OVERDUE_INVOICES',
  RequiredOpenInvoices = 'REQUIRED_OPEN_INVOICES',
  TodaysDeliveries = 'TODAYS_DELIVERIES',
}

export type DriverAppSubmissionRecord = {
  BSAForm8300SubmissionId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfTransaction?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flaggedDiscrepancy?: Maybe<Scalars['String']['output']>;
  form8300ConfirmationStatus?: Maybe<Scalars['Boolean']['output']>;
  form8300Email?: Maybe<Scalars['String']['output']>;
  genericFiles?: Maybe<Array<GenericFile>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  licensedLocationConfirmationUserId?: Maybe<Scalars['ID']['output']>;
  licensedLocationId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<DriverAppSubmissionRecordOrder>;
  orderId?: Maybe<Scalars['ID']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<PaymentMethodDriverEnum>;
  paymentStatus?: Maybe<PaymentStatusDriverEnum>;
  retailerPaymentAmount?: Maybe<Scalars['Float']['output']>;
  type: PaymentPickupConfirmationEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type DriverAppSubmissionRecordOrder = {
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  orderFiles?: Maybe<Array<Maybe<OrderFile>>>;
  orderRestrictionRequired?: Maybe<Array<Maybe<OrderRestriction>>>;
  paymentStatus: OrderPaymentStatusEnum;
};

export type DriverMultiPaymentPickupConfirmationElement = {
  number: Scalars['Int']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentMethod: PaymentMethodEnum;
  paymentStatus: DriverReportedPaymentStatus;
};

export type DriverOrder = {
  action: OrderActionEnum;
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  codRestriction?: Maybe<Scalars['Boolean']['output']>;
  collected?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  driverConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  driverReportedStatus?: Maybe<DriverReportedStatus>;
  estimatedArrivalTimeAfter?: Maybe<Scalars['DateTime']['output']>;
  estimatedArrivalTimeBefore?: Maybe<Scalars['DateTime']['output']>;
  exciseTax: Scalars['Float']['output'];
  externalPaymentCollected?: Maybe<Scalars['Float']['output']>;
  externalPaymentDesired?: Maybe<Scalars['Float']['output']>;
  externalPaymentMin?: Maybe<Scalars['Float']['output']>;
  externalPaymentNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  irn?: Maybe<Scalars['String']['output']>;
  isDropAndGo?: Maybe<Scalars['Boolean']['output']>;
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isRetailerRestricted: Scalars['Boolean']['output'];
  isRetailerRestrictedForBrand: Scalars['Boolean']['output'];
  licensedLocationId: Scalars['ID']['output'];
  licensedLocationName: Scalars['String']['output'];
  metrcManifestS3FileLink?: Maybe<Scalars['String']['output']>;
  mustPayExciseTaxRestriction?: Maybe<Scalars['Boolean']['output']>;
  mustPayExternalBalance?: Maybe<Scalars['Boolean']['output']>;
  mustPayPreviousBalance?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  onfleetTask?: Maybe<OnfleetTask>;
  onfleetTaskId?: Maybe<Scalars['String']['output']>;
  onfleetTaskUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  orderContact?: Maybe<OrderContact>;
  orderFiles: Array<OrderFile>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentPickupConfirmations: Array<PaymentPickupConfirmation>;
  paymentStatus: OrderPaymentStatusEnum;
  site?: Maybe<Site>;
  siteId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  totalBalance?: Maybe<Scalars['Float']['output']>;
};

export type DriverOrderConfirmation = {
  deliveryStatus: DriverReportedStatus;
  form8300Email?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type DriverOutstandingOrder = {
  action: OrderActionEnum;
  amountDue: Scalars['Float']['output'];
  amountNotYetDue: Scalars['Float']['output'];
  amountOutstanding: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  amountRequiredExciseTax: Scalars['Float']['output'];
  amountRequiredForDelivery: Scalars['Float']['output'];
  amountRequiredFromThisOrderForThisOrdersDelivery: Scalars['Float']['output'];
  brand: Scalars['String']['output'];
  cashCollected: Scalars['Float']['output'];
  daysOverdue: Scalars['Int']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  deliveryDate: Scalars['String']['output'];
  disputeStatus: OrderDisputeStatus;
  dueDate: Scalars['String']['output'];
  exciseTax: Scalars['Float']['output'];
  exciseTaxCollected?: Maybe<Scalars['Float']['output']>;
  hasValidCODRestriction: Scalars['Boolean']['output'];
  hasValidTaxRestriction: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  irn?: Maybe<Scalars['String']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isRetailerRestricted: Scalars['Boolean']['output'];
  isRetailerRestrictedForBrand: Scalars['Boolean']['output'];
  lastDispute?: Maybe<OrderIssue>;
  lastNonpayment?: Maybe<OrderIssue>;
  licensedLocationId: Scalars['ID']['output'];
  logoS3Link?: Maybe<Scalars['String']['output']>;
  manifestUrl?: Maybe<Scalars['String']['output']>;
  orderFiles: Array<MinimalOrderFile>;
  orderNumber: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  paymentPickupConfirmations: Array<PaymentPickupConfirmationMinimal>;
  paymentStatus: OrderPaymentStatusEnum;
  section: DriverAppOpenInvoicesSection;
  totalBalance: Scalars['Float']['output'];
};

export type DriverPaymentPickupConfirmation = {
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  paymentAmount: Scalars['Float']['input'];
  paymentMethod: PaymentMethodEnum;
  paymentStatus: DriverReportedPaymentStatus;
};

/** Values for the DriverReportedPaymentStatus enum */
export enum DriverReportedPaymentStatus {
  PaidInFull = 'PAID_IN_FULL',
  PaidInPartial = 'PAID_IN_PARTIAL',
}

/** Values for the DriverReportedStatus enum */
export enum DriverReportedStatus {
  Delivered = 'DELIVERED',
  DeliveredWithEdits = 'DELIVERED_WITH_EDITS',
  Rejected = 'REJECTED',
  RequestForReschedule = 'REQUEST_FOR_RESCHEDULE',
}

export type DriverRetailersInvoices = {
  data: GetDriverRetailerInvoicesPayload;
  licensedLocationId: Scalars['String']['output'];
};

export type EtaPayload = {
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EwbMinimalChildTransaction = {
  id: Scalars['ID']['output'];
  order?: Maybe<EwbMinimalOrder>;
  orderId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  status: EwbTransactionStatusEnum;
  transactionAmount: Scalars['Float']['output'];
  transactionCount: Scalars['Int']['output'];
  willFullyRemit: Scalars['Boolean']['output'];
};

export type EwbMinimalOrder = {
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
};

export type EwbTransaction = {
  bankAccountInfoId: Scalars['ID']['output'];
  bankAccountSuffix?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  scheduledDateOfTransaction: Scalars['DateTime']['output'];
  status: EwbTransactionStatusEnum;
  submitterEmail: Scalars['String']['output'];
  submitterId: Scalars['ID']['output'];
  submitterName?: Maybe<Scalars['String']['output']>;
  transactionAmount: Scalars['Float']['output'];
  transactionCount: Scalars['Int']['output'];
  transactionIdReference?: Maybe<Scalars['String']['output']>;
  transactionNotes: Scalars['String']['output'];
  transactionType: EwbTransactionTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  willFullyRemit: Scalars['Boolean']['output'];
};

export type EwbTransactionForOrg = {
  bankAccountInfoId: Scalars['ID']['output'];
  bankAccountSuffix?: Maybe<Scalars['String']['output']>;
  childrenTransactions?: Maybe<Array<EwbMinimalChildTransaction>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  scheduledDateOfTransaction: Scalars['DateTime']['output'];
  status: EwbTransactionStatusEnum;
  submitterEmail: Scalars['String']['output'];
  submitterId: Scalars['ID']['output'];
  submitterName?: Maybe<Scalars['String']['output']>;
  transactionAmount: Scalars['Float']['output'];
  transactionCount: Scalars['Int']['output'];
  transactionIdReference?: Maybe<Scalars['String']['output']>;
  transactionNotes: Scalars['String']['output'];
  transactionType: EwbTransactionTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  willFullyRemit: Scalars['Boolean']['output'];
};

export type EwbTransactionOrderData = {
  orderId: Scalars['ID']['input'];
  transactionAmount?: InputMaybe<Scalars['Float']['input']>;
  transactionNotes?: InputMaybe<Scalars['String']['input']>;
  willFullyRemit: Scalars['Boolean']['input'];
};

/** Values for the EWBTransactionStatusEnum enum */
export enum EwbTransactionStatusEnum {
  Accepted = 'ACCEPTED',
  Attempted = 'ATTEMPTED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  FailedValidation = 'FAILED_VALIDATION',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
}

/** Values for the EWBTransactionTypeEnum enum */
export enum EwbTransactionTypeEnum {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  ValidateBankMicrodeposit = 'VALIDATE_BANK_MICRODEPOSIT',
  Wire = 'WIRE',
}

export type EarmarkedOrganization = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EditZipcodesInput = {
  deliveringWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  deliveryDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['ID']['input'];
  periodMultiplier?: InputMaybe<Scalars['Int']['input']>;
  pickupDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  receivingWarehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type ElasticBatch = {
  cbdPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  expirationDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  thcPercentage: Scalars['Float']['output'];
};

export type ElasticMarketplaceBatch = {
  aromas: Array<Scalars['String']['output']>;
  calculatedAvailableQuantity?: Maybe<Scalars['Int']['output']>;
  cbdPercentage?: Maybe<Scalars['Float']['output']>;
  cbdWeight?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPriorityBatch?: Maybe<Scalars['Boolean']['output']>;
  manufacturingDate?: Maybe<Scalars['String']['output']>;
  otherCannabinoidPercentage?: Maybe<Scalars['Float']['output']>;
  otherCannabinoidWeight?: Maybe<Scalars['Float']['output']>;
  skuBatchId?: Maybe<Scalars['ID']['output']>;
  thcAPercentage?: Maybe<Scalars['Float']['output']>;
  thcAWeight?: Maybe<Scalars['Float']['output']>;
  thcPercentage?: Maybe<Scalars['Float']['output']>;
  thcWeight?: Maybe<Scalars['Float']['output']>;
};

export type ElasticMarketplaceSku = {
  allowMarketplacePurchase?: Maybe<Scalars['Boolean']['output']>;
  averageCbdPercentage?: Maybe<Scalars['Float']['output']>;
  averageCbdWeight?: Maybe<Scalars['Float']['output']>;
  averageOtherCannabinoidPercentage?: Maybe<Scalars['Float']['output']>;
  averageOtherCannabinoidWeight?: Maybe<Scalars['Float']['output']>;
  averageThcAPercentage?: Maybe<Scalars['Float']['output']>;
  averageThcAWeight?: Maybe<Scalars['Float']['output']>;
  averageThcPercentage?: Maybe<Scalars['Float']['output']>;
  averageThcWeight?: Maybe<Scalars['Float']['output']>;
  batches: Array<ElasticMarketplaceBatch>;
  calculatedAvailableQuantity?: Maybe<Scalars['Int']['output']>;
  customTags: Array<Maybe<Scalars['String']['output']>>;
  height?: Maybe<Scalars['Float']['output']>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  inventoryCategory?: Maybe<Scalars['String']['output']>;
  inventoryCategoryTags: Array<Maybe<Scalars['String']['output']>>;
  inventoryClass?: Maybe<Scalars['String']['output']>;
  inventoryType?: Maybe<Scalars['String']['output']>;
  inventoryUnitOfMeasure?: Maybe<Scalars['String']['output']>;
  isSampleAllowed?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplaceName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  otherCannabinoidPercentage?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  quantityPerUnitOfMeasure?: Maybe<Scalars['Int']['output']>;
  skuBatchId: Scalars['ID']['output'];
  skuCode?: Maybe<Scalars['String']['output']>;
  skuId: Scalars['ID']['output'];
  skuName?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnitOfMeasure?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ElasticMarketplaceSkuInfo = {
  pageInfo: PageInfo;
  results: Array<MarketplaceSku>;
};

export type ElasticMarketplaceSkuResult = {
  result?: Maybe<ElasticMarketplaceSku>;
};

export type ElasticSku = {
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inventoryCategory: InventoryCategoryEnum;
  inventoryClass: InventoryClassEnum;
  inventoryType: InventoryTypeEnum;
  isSample: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  pricePerUnit: Scalars['Float']['output'];
  unit: Scalars['String']['output'];
};

export type ElasticSkuBatch = {
  batch: ElasticBatch;
  calculatedAvailableQuantity: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  quantityPerUnitOfMeasure: Scalars['Int']['output'];
  singleHubWarehouseQuantity: Scalars['Int']['output'];
  sku: ElasticSku;
};

export type ElasticSkuBatchInfo = {
  pageInfo: PageInfo;
  results: Array<ElasticSkuBatch>;
};

export type EmailTemplate = {
  bcc: Array<Maybe<Scalars['String']['output']>>;
  body: Scalars['String']['output'];
  cc: Array<Maybe<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator: User;
  creatorId: Scalars['ID']['output'];
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  to: Array<Maybe<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnrichedBrandRetailerCreditLimit = {
  brandOrganizationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  isCreditLimitEpicFeatureFlagEnabled: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  retailerOrganizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById: Scalars['ID']['output'];
};

export type EnterpriseNabisRetailerCreditHold = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById: Scalars['ID']['output'];
};

export type EnterpriseNabisRetailerCreditHoldInput = {
  licensedLocationId: Scalars['ID']['input'];
};

export type EnterpriseNabisRetailerOrderingRestriction = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  maxTerms?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type EnterpriseNabisRetailerOrderingRestrictionInput = {
  licensedLocationId: Scalars['ID']['input'];
};

export type FactorChangelog = {
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type FactorFeeTotals = {
  avgFactorFee: Scalars['Float']['output'];
  totalFactorFees: Scalars['Float']['output'];
};

export type FactorInvoice = {
  accountingNotes?: Maybe<Scalars['String']['output']>;
  adminFee?: Maybe<Scalars['Float']['output']>;
  advanceAmount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  creditMemo?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  discount: Scalars['Float']['output'];
  distroFees?: Maybe<Scalars['Float']['output']>;
  dueToBrand?: Maybe<Scalars['Float']['output']>;
  exciseTax?: Maybe<Scalars['Float']['output']>;
  exciseTaxCollected?: Maybe<Scalars['Float']['output']>;
  extraFees?: Maybe<Scalars['Float']['output']>;
  factorRate?: Maybe<Scalars['Float']['output']>;
  factorStartDate?: Maybe<Scalars['DateTime']['output']>;
  factorStatus: OrderFactorStatusEnum;
  gmv: Scalars['Float']['output'];
  gmvCollected: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  irn?: Maybe<Scalars['String']['output']>;
  isAdvancePaid?: Maybe<Scalars['Boolean']['output']>;
  isReservePaid?: Maybe<Scalars['Boolean']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  mustPayPreviousBalance?: Maybe<Scalars['Boolean']['output']>;
  nabisDiscount?: Maybe<Scalars['Float']['output']>;
  nabisDistroFees?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  netGmv?: Maybe<Scalars['Float']['output']>;
  newFactorRate?: Maybe<Scalars['Float']['output']>;
  number: Scalars['Int']['output'];
  organization: Organization;
  organizationFactorRate?: Maybe<Scalars['Float']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  paymentStatus: OrderPaymentStatusEnum;
  pricingFee?: Maybe<Scalars['Float']['output']>;
  pricingPercentage?: Maybe<Scalars['Float']['output']>;
  remittedAt?: Maybe<Scalars['DateTime']['output']>;
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  site: Site;
  status: OrderStatusEnum;
  surcharge: Scalars['Float']['output'];
  totalFactorFee?: Maybe<Scalars['Float']['output']>;
  totalFees?: Maybe<Scalars['Float']['output']>;
};

export type FactoringTotalSums = {
  approvedSum: Scalars['Float']['output'];
  rejectedT3mSum: Scalars['Float']['output'];
  requestedSum: Scalars['Float']['output'];
};

export type FeatureFlagStatus = {
  defaultValue: Scalars['String']['output'];
  isDefaulted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FeaturedBrand = {
  bannerImageS3Link?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate: Scalars['DateTime']['output'];
  feesCharged?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplaceHeaderItemUiType: MarketplaceHeaderItemUiType;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  sku1?: Maybe<Sku>;
  sku1Id?: Maybe<Scalars['ID']['output']>;
  sku2?: Maybe<Sku>;
  sku2Id?: Maybe<Scalars['ID']['output']>;
  squareBannerImageS3Link?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wideBannerImageS3Link?: Maybe<Scalars['String']['output']>;
};

export type Fee = {
  basePrice: Scalars['Float']['output'];
  basePriceOrganizationOverride?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  feeType: FeeTypeEnum;
  groupTag: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type FeeBasePriceOrganizationOverrideArgs = {
  brandOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type FeeChange = {
  basePrice: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['ID']['output'];
  feeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['DateTime']['output'];
  tag: FeeChangeTag;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Values for the FeeChangeTag enum */
export enum FeeChangeTag {
  ArchiveFee = 'ARCHIVE_FEE',
  CreateFee = 'CREATE_FEE',
  CreateScheduledChange = 'CREATE_SCHEDULED_CHANGE',
  DeleteScheduledChange = 'DELETE_SCHEDULED_CHANGE',
  UnarchiveFee = 'UNARCHIVE_FEE',
  UpdateScheduledChange = 'UPDATE_SCHEDULED_CHANGE',
}

export type FeeServiceOrganization = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  hasAnalyticsDashboard: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFeaturedBrand?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: OrganizationType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Values for the FeeTypeEnum enum */
export enum FeeTypeEnum {
  Distro = 'DISTRO',
  Extra = 'EXTRA',
}

export type FetchAsyncTasksInput = {
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type FetchJournalsForDatesInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type FetchLicensedLocationForm8300Input = {
  licensedLocationId: Scalars['ID']['input'];
};

export type FetchMultiBrandRetailerCreditLimitsBrandUserInput = {
  organizationId: Scalars['ID']['input'];
  payload: Array<FetchMultiBrandRetailerCreditLimitsInputPayload>;
};

export type FetchMultiBrandRetailerCreditLimitsInputPayload = {
  brandOrganizationId: Scalars['ID']['input'];
  licensedLocationId: Scalars['ID']['input'];
};

export type FetchMultiBrandRetailerCreditLimitsRetailerUserInput = {
  licensedLocationId: Scalars['ID']['input'];
  payload: Array<FetchMultiBrandRetailerCreditLimitsInputPayload>;
};

export type FetchMultiBrandRetailerCreditLimitsSalesUserInput = {
  payload: Array<FetchMultiBrandRetailerCreditLimitsInputPayload>;
  salesOrgId: Scalars['ID']['input'];
};

export type FindStrainsByNameReturn = {
  strains?: Maybe<Array<Maybe<Strain>>>;
};

export type Form8300LicensedLocationPayload = {
  isForm8300DisabledOnDriverApp: Scalars['Boolean']['output'];
  licensedLocationForm8300Data: LicensedLocationForm8300Data;
};

export type GenerateManifestPayload = {
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  packingListS3FileLink?: Maybe<Scalars['String']['output']>;
};

export type GenerateOrderQrCodePayload = {
  qrcodeS3FileLink?: Maybe<Scalars['String']['output']>;
};

export type GenerateQuickbooksInvoiceInput = {
  invoiceTypesToGenerate: Array<InvoiceGenerationEnum>;
  nabisDiscount: Scalars['Float']['input'];
  orderId: Scalars['ID']['input'];
  pricingFee: Scalars['Float']['input'];
  pricingPercentage: Scalars['Float']['input'];
};

export type GenerateQuickbooksInvoicePayload = {
  orderId: Scalars['ID']['output'];
};

export type GenericFile = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  filePurpose?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  licensedLocationConfirmationUserId?: Maybe<Scalars['ID']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentPickupConfirmationId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type GenericOrderFileContainerInput = {
  file: Scalars['Upload']['input'];
  type: GenericOrderFileUploadType;
};

/** Values for the GenericOrderFileUploadType enum */
export enum GenericOrderFileUploadType {
  MetrcManifestFile = 'METRC_MANIFEST_FILE',
}

export type GetAccountingApiBrandTransactionsDetailedPageInput = {
  organizationId: Scalars['ID']['input'];
  transactionId: Scalars['ID']['input'];
};

export type GetAccountingApiBrandTransactionsDetailedPagePayload = {
  appliedToBrandInQuestion: Array<AppliedToBrandTransactions>;
  appliedToOtherBrandsAmount: Scalars['Float']['output'];
  method?: Maybe<TransactionMethod>;
  name: Scalars['String']['output'];
  paidAt: Scalars['DateTime']['output'];
  retailerOrgName: Scalars['String']['output'];
  transactionAmount: Scalars['Float']['output'];
  transactionNumber: Scalars['Int']['output'];
  unappliedAmount: Scalars['Float']['output'];
};

export type GetAccountingApiBrandTransactionsPageCsvInput = {
  email: Scalars['String']['input'];
  endPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  retailerOrgId?: InputMaybe<Scalars['ID']['input']>;
  startPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAccountingApiBrandTransactionsPageInput = {
  endPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
  retailerOrgId?: InputMaybe<Scalars['ID']['input']>;
  startPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAccountingApiBrandTransactionsPagePayload = {
  pageInfo: AccountingPageInfo;
  transactions: Array<GetAccountingApiBrandTransactionsPagePayloadSingle>;
};

export type GetAccountingApiBrandTransactionsPagePayloadSingle = {
  appliedAmount: Scalars['Float']['output'];
  appliedToBrandInQuestion: Array<AppliedToBrandTransactions>;
  method?: Maybe<TransactionMethod>;
  name: Scalars['String']['output'];
  paidAt: Scalars['DateTime']['output'];
  retailerOrgName: Scalars['String']['output'];
  transactionAmount: Scalars['Float']['output'];
  transactionId: Scalars['ID']['output'];
  transactionNumber: Scalars['Int']['output'];
  unappliedAmount: Scalars['Float']['output'];
};

export type GetAccountingApiDetailedInvoiceAdjustmentSingle = {
  adjustedAt: Scalars['DateTime']['output'];
  adjustmentNumber: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  pendingAdjustment: Scalars['Float']['output'];
  type: AdjustmentType;
};

export type GetAccountingApiDetailedInvoiceAdjustments = {
  adjustment: GetAccountingApiDetailedInvoiceAdjustmentSingle;
  childrenAdjustments: Array<GetAccountingApiDetailedInvoiceAdjustmentSingle>;
};

export type GetAccountingApiDetailedInvoiceInput = {
  invoiceNumber: Scalars['Int']['input'];
};

export type GetAccountingApiDetailedInvoicePayload = {
  adjustments?: Maybe<Array<GetAccountingApiDetailedInvoiceAdjustments>>;
  adminNotes: Scalars['String']['output'];
  autoGenerated: Scalars['Boolean']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  collectedTransactions?: Maybe<Array<GetAccountingApiDetailedInvoiceTransactions>>;
  createdAt: Scalars['String']['output'];
  creditMemo?: Maybe<Scalars['Float']['output']>;
  deduction?: Maybe<Scalars['Float']['output']>;
  deductions?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  dueDate: Scalars['String']['output'];
  expectedDeduction?: Maybe<Scalars['Float']['output']>;
  invoiceGroupType: InvoiceTypeGroupType;
  invoiceNumber: Scalars['Int']['output'];
  invoiceTypeName: Scalars['String']['output'];
  nabisCreditMemo?: Maybe<Scalars['Float']['output']>;
  notes: Scalars['String']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  paidByName?: Maybe<Scalars['String']['output']>;
  paidToName?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Scalars['Float']['output']>;
  publicNotes: Scalars['String']['output'];
  remittedTransactions?: Maybe<Array<GetAccountingApiDetailedInvoiceTransactions>>;
  retailerName?: Maybe<Scalars['String']['output']>;
  selfCollected?: Maybe<Scalars['Float']['output']>;
  totalBalance: Scalars['Float']['output'];
  totalCollected: Scalars['Float']['output'];
  totalRemitted: Scalars['Float']['output'];
  writeOffExternal?: Maybe<Scalars['Float']['output']>;
  writeOffNabis?: Maybe<Scalars['Float']['output']>;
};

export type GetAccountingApiDetailedInvoiceTransactions = {
  amount: Scalars['Float']['output'];
  appliedAt?: Maybe<Scalars['String']['output']>;
  invoiceImpact: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  originalTransactionNumber?: Maybe<Scalars['Int']['output']>;
  paidByOrgName: Scalars['String']['output'];
  remittedAt?: Maybe<Scalars['String']['output']>;
  transactionNumber: Scalars['Int']['output'];
  transactionType: Scalars['String']['output'];
};

export type GetAccountingApiDetailedInvoicesByNumberInput = {
  number: Scalars['Int']['input'];
};

export type GetAccountingApiDetailedInvoicesByNumberInvoice = {
  brandName?: Maybe<Scalars['String']['output']>;
  invoiceCollected: Scalars['Float']['output'];
  invoiceCollectedRemaining: Scalars['Float']['output'];
  invoiceGroupType: InvoiceTypeGroupType;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  invoiceTotal: Scalars['Float']['output'];
  invoiceTypeName: Scalars['String']['output'];
  orderNumber?: Maybe<Scalars['Int']['output']>;
  paidByName?: Maybe<Scalars['String']['output']>;
  paidToName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
};

export type GetAccountingApiDetailedInvoicesByNumberPayload = {
  matchingInvoiceNumber?: Maybe<GetAccountingApiDetailedInvoicesByNumberInvoice>;
  matchingOrderNumber: Array<GetAccountingApiDetailedInvoicesByNumberInvoice>;
};

export type GetAccountingApiDetailedPaymentChildTransaction = {
  amount: Scalars['Float']['output'];
  appliedAt?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Float']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  invoiceCollected: Scalars['Float']['output'];
  invoiceCollectedRemaining: Scalars['Float']['output'];
  invoiceGroupType: InvoiceTypeGroupType;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  invoiceTotal: Scalars['Float']['output'];
  invoiceTypeName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderNumber?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidByName?: Maybe<Scalars['String']['output']>;
  paidToName?: Maybe<Scalars['String']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  transactionNumber: Scalars['Int']['output'];
};

export type GetAccountingApiDetailedPaymentInput = {
  transactionNumber: Scalars['Int']['input'];
};

export type GetAccountingApiDetailedPaymentPayload = {
  amount: Scalars['Float']['output'];
  autoGenerated: Scalars['Boolean']['output'];
  balance: Scalars['Float']['output'];
  childrenTransactions?: Maybe<Array<GetAccountingApiDetailedPaymentChildTransaction>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  earmarkedOrganizations: Array<EarmarkedOrganization>;
  fromAccountId?: Maybe<Scalars['ID']['output']>;
  fromAccountType?: Maybe<AccountType>;
  impactedInvoiceNumber?: Maybe<Scalars['Int']['output']>;
  isOrderAppliedTransaction?: Maybe<Scalars['Boolean']['output']>;
  isOriginalTransaction: Scalars['Boolean']['output'];
  location?: Maybe<TransactionLocation>;
  method?: Maybe<TransactionMethod>;
  name?: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
  originCompany?: Maybe<OriginCompany>;
  originalTransactionName?: Maybe<Scalars['String']['output']>;
  originalTransactionNumber?: Maybe<Scalars['Int']['output']>;
  originalTransactionPaidByName?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidByOrgName?: Maybe<Scalars['String']['output']>;
  toAccountId?: Maybe<Scalars['ID']['output']>;
  toAccountType?: Maybe<AccountType>;
  transactionName?: Maybe<Scalars['String']['output']>;
  transactionNumber: Scalars['Int']['output'];
  transactionType: TransactionType;
  unappliedReason?: Maybe<UnappliedReason>;
};

export type GetAccountingApiDownloadReportCsvInput = {
  id: Scalars['ID']['input'];
};

export type GetAccountingApiFetchAllAccountsPayload = {
  accounts?: Maybe<Array<GetAccountingApiFetchAllAccountsPayloadSingle>>;
};

export type GetAccountingApiFetchAllAccountsPayloadSingle = {
  id: Scalars['ID']['output'];
  type: AccountType;
};

export type GetAccountingApiFetchJournalsForDatesPayload = {
  journals?: Maybe<Array<GetAccountingApiFetchJournalsForDatesSingle>>;
};

export type GetAccountingApiFetchJournalsForDatesSingle = {
  changeTag: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  newCustomDate?: Maybe<Scalars['DateTime']['output']>;
  notes: Scalars['String']['output'];
  oldCustomDate?: Maybe<Scalars['DateTime']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  reportedCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GetAccountingApiFetchRemittanceReportByOrgInput = {
  atLeastAmount?: InputMaybe<Scalars['Float']['input']>;
  atLeastEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  atLeastStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  atMostAmount?: InputMaybe<Scalars['Float']['input']>;
  atMostEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  atMostStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  equalAmount?: InputMaybe<Scalars['Float']['input']>;
  equalEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  equalStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  orgId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
  status?: InputMaybe<RemittanceReportStatus>;
};

export type GetAccountingApiFetchRemittanceReportByOrgPayload = {
  pageInfo: AccountingPageInfo;
  remittanceReports?: Maybe<Array<GetAccountingApiFetchRemittanceReportByOrgPayloadSingle>>;
};

export type GetAccountingApiFetchRemittanceReportByOrgPayloadSingle = {
  amount: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  s3Link: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  status: RemittanceReportStatus;
};

export type GetAccountingApiGenerateInvoicePageCsvInput = {
  brandOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paidBy?: InputMaybe<Scalars['ID']['input']>;
  paidTo?: InputMaybe<Scalars['ID']['input']>;
  retailerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAccountingApiGenerateInvoicePageCsvPayload = {
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type GetAccountingApiGenerateTransactionsPageCsvInput = {
  afterAppliedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  afterCreatedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  afterPaidAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  afterRemittedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  appliedOrderNumber?: InputMaybe<Scalars['Int']['input']>;
  atLeastAmount?: InputMaybe<Scalars['Float']['input']>;
  atLeastUnapplied?: InputMaybe<Scalars['Float']['input']>;
  atMostAmount?: InputMaybe<Scalars['Float']['input']>;
  atMostUnapplied?: InputMaybe<Scalars['Float']['input']>;
  beforeAppliedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforeCreatedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforePaidAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforeRemittedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  equalAmount?: InputMaybe<Scalars['Float']['input']>;
  equalUnapplied?: InputMaybe<Scalars['Float']['input']>;
  fromAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicePaidBy?: InputMaybe<Scalars['ID']['input']>;
  invoicePaidTo?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<TransactionLocation>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalTransactionNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paidBy?: InputMaybe<Scalars['ID']['input']>;
  paidByForGroup?: InputMaybe<Scalars['ID']['input']>;
  sameAppliedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  sameCreatedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  samePaidAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  sameRemittedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  unappliedReason?: InputMaybe<UnappliedReason>;
};

export type GetAccountingApiGenerateTransactionsPageCsvPayload = {
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type GetAccountingApiInvoiceTypeAllPayload = {
  defaultAmount?: Maybe<Scalars['Float']['output']>;
  defaultGroupType: Scalars['String']['output'];
  defaultPaidBy?: Maybe<Scalars['String']['output']>;
  defaultPaidTo?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GetAccountingApiInvoicesInput = {
  brandOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  invoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo: PageInfoInput;
  paidBy?: InputMaybe<Scalars['ID']['input']>;
  paidTo?: InputMaybe<Scalars['ID']['input']>;
  retailerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAccountingApiInvoicesPayload = {
  invoices?: Maybe<Array<GetAccountingApiInvoicesSingle>>;
  pageInfo: AccountingPageInfo;
};

export type GetAccountingApiInvoicesSingle = {
  autoGenerated: Scalars['Boolean']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creditMemo?: Maybe<Scalars['Float']['output']>;
  deduction?: Maybe<Scalars['Float']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  expectedDeduction?: Maybe<Scalars['Float']['output']>;
  invoiceGroupType: InvoiceTypeGroupType;
  invoiceNumber: Scalars['Int']['output'];
  invoiceTypeName: Scalars['String']['output'];
  isFactored?: Maybe<Scalars['Boolean']['output']>;
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  nabisCreditMemo?: Maybe<Scalars['Float']['output']>;
  orderAction?: Maybe<OrderActionEnum>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderStatus?: Maybe<OrderStatusEnum>;
  orderTotal?: Maybe<Scalars['Float']['output']>;
  paidByName?: Maybe<Scalars['String']['output']>;
  paidToName?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Scalars['Float']['output']>;
  retailerName?: Maybe<Scalars['String']['output']>;
  selfCollected?: Maybe<Scalars['Float']['output']>;
  totalBalance: Scalars['Float']['output'];
  totalCollected: Scalars['Float']['output'];
  totalRemitted: Scalars['Float']['output'];
  writeOffExternal?: Maybe<Scalars['Float']['output']>;
  writeOffNabis?: Maybe<Scalars['Float']['output']>;
};

export type GetAccountingApiPaymentTransactionsInput = {
  afterAppliedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  afterCreatedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  afterPaidAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  afterRemittedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  appliedOrderNumber?: InputMaybe<Scalars['Int']['input']>;
  atLeastAmount?: InputMaybe<Scalars['Float']['input']>;
  atLeastUnapplied?: InputMaybe<Scalars['Float']['input']>;
  atMostAmount?: InputMaybe<Scalars['Float']['input']>;
  atMostUnapplied?: InputMaybe<Scalars['Float']['input']>;
  beforeAppliedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforeCreatedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforePaidAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforeRemittedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  equalAmount?: InputMaybe<Scalars['Float']['input']>;
  equalUnapplied?: InputMaybe<Scalars['Float']['input']>;
  fromAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoicePaidBy?: InputMaybe<Scalars['ID']['input']>;
  invoicePaidTo?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<TransactionLocation>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalTransactionNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo: PageInfoInput;
  paidBy?: InputMaybe<Scalars['ID']['input']>;
  paidByForGroup?: InputMaybe<Scalars['ID']['input']>;
  sameAppliedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  sameCreatedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  samePaidAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  sameRemittedAtDate?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId?: InputMaybe<Array<Scalars['ID']['input']>>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  unappliedReason?: InputMaybe<UnappliedReason>;
};

export type GetAccountingApiPaymentTransactionsPayload = {
  pageInfo: AccountingPageInfo;
  payments?: Maybe<Array<GetAccountingApiPaymentTransactionsSingle>>;
};

export type GetAccountingApiPaymentTransactionsSingle = {
  adminNotes?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  appliedAt?: Maybe<Scalars['String']['output']>;
  appliedDeductions?: Maybe<Scalars['Float']['output']>;
  autoGenerated: Scalars['Boolean']['output'];
  balance: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  expectedDeductions?: Maybe<Scalars['Float']['output']>;
  fromAccount?: Maybe<Scalars['ID']['output']>;
  fromAccountType?: Maybe<AccountType>;
  location?: Maybe<TransactionLocation>;
  method?: Maybe<TransactionMethod>;
  name: Scalars['String']['output'];
  originalTransactionName?: Maybe<Scalars['String']['output']>;
  originalTransactionNumber?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidByOrgName: Scalars['String']['output'];
  publicNotes?: Maybe<Scalars['String']['output']>;
  remittedAt?: Maybe<Scalars['String']['output']>;
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  toAccount?: Maybe<Scalars['ID']['output']>;
  toAccountType?: Maybe<AccountType>;
  totalDeductions?: Maybe<Scalars['Float']['output']>;
  transactionNumber: Scalars['Int']['output'];
  transactionType?: Maybe<TransactionType>;
  unappliedReason?: Maybe<UnappliedReason>;
};

export type GetAccountingApiRetailerTransactionsAllCsvInput = {
  email: Scalars['String']['input'];
};

export type GetAccountingApiRetailerTransactionsPageCsvInput = {
  email: Scalars['String']['input'];
  endPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  includeApplied: Scalars['Boolean']['input'];
  licensedLocationId: Scalars['ID']['input'];
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  startPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAccountingApiRetailerTransactionsPageInput = {
  endPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo: PageInfoInput;
  startPaidDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAccountingApiRetailerTransactionsPagePayload = {
  pageInfo: AccountingPageInfo;
  transactions: Array<GetAccountingApiRetailerTransactionsPagePayloadSingle>;
};

export type GetAccountingApiRetailerTransactionsPagePayloadSingle = {
  applications: Array<Applications>;
  appliedAmount: Scalars['Float']['output'];
  method?: Maybe<TransactionMethod>;
  name: Scalars['String']['output'];
  paidAt: Scalars['DateTime']['output'];
  retailerOrgName: Scalars['String']['output'];
  transactionAmount: Scalars['Float']['output'];
  transactionId: Scalars['ID']['output'];
  transactionNumber: Scalars['Int']['output'];
  unappliedAmount: Scalars['Float']['output'];
};

export type GetAdminCreditSettingsDataInput = {
  licensedLocationName?: InputMaybe<Scalars['String']['input']>;
  pageInfo: PageInfoInput;
  retailerRestrictionFilters?: InputMaybe<Scalars['String']['input']>;
};

export type GetAdminCreditSettingsDataResponse = {
  data: Array<AdminCreditSettingsRow>;
  hasNextPage: Scalars['Boolean']['output'];
  totalNumItems: Scalars['Int']['output'];
};

export type GetAllCustomTagsPayload = {
  pageInfo: PageInfo;
  results: Array<CustomTag>;
};

export type GetAllDriverRetailerInvoicesPayload = {
  isForm8300DisabledOnDriverApp: Scalars['Boolean']['output'];
  licensedLocationForm8300Data: Array<LicensedLocationForm8300Data>;
  retailersInvoices?: Maybe<Array<DriverRetailersInvoices>>;
};

export type GetAllOrdersForInvoice = {
  pageInfo: PageInfo;
  results?: Maybe<Array<Maybe<OrderForInvoice>>>;
};

export type GetAllOrdersForInvoiceInput = {
  number?: InputMaybe<Scalars['Int']['input']>;
  pageInfo: PageInfoInput;
};

export type GetBankAccountInfosInput = {
  organizationId: Scalars['ID']['input'];
};

export type GetBankingPageOrdersInput = {
  actions?: InputMaybe<Array<OrderActionEnum>>;
  number?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type GetBankingPageOrdersPayload = {
  pageInfo: PageInfo;
  results: Array<BankingInvoice>;
};

export type GetBrandCreditHoldsResponse = {
  pageInfo: PageInfo;
  results: Array<OrganizationRelationshipTags>;
};

export type GetBrandCreditSettingsDataInput = {
  licensedLocationName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
  retailerRestrictionFilters?: InputMaybe<Scalars['String']['input']>;
};

export type GetBrandCreditSettingsDataResponse = {
  data: Array<BrandCreditSettingsRow>;
  hasNextPage: Scalars['Boolean']['output'];
  isCreditLimitFeatureFlagEnabled: Scalars['Boolean']['output'];
  totalNumItems: Scalars['Int']['output'];
};

export type GetDataTableDataPayload = {
  pageInfo: PageInfo;
  results: Array<DataTableData>;
};

/** Values for the GetDefaultSalesRepOriginEnum enum */
export enum GetDefaultSalesRepOriginEnum {
  PreviousOrder = 'PREVIOUS_ORDER',
  SalesRule = 'SALES_RULE',
}

export type GetDefaultSalesRepPayload = {
  origin: GetDefaultSalesRepOriginEnum;
  user?: Maybe<User>;
};

export type GetDriverAppSubmissionsInput = {
  afterDriverPickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  beforeDriverPickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  hasEvidence?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationName?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  pageInfo: PageInfoInput;
  query?: InputMaybe<Scalars['String']['input']>;
  retailerRestrictionFilters?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
};

export type GetDriverAppSubmissionsResponse = {
  data?: Maybe<Array<Maybe<DriverAppSubmissionRecord>>>;
  pageInfo: AccountingPageInfo;
};

export type GetDriverOrdersPayload = {
  orders: Array<DriverOrder>;
};

export type GetDriverRetailerInformationPayload = {
  retailers: Array<LicensedLocation>;
};

export type GetDriverRetailerInvoicesPayload = {
  orderToMPPBRequiredOrders: Scalars['JSON']['output'];
  orders: Array<DriverOutstandingOrder>;
  totalAmountDue: Scalars['Float']['output'];
  totalAmountOutstanding: Scalars['Float']['output'];
  totalAmountOverdue: Scalars['Float']['output'];
  totalAmountRequiredForDelivery: Scalars['Float']['output'];
  totalNotYetDue: Scalars['Float']['output'];
  totalRequiredForDeliveryToday: Scalars['Float']['output'];
};

export type GetEwbMicroTransactionsInput = {
  bankAccountInfoId: Scalars['ID']['input'];
};

export type GetEwbMicroTransactionsPayload = {
  transactions?: Maybe<Array<EwbTransaction>>;
};

export type GetEwbTransactionsForOrgInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo: PageInfoInput;
  status?: InputMaybe<EwbTransactionStatusEnum>;
  transactionIdReference?: InputMaybe<Scalars['String']['input']>;
};

export type GetEwbTransactionsForOrgPayload = {
  pageInfo: PageInfo;
  results: Array<EwbTransactionForOrg>;
};

export type GetEwbTransactionsInput = {
  orderId: Scalars['ID']['input'];
};

export type GetEwbTransactionsPayload = {
  credits?: Maybe<Array<EwbTransaction>>;
  debits?: Maybe<Array<EwbTransaction>>;
};

export type GetEnterpriseNabisRetailerCreditHoldInput = {
  licensedLocationId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
};

export type GetFeaturedBrandsPayload = {
  pageInfo: PageInfo;
  results: Array<FeaturedBrand>;
};

export type GetFeeGroupPayload = {
  activeFee: Fee;
  fees: Array<Fee>;
};

export type GetFeesForOrderByLineItemPayload = {
  hasInventoryFees: Scalars['Boolean']['output'];
  nabisFulfillmentFeeNumber: Scalars['Float']['output'];
  postDiscountFees: Scalars['Boolean']['output'];
  unitCount?: Maybe<Scalars['Int']['output']>;
  unitFulfillmentFee?: Maybe<Scalars['Float']['output']>;
  useUnitFlatFee?: Maybe<Scalars['Boolean']['output']>;
};

export type GetGmvPerBrand = {
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  gmv: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
};

export type GetLicensedLocationForConfirmationUserPayload = {
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type GetMarketplaceGeneralSettingPayload = {
  marketplaceMaxSampleDemoSubtotal: Scalars['Float']['output'];
  marketplaceSuborderMin: Scalars['Float']['output'];
  marketplaceTotalGMVThresholdForNoMinFee: Scalars['Float']['output'];
  maxCustomTagsPerSku: Scalars['Int']['output'];
};

export type GetMetrcOrdersPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Order>>;
};

export type GetMetrcSkuBatchPayload = {
  defaultItems?: Maybe<Scalars['JSON']['output']>;
  metrcSkuBatch?: Maybe<MetrcSkuBatch>;
  sourcePackages?: Maybe<Scalars['JSON']['output']>;
};

export type GetMultiBrandRetailerCreditLimitsResponse = {
  data: Array<Maybe<EnrichedBrandRetailerCreditLimit>>;
};

export type GetOnlyMetrcOrderPayload = {
  details: OrderDetails;
  errors?: Maybe<Array<MessageObject>>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<LineItem>>;
  tagSequence: Array<Scalars['String']['output']>;
  warehouseKey?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<MessageObject>>;
};

export type GetOnlyMetrcTagsMessage = {
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GetOnlyMetrcTagsPayload = {
  errors?: Maybe<Array<MessageObject>>;
  lineItems: Array<MetrcPackageWithLineItem>;
  messages?: Maybe<Array<MessageObject>>;
  metrcItems: Array<MetrcItem>;
  sourcePackages?: Maybe<Scalars['JSON']['output']>;
};

export type GetOrderChangeDriverUpdatesPayload = {
  pageInfo: PageInfo;
  results: Array<OrderChangeDriverUpdate>;
};

export type GetOrderForRetailerPayload = {
  brand: Scalars['String']['output'];
  currentUserAuthorized: Scalars['Boolean']['output'];
  date: Scalars['DateTime']['output'];
  isCOD: Scalars['Boolean']['output'];
  isOnNabisTracker: Scalars['Boolean']['output'];
  licensedLocationId?: Maybe<Scalars['String']['output']>;
  mustPayPreviousBalance: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  redirectTo?: Maybe<Scalars['String']['output']>;
  retailer: Scalars['String']['output'];
  retailerConfirmationStatus: Scalars['String']['output'];
  retailerNotes?: Maybe<Scalars['String']['output']>;
  sellerPermitLink?: Maybe<Scalars['String']['output']>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  unconfirmedOrders?: Maybe<Array<Maybe<Order>>>;
  w9Link?: Maybe<Scalars['String']['output']>;
};

export type GetOrderRestrictionsForMppbInput = {
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};

export type GetOrdersDocsContainer = {
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  deliveryDate: Scalars['DateTime']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  lastNonReturnShipment?: Maybe<Shipment>;
  metrcManifestS3FileLink?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  publicLicensedLocation: ReducedLicensedLocation;
  publicLineItems: Array<ReducedLineItem>;
  publicOrganization: ReducedOrganization;
  qrcodeS3FileLink?: Maybe<Scalars['String']['output']>;
};

export type GetOrdersDocsInput = {
  encodedOrders: Array<EncodedOrder>;
};

export type GetOrdersDocsPayload = {
  getOrdersDocsArray?: Maybe<Array<GetOrdersDocsContainer>>;
};

export type GetOrdersForChromeExtensionPayload = {
  orders: Scalars['JSON']['output'];
};

export type GetOrdersThatHaveChangedInput = {
  ordersToCheck: Array<OrderToCheckInput>;
};

export type GetOrdersThatHaveChangedPayload = {
  ordersThatHaveChanged?: Maybe<Array<Order>>;
};

export type GetOrganizationPricingPayload = {
  organizationPricing?: Maybe<OrganizationPricing>;
  shouldRemoveMinFee: Scalars['Boolean']['output'];
};

export type GetPaymentPermissionsInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type GetReorderEmailContentPayload = {
  defaultDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  reorderEmailDate?: Maybe<Scalars['DateTime']['output']>;
  subscribedUsers?: Maybe<Array<User>>;
  unsubscribedUsers?: Maybe<Array<User>>;
};

export type GetRetailerDiscountsPayload = {
  pageInfo: PageInfo;
  results: Array<RetailerDiscount>;
};

export type GetRetailerGroupsPayload = {
  pageInfo: PageInfo;
  results: Array<RetailerGroup>;
};

export type GetRetailerMenuInfoPayload = {
  bannerImageS3Link?: Maybe<Scalars['String']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logoS3Link?: Maybe<Scalars['String']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type GetRetailerMenuProductsPayload = {
  pageInfo: PageInfo;
  results: Array<Sku>;
};

export type GetRetailersFromReferrerPayload = {
  authorizedRetailers: Array<Organization>;
  brand: Organization;
  hasNoRetailers: Scalars['Boolean']['output'];
  loneAuthorizedRetailer?: Maybe<Organization>;
  loneUnauthorizedRetailer?: Maybe<Organization>;
};

export type GetSampleOrderPricingPayload = {
  amount: Scalars['Float']['output'];
  isDefault: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
  type: DefaultSpecialPricingTypeEnum;
};

export type GetSkuSalesRulePayload = {
  generalSalesRule?: Maybe<SalesRule>;
  retailerGroup?: Maybe<RetailerGroup>;
  skuSalesRule?: Maybe<SalesRule>;
};

export type GetUserByEmailPayload = {
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  orgFound: Scalars['Boolean']['output'];
  userFound: Scalars['Boolean']['output'];
};

export type GetZipcodesInput = {
  pageInfo: PageInfoInput;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type GetZipcodesPayload = {
  pageInfo: PageInfo;
  results: Array<Zipcode>;
};

export type GlobalRetailerRestriction = {
  id: Scalars['ID']['output'];
  retailerId: Scalars['ID']['output'];
  retailerOrganizationName: Scalars['String']['output'];
};

export type GlobalRetailerRestrictionResponse = {
  pageInfo: PageInfo;
  results: Array<GlobalRetailerRestriction>;
};

export type GlobalRetailerRestrictionWhitelist = {
  id: Scalars['ID']['output'];
  retailerId: Scalars['ID']['output'];
  retailerOrganizationName?: Maybe<Scalars['String']['output']>;
};

export type GlobalRetailerRestrictionWhitelistResponse = {
  results: Array<GlobalRetailerRestrictionWhitelist>;
};

/** Values for the GuzzleFileType enum */
export enum GuzzleFileType {
  CaBatch = 'CA_BATCH',
  CaSku = 'CA_SKU',
  CaSkuBatch = 'CA_SKU_BATCH',
}

export type HighLevelFactoringDataPayload = {
  arTotalSums?: Maybe<ArTotalSums>;
  factorFeeTotals?: Maybe<FactorFeeTotals>;
  factoringTotalSums?: Maybe<FactoringTotalSums>;
  netGmvTotals?: Maybe<NetGmvTotals>;
};

export type HighlightDates = {
  deliveryDate: Array<Scalars['DateTime']['output']>;
  deliveryDatePaymentPickup: Array<Scalars['DateTime']['output']>;
  due: Array<Scalars['DateTime']['output']>;
  dueToday: Array<Scalars['DateTime']['output']>;
  dueTodayDeliveryDate: Array<Scalars['DateTime']['output']>;
  dueTodayDeliveryDatePaymentPickup: Array<Scalars['DateTime']['output']>;
  dueTodayPaymentPickup: Array<Scalars['DateTime']['output']>;
  multiple: Array<Scalars['DateTime']['output']>;
  paidLate: Array<Scalars['DateTime']['output']>;
  paidLateDeliveryDate: Array<Scalars['DateTime']['output']>;
  paidLateDeliveryDatePaymentPickup: Array<Scalars['DateTime']['output']>;
  paidLatePaymentPickup: Array<Scalars['DateTime']['output']>;
  paidOnTime: Array<Scalars['DateTime']['output']>;
  paidOnTimeDeliveryDate: Array<Scalars['DateTime']['output']>;
  paidOnTimeDeliveryDatePaymentPickup: Array<Scalars['DateTime']['output']>;
  paidOnTimePaymentPickup: Array<Scalars['DateTime']['output']>;
  paymentPickup: Array<Scalars['DateTime']['output']>;
  terminal: Array<Scalars['DateTime']['output']>;
  unpaidOverdue: Array<Scalars['DateTime']['output']>;
  unpaidOverdueDeliveryDate: Array<Scalars['DateTime']['output']>;
  unpaidOverdueDeliveryDatePaymentPickup: Array<Scalars['DateTime']['output']>;
  unpaidOverduePaymentPickup: Array<Scalars['DateTime']['output']>;
  upcoming: Array<Scalars['DateTime']['output']>;
  upcomingDue: Array<Scalars['DateTime']['output']>;
  upcomingDueDeliveryDate: Array<Scalars['DateTime']['output']>;
  upcomingDueDeliveryDatePaymentPickup: Array<Scalars['DateTime']['output']>;
  upcomingDuePaymentPickup: Array<Scalars['DateTime']['output']>;
};

export type HomeListElement = {
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  curatedSkus: Array<Sku>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inventoryClass?: Maybe<InventoryClassEnum>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplacePage: MarketplacePageType;
  name?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  retailerGroupId?: Maybe<Scalars['ID']['output']>;
  skuIds?: Maybe<Array<Scalars['ID']['output']>>;
  skus: Array<Sku>;
  startDate: Scalars['DateTime']['output'];
  type: HomeListElementType;
  updatedAt: Scalars['DateTime']['output'];
};

export type HomeListElementSkusArgs = {
  licensedLocationId: Scalars['ID']['input'];
  skusLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Values for the HomeListElementType enum */
export enum HomeListElementType {
  BestSellers = 'BEST_SELLERS',
  Curated = 'CURATED',
  Featured = 'FEATURED',
  InventoryClass = 'INVENTORY_CLASS',
  LowestPrice = 'LOWEST_PRICE',
  Newest = 'NEWEST',
  Promotions = 'PROMOTIONS',
  TopSkusByPurchaseHistory = 'TOP_SKUS_BY_PURCHASE_HISTORY',
  TopSkusByZip = 'TOP_SKUS_BY_ZIP',
}

/** Values for the HomeListElementView enum */
export enum HomeListElementView {
  Current = 'CURRENT',
  Past = 'PAST',
  Upcoming = 'UPCOMING',
}

export type Hours = {
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  enabled: Scalars['Boolean']['output'];
  hours?: Maybe<Array<Maybe<Array<Scalars['DateTime']['output']>>>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Values for the IDTypesEnum enum */
export enum IdTypesEnum {
  DriversLicense = 'DRIVERS_LICENSE',
  MilitaryId = 'MILITARY_ID',
  NativeAmericanTribalCard = 'NATIVE_AMERICAN_TRIBAL_CARD',
  PassportOrPassportCard = 'PASSPORT_OR_PASSPORT_CARD',
  PermanentResidentCard = 'PERMANENT_RESIDENT_CARD',
  StateIssuedPhotoId = 'STATE_ISSUED_PHOTO_ID',
}

export type IHeartJaneRating = {
  count: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  skuId: Scalars['ID']['output'];
};

export type IHeartJaneReview = {
  comment?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
  skuId: Scalars['ID']['output'];
  tags: Array<IHeartJaneTag>;
};

export type IHeartJaneReviews = {
  pageInfo: PageInfo;
  results: Array<IHeartJaneReview>;
};

export type IHeartJaneTag = {
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ImportOrderContactDetailsResponse = {
  results: Array<ImportOrderContactDetailsResults>;
  stats: ImportOrderContactDetailsStats;
};

export type ImportOrderContactDetailsResults = {
  licensedLocationName: Scalars['String']['output'];
  organizationContacts: Array<Scalars['String']['output']>;
  organizationContactsCreated: Scalars['Int']['output'];
  organizationUserContacts: Array<Scalars['String']['output']>;
  organizationUserContactsCreated: Scalars['Int']['output'];
  status: OrderContactDetailsEnum;
};

export type ImportOrderContactDetailsStats = {
  NoEmailAddresses: Array<Scalars['String']['output']>;
  NoEmailAddressesCount: Scalars['Int']['output'];
  NoLicensedLocationName: Array<Scalars['String']['output']>;
  NoLicensedLocationNameCount: Scalars['Int']['output'];
  NoMatchingOrganzation: Array<Scalars['String']['output']>;
  NoMatchingOrganzationCount: Scalars['Int']['output'];
  Success: Array<Scalars['String']['output']>;
  SuccessCount: Scalars['Int']['output'];
  TooManyMatchingOrganizations: Array<Scalars['String']['output']>;
  TooManyMatchingOrganizationsCount: Scalars['Int']['output'];
};

/** Values for the InfoplusAsnInventoryStatus enum */
export enum InfoplusAsnInventoryStatus {
  Ordered = 'ORDERED',
  Shelved = 'SHELVED',
}

/** Values for the InfoplusInventoryLedgerItemType enum */
export enum InfoplusInventoryLedgerItemType {
  Asn = 'ASN',
  InventoryAdjustment = 'INVENTORY_ADJUSTMENT',
  Order = 'ORDER',
  QuickReceipt = 'QUICK_RECEIPT',
}

export type InfoplusOrderCustomFields = {
  deliveryDate?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<Scalars['String']['output']>;
  shipmentDate?: Maybe<Scalars['String']['output']>;
  stagingAreaShipment1?: Maybe<Scalars['String']['output']>;
  stagingAreaShipment2?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Scalars['String']['output']>;
};

/** Values for the InfoplusOrderInventoryStatus enum */
export enum InfoplusOrderInventoryStatus {
  Fulfilled = 'FULFILLED',
  Ordered = 'ORDERED',
  Packed = 'PACKED',
}

export type InitiateBatchFileUploadInput = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
};

export type InitiateBatchFileUploadPayload = {
  chunkSize: Scalars['Int']['output'];
  fileKey: Scalars['String']['output'];
  isMultipart: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  urls: Array<Scalars['String']['output']>;
};

export type InitiateOrderFileUploadPayload = {
  chunkSize: Scalars['Int']['output'];
  fileKey: Scalars['String']['output'];
  isMultipart: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  urls: Array<Scalars['String']['output']>;
};

export type InitiateUploadPayload = {
  chunkSize: Scalars['Int']['output'];
  fileKey: Scalars['String']['output'];
  isMultipart: Scalars['Boolean']['output'];
  uploadId?: Maybe<Scalars['String']['output']>;
  urls: Array<Scalars['String']['output']>;
};

/** Values for the InventoryCategoryEnum enum */
export enum InventoryCategoryEnum {
  Airgraft = 'AIRGRAFT',
  BakedGood = 'BAKED_GOOD',
  Balm = 'BALM',
  Battery = 'BATTERY',
  Beverage = 'BEVERAGE',
  Botanical = 'BOTANICAL',
  Brownie = 'BROWNIE',
  Bud = 'BUD',
  Budder = 'BUDDER',
  ButaneHashOil = 'BUTANE_HASH_OIL',
  Butter = 'BUTTER',
  Candy = 'CANDY',
  Capsule = 'CAPSULE',
  Cartridge = 'CARTRIDGE',
  Cartridge_510 = 'CARTRIDGE_510',
  Chips = 'CHIPS',
  Chocolate = 'CHOCOLATE',
  Co2Oil = 'CO2_OIL',
  Coffee = 'COFFEE',
  ColdWaterHash = 'COLD_WATER_HASH',
  Concentrate = 'CONCENTRATE',
  Cookie = 'COOKIE',
  Cream = 'CREAM',
  Crumble = 'CRUMBLE',
  Crystalline = 'CRYSTALLINE',
  Dart = 'DART',
  Diamonds = 'DIAMONDS',
  Disposable = 'DISPOSABLE',
  DissolvablePowder = 'DISSOLVABLE_POWDER',
  Frost = 'FROST',
  Greenhouse = 'GREENHOUSE',
  Gummy = 'GUMMY',
  HardCandy = 'HARD_CANDY',
  Hash = 'HASH',
  Honey = 'HONEY',
  IceCream = 'ICE_CREAM',
  Indoor = 'INDOOR',
  InfusedFlower = 'INFUSED_FLOWER',
  InfusedPreRolls = 'INFUSED_PRE_ROLLS',
  Inhaler = 'INHALER',
  Juice = 'JUICE',
  Kief = 'KIEF',
  Kif = 'KIF',
  Leaflettes = 'LEAFLETTES',
  LightDep = 'LIGHT_DEP',
  LipBalm = 'LIP_BALM',
  LiveResin = 'LIVE_RESIN',
  Marshmallow = 'MARSHMALLOW',
  Mint = 'MINT',
  Mixed = 'MIXED',
  Oil = 'OIL',
  Other = 'OTHER',
  OtherBatteryTypes = 'OTHER_BATTERY_TYPES',
  Outdoor = 'OUTDOOR',
  Pack = 'PACK',
  Patch = 'PATCH',
  Pax = 'PAX',
  Pen = 'PEN',
  Pill = 'PILL',
  Popcorn = 'POPCORN',
  Pops = 'POPS',
  PreGround = 'PRE_GROUND',
  PreRolls = 'PRE_ROLLS',
  Proprietary = 'PROPRIETARY',
  ReadyToRoll = 'READY_TO_ROLL',
  Rosin = 'ROSIN',
  Salve = 'SALVE',
  Sauce = 'SAUCE',
  Seltzer = 'SELTZER',
  Shake = 'SHAKE',
  Shatter = 'SHATTER',
  Shot = 'SHOT',
  Single = 'SINGLE',
  Soda = 'SODA',
  Solventless = 'SOLVENTLESS',
  Spray = 'SPRAY',
  Sublingual = 'SUBLINGUAL',
  Sugar = 'SUGAR',
  SunGrown = 'SUN_GROWN',
  Suppository = 'SUPPOSITORY',
  Tablets = 'TABLETS',
  Taffy = 'TAFFY',
  Tea = 'TEA',
  Thread_510 = 'THREAD_510',
  Tinctures = 'TINCTURES',
  Topical = 'TOPICAL',
  Transdermal = 'TRANSDERMAL',
  Trim = 'TRIM',
  Water = 'WATER',
  Wax = 'WAX',
  WholeFlower = 'WHOLE_FLOWER',
}

/** Values for the InventoryCategoryTagEnum enum */
export enum InventoryCategoryTagEnum {
  Airgraft = 'AIRGRAFT',
  Blend = 'BLEND',
  Butane = 'BUTANE',
  Candy = 'CANDY',
  Cbd = 'CBD',
  Cbn = 'CBN',
  Co2 = 'CO2',
  Dart = 'DART',
  Delta_9 = 'DELTA_9',
  Distillate = 'DISTILLATE',
  Fruit = 'FRUIT',
  GlutenFree = 'GLUTEN_FREE',
  Greenhouse = 'GREENHOUSE',
  Hash = 'HASH',
  Indoor = 'INDOOR',
  Infused = 'INFUSED',
  LightDeprivation = 'LIGHT_DEPRIVATION',
  LiveResin = 'LIVE_RESIN',
  Mint = 'MINT',
  Neutral = 'NEUTRAL',
  NutFree = 'NUT_FREE',
  Oil = 'OIL',
  Other = 'OTHER',
  Pax = 'PAX',
  Rosin = 'ROSIN',
  Sauce = 'SAUCE',
  Shatter = 'SHATTER',
  Solventless = 'SOLVENTLESS',
  StrainSpecific = 'STRAIN_SPECIFIC',
  SunGrown = 'SUN_GROWN',
  Thc = 'THC',
  ThcA = 'THC_A',
  ThcV = 'THC_V',
  Vegan = 'VEGAN',
  Wax = 'WAX',
}

/** Values for the InventoryClassEnum enum */
export enum InventoryClassEnum {
  Accessories = 'ACCESSORIES',
  Concentrate = 'CONCENTRATE',
  Edibles = 'EDIBLES',
  Flower = 'FLOWER',
  InfusedPreRoll = 'INFUSED_PRE_ROLL',
  PersonalCare = 'PERSONAL_CARE',
  PreRoll = 'PRE_ROLL',
  Vape = 'VAPE',
}

export type InventoryItem = {
  allocated: Scalars['Float']['output'];
  counted: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inventoryLedgerItems: Array<InventoryLedgerItem>;
  organization: Organization;
  promised: Scalars['Float']['output'];
  skuBatch: SkuBatch;
  storageType: InventoryStorageType;
  updatedAt: Scalars['DateTime']['output'];
  warehouse: Warehouse;
};

export type InventoryItemInfoWithInfoplus = {
  pageInfo: PageInfo;
  results: Array<InventoryLedgerItemWithInfoplus>;
};

export type InventoryLedgerItem = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator: User;
  endCounted: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inventoryItem: InventoryItem;
  lineItem?: Maybe<LineItem>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  organization: Organization;
  startCounted: Scalars['Float']['output'];
  transactionType: InventoryTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InventoryLedgerItemWithInfoplus = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator: User;
  endCounted?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  inventoryAdjustmentId?: Maybe<Scalars['Float']['output']>;
  inventoryItem: InventoryItem;
  itemReceiptId?: Maybe<Scalars['Float']['output']>;
  lineItem?: Maybe<LineItem>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderLineId?: Maybe<Scalars['Float']['output']>;
  organization: Organization;
  startCounted?: Maybe<Scalars['Float']['output']>;
  taskCompletedAt: Scalars['DateTime']['output'];
  transactionType: InventoryTransactionType;
  type: InfoplusInventoryLedgerItemType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InventoryMeta = {
  category: Array<Maybe<InventoryMetaCategory>>;
  marketingTag: Array<Maybe<InventoryMetaMarketingTag>>;
  tag: Array<Maybe<InventoryMetaTag>>;
  tagGroup: Array<Maybe<InventoryMetaTagGroup>>;
};

export type InventoryMetaCategory = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inventoryClass: InventoryClassEnum;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryMetaClassEnum = {
  id: Scalars['ID']['output'];
  inventoryClass: InventoryClassEnum;
};

export type InventoryMetaMarketingTag = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryMetaTag = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inventoryTagGroup?: Maybe<InventoryMetaTagGroup>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryMetaTagGroup = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inventoryCategories?: Maybe<Array<Maybe<InventoryMetaCategory>>>;
  inventoryClasses?: Maybe<Array<Maybe<InventoryMetaClassEnum>>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryRow = {
  lastUpdatedAt: Scalars['DateTime']['output'];
  skuBatch: SkuBatch;
  totalQuantity: Scalars['Float']['output'];
};

/** Values for the InventoryStorageType enum */
export enum InventoryStorageType {
  Inventory = 'INVENTORY',
  Quarantine = 'QUARANTINE',
}

/** Values for the InventoryTagEnum enum */
export enum InventoryTagEnum {
  Accessory = 'ACCESSORY',
  Balance = 'BALANCE',
  Beginner = 'BEGINNER',
  BlackOwned = 'BLACK_OWNED',
  Blend = 'BLEND',
  Budget = 'BUDGET',
  Creative = 'CREATIVE',
  Cultivator = 'CULTIVATOR',
  Designer = 'DESIGNER',
  DistillateInfused = 'DISTILLATE_INFUSED',
  EffectBased = 'EFFECT_BASED',
  Energetic = 'ENERGETIC',
  Enthusiast = 'ENTHUSIAST',
  Euphoric = 'EUPHORIC',
  FamilyOwned = 'FAMILY_OWNED',
  FemaleOwned = 'FEMALE_OWNED',
  FiveToOneCbdThcRatio = 'FIVE_TO_ONE_CBD_THC_RATIO',
  Focused = 'FOCUSED',
  Frozen = 'FROZEN',
  Giddy = 'GIDDY',
  Glass = 'GLASS',
  Happy = 'HAPPY',
  HashInfused = 'HASH_INFUSED',
  HeritageAndLegacyBrand = 'HERITAGE_AND_LEGACY_BRAND',
  HundredPercentBiodegradable = 'HUNDRED_PERCENT_BIODEGRADABLE',
  Hungry = 'HUNGRY',
  MassMarket = 'MASS_MARKET',
  Medical = 'MEDICAL',
  MidMarket = 'MID_MARKET',
  MinorityOwned = 'MINORITY_OWNED',
  MylarBags = 'MYLAR_BAGS',
  NanoEmulsionOrFastActing = 'NANO_EMULSION_OR_FAST_ACTING',
  NonCannabis = 'NON_CANNABIS',
  OneToOneCbdThcRatio = 'ONE_TO_ONE_CBD_THC_RATIO',
  OneToTenCbdThcRatio = 'ONE_TO_TEN_CBD_THC_RATIO',
  OneToTwoCbdThcRatio = 'ONE_TO_TWO_CBD_THC_RATIO',
  PainRelief = 'PAIN_RELIEF',
  Pets = 'PETS',
  Plastic = 'PLASTIC',
  PreciseDosing = 'PRECISE_DOSING',
  Premium = 'PREMIUM',
  Recreational = 'RECREATIONAL',
  Refrigerated = 'REFRIGERATED',
  Relaxed = 'RELAXED',
  RosinInfused = 'ROSIN_INFUSED',
  ShelfStable = 'SHELF_STABLE',
  Sleepy = 'SLEEPY',
  SleepAid = 'SLEEP_AID',
  SocialEquity = 'SOCIAL_EQUITY',
  StrainSpecific = 'STRAIN_SPECIFIC',
  Talkative = 'TALKATIVE',
  TenToOneCbdThcRatio = 'TEN_TO_ONE_CBD_THC_RATIO',
  ThreeToOneCbdThcRatio = 'THREE_TO_ONE_CBD_THC_RATIO',
  TwoToOneCbdThcRatio = 'TWO_TO_ONE_CBD_THC_RATIO',
  Uplifted = 'UPLIFTED',
}

/** Values for the InventoryTransactionType enum */
export enum InventoryTransactionType {
  Allocation = 'ALLOCATION',
  Correction = 'CORRECTION',
  Intake = 'INTAKE',
  Outtake = 'OUTTAKE',
}

/** Values for the InventoryTypeEnum enum */
export enum InventoryTypeEnum {
  Cannabis = 'CANNABIS',
  NonCannabis = 'NON_CANNABIS',
}

/** Values for the InventoryUnitOfMeasureEnum enum */
export enum InventoryUnitOfMeasureEnum {
  Case = 'CASE',
  Each = 'EACH',
  Pack = 'PACK',
  Pallet = 'PALLET',
}

export type InventoryValues = {
  DEMO_FOURFRONT: Values;
  DEMO_NABIONE: Values;
  DEMO_NABITWO: Values;
  DEMO_WOODLAKE: Values;
  DEMO_ZASP: Values;
  DEMO_ZASP_2: Values;
  FOURFRONT: Values;
  LA: Values;
  NABITWO: Values;
  OAK: Values;
  WOODLAKE: Values;
  ZASP_2: Values;
};

export type Invoice = {
  ACHACRetailerUnconfirmed: Scalars['Float']['output'];
  ACHAmountCollectedRetailer: Scalars['Float']['output'];
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  brandFeesCollection?: Maybe<BrandFeesCollection>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creditMemo: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  discount: Scalars['Float']['output'];
  exciseTax: Scalars['Float']['output'];
  exciseTaxCollected?: Maybe<Scalars['Float']['output']>;
  gmv: Scalars['Float']['output'];
  gmvCollected: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  irn?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  nabisDiscount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nextDeliveryDate: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  organization: Organization;
  region?: Maybe<Scalars['String']['output']>;
  site: Site;
  surcharge: Scalars['Float']['output'];
  totalBalance: Scalars['Float']['output'];
  warehouse: Warehouse;
  warehouseId: Scalars['ID']['output'];
};

export type InvoiceChangelog = {
  changelogs?: Maybe<Array<FactorChangelog>>;
  invoiceNumber: Scalars['Int']['output'];
};

export type InvoiceChangelogPayload = {
  results?: Maybe<InvoiceChangelog>;
};

/** Values for the InvoiceGenerationEnum enum */
export enum InvoiceGenerationEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  C1 = 'C1',
  C2 = 'C2',
  Single = 'SINGLE',
}

/** Values for the InvoiceTypeGroupType enum */
export enum InvoiceTypeGroupType {
  Base = 'BASE',
  Fee = 'FEE',
  Order = 'ORDER',
}

export type ItemInput = {
  metrcId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: ItemTypes;
};

/** Values for the ItemTypes enum */
export enum ItemTypes {
  DisplaySample = 'DISPLAY_SAMPLE',
  Donation = 'DONATION',
  Main = 'MAIN',
  TradeSample = 'TRADE_SAMPLE',
}

export type License = {
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  category: LicenseCategoryEnum;
  city: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  issuanceDate?: Maybe<Scalars['DateTime']['output']>;
  legalEntityName: Scalars['String']['output'];
  licenseNumber: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  onboardedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  site: Site;
  state: Scalars['String']['output'];
  type: LicenseTypeEnum;
  zip: Scalars['String']['output'];
};

/** Values for the LicenseCategoryEnum enum */
export enum LicenseCategoryEnum {
  AdultUse = 'ADULT_USE',
  Combined = 'COMBINED',
  Medicinal = 'MEDICINAL',
}

/** Values for the LicenseTypeEnum enum */
export enum LicenseTypeEnum {
  CannabisEvents = 'CANNABIS_EVENTS',
  Cultivator = 'CULTIVATOR',
  Distributor = 'DISTRIBUTOR',
  DistributorTransportOnly = 'DISTRIBUTOR_TRANSPORT_ONLY',
  Manufacturer = 'MANUFACTURER',
  Microbusiness = 'MICROBUSINESS',
  Retailer = 'RETAILER',
  RetailerNonstorefront = 'RETAILER_NONSTOREFRONT',
  Testing = 'TESTING',
}

export type LicensedLocation = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  billingAddress1?: Maybe<Scalars['String']['output']>;
  billingAddress2?: Maybe<Scalars['String']['output']>;
  billingAddressCity?: Maybe<Scalars['String']['output']>;
  billingAddressState?: Maybe<Scalars['String']['output']>;
  billingAddressZip?: Maybe<Scalars['String']['output']>;
  centralizedPurchasingNotes?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  collect1PocAllowsText: Scalars['Boolean']['output'];
  collect1PocEmail?: Maybe<Scalars['String']['output']>;
  collect1PocFirstName?: Maybe<Scalars['String']['output']>;
  collect1PocLastName?: Maybe<Scalars['String']['output']>;
  collect1PocNumber?: Maybe<Scalars['String']['output']>;
  collect1PocTitle?: Maybe<Scalars['String']['output']>;
  collect1PreferredContactMethod?: Maybe<Scalars['String']['output']>;
  collect2PocAllowsText: Scalars['Boolean']['output'];
  collect2PocEmail?: Maybe<Scalars['String']['output']>;
  collect2PocFirstName?: Maybe<Scalars['String']['output']>;
  collect2PocLastName?: Maybe<Scalars['String']['output']>;
  collect2PocNumber?: Maybe<Scalars['String']['output']>;
  collect2PocTitle?: Maybe<Scalars['String']['output']>;
  collect2PreferredContactMethod?: Maybe<Scalars['String']['output']>;
  collectionNotes?: Maybe<Scalars['String']['output']>;
  creditRating?: Maybe<Scalars['Float']['output']>;
  delivery1PocAllowsText: Scalars['Boolean']['output'];
  delivery1PocEmail?: Maybe<Scalars['String']['output']>;
  delivery1PocFirstName?: Maybe<Scalars['String']['output']>;
  delivery1PocLastName?: Maybe<Scalars['String']['output']>;
  delivery1PocNumber?: Maybe<Scalars['String']['output']>;
  delivery1PocTitle?: Maybe<Scalars['String']['output']>;
  delivery1PreferredContactMethod?: Maybe<Scalars['String']['output']>;
  delivery2PocAllowsText: Scalars['Boolean']['output'];
  delivery2PocEmail?: Maybe<Scalars['String']['output']>;
  delivery2PocFirstName?: Maybe<Scalars['String']['output']>;
  delivery2PocLastName?: Maybe<Scalars['String']['output']>;
  delivery2PocNumber?: Maybe<Scalars['String']['output']>;
  delivery2PocTitle?: Maybe<Scalars['String']['output']>;
  delivery2PreferredContactMethod?: Maybe<Scalars['String']['output']>;
  deliveryByApptOnly: Scalars['Boolean']['output'];
  deliveryHours?: Maybe<Hours>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  form8300ComplianceRequired: Scalars['Boolean']['output'];
  hoursBusiness?: Maybe<Scalars['String']['output']>;
  hoursDelivery?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  infoplus?: Maybe<Scalars['Int']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isCodOnly: Scalars['Boolean']['output'];
  isDropAndGo?: Maybe<Scalars['Boolean']['output']>;
  isNetTermsLimited: Scalars['Boolean']['output'];
  isOnNabisTracker: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  licensedLocationOrg?: Maybe<Array<Maybe<LicensedLocationOrganizationFragment>>>;
  licenses?: Maybe<Array<License>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationNotes?: Maybe<Scalars['String']['output']>;
  nabisMaxTerms?: Maybe<Scalars['Int']['output']>;
  nabisNotes?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netTerms?: Maybe<Scalars['Int']['output']>;
  noExciseTax: Scalars['Boolean']['output'];
  payByCheck: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  previousRatingInfo?: Maybe<Array<PreviousRetailerCreditRating>>;
  printCoas: Scalars['Boolean']['output'];
  qualitativeRating: Scalars['Float']['output'];
  retailerGroups: Array<RetailerGroup>;
  retailerPricingGroup?: Maybe<RetailerPricingGroup>;
  retailerPricingGroups?: Maybe<Array<RetailerPricingGroup>>;
  schedulingSoftwareLink?: Maybe<Scalars['String']['output']>;
  schedulingSoftwareRequired: Scalars['Boolean']['output'];
  sellerPermitLink?: Maybe<Scalars['String']['output']>;
  siteCategory?: Maybe<SiteCategoryEnum>;
  specialProtocol: Scalars['Boolean']['output'];
  specialRequirementsForLocation?: Maybe<Array<SpecialRequirementsForLocation>>;
  state?: Maybe<Scalars['String']['output']>;
  submittedBy?: Maybe<User>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  trustLevelInEffect: CreditRatingTrustLevels;
  trustLevelNabis: CreditRatingTrustLevels;
  unmaskedId: Scalars['ID']['output'];
  verificationStatus?: Maybe<VerificationStatusEnum>;
  w9Link?: Maybe<Scalars['String']['output']>;
  warehouse: Warehouse;
  warehouseId: Scalars['ID']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type LicensedLocationLicensesArgs = {
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LicensedLocationConfirmationUser = {
  IDGenericFile?: Maybe<GenericFile>;
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idNumber: Scalars['String']['output'];
  idType: IdTypesEnum;
  isArchived: Scalars['Boolean']['output'];
  issuedBy: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  licensedLocationId: Scalars['ID']['output'];
  middleInitial: Scalars['String']['output'];
  noTin: Scalars['Boolean']['output'];
  occupation: Scalars['String']['output'];
  payPCs: Array<Maybe<PaymentPickupConfirmation>>;
  persistent: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  taxpayerIdentificationNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zipCode: Scalars['String']['output'];
};

export type LicensedLocationConfirmationUserMinimal = {
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  middleInitial: Scalars['String']['output'];
};

export type LicensedLocationContact = {
  copiedTo: Array<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userContact: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  userLicensedLocationRelationshipId: Scalars['ID']['output'];
};

export type LicensedLocationForOnboardingRetailers = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LicensedLocationForm8300Data = {
  form8300ComplianceRequired: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  llConfirmationUsers: Array<LicensedLocationConfirmationUserMinimal>;
};

export type LicensedLocationHomeListElementResult = {
  homeListElements: Array<HomeListElement>;
  pageInfo?: Maybe<PageInfo>;
};

export type LicensedLocationOrganizationFragment = {
  alias?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  isOnBrandCreditHold: Scalars['Boolean']['output'];
  isOnCreditHold: Scalars['Boolean']['output'];
  isRetailerRestricted: Scalars['Boolean']['output'];
  isRetailerRestrictedForBrand: Scalars['Boolean']['output'];
  licensedLocationId: Scalars['ID']['output'];
  overdueExciseTaxForCreditHold?: Maybe<Scalars['Float']['output']>;
};

export type LicensedLocationProposal = {
  body?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LineItem = {
  additionalDiscount: Scalars['Float']['output'];
  batchCOALink?: Maybe<BatchCoaLink>;
  code: Scalars['String']['output'];
  destinationSkuBatch?: Maybe<SkuBatch>;
  destinationSkuBatchId?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  includeDisplaySample?: Maybe<Scalars['Boolean']['output']>;
  infoplus?: Maybe<Scalars['Int']['output']>;
  isExciseTaxable: Scalars['Boolean']['output'];
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isSample: Scalars['Boolean']['output'];
  lineItemManifestNotes?: Maybe<Scalars['String']['output']>;
  metrcPackageTag?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Order;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  overrideQuantityPerUnitOfMeasure: Scalars['Boolean']['output'];
  oversold: Scalars['Boolean']['output'];
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  pricePerUnitAftrDscnt?: Maybe<Scalars['Float']['output']>;
  promotionsDiscount: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  sampleType?: Maybe<LineItemSampleType>;
  skuBatch?: Maybe<SkuBatch>;
  skuBatchId?: Maybe<Scalars['ID']['output']>;
  standardPricePerUnit?: Maybe<Scalars['Float']['output']>;
  subtotalAftrDscnt?: Maybe<Scalars['Float']['output']>;
  taggedAt?: Maybe<Scalars['DateTime']['output']>;
  taggerId?: Maybe<Scalars['ID']['output']>;
  unit: Scalars['String']['output'];
};

export type LineItemChange = {
  additionalDiscount: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isExciseTaxable: Scalars['Boolean']['output'];
  isSample: Scalars['Boolean']['output'];
  lineItemId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orderChange: OrderChange;
  oversold?: Maybe<Scalars['Boolean']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  promotionsDiscount: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  sampleType?: Maybe<LineItemSampleType>;
  skuBatch?: Maybe<SkuBatch>;
  skuBatchId: Scalars['ID']['output'];
  standardPricePerUnit?: Maybe<Scalars['Float']['output']>;
  type: LineItemChangeType;
};

/** Values for the LineItemChangeType enum */
export enum LineItemChangeType {
  Added = 'ADDED',
  Removed = 'REMOVED',
}

/** Values for the LineItemSampleType enum */
export enum LineItemSampleType {
  DisplaySample = 'DISPLAY_SAMPLE',
  Donation = 'DONATION',
  TradeSample = 'TRADE_SAMPLE',
}

export type LineItemWithQr = {
  id: Scalars['ID']['output'];
  lineItemQr: Array<LineItemWithQrQr>;
  sku: LineItemWithQrSku;
};

export type LineItemWithQrQr = {
  id: Scalars['ID']['output'];
  qr: Scalars['String']['output'];
};

export type LineItemWithQrSku = {
  id: Scalars['ID']['output'];
  marketplaceName?: Maybe<Scalars['String']['output']>;
};

export type LiveUpdates = {
  deploymentMessage?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocationInput = {
  items: Array<ItemInput>;
  licenseNumber: Scalars['String']['input'];
  licensedLocationId: Scalars['String']['input'];
};

export type LoginUserInput = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  password: Scalars['String']['input'];
};

export type LoginUserPayload = {
  token: Scalars['String']['output'];
  user: User;
};

/** Values for the MaintenanceSettingEnum enum */
export enum MaintenanceSettingEnum {
  Full = 'FULL',
  Off = 'OFF',
  Partial = 'PARTIAL',
}

export type MarketplaceBrand = {
  alias: Scalars['String']['output'];
  doingBusinessAs: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logoS3Link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
};

export type MarketplaceBrandInfo = {
  pageInfo: PageInfo;
  results: Array<MarketplaceBrand>;
};

/** Values for the MarketplaceHeaderItemUiType enum */
export enum MarketplaceHeaderItemUiType {
  NoSkus = 'NO_SKUS',
  TwoSkus = 'TWO_SKUS',
}

export type MarketplaceOrderingRestrictions = {
  codOnly: MarketplaceOrderingRestrictionsCodOnly;
};

export type MarketplaceOrderingRestrictionsCodOnly = {
  decodedBrandOrganizationIds: Array<Scalars['String']['output']>;
  hasNabisMax: Scalars['Boolean']['output'];
  hasNabisStandard: Scalars['Boolean']['output'];
};

/** Values for the MarketplacePageType enum */
export enum MarketplacePageType {
  Homepage = 'HOMEPAGE',
  YourMarketplace = 'YOUR_MARKETPLACE',
}

export type MarketplaceSku = {
  availableInventory: Scalars['Int']['output'];
  averageCbdPercentage: Scalars['Float']['output'];
  averageOtherCannabinoidPercentage: Scalars['Float']['output'];
  averageThcPercentage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  inventoryCategory: InventoryCategoryEnum;
  inventoryCategoryTags?: Maybe<Array<InventoryCategoryTagEnum>>;
  inventoryClass: InventoryClassEnum;
  inventoryType: InventoryTypeEnum;
  inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySampleAllowed?: Maybe<Scalars['Boolean']['output']>;
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace: Scalars['Boolean']['output'];
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSample: Scalars['Boolean']['output'];
  isSampleAllowed: Scalars['Boolean']['output'];
  janeProductId?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplaceName?: Maybe<Scalars['String']['output']>;
  maxMarketplaceInventory?: Maybe<Scalars['Float']['output']>;
  maxSamplesPerOrder?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nonSampleSku?: Maybe<Sku>;
  nonSampleSkuId?: Maybe<Scalars['ID']['output']>;
  organization: Organization;
  pricePerUnit: Scalars['Float']['output'];
  priorityBatchExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  productImageS3Link?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<Scalars['String']['output']>;
  promotionalNotes?: Maybe<Scalars['String']['output']>;
  quantityPerUnitOfMeasure: Scalars['Int']['output'];
  retailerDiscounts?: Maybe<Array<MarketplaceSkuRetailerDiscount>>;
  sampleSku?: Maybe<Sku>;
  secondaryImageS3Links?: Maybe<Array<Scalars['String']['output']>>;
  skuDetailsPdfLink?: Maybe<Scalars['String']['output']>;
  skuId: Scalars['ID']['output'];
  strainType: StrainTypeEnum;
  tags?: Maybe<Array<InventoryTagEnum>>;
  totalAvailable?: Maybe<Scalars['Int']['output']>;
  unit: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnitOfMeasure?: Maybe<WeightUnitOfMeasureEnum>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type MarketplaceSkuMaxSamplesPerOrderArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type MarketplaceSkuCount = {
  inventoryCategory: Array<MarketplaceSkuCountInventoryCategory>;
  inventoryCategoryTag: Array<MarketplaceSkuCountInventoryCategoryTag>;
  organization: Array<MarketplaceSkuCountOrganization>;
  tag: Array<MarketplaceSkuCountInventoryTag>;
};

export type MarketplaceSkuCountInventoryCategory = {
  count: Scalars['Int']['output'];
  inventoryCategory: InventoryCategoryEnum;
};

export type MarketplaceSkuCountInventoryCategoryTag = {
  count: Scalars['Int']['output'];
  inventoryCategoryTag: InventoryCategoryTagEnum;
};

export type MarketplaceSkuCountInventoryTag = {
  count: Scalars['Int']['output'];
  inventoryTag: InventoryTagEnum;
};

export type MarketplaceSkuCountOrganization = {
  count: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
};

export type MarketplaceSkuInfo = {
  pageInfo: PageInfo;
  results: Array<Sku>;
};

/** Values for the MarketplaceSkuOrder enum */
export enum MarketplaceSkuOrder {
  Alphabetical = 'ALPHABETICAL',
  LeastExpensive = 'LEAST_EXPENSIVE',
  MostExpensive = 'MOST_EXPENSIVE',
  Popularity = 'POPULARITY',
  RecentlyPurchased = 'RECENTLY_PURCHASED',
  Relevance = 'RELEVANCE',
}

export type MarketplaceSkuRetailerDiscount = {
  discountType: RetailerDiscountType;
  flatDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  minBrandOrderAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDiscount?: Maybe<Scalars['Float']['output']>;
};

export type MessageObject = {
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MessageObjectType>;
};

/** Values for the MessageObjectType enum */
export enum MessageObjectType {
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export type MetrcItem = {
  AdministrationMethod?: Maybe<Scalars['String']['output']>;
  ApprovalStatus?: Maybe<Scalars['String']['output']>;
  DefaultLabTestingState?: Maybe<Scalars['String']['output']>;
  Id?: Maybe<Scalars['Int']['output']>;
  Ingredients?: Maybe<Array<Maybe<UnencodedIngredient>>>;
  IsUsed?: Maybe<Scalars['Boolean']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Note?: Maybe<Scalars['String']['output']>;
  ProductCategoryName?: Maybe<Scalars['String']['output']>;
  ProductCategoryType?: Maybe<Scalars['String']['output']>;
  QuantityType?: Maybe<Scalars['String']['output']>;
  ServingSize?: Maybe<Scalars['String']['output']>;
  StrainId?: Maybe<Scalars['Int']['output']>;
  StrainName?: Maybe<Scalars['String']['output']>;
  SupplyDurationDays?: Maybe<Scalars['Int']['output']>;
  UnitCbdContent?: Maybe<Scalars['Float']['output']>;
  UnitCbdPercent?: Maybe<Scalars['Float']['output']>;
  UnitOfMeasureName?: Maybe<Scalars['String']['output']>;
  UnitQuantity?: Maybe<Scalars['Int']['output']>;
  UnitQuantityUnitOfMeasureName?: Maybe<Scalars['String']['output']>;
  UnitThcContent?: Maybe<Scalars['Float']['output']>;
  UnitThcContentUnitOfMeasureName?: Maybe<Scalars['String']['output']>;
  UnitThcPercent?: Maybe<Scalars['Float']['output']>;
  UnitVolume?: Maybe<Scalars['Float']['output']>;
  UnitVolumeUnitOfMeasureName?: Maybe<Scalars['String']['output']>;
  UnitWeight?: Maybe<Scalars['Float']['output']>;
  UnitWeightUnitOfMeasureName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Values for the MetrcOrderStatusEnum enum */
export enum MetrcOrderStatusEnum {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
}

export type MetrcPackageWithLineItem = {
  ActualDate?: Maybe<Scalars['DateTime']['output']>;
  Ingredients?: Maybe<Array<Maybe<UnencodedIngredient>>>;
  Item?: Maybe<Scalars['Int']['output']>;
  Note?: Maybe<Scalars['String']['output']>;
  Quantity?: Maybe<Scalars['String']['output']>;
  Tag?: Maybe<Scalars['String']['output']>;
  UnitOfMeasure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lineItem?: Maybe<UnencodedLineItem>;
  messages?: Maybe<Array<Maybe<GetOnlyMetrcTagsMessage>>>;
  metrcPackageTag?: Maybe<Scalars['String']['output']>;
  metrcSourcePackageTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MetrcSkuBatch = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  metrcItemIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  metrcSourcePackageTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skuBatch?: Maybe<SkuBatch>;
  skuBatchId: Scalars['ID']['output'];
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warehouseId: Scalars['ID']['output'];
};

export type MetrcTransfer = {
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  destinationLicensedLocation: LicensedLocation;
  destinationLicensedLocationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  metrcManifestId?: Maybe<Scalars['Int']['output']>;
  metrcManifestS3FileLink?: Maybe<Scalars['String']['output']>;
  metrcOrderNotes?: Maybe<Scalars['String']['output']>;
  metrcTransferTemplateName?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  originLicensedLocation: LicensedLocation;
  originLicensedLocationId: Scalars['ID']['output'];
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MinimalOrderFile = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  s3Link: Scalars['String']['output'];
  type: OrderFileType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type MinimalOrganizationBanking = {
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentOrgName?: Maybe<Scalars['String']['output']>;
  type: OrganizationType;
};

export type MultiShipmentPayload = {
  orderAction: OrderActionEnum;
  orderId: Scalars['ID']['output'];
  orderNumber: Scalars['Int']['output'];
  orderStatus: OrderStatusEnum;
  shipments: Array<Shipment>;
};

export type Mutation = {
  acceptOnboardingInviteExistingUser?: Maybe<Scalars['Boolean']['output']>;
  activatePendingBrandRetailerRestriction?: Maybe<BrandRetailerRestrictionResponse>;
  activatePendingGlobalRetailerRestriction?: Maybe<GlobalRetailerRestrictionResponse>;
  addItemsToCart?: Maybe<AddItemsToCartPayload>;
  addLicenseToManufacturerOrganization?: Maybe<Scalars['Boolean']['output']>;
  allAccountsAddToRetailerGroup?: Maybe<AllAccountsAddRemoveRetailerGroupPayload>;
  allAccountsDownloadCSV?: Maybe<Scalars['Boolean']['output']>;
  allAccountsRemoveFromRetailerGroup?: Maybe<AllAccountsAddRemoveRetailerGroupPayload>;
  archiveEmailTemplate?: Maybe<Scalars['Boolean']['output']>;
  archiveLicense?: Maybe<ArchiveLicensePayload>;
  archiveParentSku: ParentSku;
  archiveRetailerGroup?: Maybe<RetailerGroup>;
  archiveSalesRule?: Maybe<SalesRule>;
  associateDriversWithOnFleetIds?: Maybe<Scalars['Int']['output']>;
  bulkRequestInvoiceForFactoring?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateCustomRateProposal?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateFactoredInvoices?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateOrderDates?: Maybe<BulkUpdateOrderDatesResponse>;
  bulkUpdateOrderPricing?: Maybe<Scalars['Boolean']['output']>;
  bulkUpdateOrders?: Maybe<BulkUpdateOrdersPayload>;
  changeUserPassword?: Maybe<User>;
  completeBatchFileUpload?: Maybe<Scalars['String']['output']>;
  completeGenericFileUpload: GenericFile;
  completeGenericFileUploadLicensedLocationConfirmationUser: GenericFile;
  completeOrderFileUpload?: Maybe<Array<OrderFile>>;
  confirmDelivery?: Maybe<ConfirmDeliveryPayload>;
  confirmForm8300WithExistingUser?: Maybe<Scalars['Boolean']['output']>;
  create8300ConfirmationUrlWithoutPayment?: Maybe<Scalars['Boolean']['output']>;
  createAccountActivity?: Maybe<AccountActivity>;
  createAccountActivityPin?: Maybe<AccountActivityPin>;
  createAccountTask?: Maybe<AccountTask>;
  createAndArchiveOrderRestrictionsForMPPB: CreateAndArchiveOrderRestrictionsForMppbResponse;
  createBankAccountInfo?: Maybe<BankAccountInfo>;
  createBatch?: Maybe<Batch>;
  createBrandCreditHold?: Maybe<OrganizationRelationshipTags>;
  createBrandRetailerCreditHold?: Maybe<Array<Maybe<CreateBrandRetailerCreditHoldResponse>>>;
  createBrandRetailerCreditLimit?: Maybe<Array<Maybe<CreateBrandRetailerCreditLimitResponse>>>;
  createBrandRetailerOrderingRestrictionCodOnly?: Maybe<Array<Maybe<CreateBrandRetailerOrderingRestrictionResponse>>>;
  createBrandRetailerRestriction?: Maybe<BrandRetailerRestrictionResponse>;
  createBrandRetailerRestrictionWhitelist?: Maybe<BrandRetailerRestrictionWhitelistResponse>;
  createBrandsSaleRelationship?: Maybe<Array<Maybe<SalesOrgRelationship>>>;
  createBulkImportCsvUpload: BulkImportCsvUploadResponse;
  createBulkImportFileMapping: BulkImportFileMappingResponse;
  createBulkImportJob: BulkImportJobResponse;
  createContainerType: ContainerType;
  createCustomTag?: Maybe<CustomTag>;
  createDispute?: Maybe<OrderIssue>;
  createDraft?: Maybe<CreateDraftPayload>;
  createDriver?: Maybe<CreateDriverPayload>;
  createDriverMultiPaymentPickupConfirmations?: Maybe<CreateDriverMultiPaymentPickupConfirmationPayload>;
  createEWBMicroTransactions?: Maybe<Scalars['Boolean']['output']>;
  createEWBTransactions?: Maybe<Scalars['Boolean']['output']>;
  createEmailTemplate?: Maybe<CreateEmailTemplatePayload>;
  createEmptySkuBatch?: Maybe<SkuBatch>;
  createEnterpriseNabisRetailerCreditHold?: Maybe<Array<Maybe<CreateEnterpriseNabisRetailerCreditHoldResponse>>>;
  createEnterpriseNabisRetailerOrderingRestrictionCodOnly?: Maybe<
    Array<Maybe<CreateEnterpriseNabisRetailerOrderingRestrictionResponse>>
  >;
  createExternalPaymentConfirmation?: Maybe<Array<CreateExternalPaymentConfirmationPayload>>;
  createFeaturedBrand?: Maybe<FeaturedBrand>;
  createGlobalRetailerRestriction?: Maybe<GlobalRetailerRestrictionResponse>;
  createGlobalRetailerRestrictionWhitelist?: Maybe<GlobalRetailerRestrictionWhitelistResponse>;
  createHomeListElement: HomeListElement;
  createHours?: Maybe<Hours>;
  createInfoplusShipments?: Maybe<Scalars['Boolean']['output']>;
  createInventoryMetaCategory: InventoryMetaCategory;
  createInventoryMetaMarketingTag: InventoryMetaMarketingTag;
  createInventoryMetaTag: InventoryMetaTag;
  createInventoryMetaTagGroup: InventoryMetaTagGroup;
  createInventorySnapshot?: Maybe<Scalars['JSON']['output']>;
  createLicense?: Maybe<CreateLicensePayload>;
  createLicensedLocation?: Maybe<Scalars['ID']['output']>;
  createLicensedLocationConfirmationUser?: Maybe<LicensedLocationConfirmationUser>;
  createLicensedLocationConfirmationUserFromExistingUser?: Maybe<LicensedLocationConfirmationUser>;
  createLicensedLocationProposal?: Maybe<Scalars['ID']['output']>;
  createLineItem?: Maybe<CreateLineItemPayload>;
  createLineItemQr: LineItemWithQrQr;
  createMarketplaceParentOrder?: Maybe<CreateMarketplaceParentOrderPayload>;
  createMetrcPackage?: Maybe<Scalars['JSON']['output']>;
  createMetrcPackages?: Maybe<Scalars['JSON']['output']>;
  createMetrcTransferTemplate?: Maybe<MetrcTransfer>;
  createMetrcTransfers?: Maybe<Array<MetrcTransfer>>;
  createNabisRetailerCreditHold?: Maybe<Array<Maybe<CreateNabisRetailerCreditHoldResponse>>>;
  createNabisRetailerOrderingRestrictionCodOnly?: Maybe<Array<Maybe<CreateNabisRetailerOrderingRestrictionResponse>>>;
  createNewFee?: Maybe<Fee>;
  createNewFeeVersion?: Maybe<Fee>;
  createNonpayment?: Maybe<OrderIssue>;
  createOnboardingInvite?: Maybe<CreateOnboardingInvitePayload>;
  createOrder?: Maybe<CreateOrderPayload>;
  createOrderChange?: Maybe<Scalars['Boolean']['output']>;
  createOrderContact?: Maybe<CreateOrderContactPayload>;
  createOrderTag?: Maybe<Scalars['ID']['output']>;
  createOrganization?: Maybe<CreateOrganizationPayload>;
  createOrganizationContact: OrganizationContact;
  createOrganizationInvite?: Maybe<CreateOrganizationInvitePayload>;
  createOrganizationUser?: Maybe<CreateOrganizationUserPayload>;
  createOrganizationUserContact: OrganizationUserContact;
  createParentOrder: ParentOrder;
  createParentSku: ParentSku;
  createPaymentPickupConfirmation: PaymentPickupConfirmation;
  createPlatformAccessToken?: Maybe<PlatformAccessTokenResponse>;
  createRetailerDiscount?: Maybe<RetailerDiscount>;
  createRetailerGroup?: Maybe<CreateRetailerGroupPayload>;
  createRetailerOrganizationFromOnboardingInvite?: Maybe<Organization>;
  createRole?: Maybe<CreateRolePayload>;
  createSalesOrgRelationship?: Maybe<Array<Maybe<SalesOrgRelationship>>>;
  createSalesParentOrder?: Maybe<CreateOrderPayload>;
  createSite?: Maybe<CreateSitePayload>;
  createSku?: Maybe<CreateSkuPayload>;
  createSkuBatch?: Maybe<SkuBatch>;
  createSkuDetails?: Maybe<CreateSkuDetailsPayload>;
  createStagingArea: StagingAreaPayload;
  createStrain?: Maybe<CreateStrainReturn>;
  createTokenSendEmail?: Maybe<Scalars['String']['output']>;
  createUser?: Maybe<CreateUserPayload>;
  createUserFromOnboardingInvite?: Maybe<Scalars['String']['output']>;
  createUserLicensedLocationRelationship?: Maybe<UserLicensedLocationRelationship>;
  createVehicle?: Maybe<CreateVehiclePayload>;
  deleteAccountActivity?: Maybe<Scalars['Int']['output']>;
  deleteAccountTask?: Maybe<Scalars['Int']['output']>;
  deleteBankAccountInfo?: Maybe<Scalars['Boolean']['output']>;
  deleteBatch?: Maybe<Scalars['Boolean']['output']>;
  deleteBrandCreditHold?: Maybe<OrganizationRelationshipTags>;
  deleteBrandRetailerCreditHold?: Maybe<Array<Maybe<DeleteBrandRetailerCreditHoldResponse>>>;
  deleteBrandRetailerCreditLimit?: Maybe<Array<Maybe<DeleteBrandRetailerCreditLimitResponse>>>;
  deleteBrandRetailerOrderingRestrictionCodOnly?: Maybe<Array<Maybe<DeleteBrandRetailerOrderingRestrictionResponse>>>;
  deleteBrandRetailerRestriction?: Maybe<BrandRetailerRestrictionResponse>;
  deleteBrandRetailerRestrictionWhitelist?: Maybe<BrandRetailerRestrictionWhitelistResponse>;
  deleteCCPAUsers?: Maybe<CcpaDeletionResult>;
  deleteCart?: Maybe<Cart>;
  deleteDraft?: Maybe<DeleteDraftPayload>;
  deleteDriver?: Maybe<DeleteDriverPayload>;
  deleteEWBTransaction?: Maybe<DeleteEwbTransactionPayload>;
  deleteEnterpriseNabisRetailerCreditHold?: Maybe<Array<Maybe<DeleteEnterpriseNabisRetailerCreditHoldResponse>>>;
  deleteEnterpriseNabisRetailerOrderingRestrictionCodOnly?: Maybe<
    Array<Maybe<DeleteEnterpriseNabisRetailerOrderingRestrictionResponse>>
  >;
  deleteFeaturedBrand?: Maybe<FeaturedBrand>;
  deleteFeeOnOrder?: Maybe<DeleteOrderFeePayload>;
  deleteFutureFeeVersion?: Maybe<Scalars['Boolean']['output']>;
  deleteGlobalRetailerRestriction?: Maybe<GlobalRetailerRestrictionResponse>;
  deleteGlobalRetailerRestrictionWhitelist?: Maybe<GlobalRetailerRestrictionWhitelistResponse>;
  deleteInventoryMetaCategory: Scalars['Boolean']['output'];
  deleteInventoryMetaMarketingTag: Scalars['Boolean']['output'];
  deleteInventoryMetaTag: Scalars['Boolean']['output'];
  deleteInventoryMetaTagGroup: Scalars['Boolean']['output'];
  deleteLicense?: Maybe<DeleteLicensePayload>;
  deleteLicensedLocation?: Maybe<Scalars['Boolean']['output']>;
  deleteLicensedLocationContact?: Maybe<Scalars['Int']['output']>;
  deleteLicensedLocationProposal?: Maybe<Scalars['Boolean']['output']>;
  deleteLineItem?: Maybe<DeleteLineItemPayload>;
  deleteLineItemQr: Scalars['Boolean']['output'];
  deleteMetrcTransfer?: Maybe<MetrcTransfer>;
  deleteNabisRetailerCreditHold?: Maybe<Array<Maybe<DeleteNabisRetailerCreditHoldResponse>>>;
  deleteNabisRetailerOrderingRestrictionCodOnly?: Maybe<Array<Maybe<DeleteNabisRetailerOrderingRestrictionResponse>>>;
  deleteOnboardingInvite?: Maybe<DeleteOnboardingInvitePayload>;
  deleteOrder?: Maybe<DeleteOrderPayload>;
  deleteOrderFile?: Maybe<Scalars['Boolean']['output']>;
  deleteOrderIssue?: Maybe<OrderIssue>;
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  deleteOrganizationContact: Scalars['Boolean']['output'];
  deleteOrganizationInvite?: Maybe<DeleteOrganizationInvitePayload>;
  deleteOrganizationUser?: Maybe<DeleteOrganizationUserPayload>;
  deleteOrganizationUserContact: Scalars['Boolean']['output'];
  deleteParentOrder?: Maybe<ParentOrder>;
  deletePendingBrandRetailerRestriction?: Maybe<PendingBrandRetailerRestrictionResponse>;
  deletePendingGlobalRetailerRestriction?: Maybe<PendingGlobalRetailerRestrictionResponse>;
  deletePlatformAccessToken?: Maybe<PlatformAccessTokenResponse>;
  deleteQuickbooksInvoice?: Maybe<DeleteQuickbooksInvoicePayload>;
  deleteQuickbooksMultiInvoices?: Maybe<DeleteQuickbooksInvoicePayload>;
  deleteRetailerDiscount?: Maybe<RetailerDiscount>;
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteSalesOrgRelationship?: Maybe<SalesOrgRelationship>;
  deleteSite?: Maybe<DeleteSitePayload>;
  deleteSku?: Maybe<DeleteSkuPayload>;
  deleteSkuBatch?: Maybe<SkuBatch>;
  deleteStagingArea: Scalars['Boolean']['output'];
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteUserLicensedLocationRelationship?: Maybe<Scalars['Int']['output']>;
  deleteVehicle?: Maybe<DeleteVehiclePayload>;
  driverOrderConfirmations?: Maybe<CreateDriverConfirmationPayload>;
  driverPaymentPickupConfirmations?: Maybe<CreateDriverConfirmationPayload>;
  editBatch?: Maybe<Scalars['Boolean']['output']>;
  editZipcodes?: Maybe<Scalars['Boolean']['output']>;
  generateManifest?: Maybe<GenerateManifestPayload>;
  generateManifestForFrontend?: Maybe<GenerateManifestPayload>;
  generateManufacturerManifests?: Maybe<GenerateManifestPayload>;
  generateMarketplacePDF?: Maybe<Scalars['String']['output']>;
  generateOrderQRCode?: Maybe<GenerateOrderQrCodePayload>;
  generateQuickbooksInvoice?: Maybe<GenerateQuickbooksInvoicePayload>;
  generateQuickbooksMultiInvoices?: Maybe<GenerateQuickbooksInvoicePayload>;
  getOrderSubscriber?: Maybe<OrderSubscriber>;
  importOrderContactDetails: ImportOrderContactDetailsResponse;
  initiateBatchFileUpload?: Maybe<InitiateBatchFileUploadPayload>;
  initiateGenericFileUpload?: Maybe<InitiateUploadPayload>;
  initiateGenericFileUploadLicensedLocationConfirmationUser?: Maybe<InitiateUploadPayload>;
  initiateOrderFileUpload?: Maybe<InitiateOrderFileUploadPayload>;
  inviteToMarketplace?: Maybe<Scalars['String']['output']>;
  loginUser?: Maybe<LoginUserPayload>;
  overridePaymentStatusTimestamp?: Maybe<Scalars['Boolean']['output']>;
  overrideRetailerConfirmationStatus?: Maybe<Order>;
  populateJaneRatings: Scalars['Boolean']['output'];
  populateSkuSearchTable: Scalars['Boolean']['output'];
  postAccountingAPIApplyTransaction?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPICreateManualInvoiceForOrder?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPICreateManualInvoiceForOrg?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIDeleteInvoiceByInvoiceNumber?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIGenerateOrder?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIGenerateOutstandingAndEligibleReport?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIGenerateOutstandingBalancesReport?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIGenerateReconReport?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIRecordTransaction?: Maybe<PostAccountingApiRecordTransactionPayload>;
  postAccountingAPIRemittanceReportAcceptReject?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIRemittanceReportGeneration?: Maybe<Scalars['ID']['output']>;
  postAccountingAPIRemittanceReportSibanGeneration?: Maybe<Scalars['ID']['output']>;
  postAccountingAPIRollbackTransactionByNumber?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIUpdateAdjustmentMetaFields?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIUpdateDatesRemittanceReport?: Maybe<Scalars['Boolean']['output']>;
  postAccountingAPIUpdateTransactionMetaFields?: Maybe<Scalars['Boolean']['output']>;
  proposeLicenseDuringCheckout?: Maybe<Scalars['ID']['output']>;
  refreshMetrcItem?: Maybe<Scalars['JSON']['output']>;
  refreshMetrcPackage?: Maybe<Scalars['JSON']['output']>;
  refreshMetrcStrain?: Maybe<Scalars['JSON']['output']>;
  refreshToken?: Maybe<RefreshTokenPayload>;
  rejectDelivery?: Maybe<RejectDeliveryPayload>;
  removeAccountActivityPin?: Maybe<Scalars['Boolean']['output']>;
  removeRetailersFromRetailerGroups: Scalars['Boolean']['output'];
  reorderSecondaryImages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resetPassword?: Maybe<LoginUserPayload>;
  resolveDispute?: Maybe<OrderIssue>;
  restoreBatch?: Maybe<Batch>;
  restoreParentSku: ParentSku;
  restoreRetailerGroup?: Maybe<RestoreRetailerGroupPayload>;
  restoreSku?: Maybe<Sku>;
  restoreSkuBatch?: Maybe<SkuBatch>;
  retailerPricingCreateSalesRule: RetailerPricingSalesRuleIdResponse;
  retailerPricingDeleteSalesRule: RetailerPricingSalesRuleIdResponse;
  retailerPricingUpdateSalesRule: RetailerPricingSalesRuleIdResponse;
  retailerPricingUpdateSalesRules: Array<RetailerPricingSalesRuleIdResponse>;
  retailerPricingUpsertRetailerSettings: RetailerPricingRetailerGetSettingsResponse;
  runAsyncTask?: Maybe<AsyncTaskWithOrderResult>;
  scheduleReorderEmail?: Maybe<Order>;
  sendMarketplaceParentOrderUpdateEmailOnCreate?: Maybe<Scalars['Boolean']['output']>;
  sendOrderUpdateEmailOnCreate?: Maybe<Scalars['Boolean']['output']>;
  sendRequestedPaymentEmail?: Maybe<Scalars['Boolean']['output']>;
  sendRetailerEmail?: Maybe<SendRetailerEmailPayload>;
  sendSendGridStatusUpdateEmail?: Maybe<SendSendGridStatusUpdateEmailPayload>;
  sendSkuOutOfStockNotification?: Maybe<Sku>;
  setUserAsOwner?: Maybe<Scalars['Boolean']['output']>;
  skipAsyncTask?: Maybe<AsyncTaskWithOrderResult>;
  submitShipments?: Maybe<Scalars['Boolean']['output']>;
  subscribeToBrandSkuBatchExpiration: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuInStock: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuOutOfStock: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuStockDecrease: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuStockIncrease: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuBatchExpiration: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuInStock: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuOutOfStock: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuStockDecrease: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuStockIncrease: Array<StockSubscriptionMutationResponse>;
  swapFeaturedBrandPriorities: SwapFeaturedBrandPrioritiesPayload;
  swapHomeListElementPriorities: SwapHomeListElementPrioritiesResult;
  swapOnfleetId?: Maybe<Scalars['Boolean']['output']>;
  syncMetrcItems?: Maybe<Scalars['JSON']['output']>;
  syncMetrcPackages?: Maybe<Scalars['JSON']['output']>;
  syncMetrcSkuBatchItems?: Maybe<Scalars['JSON']['output']>;
  testInventoryValues?: Maybe<Scalars['JSON']['output']>;
  toggleArchiveFee?: Maybe<Scalars['Boolean']['output']>;
  toggleCreditHoldForLicensedLocation?: Maybe<Scalars['Boolean']['output']>;
  unarchiveLicense?: Maybe<UnarchiveLicensePayload>;
  unarchiveLicensedLocation?: Maybe<Scalars['Boolean']['output']>;
  unsubscribeFromBrand: Scalars['Boolean']['output'];
  unsubscribeFromSku: Scalars['Boolean']['output'];
  updateAccountActivity?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updateAccountTask?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updateAndGetAPSummary?: Maybe<Scalars['String']['output']>;
  updateAutoRegenerateInvoices?: Maybe<Scalars['Boolean']['output']>;
  updateBankAccountInfo?: Maybe<BankAccountInfo>;
  updateBrandFeesCollection?: Maybe<Scalars['Boolean']['output']>;
  updateBulkShipments?: Maybe<Scalars['Boolean']['output']>;
  updateCart?: Maybe<Cart>;
  updateCartItems?: Maybe<Cart>;
  updateDateRule?: Maybe<DateRule>;
  updateDraft?: Maybe<UpdateDraftPayload>;
  updateDriver?: Maybe<UpdateDriverPayload>;
  updateDriverAppSubmission?: Maybe<Scalars['String']['output']>;
  updateEWBTransactions?: Maybe<Scalars['Boolean']['output']>;
  updateEmailTemplate?: Maybe<Scalars['Boolean']['output']>;
  updateExternalPaymentCollection?: Maybe<Scalars['Boolean']['output']>;
  updateFeaturedBrand?: Maybe<FeaturedBrand>;
  updateFulfillabilityFromInfoplus?: Maybe<UpdateFulfillabilityFromInfoplusPayload>;
  updateFutureFeeVersion?: Maybe<Fee>;
  updateHomeListElement: HomeListElement;
  updateHours?: Maybe<Scalars['Boolean']['output']>;
  updateInfoplusOrderStagingAreaCustomFieldsRepair?: Maybe<UpdateInfoplusOrderStagingAreaCustomFieldRepairPayload>;
  updateInventoryMetaCategory: Scalars['Boolean']['output'];
  updateInventoryMetaMarketingTag: Scalars['Boolean']['output'];
  updateInventoryMetaTag: Scalars['Boolean']['output'];
  updateInventoryMetaTagGroup: Scalars['Boolean']['output'];
  updateLegalInfo?: Maybe<Scalars['Boolean']['output']>;
  updateLicense?: Maybe<UpdateLicensePayload>;
  updateLicensedLocation?: Maybe<Scalars['Boolean']['output']>;
  updateLicensedLocationFromOnboardingInvite?: Maybe<Scalars['Boolean']['output']>;
  updateLicensedLocationProposal?: Maybe<Scalars['Boolean']['output']>;
  updateLineItem?: Maybe<UpdateLineItemPayload>;
  updateMetrcManifestId?: Maybe<Scalars['Boolean']['output']>;
  updateMetrcOrderStatus?: Maybe<Scalars['Boolean']['output']>;
  updateMetrcSkuBatch?: Maybe<Scalars['JSON']['output']>;
  updateMetrcTransfer?: Maybe<MetrcTransfer>;
  updateMetrcWarehouseId?: Maybe<UpdateMetrcWarehouseIdPayload>;
  updateMultipleFirstShipments?: Maybe<UpdateMultipleFirstShipmentsResponse>;
  updateNonpayment?: Maybe<OrderIssue>;
  updateOnboardingInvite?: Maybe<CreateOnboardingInvitePayload>;
  updateOnboardingRoute?: Maybe<OnboardingRoute>;
  updateOrder?: Maybe<UpdateOrderPayload>;
  updateOrderFile?: Maybe<OrderFile>;
  updateOrderLockdown?: Maybe<Scalars['Boolean']['output']>;
  updateOrderRequestPaymentTerms?: Maybe<Scalars['Boolean']['output']>;
  updateOrderSyncWithInfoplus?: Maybe<Scalars['Boolean']['output']>;
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  updateOrganizationInvite?: Maybe<UpdateOrganizationInvitePayload>;
  updateOrganizationUser?: Maybe<UpdateOrganizationUserPayload>;
  updatePaymentPermissions?: Maybe<PaymentPermissionsPayload>;
  updateRetailerDiscount?: Maybe<RetailerDiscount>;
  updateRetailerGroup?: Maybe<UpdateRetailerGroupPayload>;
  updateRole?: Maybe<UpdateRolePayload>;
  updateSingleShipment?: Maybe<Scalars['Boolean']['output']>;
  updateSite?: Maybe<UpdateSitePayload>;
  updateSku?: Maybe<UpdateSkuPayload>;
  updateSkuBatch?: Maybe<Scalars['Boolean']['output']>;
  updateSkuBatchTitleholder?: Maybe<SkuBatch>;
  updateSkuDetails?: Maybe<UpdateSkuDetailsPayload>;
  updateSkuSalesRulePricePerUnit?: Maybe<SalesRule>;
  updateStagingArea: Scalars['Boolean']['output'];
  updateTagSequences?: Maybe<Scalars['JSON']['output']>;
  updateTerritory?: Maybe<Territory>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserLicensedLocationRelationship?: Maybe<UserLicensedLocationRelationship>;
  updateUserPreference?: Maybe<UserPreference>;
  updateVehicle?: Maybe<UpdateVehiclePayload>;
  uploadBatchFile?: Maybe<Scalars['String']['output']>;
  uploadGenericOrderFiles?: Maybe<UploadGenericOrderFilesPayload>;
  uploadOrganizationAssets?: Maybe<Scalars['String']['output']>;
  uploadSecondaryImage?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uploadSellerPermit?: Maybe<Scalars['String']['output']>;
  uploadSellerPermitOrderConfirmation?: Maybe<Scalars['String']['output']>;
  uploadSkuImage?: Maybe<Scalars['String']['output']>;
  uploadToOnfleet?: Maybe<UploadToOnfleetPayload>;
  uploadW9Form?: Maybe<Scalars['String']['output']>;
  uploadW9FormOrderConfirmation?: Maybe<Scalars['String']['output']>;
  upsertFeesOnOrder?: Maybe<UpsertOrderFeePayload>;
  upsertLicensedLocationContact?: Maybe<Array<Maybe<LicensedLocationContact>>>;
  validateToken?: Maybe<LoginUserPayload>;
  verifyEWBMicroTransactions?: Maybe<Scalars['Boolean']['output']>;
};

export type MutationAcceptOnboardingInviteExistingUserArgs = {
  onboardingInviteId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationActivatePendingBrandRetailerRestrictionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationActivatePendingGlobalRetailerRestrictionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAddItemsToCartArgs = {
  draftId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationAddLicenseToManufacturerOrganizationArgs = {
  brandOrgId: Scalars['ID']['input'];
  licenseId: Scalars['ID']['input'];
  manufacturerOrgId: Scalars['ID']['input'];
};

export type MutationAllAccountsAddToRetailerGroupArgs = {
  licensedLocationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  retailerGroupId: Scalars['ID']['input'];
};

export type MutationAllAccountsDownloadCsvArgs = {
  filters?: InputMaybe<AccountFiltersInput>;
  organizationId: Scalars['ID']['input'];
};

export type MutationAllAccountsRemoveFromRetailerGroupArgs = {
  licensedLocationIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationArchiveEmailTemplateArgs = {
  emailTemplateId: Scalars['ID']['input'];
};

export type MutationArchiveLicenseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationArchiveParentSkuArgs = {
  parentSkuId: Scalars['ID']['input'];
};

export type MutationArchiveRetailerGroupArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationArchiveSalesRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationBulkRequestInvoiceForFactoringArgs = {
  input: BulkRequestFactorInvoiceInput;
};

export type MutationBulkUpdateCustomRateProposalArgs = {
  input?: InputMaybe<BulkUpdateCustomRateProposalInput>;
};

export type MutationBulkUpdateFactoredInvoicesArgs = {
  input?: InputMaybe<BulkUpdateFactorInvoiceInput>;
};

export type MutationBulkUpdateOrderDatesArgs = {
  input: BulkUpdateOrderDatesPayload;
};

export type MutationBulkUpdateOrderPricingArgs = {
  input?: InputMaybe<BulkUpdatePricingInput>;
};

export type MutationBulkUpdateOrdersArgs = {
  input: BulkUpdateOrdersInput;
};

export type MutationChangeUserPasswordArgs = {
  confirmPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationCompleteBatchFileUploadArgs = {
  input: CompleteBatchFileUploadInput;
};

export type MutationCompleteGenericFileUploadArgs = {
  fileKey: Scalars['String']['input'];
  filePurpose: Scalars['String']['input'];
  isMultipart: Scalars['Boolean']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<UploadPart>>;
  paymentPickupConfirmationId: Scalars['ID']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteGenericFileUploadLicensedLocationConfirmationUserArgs = {
  fileKey: Scalars['String']['input'];
  filePurpose: Scalars['String']['input'];
  isMultipart: Scalars['Boolean']['input'];
  licensedLocationConfirmationUserId: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<UploadPart>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteOrderFileUploadArgs = {
  fileKey: Scalars['String']['input'];
  isMultipart: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  orderNumbers: Array<Scalars['Int']['input']>;
  parts?: InputMaybe<Array<UploadPart>>;
  s3Link?: InputMaybe<Scalars['String']['input']>;
  type: OrderFileType;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationConfirmDeliveryArgs = {
  input: ConfirmDeliveryInput;
};

export type MutationConfirmForm8300WithExistingUserArgs = {
  licensedLocationConfirmationUserId: Scalars['ID']['input'];
  paymentPickupConfirmationId: Scalars['ID']['input'];
};

export type MutationCreate8300ConfirmationUrlWithoutPaymentArgs = {
  input: CreateForm8300UrlWithoutPayment;
};

export type MutationCreateAccountActivityArgs = {
  input: CreateAccountActivityInput;
};

export type MutationCreateAccountActivityPinArgs = {
  input: CreateAccountActivityPinInput;
};

export type MutationCreateAccountTaskArgs = {
  input: CreateAccountTaskInput;
};

export type MutationCreateAndArchiveOrderRestrictionsForMppbArgs = {
  input: CreateAndArchiveOrderRestrictionsForMppbInput;
};

export type MutationCreateBankAccountInfoArgs = {
  input?: InputMaybe<CreateBankAccountInfoInput>;
};

export type MutationCreateBatchArgs = {
  input: CreateBatchInput;
};

export type MutationCreateBrandCreditHoldArgs = {
  brandOrganizationId: Scalars['ID']['input'];
  retailerOrganizationId: Scalars['ID']['input'];
};

export type MutationCreateBrandRetailerCreditHoldArgs = {
  input?: InputMaybe<Array<InputMaybe<MutationBrandRetailerCreditHoldInput>>>;
  organizationId: Scalars['String']['input'];
};

export type MutationCreateBrandRetailerCreditLimitArgs = {
  creditLimit: Scalars['Int']['input'];
  input?: InputMaybe<Array<InputMaybe<BrandRetailerCreditLimitInput>>>;
  organizationId: Scalars['String']['input'];
};

export type MutationCreateBrandRetailerOrderingRestrictionCodOnlyArgs = {
  input?: InputMaybe<Array<InputMaybe<BrandRetailerOrderingRestrictionInput>>>;
  organizationId: Scalars['String']['input'];
};

export type MutationCreateBrandRetailerRestrictionArgs = {
  brandId: Scalars['ID']['input'];
  retailerId: Scalars['ID']['input'];
};

export type MutationCreateBrandRetailerRestrictionWhitelistArgs = {
  brandId: Scalars['ID']['input'];
};

export type MutationCreateBrandsSaleRelationshipArgs = {
  input: CreateBrandsSaleRelationshipInput;
};

export type MutationCreateBulkImportCsvUploadArgs = {
  input: CreateBulkImportCsvUploadInput;
};

export type MutationCreateBulkImportFileMappingArgs = {
  input: CreateBulkImportFileMappingInput;
};

export type MutationCreateBulkImportJobArgs = {
  input: CreateBulkImportJobInput;
};

export type MutationCreateContainerTypeArgs = {
  name: Scalars['String']['input'];
};

export type MutationCreateCustomTagArgs = {
  addToId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: CustomTagTypeEnum;
};

export type MutationCreateDisputeArgs = {
  initiatedNotes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  reason: OrderIssueReason;
};

export type MutationCreateDraftArgs = {
  input: CreateDraftInput;
};

export type MutationCreateDriverArgs = {
  input: CreateDriverInput;
};

export type MutationCreateDriverMultiPaymentPickupConfirmationsArgs = {
  input: CreateDriverMultiPaymentPickupConfirmationsInput;
};

export type MutationCreateEwbMicroTransactionsArgs = {
  input?: InputMaybe<CreateEwbMicroTransactionsInput>;
};

export type MutationCreateEwbTransactionsArgs = {
  input?: InputMaybe<CreateEwbTransactionsInput>;
};

export type MutationCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};

export type MutationCreateEmptySkuBatchArgs = {
  skuId: Scalars['ID']['input'];
};

export type MutationCreateEnterpriseNabisRetailerCreditHoldArgs = {
  input?: InputMaybe<Array<InputMaybe<EnterpriseNabisRetailerCreditHoldInput>>>;
};

export type MutationCreateEnterpriseNabisRetailerOrderingRestrictionCodOnlyArgs = {
  input?: InputMaybe<Array<InputMaybe<EnterpriseNabisRetailerOrderingRestrictionInput>>>;
};

export type MutationCreateExternalPaymentConfirmationArgs = {
  input: Array<CreateExternalPaymentConfirmationInput>;
};

export type MutationCreateFeaturedBrandArgs = {
  endDate: Scalars['DateTime']['input'];
  feesCharged?: InputMaybe<Scalars['Float']['input']>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sku1Id?: InputMaybe<Scalars['ID']['input']>;
  sku2Id?: InputMaybe<Scalars['ID']['input']>;
  squareBannerImageFile?: InputMaybe<Scalars['Upload']['input']>;
  squareBannerImageS3Link?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  wideBannerImageFile?: InputMaybe<Scalars['Upload']['input']>;
  wideBannerImageS3Link?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateGlobalRetailerRestrictionArgs = {
  retailerId: Scalars['ID']['input'];
};

export type MutationCreateGlobalRetailerRestrictionWhitelistArgs = {
  retailerId: Scalars['ID']['input'];
};

export type MutationCreateHomeListElementArgs = {
  input?: InputMaybe<CreateHomeListElementInput>;
};

export type MutationCreateHoursArgs = {
  field: Scalars['String']['input'];
  input: CreateHoursInput;
};

export type MutationCreateInfoplusShipmentsArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationCreateInventoryMetaCategoryArgs = {
  inventoryClass: InventoryClassEnum;
  name: Scalars['String']['input'];
};

export type MutationCreateInventoryMetaMarketingTagArgs = {
  name: Scalars['String']['input'];
};

export type MutationCreateInventoryMetaTagArgs = {
  inventoryTagGroupId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type MutationCreateInventoryMetaTagGroupArgs = {
  inventoryCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inventoryClasses?: InputMaybe<Array<InputMaybe<InventoryClassEnum>>>;
  name: Scalars['String']['input'];
};

export type MutationCreateInventorySnapshotArgs = {
  input: CreateInventorySnapshotInput;
};

export type MutationCreateLicenseArgs = {
  input: CreateLicenseInput;
};

export type MutationCreateLicensedLocationArgs = {
  input: CreateLicensedLocationInput;
};

export type MutationCreateLicensedLocationConfirmationUserArgs = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  dateOfBirth: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  idType: IdTypesEnum;
  issuedBy: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  licensedLocationConfirmationUserId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  middleInitial: Scalars['String']['input'];
  noTin: Scalars['Boolean']['input'];
  occupation: Scalars['String']['input'];
  paymentPickupConfirmationId?: InputMaybe<Scalars['ID']['input']>;
  retailerPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  state: Scalars['String']['input'];
  taxpayerIdentificationNumber: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type MutationCreateLicensedLocationConfirmationUserFromExistingUserArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<IdTypesEnum>;
  issuedBy?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licensedLocationConfirmationUserId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  noTin: Scalars['Boolean']['input'];
  occupation?: InputMaybe<Scalars['String']['input']>;
  paymentPickupConfirmationId?: InputMaybe<Scalars['ID']['input']>;
  retailerPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxpayerIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateLicensedLocationProposalArgs = {
  input: CreateLicensedLocationProposalInput;
};

export type MutationCreateLineItemArgs = {
  input: CreateLineItemInput;
};

export type MutationCreateLineItemQrArgs = {
  lineItemId: Scalars['ID']['input'];
  qr: Scalars['String']['input'];
};

export type MutationCreateMarketplaceParentOrderArgs = {
  input: CreateMarketplaceParentOrderInput;
  licensedLocationId: Scalars['ID']['input'];
};

export type MutationCreateMetrcPackageArgs = {
  licenseNumber: Scalars['String']['input'];
  lineItem: Scalars['JSON']['input'];
};

export type MutationCreateMetrcPackagesArgs = {
  licenseNumber: Scalars['String']['input'];
  lineItems?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type MutationCreateMetrcTransferTemplateArgs = {
  metrcTransferId: Scalars['ID']['input'];
};

export type MutationCreateMetrcTransfersArgs = {
  input: Array<CreateMetrcTransferInput>;
};

export type MutationCreateNabisRetailerCreditHoldArgs = {
  input?: InputMaybe<Array<InputMaybe<MutationNabisRetailerCreditHoldInput>>>;
};

export type MutationCreateNabisRetailerOrderingRestrictionCodOnlyArgs = {
  input?: InputMaybe<Array<InputMaybe<NabisRetailerOrderingRestrictionInput>>>;
};

export type MutationCreateNewFeeArgs = {
  basePrice: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type MutationCreateNewFeeVersionArgs = {
  basePrice: Scalars['Float']['input'];
  groupTag: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type MutationCreateNonpaymentArgs = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  initiatedNotes?: InputMaybe<Scalars['String']['input']>;
  issueType: OrderIssueType;
  orderId: Scalars['ID']['input'];
  reason: OrderIssueReason;
};

export type MutationCreateOnboardingInviteArgs = {
  input: CreateOnboardingInviteInput;
};

export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};

export type MutationCreateOrderChangeArgs = {
  description: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  submitterId: Scalars['ID']['input'];
};

export type MutationCreateOrderContactArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderIds: Array<Scalars['ID']['input']>;
};

export type MutationCreateOrderTagArgs = {
  orderId: Scalars['ID']['input'];
  tagType: OrderTagType;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationContactArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationContactTypeId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateOrganizationInviteArgs = {
  input: CreateOrganizationInviteInput;
};

export type MutationCreateOrganizationUserArgs = {
  input: CreateOrganizationUserInput;
};

export type MutationCreateOrganizationUserContactArgs = {
  organizationContactTypeId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationCreateParentOrderArgs = {
  discount?: InputMaybe<Scalars['Float']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateParentSkuArgs = {
  name: Scalars['String']['input'];
};

export type MutationCreatePaymentPickupConfirmationArgs = {
  licensedLocationId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  paymentAmount: Scalars['Float']['input'];
  paymentMethod?: InputMaybe<PaymentMethodDriverEnum>;
  paymentStatus: PaymentStatusDriverEnum;
  type: PaymentPickupConfirmationEnum;
};

export type MutationCreatePlatformAccessTokenArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateRetailerDiscountArgs = {
  allProducts: Scalars['Boolean']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  discountType: RetailerDiscountType;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatDiscount?: InputMaybe<Scalars['Float']['input']>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  maxCodeRedemptions?: InputMaybe<Scalars['Int']['input']>;
  minBrandCount?: InputMaybe<Scalars['Int']['input']>;
  minBrandOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['DateTime']['input'];
  tiers?: InputMaybe<Array<DiscountTierInput>>;
};

export type MutationCreateRetailerGroupArgs = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  canRequestAdditionalNetTerms: Scalars['Boolean']['input'];
  defaultDaysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  isHardMinCap?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace: Scalars['Boolean']['input'];
  isPaymentTermsBasedOnCreditRating: Scalars['Boolean']['input'];
  isSampleAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemoOrdersAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  maxAvailableInventory?: InputMaybe<Scalars['Float']['input']>;
  maxDaysTillPaymentDueForExcellent?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForFair?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForGood?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForPoor?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForWeak?: InputMaybe<Scalars['Int']['input']>;
  maxSamplesPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minOrderBalance?: InputMaybe<Scalars['Float']['input']>;
  mustPayPreviousBalance: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  retailerGroupLicensedLocations: Array<RetailerGroupLicensedLocationInput>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateRetailerOrganizationFromOnboardingInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

export type MutationCreateSalesOrgRelationshipArgs = {
  input: CreateSalesOrgRelationshipInput;
};

export type MutationCreateSalesParentOrderArgs = {
  input: CreateSalesOrderInput;
};

export type MutationCreateSiteArgs = {
  input: CreateSiteInput;
};

export type MutationCreateSkuArgs = {
  input: CreateSkuInput;
};

export type MutationCreateSkuBatchArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  skuId: Scalars['ID']['input'];
  titleholderId: Scalars['ID']['input'];
};

export type MutationCreateSkuDetailsArgs = {
  input: CreateSkuDetailsInput;
};

export type MutationCreateStagingAreaArgs = {
  name: Scalars['String']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type MutationCreateStrainArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateTokenSendEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateUserFromOnboardingInviteArgs = {
  input: CreateUserFromOnboardingInviteInput;
};

export type MutationCreateUserLicensedLocationRelationshipArgs = {
  input: CreateUserLicensedLocationRelationship;
};

export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};

export type MutationDeleteAccountActivityArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAccountTaskArgs = {
  input: DeleteAccountTaskInput;
};

export type MutationDeleteBankAccountInfoArgs = {
  input?: InputMaybe<DeleteBankAccountInfoInput>;
};

export type MutationDeleteBatchArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBrandCreditHoldArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBrandRetailerCreditHoldArgs = {
  input?: InputMaybe<Array<InputMaybe<MutationBrandRetailerCreditHoldInput>>>;
  organizationId: Scalars['String']['input'];
};

export type MutationDeleteBrandRetailerCreditLimitArgs = {
  input?: InputMaybe<Array<InputMaybe<BrandRetailerCreditLimitInput>>>;
  organizationId: Scalars['String']['input'];
};

export type MutationDeleteBrandRetailerOrderingRestrictionCodOnlyArgs = {
  input?: InputMaybe<Array<InputMaybe<BrandRetailerOrderingRestrictionInput>>>;
  organizationId: Scalars['String']['input'];
};

export type MutationDeleteBrandRetailerRestrictionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteBrandRetailerRestrictionWhitelistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCcpaUsersArgs = {
  dateOfBirth: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type MutationDeleteCartArgs = {
  id: Scalars['ID']['input'];
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteDraftArgs = {
  input: DeleteDraftInput;
};

export type MutationDeleteDriverArgs = {
  input: DeleteDriverInput;
};

export type MutationDeleteEwbTransactionArgs = {
  input?: InputMaybe<DeleteEwbTransactionInput>;
};

export type MutationDeleteEnterpriseNabisRetailerCreditHoldArgs = {
  input?: InputMaybe<Array<InputMaybe<EnterpriseNabisRetailerCreditHoldInput>>>;
};

export type MutationDeleteEnterpriseNabisRetailerOrderingRestrictionCodOnlyArgs = {
  input?: InputMaybe<Array<InputMaybe<EnterpriseNabisRetailerOrderingRestrictionInput>>>;
};

export type MutationDeleteFeaturedBrandArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFeeOnOrderArgs = {
  input?: InputMaybe<DeleteOrderFeeInput>;
};

export type MutationDeleteFutureFeeVersionArgs = {
  feeId: Scalars['ID']['input'];
};

export type MutationDeleteGlobalRetailerRestrictionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteGlobalRetailerRestrictionWhitelistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInventoryMetaCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInventoryMetaMarketingTagArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInventoryMetaTagArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInventoryMetaTagGroupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLicenseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLicensedLocationArgs = {
  input: DeleteLicensedLocationInput;
};

export type MutationDeleteLicensedLocationContactArgs = {
  input: DeleteLicensedLocationContactInput;
};

export type MutationDeleteLicensedLocationProposalArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLineItemArgs = {
  input: DeleteLineItemInput;
};

export type MutationDeleteLineItemQrArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMetrcTransferArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteNabisRetailerCreditHoldArgs = {
  input?: InputMaybe<Array<InputMaybe<MutationNabisRetailerCreditHoldInput>>>;
};

export type MutationDeleteNabisRetailerOrderingRestrictionCodOnlyArgs = {
  input?: InputMaybe<Array<InputMaybe<NabisRetailerOrderingRestrictionInput>>>;
};

export type MutationDeleteOnboardingInviteArgs = {
  input: DeleteOnboardingInviteInput;
};

export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};

export type MutationDeleteOrderFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOrderIssueArgs = {
  orderIssueId: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};

export type MutationDeleteOrganizationContactArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteOrganizationInviteArgs = {
  input: DeleteOrganizationInviteInput;
};

export type MutationDeleteOrganizationUserArgs = {
  input: DeleteOrganizationUserInput;
};

export type MutationDeleteOrganizationUserContactArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteParentOrderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePendingBrandRetailerRestrictionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePendingGlobalRetailerRestrictionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePlatformAccessTokenArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteQuickbooksInvoiceArgs = {
  input?: InputMaybe<DeleteQuickbooksInvoiceInput>;
};

export type MutationDeleteQuickbooksMultiInvoicesArgs = {
  input?: InputMaybe<DeleteQuickbooksInvoiceInput>;
};

export type MutationDeleteRetailerDiscountArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};

export type MutationDeleteSalesOrgRelationshipArgs = {
  input: DeleteSalesOrgRelationshipInput;
};

export type MutationDeleteSiteArgs = {
  input: DeleteSiteInput;
};

export type MutationDeleteSkuArgs = {
  input: DeleteSkuInput;
};

export type MutationDeleteSkuBatchArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteStagingAreaArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};

export type MutationDeleteUserLicensedLocationRelationshipArgs = {
  input: DeleteUserLicensedLocationRelationshipInput;
};

export type MutationDeleteVehicleArgs = {
  input: DeleteVehicleInput;
};

export type MutationDriverOrderConfirmationsArgs = {
  input: Array<DriverOrderConfirmation>;
};

export type MutationDriverPaymentPickupConfirmationsArgs = {
  input: Array<DriverPaymentPickupConfirmation>;
};

export type MutationEditBatchArgs = {
  input: UpdateBatchInput;
};

export type MutationEditZipcodesArgs = {
  input: Array<EditZipcodesInput>;
};

export type MutationGenerateManifestArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationGenerateManifestForFrontendArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationGenerateManufacturerManifestsArgs = {
  manufacturerLicenseIds: Array<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};

export type MutationGenerateMarketplacePdfArgs = {
  skuId: Scalars['ID']['input'];
};

export type MutationGenerateOrderQrCodeArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationGenerateQuickbooksInvoiceArgs = {
  input?: InputMaybe<GenerateQuickbooksInvoiceInput>;
};

export type MutationGenerateQuickbooksMultiInvoicesArgs = {
  input?: InputMaybe<GenerateQuickbooksInvoiceInput>;
};

export type MutationGetOrderSubscriberArgs = {
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationImportOrderContactDetailsArgs = {
  remotePath: Scalars['String']['input'];
};

export type MutationInitiateBatchFileUploadArgs = {
  input: InitiateBatchFileUploadInput;
};

export type MutationInitiateGenericFileUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  paymentPickupConfirmationId: Scalars['ID']['input'];
};

export type MutationInitiateGenericFileUploadLicensedLocationConfirmationUserArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  licensedLocationConfirmationUserId: Scalars['ID']['input'];
};

export type MutationInitiateOrderFileUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  orderNumbers: Array<Scalars['Int']['input']>;
};

export type MutationInviteToMarketplaceArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  locationValidation?: InputMaybe<Scalars['String']['input']>;
};

export type MutationLoginUserArgs = {
  input: LoginUserInput;
};

export type MutationOverridePaymentStatusTimestampArgs = {
  orderId: Scalars['ID']['input'];
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentSentAt?: InputMaybe<Scalars['String']['input']>;
  processingAt?: InputMaybe<Scalars['String']['input']>;
  remittedAt?: InputMaybe<Scalars['String']['input']>;
};

export type MutationOverrideRetailerConfirmationStatusArgs = {
  orderId: Scalars['ID']['input'];
  retailerConfirmationStatus: Scalars['String']['input'];
};

export type MutationPostAccountingApiApplyTransactionArgs = {
  input?: InputMaybe<PostAccountingApiApplyTransactionInput>;
};

export type MutationPostAccountingApiCreateManualInvoiceForOrderArgs = {
  input?: InputMaybe<PostAccountingApiCreateManualInvoiceForOrderInput>;
};

export type MutationPostAccountingApiCreateManualInvoiceForOrgArgs = {
  input?: InputMaybe<PostAccountingApiCreateManualInvoiceForOrgInput>;
};

export type MutationPostAccountingApiDeleteInvoiceByInvoiceNumberArgs = {
  input?: InputMaybe<PostAccountingApiDeleteInvoiceByInvoiceNumberInput>;
};

export type MutationPostAccountingApiGenerateOrderArgs = {
  input?: InputMaybe<PostAccountingApiGenerateOrderInput>;
};

export type MutationPostAccountingApiGenerateOutstandingAndEligibleReportArgs = {
  input?: InputMaybe<PostAccountingApiGenerateOutstandingAndEligibleInput>;
};

export type MutationPostAccountingApiGenerateOutstandingBalancesReportArgs = {
  input?: InputMaybe<PostAccountingApiGenerateOutstandingBalancesReportInput>;
};

export type MutationPostAccountingApiGenerateReconReportArgs = {
  input?: InputMaybe<PostAccountingApiGenerateReconReportInput>;
};

export type MutationPostAccountingApiRecordTransactionArgs = {
  input?: InputMaybe<PostAccountingApiRecordTransactionInput>;
};

export type MutationPostAccountingApiRemittanceReportAcceptRejectArgs = {
  input?: InputMaybe<PostAccountingApiRemittanceReportAcceptRejectInput>;
};

export type MutationPostAccountingApiRemittanceReportGenerationArgs = {
  input?: InputMaybe<PostAccountingApiRemittanceReportGenerationInput>;
};

export type MutationPostAccountingApiRemittanceReportSibanGenerationArgs = {
  input?: InputMaybe<PostAccountingApiRemittanceReportSibanGenerationInput>;
};

export type MutationPostAccountingApiRollbackTransactionByNumberArgs = {
  input?: InputMaybe<PostAccountingApiRollbackTransactionByNumberInput>;
};

export type MutationPostAccountingApiUpdateAdjustmentMetaFieldsArgs = {
  input?: InputMaybe<PostAccountingApiUpdateAdjustmentMetaFieldsInput>;
};

export type MutationPostAccountingApiUpdateDatesRemittanceReportArgs = {
  input?: InputMaybe<PostAccountingApiUpdateDatesRemittanceReportInput>;
};

export type MutationPostAccountingApiUpdateTransactionMetaFieldsArgs = {
  input?: InputMaybe<PostAccountingApiUpdateTransactionMetaFieldsInput>;
};

export type MutationProposeLicenseDuringCheckoutArgs = {
  license: CreateLicenseInput;
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationRefreshMetrcItemArgs = {
  licenseNumber: Scalars['String']['input'];
  metrcId: Scalars['Int']['input'];
};

export type MutationRefreshMetrcPackageArgs = {
  licenseNumber: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export type MutationRefreshMetrcStrainArgs = {
  licenseNumber: Scalars['String']['input'];
  metrcId: Scalars['Int']['input'];
};

export type MutationRefreshTokenArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type MutationRejectDeliveryArgs = {
  input: RejectDeliveryInput;
};

export type MutationRemoveAccountActivityPinArgs = {
  input: RemoveAccountActivityPinInput;
};

export type MutationRemoveRetailersFromRetailerGroupsArgs = {
  organizationId: Scalars['ID']['input'];
  retailerGroupLicensedLocationIds: Array<Scalars['ID']['input']>;
};

export type MutationReorderSecondaryImagesArgs = {
  order: Array<InputMaybe<Scalars['String']['input']>>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationResolveDisputeArgs = {
  orderIssueId: Scalars['ID']['input'];
  resolvedNotes: Scalars['String']['input'];
};

export type MutationRestoreBatchArgs = {
  batchId: Scalars['ID']['input'];
};

export type MutationRestoreParentSkuArgs = {
  parentSkuId: Scalars['ID']['input'];
};

export type MutationRestoreRetailerGroupArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationRestoreSkuArgs = {
  skuId: Scalars['ID']['input'];
};

export type MutationRestoreSkuBatchArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRetailerPricingCreateSalesRuleArgs = {
  brandId: Scalars['String']['input'];
  salesRule: RetailerPricingSalesRuleCreateInput;
};

export type MutationRetailerPricingDeleteSalesRuleArgs = {
  brandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationRetailerPricingUpdateSalesRuleArgs = {
  brandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  salesRule: RetailerPricingSalesRuleUpdateInput;
};

export type MutationRetailerPricingUpdateSalesRulesArgs = {
  brandId: Scalars['String']['input'];
  salesRules: Array<RetailerPricingSalesRuleUpdateInput>;
};

export type MutationRetailerPricingUpsertRetailerSettingsArgs = {
  brandId: Scalars['String']['input'];
  retailerSettings: Array<RetailerPricingUpsertRetailerSettingsInput>;
};

export type MutationRunAsyncTaskArgs = {
  input: RunAsyncTaskInput;
};

export type MutationScheduleReorderEmailArgs = {
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  reorderEmailDate: Scalars['DateTime']['input'];
};

export type MutationSendMarketplaceParentOrderUpdateEmailOnCreateArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationSendOrderUpdateEmailOnCreateArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationSendRequestedPaymentEmailArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationSendRetailerEmailArgs = {
  input: SendRetailerEmailInput;
};

export type MutationSendSendGridStatusUpdateEmailArgs = {
  input: SendSendGridStatusUpdateInput;
};

export type MutationSendSkuOutOfStockNotificationArgs = {
  licensedLocationId: Scalars['ID']['input'];
  referralEmail?: InputMaybe<Scalars['String']['input']>;
  skuId: Scalars['ID']['input'];
};

export type MutationSetUserAsOwnerArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSkipAsyncTaskArgs = {
  input: SkipAsyncTaskInput;
};

export type MutationSubmitShipmentsArgs = {
  allShipments: Array<ShipmentInput>;
  lastLoadTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MutationSubscribeToBrandSkuBatchExpirationArgs = {
  brandId: Scalars['ID']['input'];
  hoursBeforeExpiration: Scalars['Int']['input'];
};

export type MutationSubscribeToBrandSkuInStockArgs = {
  brandId: Scalars['ID']['input'];
};

export type MutationSubscribeToBrandSkuOutOfStockArgs = {
  brandId: Scalars['ID']['input'];
};

export type MutationSubscribeToBrandSkuStockDecreaseArgs = {
  brandId: Scalars['ID']['input'];
  minStockThreshold: Scalars['Int']['input'];
};

export type MutationSubscribeToBrandSkuStockIncreaseArgs = {
  brandId: Scalars['ID']['input'];
  minStockThreshold: Scalars['Int']['input'];
};

export type MutationSubscribeToSkuBatchExpirationArgs = {
  hoursBeforeExpiration: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

export type MutationSubscribeToSkuInStockArgs = {
  skuId: Scalars['ID']['input'];
};

export type MutationSubscribeToSkuOutOfStockArgs = {
  skuId: Scalars['ID']['input'];
};

export type MutationSubscribeToSkuStockDecreaseArgs = {
  minStockThreshold: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

export type MutationSubscribeToSkuStockIncreaseArgs = {
  minStockThreshold: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

export type MutationSwapFeaturedBrandPrioritiesArgs = {
  featuredBrand1Id: Scalars['ID']['input'];
  featuredBrand2Id: Scalars['ID']['input'];
};

export type MutationSwapHomeListElementPrioritiesArgs = {
  homeListElement1Id: Scalars['ID']['input'];
  homeListElement2Id: Scalars['ID']['input'];
};

export type MutationSwapOnfleetIdArgs = {
  onfleetTaskShortId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type MutationSyncMetrcItemsArgs = {
  lastModifiedDays: Scalars['Int']['input'];
  licenseNumber: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type MutationSyncMetrcPackagesArgs = {
  lastModifiedDays: Scalars['Int']['input'];
  licenseNumber: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type MutationSyncMetrcSkuBatchItemsArgs = {
  input: SyncMetrcSkuBatchItemsInput;
};

export type MutationTestInventoryValuesArgs = {
  skuBatchIds: Array<Scalars['String']['input']>;
};

export type MutationToggleArchiveFeeArgs = {
  feeId: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
};

export type MutationToggleCreditHoldForLicensedLocationArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type MutationUnarchiveLicenseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationUnarchiveLicensedLocationArgs = {
  input: UnarchiveLicensedLocationInput;
};

export type MutationUnsubscribeFromBrandArgs = {
  subscriptionId: Scalars['String']['input'];
  type: StockSubscriptionEnum;
};

export type MutationUnsubscribeFromSkuArgs = {
  subscriptionId: Scalars['String']['input'];
  type: StockSubscriptionEnum;
};

export type MutationUpdateAccountActivityArgs = {
  input: UpdateAccountActivityInput;
};

export type MutationUpdateAccountTaskArgs = {
  input: UpdateAccountTaskInput;
};

export type MutationUpdateAndGetApSummaryArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type MutationUpdateAutoRegenerateInvoicesArgs = {
  orderId: Scalars['ID']['input'];
  shouldAutoRegenerateInvoices: Scalars['Boolean']['input'];
};

export type MutationUpdateBankAccountInfoArgs = {
  input?: InputMaybe<UpdateBankAccountInfoInput>;
};

export type MutationUpdateBrandFeesCollectionArgs = {
  collectionStatus?: InputMaybe<BrandFeesCollectionCollectionStatusEnum>;
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};

export type MutationUpdateBulkShipmentsArgs = {
  shipments?: InputMaybe<Array<UpdateSingleShipmentInput>>;
};

export type MutationUpdateCartArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateCartInput;
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateCartItemsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: Array<CartItemInput>;
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationUpdateDateRuleArgs = {
  dateRuleId: Scalars['ID']['input'];
  maxDeliveryShipments?: InputMaybe<Scalars['Int']['input']>;
  maxNumIncomingUnits?: InputMaybe<Scalars['Int']['input']>;
  maxPackingShipments?: InputMaybe<Scalars['Int']['input']>;
  superOrderThreshold?: InputMaybe<Scalars['Float']['input']>;
  uniqueRetailersCap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateDraftArgs = {
  input: UpdateDraftInput;
};

export type MutationUpdateDriverArgs = {
  input: UpdateDriverInput;
};

export type MutationUpdateDriverAppSubmissionArgs = {
  input?: InputMaybe<UpdateDriverAppSubmissionInput>;
};

export type MutationUpdateEwbTransactionsArgs = {
  input?: InputMaybe<UpdateEwbTransactionsInput>;
};

export type MutationUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
};

export type MutationUpdateExternalPaymentCollectionArgs = {
  input: UpdateExternalPaymentCollectionInput;
};

export type MutationUpdateFeaturedBrandArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  feesCharged?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sku1Id?: InputMaybe<Scalars['ID']['input']>;
  sku2Id?: InputMaybe<Scalars['ID']['input']>;
  squareBannerImageFile?: InputMaybe<Scalars['Upload']['input']>;
  squareBannerImageS3Link?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  wideBannerImageFile?: InputMaybe<Scalars['Upload']['input']>;
  wideBannerImageS3Link?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateFulfillabilityFromInfoplusArgs = {
  input: UpdateFulfillabilityFromInfoplusInput;
};

export type MutationUpdateFutureFeeVersionArgs = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  feeId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateHomeListElementArgs = {
  input?: InputMaybe<UpdateHomeListElementInput>;
};

export type MutationUpdateHoursArgs = {
  input: UpdateHoursInput;
};

export type MutationUpdateInfoplusOrderStagingAreaCustomFieldsRepairArgs = {
  orderId: Scalars['ID']['input'];
};

export type MutationUpdateInventoryMetaCategoryArgs = {
  id: Scalars['ID']['input'];
  inventoryClass?: InputMaybe<InventoryClassEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInventoryMetaMarketingTagArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationUpdateInventoryMetaTagArgs = {
  id: Scalars['ID']['input'];
  inventoryTagGroupId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateInventoryMetaTagGroupArgs = {
  id: Scalars['ID']['input'];
  inventoryCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inventoryClasses?: InputMaybe<Array<InputMaybe<InventoryClassEnum>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLegalInfoArgs = {
  licensedLocationId: Scalars['ID']['input'];
  sellerPermitLink?: InputMaybe<Scalars['String']['input']>;
  tin?: InputMaybe<Scalars['String']['input']>;
  w9Link?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};

export type MutationUpdateLicensedLocationArgs = {
  input: UpdateLicensedLocationInput;
};

export type MutationUpdateLicensedLocationFromOnboardingInviteArgs = {
  input: UpdateLicensedLocationInput;
  proposalInput?: InputMaybe<CreateLicensedLocationProposalInput>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateLicensedLocationProposalArgs = {
  input: UpdateLicensedLocationProposalInput;
};

export type MutationUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};

export type MutationUpdateMetrcManifestIdArgs = {
  crosshubMetrcManifest?: InputMaybe<Scalars['String']['input']>;
  metrcManifest?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type MutationUpdateMetrcOrderStatusArgs = {
  allowMovingStatusFromCompleteToInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  associate?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMetrcSkuBatchArgs = {
  input: UpdateMetrcSkuBatchInput;
};

export type MutationUpdateMetrcTransferArgs = {
  id: Scalars['ID']['input'];
  metrcManifestFile?: InputMaybe<Scalars['Upload']['input']>;
  metrcManifestId?: InputMaybe<Scalars['Int']['input']>;
  metrcManifestS3FileLink?: InputMaybe<Scalars['String']['input']>;
  metrcOrderNotes?: InputMaybe<Scalars['String']['input']>;
  metrcTransferTemplateName?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMetrcWarehouseIdArgs = {
  input: UpdateMetrcWarehouseIdInput;
};

export type MutationUpdateMultipleFirstShipmentsArgs = {
  input?: InputMaybe<Array<UpdateMultipleFirstShipmentsPayload>>;
};

export type MutationUpdateNonpaymentArgs = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  initiatedNotes: Scalars['String']['input'];
  issueType: OrderIssueType;
  orderIssueId: Scalars['ID']['input'];
  reason: OrderIssueReason;
  recordEdit: Scalars['Boolean']['input'];
};

export type MutationUpdateOnboardingInviteArgs = {
  input: CreateOnboardingInviteInput;
};

export type MutationUpdateOnboardingRouteArgs = {
  input: UpdateOnboardingRouteInput;
};

export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
  isFromOrderForm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateOrderFileArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrderFileType>;
};

export type MutationUpdateOrderLockdownArgs = {
  input: UpdateOrderLockdownInput;
};

export type MutationUpdateOrderRequestPaymentTermsArgs = {
  action: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['String']['input'];
};

export type MutationUpdateOrderSyncWithInfoplusArgs = {
  base64Payload: Scalars['String']['input'];
};

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

export type MutationUpdateOrganizationInviteArgs = {
  input: UpdateOrganizationInviteInput;
};

export type MutationUpdateOrganizationUserArgs = {
  input: UpdateOrganizationUserInput;
};

export type MutationUpdatePaymentPermissionsArgs = {
  input?: InputMaybe<UpdatePaymentPermissionsInput>;
};

export type MutationUpdateRetailerDiscountArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<RetailerDiscountType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatDiscount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  maxCodeRedemptions?: InputMaybe<Scalars['Int']['input']>;
  minBrandCount?: InputMaybe<Scalars['Int']['input']>;
  minBrandOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  percentageDiscount?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  retailerGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tiers?: InputMaybe<Array<DiscountTierInput>>;
};

export type MutationUpdateRetailerGroupArgs = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  canRequestAdditionalNetTerms?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDaysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isHardMinCap?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isPaymentTermsBasedOnCreditRating?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemoOrdersAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  maxAvailableInventory?: InputMaybe<Scalars['Float']['input']>;
  maxDaysTillPaymentDueForExcellent?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForFair?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForGood?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForPoor?: InputMaybe<Scalars['Int']['input']>;
  maxDaysTillPaymentDueForWeak?: InputMaybe<Scalars['Int']['input']>;
  maxSamplesPerOrder?: InputMaybe<Scalars['Int']['input']>;
  minOrderBalance?: InputMaybe<Scalars['Float']['input']>;
  mustPayPreviousBalance?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  retailerGroupLicensedLocations?: InputMaybe<Array<RetailerGroupLicensedLocationInput>>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};

export type MutationUpdateSingleShipmentArgs = {
  shipment: UpdateSingleShipmentInput;
};

export type MutationUpdateSiteArgs = {
  input: UpdateSiteInput;
};

export type MutationUpdateSkuArgs = {
  input: UpdateSkuInput;
};

export type MutationUpdateSkuBatchArgs = {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  skuBatchId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
};

export type MutationUpdateSkuBatchTitleholderArgs = {
  skuBatchId: Scalars['ID']['input'];
  titleholderId: Scalars['ID']['input'];
};

export type MutationUpdateSkuDetailsArgs = {
  input: UpdateSkuDetailsInput;
};

export type MutationUpdateSkuSalesRulePricePerUnitArgs = {
  id: Scalars['ID']['input'];
  pricePerUnit: Scalars['Float']['input'];
};

export type MutationUpdateStagingAreaArgs = {
  archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTagSequencesArgs = {
  orderNumber: Scalars['Int']['input'];
  tagSequences?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>>>;
};

export type MutationUpdateTerritoryArgs = {
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Period>;
  periodMultiplier?: InputMaybe<Scalars['Int']['input']>;
  pickupDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  territoryId: Scalars['ID']['input'];
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  userPreferenceInput?: InputMaybe<UserPreferenceInput>;
};

export type MutationUpdateUserLicensedLocationRelationshipArgs = {
  input: UpdateUserLicensedLocationRelationship;
};

export type MutationUpdateUserPreferenceArgs = {
  allowMarketplaceContactInfo?: InputMaybe<Scalars['Boolean']['input']>;
  orderCSV?: InputMaybe<Scalars['JSON']['input']>;
  organizationId: Scalars['ID']['input'];
  receiveMarketplaceDealsEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveMarketplaceReorderEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveOrderUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receivePaymentTermsRequestEmails?: InputMaybe<Scalars['Boolean']['input']>;
  receiveRetailerRequestEmails?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInput;
};

export type MutationUploadBatchFileArgs = {
  inputFile: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationUploadGenericOrderFilesArgs = {
  orderId: Scalars['ID']['input'];
  uploads?: InputMaybe<Array<GenericOrderFileContainerInput>>;
};

export type MutationUploadOrganizationAssetsArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileKey: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationUploadSecondaryImageArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  organizationId: Scalars['ID']['input'];
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUploadSellerPermitArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  licensedLocationId: Scalars['ID']['input'];
};

export type MutationUploadSellerPermitOrderConfirmationArgs = {
  file: Scalars['Upload']['input'];
  licensedLocationId: Scalars['ID']['input'];
  retailerConfirmLinkId: Scalars['ID']['input'];
};

export type MutationUploadSkuImageArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  organizationId: Scalars['ID']['input'];
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUploadToOnfleetArgs = {
  input: UploadToOnfleetInput;
};

export type MutationUploadW9FormArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  licensedLocationId: Scalars['ID']['input'];
};

export type MutationUploadW9FormOrderConfirmationArgs = {
  file: Scalars['Upload']['input'];
  licensedLocationId: Scalars['ID']['input'];
  retailerConfirmLinkId: Scalars['ID']['input'];
};

export type MutationUpsertFeesOnOrderArgs = {
  input?: InputMaybe<UpsertOrderFeeInput>;
};

export type MutationUpsertLicensedLocationContactArgs = {
  input: UpsertLicensedLocationContactInput;
};

export type MutationValidateTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationVerifyEwbMicroTransactionsArgs = {
  input?: InputMaybe<VerifyEwbMicroTransactionsInput>;
};

export type MutationBrandRetailerCreditHoldInput = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationNabisRetailerCreditHoldInput = {
  licensedLocationId: Scalars['ID']['input'];
};

export type NabisCreditHold = {
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
};

export type NabisRetailerOrderingRestriction = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  maxTerms?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type NabisRetailerOrderingRestrictionInput = {
  licensedLocationId: Scalars['ID']['input'];
};

export type NetGmvTotals = {
  netGmvDelivered: Scalars['Float']['output'];
  netGmvDeliveredFactoredRatio: Scalars['Float']['output'];
  netGmvFactored: Scalars['Float']['output'];
};

export type NewSpecialRequirementsForLocation = {
  extraLeadTimeDays: Scalars['Int']['input'];
  metrcTargetCreationDate: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type NextOrder = {
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
};

export type OnboardingInvite = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedUserId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  onboardingRoute?: Maybe<OnboardingRoute>;
  phone?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<User>;
  token: Scalars['String']['output'];
  type: OnboardingInviteType;
};

export type OnboardingInvitePayload = {
  isDone: Scalars['Boolean']['output'];
  license?: Maybe<License>;
  licensedLocation?: Maybe<LicensedLocation>;
  onboardingRoute?: Maybe<OnboardingRoute>;
  organization?: Maybe<Organization>;
};

/** Values for the OnboardingInviteType enum */
export enum OnboardingInviteType {
  Manufacturer = 'MANUFACTURER',
  Retailer = 'RETAILER',
  Sales = 'SALES',
}

export type OnboardingRoute = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OnfleetDestination = {
  notes?: Maybe<Scalars['String']['output']>;
};

export type OnfleetError = {
  error: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
};

export type OnfleetMetadata = {
  name: Scalars['String']['output'];
  subtype: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
  visibility: Scalars['JSON']['output'];
};

export type OnfleetRecipients = {
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type OnfleetTask = {
  completeAfter?: Maybe<Scalars['DateTime']['output']>;
  completeBefore?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<OnfleetDestination>;
  metadata?: Maybe<Array<OnfleetMetadata>>;
  recipients?: Maybe<Array<OnfleetRecipients>>;
};

export type OnlyOrderByPageInfoInput = {
  orderBy?: InputMaybe<Array<OrderByInput>>;
};

export type Order = {
  ACHACRetailerUnconfirmed?: Maybe<Scalars['Float']['output']>;
  ACHAmountCollectedRetailer?: Maybe<Scalars['Float']['output']>;
  ACHAmountPaidBrand?: Maybe<Scalars['Float']['output']>;
  accountingNotes?: Maybe<Scalars['String']['output']>;
  action: OrderActionEnum;
  additionalDiscount: Scalars['Float']['output'];
  adminNotes?: Maybe<Scalars['String']['output']>;
  advanceAmount?: Maybe<Scalars['Float']['output']>;
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  asnInventoryStatus?: Maybe<OrderAsnInventoryStatusEnum>;
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']['output']>;
  basePricing?: Maybe<BaseOrgPricing>;
  brandFeesCollection?: Maybe<BrandFeesCollection>;
  brandFeesCollectionId?: Maybe<Scalars['ID']['output']>;
  brandManifestNotes?: Maybe<Scalars['String']['output']>;
  confirmationPocName?: Maybe<Scalars['String']['output']>;
  confirmationPocNotes?: Maybe<Scalars['String']['output']>;
  confirmationTrail?: Maybe<ConfirmationTrailEnum>;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creditMemo: Scalars['Float']['output'];
  creditMemos?: Maybe<Array<OrderCreditMemo>>;
  crossHubTransferDate?: Maybe<Scalars['DateTime']['output']>;
  crosshubMetrcManifestId?: Maybe<Scalars['Int']['output']>;
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  discount: Scalars['Float']['output'];
  disputeStatus: OrderDisputeStatus;
  distroFees?: Maybe<Scalars['Float']['output']>;
  driver?: Maybe<Driver>;
  driverConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  driverReportedStatus?: Maybe<DriverReportedStatus>;
  dueToBrand?: Maybe<Scalars['Float']['output']>;
  edited?: Maybe<Scalars['Boolean']['output']>;
  estimatedArrivalTimeAfter?: Maybe<Scalars['DateTime']['output']>;
  estimatedArrivalTimeBefore?: Maybe<Scalars['DateTime']['output']>;
  exciseTax: Scalars['Float']['output'];
  exciseTaxCollected?: Maybe<Scalars['Float']['output']>;
  externalPaymentCollected?: Maybe<Scalars['Float']['output']>;
  externalPaymentDesired?: Maybe<Scalars['Float']['output']>;
  externalPaymentMin?: Maybe<Scalars['Float']['output']>;
  externalPaymentNotes?: Maybe<Scalars['String']['output']>;
  extraFees?: Maybe<Scalars['Float']['output']>;
  factorRate?: Maybe<Scalars['Float']['output']>;
  factorStartDate?: Maybe<Scalars['DateTime']['output']>;
  factorStatus: OrderFactorStatusEnum;
  firstShipmentId?: Maybe<Scalars['ID']['output']>;
  fulfillability?: Maybe<OrderFulfillabilityEnum>;
  gmv: Scalars['Float']['output'];
  gmvCollected: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  infoplus?: Maybe<Scalars['Int']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  inventoryLedgerItems: Array<InventoryLedgerItem>;
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  irn?: Maybe<Scalars['String']['output']>;
  isAdvancePaid?: Maybe<Scalars['Boolean']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isAtStartingStatus: Scalars['Boolean']['output'];
  isAtTerminalStatus: Scalars['Boolean']['output'];
  isCrossHubOrder?: Maybe<Scalars['Boolean']['output']>;
  isCrossHubRetailTransfer: Scalars['Boolean']['output'];
  isEditableByBrand: Scalars['Boolean']['output'];
  isEmailSentConfirmation: Scalars['Boolean']['output'];
  isEmailSentInboundConfirmation: Scalars['Boolean']['output'];
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  isPrinted?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isReceived: Scalars['Boolean']['output'];
  isReservePaid?: Maybe<Scalars['Boolean']['output']>;
  isRetailerRestricted: Scalars['Boolean']['output'];
  isRetailerRestrictedForBrand: Scalars['Boolean']['output'];
  isSample?: Maybe<Scalars['Boolean']['output']>;
  isSampleDemo?: Maybe<Scalars['Boolean']['output']>;
  isSingleHubOrigin?: Maybe<Scalars['Boolean']['output']>;
  isStaged?: Maybe<Scalars['Boolean']['output']>;
  issueReason?: Maybe<OrderIssueReasons>;
  lastDispute?: Maybe<OrderIssue>;
  lastNonReturnShipment?: Maybe<Shipment>;
  lastNonReturnShipmentId?: Maybe<Scalars['ID']['output']>;
  lastNonpayment?: Maybe<OrderIssue>;
  lastShipment?: Maybe<Shipment>;
  lastShipmentId?: Maybe<Scalars['ID']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  licensedLocationId?: Maybe<Scalars['ID']['output']>;
  lineItems: Array<LineItem>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  manufacturerOrg?: Maybe<Organization>;
  manufacturerOrgId?: Maybe<Scalars['String']['output']>;
  metrcManifestId?: Maybe<Scalars['Int']['output']>;
  metrcManifestS3FileLink?: Maybe<Scalars['String']['output']>;
  metrcOrderAssociate?: Maybe<Scalars['ID']['output']>;
  metrcOrderNotes?: Maybe<Scalars['String']['output']>;
  metrcOrderStatus: MetrcOrderStatusEnum;
  metrcTagSequences?: Maybe<Array<Array<TagSequence>>>;
  metrcTransferTemplateName?: Maybe<Scalars['String']['output']>;
  metrcTransfers: Array<MetrcTransfer>;
  metrcWarehouse?: Maybe<Warehouse>;
  metrcWarehouseId?: Maybe<Scalars['ID']['output']>;
  metrcWarehouseLicenseNumber?: Maybe<Scalars['String']['output']>;
  mustPayExternalBalance: Scalars['Boolean']['output'];
  mustPayPreviousBalance?: Maybe<Scalars['Boolean']['output']>;
  nabisDiscount?: Maybe<Scalars['Float']['output']>;
  nabisManifestNotes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  netGmv?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  numberOfCartons?: Maybe<Scalars['Int']['output']>;
  onfleetTask?: Maybe<Scalars['JSON']['output']>;
  onfleetTaskId?: Maybe<Scalars['String']['output']>;
  onfleetTaskUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  orderChanges?: Maybe<Array<Maybe<OrderChange>>>;
  orderFees?: Maybe<Array<Maybe<OrderFee>>>;
  orderFiles: Array<OrderFile>;
  orderInventoryStatus?: Maybe<OrderOrderInventoryStatusEnum>;
  orderLockdown?: Maybe<OrderLockdown>;
  orderLockdownId?: Maybe<Scalars['ID']['output']>;
  orderSubscribers: Array<OrderSubscriber>;
  orderTags?: Maybe<Array<OrderTag>>;
  orgLicenseNum?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  packingListS3FileLink?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  parentOrder?: Maybe<ParentOrder>;
  parentOrderId?: Maybe<Scalars['ID']['output']>;
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethodEnum>;
  paymentStatus: OrderPaymentStatusEnum;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  paymentTermsRequestStatus?: Maybe<PaymentTermsRequestStatusEnum>;
  pickers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pickupDropoffWarehouseId?: Maybe<Scalars['ID']['output']>;
  postDiscountFees?: Maybe<Scalars['Boolean']['output']>;
  priceDifference: Scalars['Float']['output'];
  pricingFee?: Maybe<Scalars['Float']['output']>;
  pricingPercentage?: Maybe<Scalars['Float']['output']>;
  promotionsDiscount: Scalars['Float']['output'];
  qrcodeS3FileLink?: Maybe<Scalars['String']['output']>;
  referrer: OrderReferrer;
  remittedAt?: Maybe<Scalars['DateTime']['output']>;
  reorderEmailDate?: Maybe<Scalars['DateTime']['output']>;
  reorderExecutionArn?: Maybe<Scalars['String']['output']>;
  requestedDaysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  retailSourceWarehouse?: Maybe<Warehouse>;
  retailSourceWarehouseId?: Maybe<Scalars['ID']['output']>;
  retailerConfirmLinkId?: Maybe<Scalars['String']['output']>;
  retailerConfirmationStatus: RetailerConfirmationStatus;
  retailerManifestNotes?: Maybe<Scalars['String']['output']>;
  retailerNotes?: Maybe<Scalars['String']['output']>;
  salesOrgId?: Maybe<Scalars['ID']['output']>;
  secondaryInfoplus?: Maybe<Scalars['Int']['output']>;
  shipments?: Maybe<Array<Shipment>>;
  shouldEnableOrderForm: Scalars['Boolean']['output'];
  site: Site;
  siteLicenseNum?: Maybe<Scalars['String']['output']>;
  sourceEnv: SourceEnvEnum;
  stagingArea?: Maybe<StagingArea>;
  stagingAreaId?: Maybe<Scalars['ID']['output']>;
  status: OrderStatusEnum;
  surcharge: Scalars['Float']['output'];
  timeWindow?: Maybe<Scalars['String']['output']>;
  totalAmountDue?: Maybe<Scalars['Float']['output']>;
  totalFactorFee?: Maybe<Scalars['Float']['output']>;
  unaddressedMessages?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vehicle?: Maybe<Vehicle>;
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['ID']['output'];
  wholesaleGmv: Scalars['Float']['output'];
};

export type OrderLineItemsArgs = {
  isNewOrder?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sortLikeMetrc?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Values for the OrderActionEnum enum */
export enum OrderActionEnum {
  DeliveryToBrand = 'DELIVERY_TO_BRAND',
  DeliveryToRetailer = 'DELIVERY_TO_RETAILER',
  DropoffToNabis = 'DROPOFF_TO_NABIS',
  InternalTransfer = 'INTERNAL_TRANSFER',
  Other = 'OTHER',
  PaymentPickupFromRetailer = 'PAYMENT_PICKUP_FROM_RETAILER',
  PickupFromBrand = 'PICKUP_FROM_BRAND',
  PickupFromNabis = 'PICKUP_FROM_NABIS',
  ReturnFromRetailer = 'RETURN_FROM_RETAILER',
  SampleSkuConversion = 'SAMPLE_SKU_CONVERSION',
}

/** Values for the OrderAsnInventoryStatusEnum enum */
export enum OrderAsnInventoryStatusEnum {
  Ordered = 'ORDERED',
  Shelved = 'SHELVED',
}

export type OrderBy = {
  attribute?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderByEnum>;
};

/** Values for the OrderByEnum enum */
export enum OrderByEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type OrderByInput = {
  attribute: Scalars['String']['input'];
  order: OrderByEnum;
};

export type OrderCalendarDate = {
  date: Scalars['DateTime']['output'];
  datePaidInFull?: Maybe<Scalars['DateTime']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  destination: Scalars['String']['output'];
  due?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  manifestUrl?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  paymentTerms?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatusEnum>;
  type: OrderActionEnum;
};

export type OrderCalendarPayload = {
  dates: Array<OrderCalendarDate>;
  highlightDates: HighlightDates;
};

export type OrderChange = {
  addedLineItems?: Maybe<Array<LineItemChange>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fromDriver: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  issueReason?: Maybe<OrderIssueReasons>;
  order: Order;
  orderRestrictionMPPBChangelogs?: Maybe<Array<OrderRestrictionMppbChangelog>>;
  organization?: Maybe<Organization>;
  removedLineItems?: Maybe<Array<LineItemChange>>;
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['ID']['output']>;
  submitter?: Maybe<User>;
  submitterOrganization?: Maybe<Organization>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type OrderChangeDriverUpdate = {
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  submitter?: Maybe<User>;
};

export type OrderColdStorageInfo = {
  isColdStorage: Scalars['Boolean']['output'];
  orderId: Scalars['ID']['output'];
};

export type OrderContact = {
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Values for the OrderContactDetailsEnum enum */
export enum OrderContactDetailsEnum {
  NoEmailAddresses = 'NoEmailAddresses',
  NoLicensedLocationName = 'NoLicensedLocationName',
  NoMatchingOrganzation = 'NoMatchingOrganzation',
  Success = 'Success',
  TooManyMatchingOrganizations = 'TooManyMatchingOrganizations',
}

export type OrderCreditMemo = {
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  creditMemoType?: Maybe<CreditMemoType>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById: Scalars['ID']['output'];
};

export type OrderDetails = {
  action: OrderActionEnum;
  crosshubMetrcManifestId?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  metrcManifestId?: Maybe<Scalars['Int']['output']>;
  metrcOrderAssociate?: Maybe<Scalars['ID']['output']>;
  metrcOrderNotes?: Maybe<Scalars['String']['output']>;
  metrcOrderStatus: MetrcOrderStatusEnum;
  metrcTransferTemplateName?: Maybe<Scalars['String']['output']>;
  metrcTransfers?: Maybe<Array<Maybe<OrderDetailsMetrcTransfer>>>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  packingWarehouse?: Maybe<Scalars['String']['output']>;
  packingWarehouseKey?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  status: OrderStatusEnum;
  warehouse?: Maybe<Scalars['String']['output']>;
};

export type OrderDetailsMetrcTransfer = {
  metrcManifestId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<OrderDetailsMetrcTransferShipmentOrder>;
  shipment?: Maybe<OrderDetailsMetrcTransferShipmentOrder>;
};

export type OrderDetailsMetrcTransferShipmentOrder = {
  metrcWarehouseLicenseNumber?: Maybe<Scalars['String']['output']>;
};

/** Values for the OrderDisputeStatus enum */
export enum OrderDisputeStatus {
  Disputed = 'DISPUTED',
  NotDisputed = 'NOT_DISPUTED',
  Resolved = 'RESOLVED',
}

/** Values for the OrderEditReasons enum */
export enum OrderEditReasons {
  AccountingChange = 'ACCOUNTING_CHANGE',
  CancelledOrderBrandRequest = 'CANCELLED_ORDER_BRAND_REQUEST',
  CancelledOrderRetailerRequest = 'CANCELLED_ORDER_RETAILER_REQUEST',
  ContentsChangeBatchSwapDueToUnlocatedInventory = 'CONTENTS_CHANGE_BATCH_SWAP_DUE_TO_UNLOCATED_INVENTORY',
  ContentsChangeBrandRequest = 'CONTENTS_CHANGE_BRAND_REQUEST',
  ContentsChangeCantLocateItems = 'CONTENTS_CHANGE_CANT_LOCATE_ITEMS',
  ContentsChangeCoasDidntMatch = 'CONTENTS_CHANGE_COAS_DIDNT_MATCH',
  ContentsChangeCoasMissing = 'CONTENTS_CHANGE_COAS_MISSING',
  ContentsChangeDamagedProductNabisFault = 'CONTENTS_CHANGE_DAMAGED_PRODUCT_NABIS_FAULT',
  ContentsChangeManufacturingError = 'CONTENTS_CHANGE_MANUFACTURING_ERROR',
  ContentsChangeMispack = 'CONTENTS_CHANGE_MISPACK',
  ContentsChangePaymentTerms = 'CONTENTS_CHANGE_PAYMENT_TERMS',
  ContentsChangePreapprovedBatchswapDuetoUnlocatedinventory = 'CONTENTS_CHANGE_PREAPPROVED_BATCHSWAP_DUETO_UNLOCATEDINVENTORY',
  ContentsChangeRetailerRequest = 'CONTENTS_CHANGE_RETAILER_REQUEST',
  ContentChangePaymentTermsRefusesForm_8300 = 'CONTENT_CHANGE_PAYMENT_TERMS_REFUSES_FORM_8300',
  DateChangeBrandOversold = 'DATE_CHANGE_BRAND_OVERSOLD',
  DateChangeBrandRequest = 'DATE_CHANGE_BRAND_REQUEST',
  DateChangeBundledOrderToEarlierDate = 'DATE_CHANGE_BUNDLED_ORDER_TO_EARLIER_DATE',
  DateChangeBundledOrderToLaterDate = 'DATE_CHANGE_BUNDLED_ORDER_TO_LATER_DATE',
  DateChangeCouldntFindOrderAtLaunch = 'DATE_CHANGE_COULDNT_FIND_ORDER_AT_LAUNCH',
  DateChangeDriverComplications = 'DATE_CHANGE_DRIVER_COMPLICATIONS',
  DateChangeDueToMissedShipment = 'DATE_CHANGE_DUE_TO_MISSED_SHIPMENT',
  DateChangeFirstAvailableOnSchedulingSystem = 'DATE_CHANGE_FIRST_AVAILABLE_ON_SCHEDULING_SYSTEM',
  DateChangeMadeByBrand = 'DATE_CHANGE_MADE_BY_BRAND',
  DateChangeMissedDelivery = 'DATE_CHANGE_MISSED_DELIVERY',
  DateChangeMissedDeliveryWindow = 'DATE_CHANGE_MISSED_DELIVERY_WINDOW',
  DateChangeMissedInitialShipment = 'DATE_CHANGE_MISSED_INITIAL_SHIPMENT',
  DateChangeNabisDeliveryCapacity = 'DATE_CHANGE_NABIS_DELIVERY_CAPACITY',
  DateChangeNabisPackingCapacity = 'DATE_CHANGE_NABIS_PACKING_CAPACITY',
  DateChangeRefusesForm_8300 = 'DATE_CHANGE_REFUSES_FORM_8300',
  DateChangeRetailerRequest = 'DATE_CHANGE_RETAILER_REQUEST',
  DateChangeSetRetailerDeliveryDate = 'DATE_CHANGE_SET_RETAILER_DELIVERY_DATE',
  LineItemDiscountChangeBrandRequest = 'LINE_ITEM_DISCOUNT_CHANGE_BRAND_REQUEST',
  LineItemPricingChangeBrandRequest = 'LINE_ITEM_PRICING_CHANGE_BRAND_REQUEST',
  OrderCreditChangeBrandRequest = 'ORDER_CREDIT_CHANGE_BRAND_REQUEST',
  OrderDiscountChangeBrandRequest = 'ORDER_DISCOUNT_CHANGE_BRAND_REQUEST',
}

/** Values for the OrderFactorStatusEnum enum */
export enum OrderFactorStatusEnum {
  Approved = 'APPROVED',
  CustomRateProposal = 'CUSTOM_RATE_PROPOSAL',
  NotRequested = 'NOT_REQUESTED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
}

export type OrderFee = {
  createdBy?: Maybe<User>;
  fee: Fee;
  feeId: Scalars['ID']['output'];
  feeName: Scalars['String']['output'];
  feeNotes: Scalars['String']['output'];
  feePrice: Scalars['Float']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  orderId: Scalars['ID']['output'];
};

export type OrderFeeInput = {
  feeId: Scalars['ID']['input'];
  feeName?: InputMaybe<Scalars['String']['input']>;
  feeNotes: Scalars['String']['input'];
  feePrice: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderFile = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  s3Link: Scalars['String']['output'];
  type: OrderFileType;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

/** Values for the OrderFileType enum */
export enum OrderFileType {
  MetrcManifest = 'METRC_MANIFEST',
  NabisManifest = 'NABIS_MANIFEST',
  Other = 'OTHER',
  PaymentBag = 'PAYMENT_BAG',
  PaymentConfirmation = 'PAYMENT_CONFIRMATION',
}

export type OrderForInvoice = {
  id: Scalars['ID']['output'];
  licensedLocation?: Maybe<OrderForInvoiceLocationAttributes>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  organization?: Maybe<OrderForInvoiceLocationAttributes>;
};

export type OrderForInvoiceLocationAttributes = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrderForMppb = {
  amount: Scalars['Float']['output'];
  amountCollected?: Maybe<Scalars['Float']['output']>;
  amountOutstanding: Scalars['Float']['output'];
  amountOverdue: Scalars['Float']['output'];
  assignee?: Maybe<User>;
  creator: User;
  daysOverdue: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  exciseTaxCollected: Scalars['Float']['output'];
  gmvCollected: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  isFactoredOverdueOrder?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice: Scalars['Boolean']['output'];
  orderNumber: Scalars['Int']['output'];
};

/** Values for the OrderFulfillabilityEnum enum */
export enum OrderFulfillabilityEnum {
  Fulfillable = 'FULFILLABLE',
  Manual = 'MANUAL',
  NotFulfillable = 'NOT_FULFILLABLE',
  PartiallyFulfillable = 'PARTIALLY_FULFILLABLE',
}

export type OrderIssue = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiatedAt: Scalars['DateTime']['output'];
  initiatedNotes?: Maybe<Scalars['String']['output']>;
  issueType: OrderIssueType;
  orderId: Scalars['ID']['output'];
  reason: OrderIssueReason;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedNotes?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Values for the OrderIssueReason enum */
export enum OrderIssueReason {
  DiscrepancyInPricingOfProductsReceived = 'DISCREPANCY_IN_PRICING_OF_PRODUCTS_RECEIVED',
  DiscrepancyInQualityOrNatureOfProductsReceived = 'DISCREPANCY_IN_QUALITY_OR_NATURE_OF_PRODUCTS_RECEIVED',
  Form_8300ComplianceRefusal = 'FORM_8300_COMPLIANCE_REFUSAL',
  InsolvencyRisk = 'INSOLVENCY_RISK',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  OrderNeverReceived = 'ORDER_NEVER_RECEIVED',
  PickupUnalignedWithRetailerAccountingPractices = 'PICKUP_UNALIGNED_WITH_RETAILER_ACCOUNTING_PRACTICES',
  RepresentativeCannotFacilitatePayment = 'REPRESENTATIVE_CANNOT_FACILITATE_PAYMENT',
  RetailerAllegesToHaveAlreadyPaidInvoiceToBrand = 'RETAILER_ALLEGES_TO_HAVE_ALREADY_PAID_INVOICE_TO_BRAND',
  RetailerAllegesToHaveAlreadyPaidInvoiceToNabis = 'RETAILER_ALLEGES_TO_HAVE_ALREADY_PAID_INVOICE_TO_NABIS',
}

/** Values for the OrderIssueReasons enum */
export enum OrderIssueReasons {
  BrandFault = 'BRAND_FAULT',
  BrandManufacturingError = 'BRAND_MANUFACTURING_ERROR',
  BrandMiscommunication = 'BRAND_MISCOMMUNICATION',
  BrandRequestedChange = 'BRAND_REQUESTED_CHANGE',
  BrandRequestsDelay = 'BRAND_REQUESTS_DELAY',
  NabisAddressError = 'NABIS_ADDRESS_ERROR',
  NabisCapacityDelay = 'NABIS_CAPACITY_DELAY',
  NabisCoaError = 'NABIS_COA_ERROR',
  NabisInventoryShortage = 'NABIS_INVENTORY_SHORTAGE',
  NabisLicenseError = 'NABIS_LICENSE_ERROR',
  NabisMetrcError = 'NABIS_METRC_ERROR',
  NabisMispack = 'NABIS_MISPACK',
  NabisMissedTimeWindow = 'NABIS_MISSED_TIME_WINDOW',
  NabisSchedulingError = 'NABIS_SCHEDULING_ERROR',
  PartialRejectionOfCorrectItems = 'PARTIAL_REJECTION_OF_CORRECT_ITEMS',
  PendingInventoryResolution = 'PENDING_INVENTORY_RESOLUTION',
  RetailerMiscommunication = 'RETAILER_MISCOMMUNICATION',
  RetailerPaymentNotReady = 'RETAILER_PAYMENT_NOT_READY',
  RetailerRefusalOfForm_8300 = 'RETAILER_REFUSAL_OF_FORM_8300',
  RetailerRequestsDelay = 'RETAILER_REQUESTS_DELAY',
  RetailerWillNotAcceptPaymentTerms = 'RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS',
  RetailerWillNotPayExciseTax = 'RETAILER_WILL_NOT_PAY_EXCISE_TAX',
}

/** Values for the OrderIssueType enum */
export enum OrderIssueType {
  Dispute = 'DISPUTE',
  Nonpayment = 'NONPAYMENT',
}

export type OrderLockdown = {
  createdAt: Scalars['DateTime']['output'];
  createdAtById?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCreditMemoLocked: Scalars['Boolean']['output'];
  orderEditLockdownTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Values for the OrderOrderInventoryStatusEnum enum */
export enum OrderOrderInventoryStatusEnum {
  Fulfilled = 'FULFILLED',
  Ordered = 'ORDERED',
  Packed = 'PACKED',
}

/** Values for the OrderPaymentStatusEnum enum */
export enum OrderPaymentStatusEnum {
  CodPaid = 'COD_PAID',
  DriverProcessing = 'DRIVER_PROCESSING',
  NetTermsPaid = 'NET_TERMS_PAID',
  PartialPaid = 'PARTIAL_PAID',
  PaymentSent = 'PAYMENT_SENT',
  Processing = 'PROCESSING',
  Remitted = 'REMITTED',
  SelfCollected = 'SELF_COLLECTED',
  ThirdPartyCollections = 'THIRD_PARTY_COLLECTIONS',
  Unpaid = 'UNPAID',
  WriteOff = 'WRITE_OFF',
}

/** Values for the OrderReferrer enum */
export enum OrderReferrer {
  Brand = 'BRAND',
  Manufacturer = 'MANUFACTURER',
  Retailer = 'RETAILER',
  Sales = 'SALES',
}

export type OrderRepairGroup = {
  errors: Array<OrderRepairType>;
  order: OrderRepairOrder;
};

export type OrderRepairInput = {
  endCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  pageInfo?: InputMaybe<PageInfoInput>;
  startCreatedAt: Scalars['DateTime']['input'];
};

export type OrderRepairOrder = {
  action: OrderActionEnum;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  isEmailSentConfirmation: Scalars['Boolean']['output'];
  isEmailSentInboundConfirmation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  qrCodeS3FileLink?: Maybe<Scalars['String']['output']>;
  shipments?: Maybe<Array<Shipment>>;
};

/** Values for the OrderRepairType enum */
export enum OrderRepairType {
  MissingEmails = 'MISSING_EMAILS',
  MissingInfoplus = 'MISSING_INFOPLUS',
  MissingManifests = 'MISSING_MANIFESTS',
  MissingQrCode = 'MISSING_QR_CODE',
  MissingShipments = 'MISSING_SHIPMENTS',
}

export type OrderRestriction = {
  adjudicatedAt?: Maybe<Scalars['DateTime']['output']>;
  adjudicatedBy?: Maybe<Scalars['ID']['output']>;
  adjudicatedNotes?: Maybe<Scalars['String']['output']>;
  amountToCollect?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isPartialRequired?: Maybe<Scalars['Boolean']['output']>;
  orderId: Scalars['ID']['output'];
  overrideStatus: OrderRestrictionOverrideStatusEnum;
  requestNotes?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Scalars['ID']['output']>;
  requiredAt?: Maybe<Scalars['DateTime']['output']>;
  requiredOrderId?: Maybe<Scalars['ID']['output']>;
  type: OrderRestrictionTypeEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderRestrictionMppbChangelog = {
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newAmountToCollect?: Maybe<Scalars['Float']['output']>;
  newIsPartialRequired: Scalars['Boolean']['output'];
  orderRestrictionId: Scalars['ID']['output'];
  previousAmountToCollect?: Maybe<Scalars['Float']['output']>;
  previousIsPartialRequired: Scalars['Boolean']['output'];
  requiredOrderNumber: Scalars['Int']['output'];
};

/** Values for the OrderRestrictionOverrideStatusEnum enum */
export enum OrderRestrictionOverrideStatusEnum {
  Authorized = 'AUTHORIZED',
  Expired = 'EXPIRED',
  NotRequested = 'NOT_REQUESTED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
}

/** Values for the OrderRestrictionTypeEnum enum */
export enum OrderRestrictionTypeEnum {
  CodRequired = 'COD_REQUIRED',
  MustPayExciseTax = 'MUST_PAY_EXCISE_TAX',
  MustPayPriorBalance = 'MUST_PAY_PRIOR_BALANCE',
  RequiredOrderAmount = 'REQUIRED_ORDER_AMOUNT',
}

export type OrderRestrictionWithMppbOrder = {
  order: OrderForMppb;
  orderRestriction: OrderRestriction;
};

export type OrderRestrictionsForOrderPayload = {
  orderRestrictions?: Maybe<Array<OrderRestrictionWithMppbOrder>>;
  outstandingOrdersForMPPB?: Maybe<Array<OutstandingOrderForMppb>>;
};

export type OrderRetailer = {
  ACHACRetailerUnconfirmed?: Maybe<Scalars['Float']['output']>;
  ACHAmountCollectedRetailer?: Maybe<Scalars['Float']['output']>;
  accountingInfo?: Maybe<AccountingInfo>;
  apSummaryGDriveFileId?: Maybe<Scalars['String']['output']>;
  apSummaryS3FileLink?: Maybe<Scalars['String']['output']>;
  brand: Organization;
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creditMemo: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  daysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  driver?: Maybe<Driver>;
  dueOnDelivery?: Maybe<Scalars['Float']['output']>;
  estimatedArrivalTimeAfter?: Maybe<Scalars['DateTime']['output']>;
  estimatedArrivalTimeBefore?: Maybe<Scalars['DateTime']['output']>;
  eta?: Maybe<EtaPayload>;
  exciseTax: Scalars['Float']['output'];
  gmv: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  irn?: Maybe<Scalars['String']['output']>;
  isEditableByBrand?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  lineItems: Array<LineItem>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  onfleetTask?: Maybe<Scalars['JSON']['output']>;
  onfleetTaskId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  orgLicenseNum?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  packingListS3FileLink?: Maybe<Scalars['String']['output']>;
  paymentStatus: OrderPaymentStatusEnum;
  priceDifference: Scalars['Float']['output'];
  referrer: OrderReferrer;
  requiredBalance?: Maybe<Scalars['Float']['output']>;
  retailer: LicensedLocation;
  retailerConfirmLinkId?: Maybe<Scalars['String']['output']>;
  retailerConfirmationStatus?: Maybe<Scalars['String']['output']>;
  retailerNotes?: Maybe<Scalars['String']['output']>;
  siteLicenseNum?: Maybe<Scalars['String']['output']>;
  status: OrderStatusEnum;
  surcharge: Scalars['Float']['output'];
  timeWindow?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Vehicle>;
  warehouse?: Maybe<Warehouse>;
  warehouseId: Scalars['ID']['output'];
  wholesaleGmv: Scalars['Float']['output'];
};

/** Values for the OrderRetailerDeliveryStatusEnum enum */
export enum OrderRetailerDeliveryStatusEnum {
  ActiveOnOverviewPage = 'ACTIVE_ON_OVERVIEW_PAGE',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

/** Values for the OrderSampleFilterEnum enum */
export enum OrderSampleFilterEnum {
  AllOrders = 'ALL_ORDERS',
  OnlyNonSamples = 'ONLY_NON_SAMPLES',
  OnlySamples = 'ONLY_SAMPLES',
}

/** Values for the OrderStatusEnum enum */
export enum OrderStatusEnum {
  Attempted = 'ATTEMPTED',
  Cancelled = 'CANCELLED',
  Delayed = 'DELAYED',
  Delivered = 'DELIVERED',
  DeliveredWithEdits = 'DELIVERED_WITH_EDITS',
  InTransit = 'IN_TRANSIT',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  Transferring = 'TRANSFERRING',
  Unscheduled = 'UNSCHEDULED',
}

export type OrderSubscriber = {
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  subscriberId: Scalars['ID']['output'];
};

export type OrderTag = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  tagType: OrderTagType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Values for the OrderTagType enum */
export enum OrderTagType {
  TieredServiceBundledOrder = 'TIERED_SERVICE_BUNDLED_ORDER',
}

export type OrderToCheckInput = {
  id: Scalars['ID']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type OrderingRestrictions = {
  codOnlyRetailers: Array<RestrictionInformationRetailer>;
  codOnlyRetailersThatCanNotBeOverriden: Array<BrandCodOnlyRetailersThatCanNotBeOverriden>;
};

export type Organization = {
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  alias: Scalars['String']['output'];
  assignedBrandSalesRepId?: Maybe<Scalars['ID']['output']>;
  bannerImageS3Link?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditRatingNotificationAccess: Scalars['Boolean']['output'];
  currentAndFormerAssignedMembers: Array<User>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  factoredStatus: OrganizationFactoredStatusEnum;
  hasAllowOrderCapOverride: Scalars['Boolean']['output'];
  hasAnalyticsDashboard: Scalars['Boolean']['output'];
  hasMustPayExternalBalance: Scalars['Boolean']['output'];
  hasPlatformV2ApiAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  infoplus?: Maybe<Scalars['Int']['output']>;
  inventoryItems: Array<InventoryItem>;
  inventoryLedgerItems: Array<InventoryLedgerItem>;
  isBrand: Scalars['Boolean']['output'];
  isEnterpriseCreditHold: Scalars['Boolean']['output'];
  isHardMinCap?: Maybe<Scalars['Boolean']['output']>;
  isManufacturer: Scalars['Boolean']['output'];
  isMarketplace: Scalars['Boolean']['output'];
  isOnCreditHold: Scalars['Boolean']['output'];
  isRetailer: Scalars['Boolean']['output'];
  isSalesOrg: Scalars['Boolean']['output'];
  isSampleDemoOrdersAllowed?: Maybe<Scalars['Boolean']['output']>;
  licensedLocationId?: Maybe<Scalars['String']['output']>;
  licenses: Array<License>;
  logoS3Link?: Maybe<Scalars['String']['output']>;
  manifestGDriveFolderId?: Maybe<Scalars['String']['output']>;
  manufacturerLicenses?: Maybe<Array<License>>;
  marketingPDF?: Maybe<Scalars['String']['output']>;
  marketplaceContactEmail?: Maybe<Scalars['String']['output']>;
  marketplaceContactName?: Maybe<Scalars['String']['output']>;
  marketplaceContactNumber?: Maybe<Scalars['String']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  maxSamplesPerOrder?: Maybe<Scalars['Float']['output']>;
  members: Array<User>;
  minOrderBalance: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  orders: Array<Order>;
  organizationUserRole?: Maybe<Role>;
  owner: User;
  phone?: Maybe<Scalars['String']['output']>;
  receiveReports?: Maybe<Scalars['Boolean']['output']>;
  restrictions: RestrictionInformation;
  salesOrgRelationships?: Maybe<Array<SalesOrgRelationship>>;
  salesSettings?: Maybe<SalesOrganizationSetting>;
  singleHubWarehouse?: Maybe<Warehouse>;
  singleHubWarehouseId?: Maybe<Scalars['ID']['output']>;
  sites: Array<Site>;
  state?: Maybe<Scalars['String']['output']>;
  type: OrganizationType;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAssignedBrandSalesRepIdArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type OrganizationIsHardMinCapArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type OrganizationIsSampleDemoOrdersAllowedArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type OrganizationManufacturerLicensesArgs = {
  brandOrgId?: InputMaybe<Scalars['ID']['input']>;
  manufacturerOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationMaxSamplesPerOrderArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type OrganizationMinOrderBalanceArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type OrganizationSalesOrgRelationshipsArgs = {
  organizationType?: InputMaybe<OrganizationType>;
};

export type OrganizationContact = {
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organization: OrganizationContactOrganization;
  organizationContactType: OrganizationContactType;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationContactOrganization = {
  alias: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationContactResponse = {
  organizationContacts: Array<OrganizationContact>;
  organizationUserContacts: Array<OrganizationUserContact>;
};

export type OrganizationContactType = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationCount = {
  count: Scalars['Int']['output'];
  type: OrganizationType;
};

export type OrganizationFactorPricing = {
  adminFee?: Maybe<Scalars['Float']['output']>;
  advanceRate?: Maybe<Scalars['Float']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  currentTotalFactorBalances?: Maybe<CurrentTotalFactorBalances>;
  id: Scalars['ID']['output'];
  net7?: Maybe<Scalars['Float']['output']>;
  net14?: Maybe<Scalars['Float']['output']>;
  net15?: Maybe<Scalars['Float']['output']>;
  net21?: Maybe<Scalars['Float']['output']>;
  net28?: Maybe<Scalars['Float']['output']>;
  net30?: Maybe<Scalars['Float']['output']>;
  net45?: Maybe<Scalars['Float']['output']>;
  net60?: Maybe<Scalars['Float']['output']>;
  net90?: Maybe<Scalars['Float']['output']>;
  organizationId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** Values for the OrganizationFactoredStatusEnum enum */
export enum OrganizationFactoredStatusEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Suspended = 'SUSPENDED',
}

export type OrganizationInvite = {
  accepted?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  sender: User;
};

export type OrganizationPricing = {
  additionalPricingInstructions?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  dayOfCollection?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id: Scalars['ID']['output'];
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  postDiscountFees?: Maybe<Scalars['Boolean']['output']>;
  pricingFee?: Maybe<Scalars['Float']['output']>;
  pricingPercentage?: Maybe<Scalars['Float']['output']>;
  remittancePeriod?: Maybe<Scalars['String']['output']>;
  remittanceType?: Maybe<Scalars['String']['output']>;
};

export type OrganizationRelationshipTags = {
  brandOrganization: Organization;
  brandOrganizationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  retailerOrganization: Organization;
  retailerOrganizationId: Scalars['ID']['output'];
  tag: Tag;
  tagId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** Values for the OrganizationType enum */
export enum OrganizationType {
  Brand = 'BRAND',
  Manufacturer = 'MANUFACTURER',
  Retailer = 'RETAILER',
  Sales = 'SALES',
}

export type OrganizationUser = {
  id: Scalars['ID']['output'];
  organization: Organization;
  roleId?: Maybe<Scalars['ID']['output']>;
  user: User;
};

export type OrganizationUserContact = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: OrganizationContactOrganization;
  organizationContactType: OrganizationContactType;
  updatedAt: Scalars['DateTime']['output'];
  user: OrganizationUserContactUser;
};

export type OrganizationUserContactUser = {
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Values for the OriginCompany enum */
export enum OriginCompany {
  Nabifive = 'NABIFIVE',
  Nabifour = 'NABIFOUR',
  Nabitwo = 'NABITWO',
  Siban = 'SIBAN',
}

export type OutstandingBalanceResponse = {
  orders: Array<OutstandingBalanceResponseOrder>;
  totalAmount: Scalars['Float']['output'];
  totalAmountCollected: Scalars['Float']['output'];
  totalAmountDue: Scalars['Float']['output'];
  totalAmountExciseTaxOutstanding: Scalars['Float']['output'];
  totalAmountNotYetDue: Scalars['Float']['output'];
  totalAmountOutstanding: Scalars['Float']['output'];
  totalAmountOverdue: Scalars['Float']['output'];
  totalAmountRequiredForDelivery: Scalars['Float']['output'];
  totalCountOutstanding: Scalars['Int']['output'];
  totalCountOverdue: Scalars['Int']['output'];
};

export type OutstandingBalanceResponseOrder = {
  amount: Scalars['Float']['output'];
  amountCollected: Scalars['Float']['output'];
  amountDue: Scalars['Float']['output'];
  amountExciseTaxOutstanding: Scalars['Float']['output'];
  amountMustPayPriorBalanceRestriction: Scalars['Float']['output'];
  amountNotYetDue: Scalars['Float']['output'];
  amountOutstanding: Scalars['Float']['output'];
  amountOverdue: Scalars['Float']['output'];
  amountRequiredForDelivery: Scalars['Float']['output'];
  assignee?: Maybe<OutstandingBalanceResponseOrderAssignee>;
  codRestriction: Scalars['Boolean']['output'];
  creator?: Maybe<OutstandingBalanceResponseOrderCreator>;
  date: Scalars['String']['output'];
  dueDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  isFactoredOverdueOrder?: Maybe<Scalars['Boolean']['output']>;
  isPreselectedForMPPBNonOverridable?: Maybe<Scalars['Boolean']['output']>;
  isPreselectedForMPPBOverridable?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  mustPayExciseTaxRestriction: Scalars['Boolean']['output'];
  mustPayPriorBalanceRestrictions: Array<OutstandingBalanceResponseOrderRestriction>;
  number: Scalars['Int']['output'];
  orderStatus?: Maybe<OrderStatusEnum>;
};

export type OutstandingBalanceResponseOrderAssignee = {
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type OutstandingBalanceResponseOrderCreator = {
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type OutstandingBalanceResponseOrderRestriction = {
  amount: Scalars['Float']['output'];
  requiredOrderId: Scalars['String']['output'];
};

export type OutstandingOrderForMppb = {
  amount: Scalars['Float']['output'];
  amountCollected: Scalars['Float']['output'];
  amountDue: Scalars['Float']['output'];
  amountExciseTaxOutstanding: Scalars['Float']['output'];
  amountMustPayPriorBalanceRestriction: Scalars['Float']['output'];
  amountNotYetDue: Scalars['Float']['output'];
  amountOutstanding: Scalars['Float']['output'];
  amountOverdue: Scalars['Float']['output'];
  amountRequiredForDelivery: Scalars['Float']['output'];
  assignee?: Maybe<OutstandingBalanceResponseOrderAssignee>;
  codRestriction: Scalars['Boolean']['output'];
  creator?: Maybe<OutstandingBalanceResponseOrderCreator>;
  date: Scalars['String']['output'];
  daysOverdue: Scalars['Int']['output'];
  dueDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoicesS3FileLink?: Maybe<Scalars['String']['output']>;
  isFactoredOverdueOrder?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
};

export type OversoldSkuPayload = {
  availableQuantity: Scalars['Int']['output'];
  requestedQuantity: Scalars['Int']['output'];
  sku: Sku;
};

export type PageInfo = {
  numItemsPerPage?: Maybe<Scalars['Int']['output']>;
  orderBy: Array<OrderBy>;
  page?: Maybe<Scalars['Int']['output']>;
  totalNumItems?: Maybe<Scalars['Int']['output']>;
  totalNumPages?: Maybe<Scalars['Int']['output']>;
};

export type PageInfoInput = {
  numItemsPerPage: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<OrderByInput>>;
  page: Scalars['Int']['input'];
};

export type ParentOrder = {
  createdAt: Scalars['DateTime']['output'];
  discount: Scalars['Float']['output'];
  hashOfNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  orders: Array<Order>;
  organizationId: Scalars['ID']['output'];
  shouldRemoveMinFee: Scalars['Boolean']['output'];
  totalDiscount: Scalars['Float']['output'];
  totalGMV: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ParentSku = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  skus: Array<Sku>;
};

export type Payment = {
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  depositAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<QuickbooksInvoice>;
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  processedDate?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['Int']['output']>;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Values for the PaymentMethodDriverEnum enum */
export enum PaymentMethodDriverEnum {
  Cash = 'CASH',
  Check = 'CHECK',
  Eft = 'EFT',
  Other = 'OTHER',
}

/** Values for the PaymentMethodEnum enum */
export enum PaymentMethodEnum {
  Cash = 'CASH',
  Check = 'CHECK',
  Eft = 'EFT',
  Other = 'OTHER',
}

export type PaymentPayload = {
  pageInfo?: Maybe<PageInfo>;
  results?: Maybe<Array<Maybe<Payment>>>;
};

export type PaymentPermissions = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  hasAllBankingPermissions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type PaymentPermissionsPayload = {
  hasAllBankingPermissions: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type PaymentPickupConfirmation = {
  BSAForm8300SubmissionId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateOfTransaction?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  form8300ConfirmationStatus?: Maybe<Scalars['Boolean']['output']>;
  form8300Email?: Maybe<Scalars['String']['output']>;
  genericFiles?: Maybe<Array<GenericFile>>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  licensedLocationConfirmationUserId?: Maybe<Scalars['ID']['output']>;
  licensedLocationId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['ID']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<PaymentMethodDriverEnum>;
  paymentStatus?: Maybe<PaymentStatusDriverEnum>;
  retailerPaymentAmount?: Maybe<Scalars['Float']['output']>;
  type: PaymentPickupConfirmationEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

/** Values for the PaymentPickupConfirmationEnum enum */
export enum PaymentPickupConfirmationEnum {
  Order = 'ORDER',
  Unscheduled = 'UNSCHEDULED',
}

export type PaymentPickupConfirmationMinimal = {
  createdAt: Scalars['DateTime']['output'];
  dateOfTransaction?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  orderId: Scalars['ID']['output'];
  orderNumber: Scalars['Int']['output'];
  paymentAmount: Scalars['Float']['output'];
};

/** Values for the PaymentStage enum */
export enum PaymentStage {
  Outstanding = 'OUTSTANDING',
  Paid = 'PAID',
}

/** Values for the PaymentStatusDriverEnum enum */
export enum PaymentStatusDriverEnum {
  PaidInFull = 'PAID_IN_FULL',
  PaidInPartial = 'PAID_IN_PARTIAL',
}

/** Values for the PaymentTermsRequestStatusEnum enum */
export enum PaymentTermsRequestStatusEnum {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
}

export type PendingBrandRetailerRestriction = {
  brandId: Scalars['ID']['output'];
  brandOrganizationName: Scalars['String']['output'];
  daysRemaining: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  retailerId: Scalars['ID']['output'];
  retailerOrganizationName: Scalars['String']['output'];
};

export type PendingBrandRetailerRestrictionResponse = {
  pageInfo: PageInfo;
  results: Array<PendingBrandRetailerRestriction>;
};

export type PendingGlobalRetailerRestriction = {
  daysRemaining: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  retailerId: Scalars['ID']['output'];
  retailerOrganizationName: Scalars['String']['output'];
};

export type PendingGlobalRetailerRestrictionResponse = {
  pageInfo: PageInfo;
  results: Array<PendingGlobalRetailerRestriction>;
};

export type PendingOnboardingInvite = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  data: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  type: OnboardingInviteType;
};

export type PerformPreSubmissionCheckOrder = {
  action: OrderActionEnum;
  creditMemo?: InputMaybe<Scalars['Float']['input']>;
  creditMemoPayload?: InputMaybe<Array<CreditMemoPayload>>;
  date: Scalars['DateTime']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  gmv?: InputMaybe<Scalars['Float']['input']>;
  isEditingAndDeliveryDateChanged?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isSalesOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  lineItems?: InputMaybe<Array<Scalars['JSON']['input']>>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organization?: InputMaybe<Scalars['JSON']['input']>;
  site: Scalars['JSON']['input'];
  subOrders?: InputMaybe<Array<Scalars['JSON']['input']>>;
  surcharge?: InputMaybe<Scalars['Float']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type PerformPreSubmissionCheckOrderPayload = {
  errors: PreSubmissionErrors;
};

/** Values for the Period enum */
export enum Period {
  AsNeeded = 'AS_NEEDED',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type PlatformAccessToken = {
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
};

export type PlatformAccessTokenResponse = {
  pageInfo: PageInfo;
  results: Array<PlatformAccessToken>;
};

export type PlatformApiAccessLog = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  method: Scalars['String']['output'];
  platformAccessTokenId: Scalars['String']['output'];
  platformAccessTokenName?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type PlatformApiAccessLogResponse = {
  pageInfo: PageInfo;
  results: Array<PlatformApiAccessLog>;
};

export type PlatformCsvFileLinkResponse = {
  csvFileLink?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlatformCsvInventoryResponse = {
  initiatedSuccessfully: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type PostAccountingApiApplyTransactionInput = {
  newTransactions?: InputMaybe<Array<PostAccountingApiApplyTransactionInputNew>>;
  originalTransactionNumber: Scalars['Int']['input'];
  updateTransactions?: InputMaybe<Array<PostAccountingApiApplyTransactionInputUpdate>>;
};

export type PostAccountingApiApplyTransactionInputNew = {
  amount: Scalars['Float']['input'];
  appliedAt: Scalars['DateTime']['input'];
  invoiceNumber: Scalars['Int']['input'];
};

export type PostAccountingApiApplyTransactionInputUpdate = {
  appliedAt: Scalars['DateTime']['input'];
  transactionNumber: Scalars['Int']['input'];
};

export type PostAccountingApiCreateManualInvoiceForOrderInput = {
  adminNotes: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  invoiceTypeGroupType: InvoiceTypeGroupType;
  invoiceTypeId: Scalars['ID']['input'];
  orderNumber: Scalars['Int']['input'];
};

export type PostAccountingApiCreateManualInvoiceForOrgInput = {
  adminNotes: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  dueDate: Scalars['DateTime']['input'];
  enforcedDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceTypeGroupType: InvoiceTypeGroupType;
  invoiceTypeId: Scalars['ID']['input'];
  isCapitalRemittance?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paidBy: Scalars['ID']['input'];
  paidTo: Scalars['ID']['input'];
};

export type PostAccountingApiDeleteInvoiceByInvoiceNumberInput = {
  invoiceNumber: Scalars['Int']['input'];
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAccountingApiGenerateOrderInput = {
  orderNumber: Scalars['Int']['input'];
};

export type PostAccountingApiGenerateOutstandingAndEligibleInput = {
  email: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PostAccountingApiGenerateOutstandingBalancesReportInput = {
  email: Scalars['String']['input'];
};

export type PostAccountingApiGenerateReconReportInput = {
  email: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type PostAccountingApiRecordTransactionInput = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  earmarkedOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<TransactionLocation>;
  method?: InputMaybe<TransactionMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  originCompany?: InputMaybe<OriginCompany>;
  paidAt: Scalars['String']['input'];
  paidBy?: InputMaybe<Scalars['ID']['input']>;
  publicNotes?: InputMaybe<Scalars['String']['input']>;
  transactionType: TransactionType;
  unappliedReason?: InputMaybe<UnappliedReason>;
};

export type PostAccountingApiRecordTransactionPayload = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
};

export type PostAccountingApiRemittanceReportAcceptRejectInput = {
  accepted: Scalars['Boolean']['input'];
  remittanceReportId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type PostAccountingApiRemittanceReportGenerationInput = {
  endDate: Scalars['DateTime']['input'];
  orgId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type PostAccountingApiRemittanceReportSibanGenerationInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type PostAccountingApiRollbackTransactionByNumberInput = {
  rollbackDate: Scalars['DateTime']['input'];
  rollbackReason?: InputMaybe<RollbackReason>;
  transactionNumber: Scalars['Int']['input'];
};

export type PostAccountingApiUpdateAdjustmentMetaFieldsInput = {
  adjustedAt: Scalars['DateTime']['input'];
  adjustmentNumber: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type PostAccountingApiUpdateDatesRemittanceReportInput = {
  endDate: Scalars['DateTime']['input'];
  remittanceReportId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type PostAccountingApiUpdateTransactionMetaFieldsInput = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  appliedAt?: InputMaybe<Scalars['DateTime']['input']>;
  earmarkedOrganizations?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<TransactionLocation>;
  method?: InputMaybe<TransactionMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  originCompany?: InputMaybe<OriginCompany>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  publicNotes?: InputMaybe<Scalars['String']['input']>;
  transactionNumber: Scalars['Int']['input'];
  unappliedReason?: InputMaybe<UnappliedReason>;
};

export type PreSubmissionErrors = {
  invalidDeliveryDateErrors?: Maybe<Scalars['JSON']['output']>;
  lineItemsThatRequireInternalTransfer?: Maybe<Scalars['JSON']['output']>;
};

export type PremierCreditHoldOrganization = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PreviousRetailerCreditRating = {
  lastCreditRating: Scalars['String']['output'];
  lastCreditRatingDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PromotionRedemption = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lineItemId?: Maybe<Scalars['ID']['output']>;
  orderId: Scalars['ID']['output'];
  promotionsDiscount: Scalars['Float']['output'];
  retailerDiscount: RetailerDiscount;
  retailerDiscountId: Scalars['ID']['output'];
  retailerDiscountSnapshot?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PromotionTier = {
  createdAt: Scalars['DateTime']['output'];
  flatDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  minBrandOrderAmount: Scalars['Float']['output'];
  percentageDiscount?: Maybe<Scalars['Float']['output']>;
  retailerDiscount: RetailerDiscount;
  retailerDiscountId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PublicHomeListElement = {
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inventoryClass?: Maybe<InventoryClassEnum>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplacePage: MarketplacePageType;
  name?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  skus: Array<Sku>;
  startDate: Scalars['DateTime']['output'];
  type: HomeListElementType;
};

export type Query = {
  accountActivity?: Maybe<Array<AccountActivity>>;
  accountTask?: Maybe<Array<AccountTask>>;
  adminCreditSettingsCsv?: Maybe<Scalars['String']['output']>;
  allPayments?: Maybe<PaymentPayload>;
  allStagingAreas?: Maybe<Array<StagingArea>>;
  allStagingAreasWithPagination: StagingAreasPayload;
  bccLicense?: Maybe<Array<BccLicense>>;
  brandRetailerRestrictionWhitelist?: Maybe<BrandRetailerRestrictionWhitelistResponse>;
  brandRetailerRestrictions?: Maybe<BrandRetailerRestrictionResponse>;
  checkConfirmationId?: Maybe<CheckConfirmationIdPayload>;
  checkForDuplicateRetailerGroups: CheckForDuplicateRetailerGroupsPayload;
  checkForDuplicateRetailerGroupsOld?: Maybe<CheckForDuplicateRetailerGroupsOldPayload>;
  checkForExistingOrderFilesByType: CheckForExistingOrderFilesByTypePayload;
  checkOrderNumber?: Maybe<Scalars['Boolean']['output']>;
  countEWBPrePayableOrders?: Maybe<Scalars['Int']['output']>;
  countMarketplaceSkus: MarketplaceSkuCount;
  debugOversoldValidation?: Maybe<Scalars['JSON']['output']>;
  downloadProformaOrder?: Maybe<Scalars['JSON']['output']>;
  elasticSearchMarketplaceSku?: Maybe<ElasticMarketplaceSkuResult>;
  elasticSearchMarketplaceSkus: ElasticMarketplaceSkuInfo;
  environment?: Maybe<Scalars['String']['output']>;
  fetchAsyncTasks?: Maybe<Array<AsyncTaskWithOrder>>;
  fetchConfirmationUser?: Maybe<LicensedLocationConfirmationUser>;
  fetchConfirmationUsers?: Maybe<Array<LicensedLocationConfirmationUser>>;
  fetchLicensedLocationForm8300?: Maybe<Form8300LicensedLocationPayload>;
  findStrainsByName?: Maybe<FindStrainsByNameReturn>;
  getAPIAllOrganizations?: Maybe<Array<FeeServiceOrganization>>;
  getAccountingAPIAllOrganizationsWithRetailers: Array<MinimalOrganizationBanking>;
  getAccountingAPIBrandTransactionsDetailedPage?: Maybe<GetAccountingApiBrandTransactionsDetailedPagePayload>;
  getAccountingAPIBrandTransactionsPage?: Maybe<GetAccountingApiBrandTransactionsPagePayload>;
  getAccountingAPIBrandTransactionsPageCSV?: Maybe<Scalars['Boolean']['output']>;
  getAccountingAPIDetailedInvoice?: Maybe<GetAccountingApiDetailedInvoicePayload>;
  getAccountingAPIDetailedInvoicesByNumber?: Maybe<GetAccountingApiDetailedInvoicesByNumberPayload>;
  getAccountingAPIDetailedPayment?: Maybe<GetAccountingApiDetailedPaymentPayload>;
  getAccountingAPIDownloadReconReport?: Maybe<Scalars['String']['output']>;
  getAccountingAPIDownloadReportCSV?: Maybe<Scalars['String']['output']>;
  getAccountingAPIFetchAllAccounts?: Maybe<GetAccountingApiFetchAllAccountsPayload>;
  getAccountingAPIFetchJournalsForDates?: Maybe<GetAccountingApiFetchJournalsForDatesPayload>;
  getAccountingAPIFetchRemittanceReportByOrg?: Maybe<GetAccountingApiFetchRemittanceReportByOrgPayload>;
  getAccountingAPIGenerateInvoicePageCSV?: Maybe<GetAccountingApiGenerateInvoicePageCsvPayload>;
  getAccountingAPIGenerateTransactionsPageCSV?: Maybe<GetAccountingApiGenerateTransactionsPageCsvPayload>;
  getAccountingAPIInvoiceTypeAll?: Maybe<Array<GetAccountingApiInvoiceTypeAllPayload>>;
  getAccountingAPIInvoices?: Maybe<GetAccountingApiInvoicesPayload>;
  getAccountingAPIPaymentTransactions?: Maybe<GetAccountingApiPaymentTransactionsPayload>;
  getAccountingAPIRetailerTransactionsAllCSV?: Maybe<Scalars['Boolean']['output']>;
  getAccountingAPIRetailerTransactionsPage?: Maybe<GetAccountingApiRetailerTransactionsPagePayload>;
  getAccountingAPIRetailerTransactionsPageCSV?: Maybe<Scalars['Boolean']['output']>;
  getActiveOrdersForSkuBatch: Array<Order>;
  getAdminCreditSettingsData?: Maybe<GetAdminCreditSettingsDataResponse>;
  getAdminFactoredInvoices?: Maybe<AllFactoringInvoicesPayload>;
  getAllAvailableBrandsToRetailer?: Maybe<Array<Organization>>;
  getAllBatchesByCode?: Maybe<Array<Batch>>;
  getAllBrandCreditHoldsForRetailer?: Maybe<Array<OrganizationRelationshipTags>>;
  getAllCustomTags?: Maybe<GetAllCustomTagsPayload>;
  getAllDriverRetailerInvoices?: Maybe<GetAllDriverRetailerInvoicesPayload>;
  getAllMetrcAssociates?: Maybe<Array<User>>;
  getAllOrdersForInvoice?: Maybe<GetAllOrdersForInvoice>;
  getAllRetailerDiscountsApplicableToLicensedLocation?: Maybe<Array<RetailerDiscount>>;
  getAllSalesAssociatedBrands?: Maybe<Array<Maybe<Organization>>>;
  getAllSalesOrganizations?: Maybe<Array<Maybe<Organization>>>;
  getAllSkuByCodeOrName?: Maybe<Array<Sku>>;
  getAnalyticsRetailersInTerritories?: Maybe<Array<LicensedLocation>>;
  getApiKey?: Maybe<Scalars['String']['output']>;
  getAppConstant?: Maybe<AppConstant>;
  getApprovedRetailerLicensedLocations?: Maybe<Array<LicensedLocationForOnboardingRetailers>>;
  getAvailableEmails?: Maybe<Array<AvailableEmail>>;
  getBankAccountInfos?: Maybe<BankAccountInfosPayload>;
  getBankingPageOrders?: Maybe<GetBankingPageOrdersPayload>;
  getBatch?: Maybe<Batch>;
  getBrandCreditHolds?: Maybe<GetBrandCreditHoldsResponse>;
  getBrandCreditSettingsData?: Maybe<GetBrandCreditSettingsDataResponse>;
  getBrandRetailerCreditLimitBrand?: Maybe<GetMultiBrandRetailerCreditLimitsResponse>;
  getBrandRetailerCreditLimitRetailer?: Maybe<GetMultiBrandRetailerCreditLimitsResponse>;
  getBrandRetailerCreditLimitSales?: Maybe<GetMultiBrandRetailerCreditLimitsResponse>;
  getCCPAUsers: Array<Maybe<CcpaUser>>;
  getColdStorageDetails: Array<ColdStorageInfo>;
  getContainerTypes: Array<Scalars['String']['output']>;
  getCreditHoldForLicensedLocation?: Maybe<Scalars['Boolean']['output']>;
  getCreditMemoTypes?: Maybe<Array<Maybe<CreditMemoType>>>;
  getCreditMemosForOrder?: Maybe<Array<Maybe<CreditMemo>>>;
  getCurrentFeaturedBrands: Array<FeaturedBrand>;
  getCustomTags?: Maybe<Array<CustomTag>>;
  getDataTableData?: Maybe<GetDataTableDataPayload>;
  getDefaultSalesRep?: Maybe<GetDefaultSalesRepPayload>;
  getDeploymentMessage: LiveUpdates;
  getDraft?: Maybe<Draft>;
  getDriverAppSubmissions?: Maybe<GetDriverAppSubmissionsResponse>;
  getDriverOrders?: Maybe<GetDriverOrdersPayload>;
  getDriverRetailerInformation?: Maybe<GetDriverRetailerInformationPayload>;
  getEWBMicroTransactions?: Maybe<GetEwbMicroTransactionsPayload>;
  getEWBTransactions?: Maybe<GetEwbTransactionsPayload>;
  getEWBTransactionsForOrg?: Maybe<GetEwbTransactionsForOrgPayload>;
  getEnterpriseNabisRetailerCreditHold?: Maybe<Array<Maybe<EnterpriseNabisRetailerCreditHold>>>;
  getFactoredInvoices?: Maybe<AllFactoringInvoicesPayload>;
  getFeatureFlag?: Maybe<FeatureFlagStatus>;
  getFeaturedBrand?: Maybe<FeaturedBrand>;
  getFeaturedBrands?: Maybe<GetFeaturedBrandsPayload>;
  getFeeChanges?: Maybe<Array<FeeChange>>;
  getFeeGroup?: Maybe<GetFeeGroupPayload>;
  getFeesForOrderByLineItem?: Maybe<GetFeesForOrderByLineItemPayload>;
  getFeesOnOrder?: Maybe<Array<OrderFee>>;
  getFirstShipment?: Maybe<Shipment>;
  getHasMustPayExternalBalance?: Maybe<Scalars['Boolean']['output']>;
  getHighLevelFactoringData?: Maybe<HighLevelFactoringDataPayload>;
  getHomeListElement?: Maybe<HomeListElement>;
  getHomeListElements?: Maybe<Array<HomeListElement>>;
  getInventoryItem?: Maybe<InventoryItem>;
  getInventoryItems: Array<InventoryItem>;
  getInventoryLedgerItem?: Maybe<InventoryLedgerItem>;
  getInventoryQuantity?: Maybe<Scalars['Float']['output']>;
  getInvoiceChangelog?: Maybe<InvoiceChangelogPayload>;
  getLastBrandOrderToLicensedLocation?: Maybe<Order>;
  getLastOrderForLicensedLocation?: Maybe<Order>;
  getLastShipment?: Maybe<Shipment>;
  getLicense?: Maybe<License>;
  getLicensedLocation?: Maybe<LicensedLocation>;
  getLicensedLocationChangelog?: Maybe<Array<Maybe<Changelog>>>;
  getLicensedLocationForConfirmationUser?: Maybe<GetLicensedLocationForConfirmationUserPayload>;
  getLicensedLocationHomeListElements: LicensedLocationHomeListElementResult;
  getLicensedLocations?: Maybe<Array<LicensedLocation>>;
  getLineItem?: Maybe<LineItem>;
  getManufacturerOrderSubscribers?: Maybe<Scalars['JSON']['output']>;
  getMarketplaceGeneralSetting?: Maybe<GetMarketplaceGeneralSettingPayload>;
  getMetrcTransfer?: Maybe<MetrcTransfer>;
  getMetrcTransfers?: Maybe<Array<MetrcTransfer>>;
  getOnboardingInviteData?: Maybe<OnboardingInvitePayload>;
  getOnboardingInvites?: Maybe<Array<PendingOnboardingInvite>>;
  getOnboardingRouteByToken?: Maybe<OnboardingRoute>;
  getOrder?: Maybe<Order>;
  getOrderChangeDriverUpdates?: Maybe<GetOrderChangeDriverUpdatesPayload>;
  getOrderChangelog: Array<OrderChange>;
  getOrderChangelogRetailer: Array<OrderChange>;
  getOrderColdStorageDetails: Array<OrderColdStorageInfo>;
  getOrderExciseTax?: Maybe<CalculateMoneyValues>;
  getOrderFiles?: Maybe<Array<OrderFile>>;
  getOrderForRetailer?: Maybe<GetOrderForRetailerPayload>;
  getOrderRestrictionsForMPPB?: Maybe<OrderRestrictionsForOrderPayload>;
  getOrderRetailer?: Maybe<OrderRetailer>;
  getOrders: Array<Order>;
  getOrdersDocs?: Maybe<GetOrdersDocsPayload>;
  getOrdersForChromeExtension?: Maybe<GetOrdersForChromeExtensionPayload>;
  getOrganization?: Maybe<Organization>;
  getOrganizationByAlias?: Maybe<Organization>;
  getOrganizationContactMembers?: Maybe<Organization>;
  getOrganizationFactorInformation?: Maybe<OrganizationFactorPricing>;
  getOrganizationInvite?: Maybe<OrganizationInvite>;
  getOrganizationPricing?: Maybe<GetOrganizationPricingPayload>;
  getOrganizationSalesMembers?: Maybe<Array<Maybe<Organization>>>;
  getOrganizationUser?: Maybe<OrganizationUser>;
  getOverdueBrandFeesCollectionDays?: Maybe<Scalars['Int']['output']>;
  getPaymentPermissions?: Maybe<PaymentPermissionsPayload>;
  getPaymentPickupOrganizations?: Maybe<Array<Organization>>;
  getPromotionRedemptions?: Maybe<Array<PromotionRedemption>>;
  getPublicHomeListElements?: Maybe<Array<PublicHomeListElement>>;
  getReferralById?: Maybe<Referral>;
  getReorderEmailContent?: Maybe<GetReorderEmailContentPayload>;
  getRetailerDiscount?: Maybe<RetailerDiscount>;
  getRetailerDiscountByCode?: Maybe<RetailerDiscount>;
  getRetailerDiscounts?: Maybe<GetRetailerDiscountsPayload>;
  getRetailerDiscountsByCodes?: Maybe<Array<RetailerDiscount>>;
  getRetailerGroupSalesRules: Array<SalesRulesPayload>;
  getRetailerGroups: GetRetailerGroupsPayload;
  getRetailerMenuInfo?: Maybe<GetRetailerMenuInfoPayload>;
  getRetailerMenuProducts?: Maybe<GetRetailerMenuProductsPayload>;
  getRetailersFromOrganizationOrders?: Maybe<Array<LicensedLocation>>;
  getRetailersFromReferral?: Maybe<GetRetailersFromReferrerPayload>;
  getRole?: Maybe<Role>;
  getSalesRulesByRetailerGroup?: Maybe<Array<SalesRule>>;
  getSampleOrderPricing?: Maybe<GetSampleOrderPricingPayload>;
  getShipment?: Maybe<Shipment>;
  getShipmentsByOrder?: Maybe<Array<MultiShipmentPayload>>;
  getShipmentsForChromeExtension?: Maybe<Array<Shipment>>;
  getSimilarSkus?: Maybe<Array<Sku>>;
  getSite?: Maybe<Site>;
  getSku?: Maybe<Sku>;
  getSkuBatch?: Maybe<SkuBatch>;
  getSkuBatchPair?: Maybe<Array<SkuBatch>>;
  getSkuBrandNames?: Maybe<Array<Scalars['String']['output']>>;
  getSkuDetails?: Maybe<SkuDetails>;
  getSkuProductLines?: Maybe<Array<Scalars['String']['output']>>;
  getSkuSalesRule?: Maybe<GetSkuSalesRulePayload>;
  getStagingArea?: Maybe<StagingArea>;
  getStrain?: Maybe<Strain>;
  getSubscriptionsForBrand: StockBrandSubscription;
  getSubscriptionsForSku: StockSkuSubscription;
  getTrackerShipments?: Maybe<ShipmentTrackerPayload>;
  getUnfactoredInvoices?: Maybe<AllFactoringInvoicesPayload>;
  getUser?: Maybe<User>;
  getUserByEmail?: Maybe<GetUserByEmailPayload>;
  getUserCart?: Maybe<Cart>;
  getUserPreferences?: Maybe<Array<UserPreference>>;
  getVehicle?: Maybe<Vehicle>;
  getZipcodes?: Maybe<GetZipcodesPayload>;
  globalRetailerRestrictionWhitelist?: Maybe<GlobalRetailerRestrictionWhitelistResponse>;
  globalRetailerRestrictions?: Maybe<GlobalRetailerRestrictionResponse>;
  inventoryMeta: InventoryMeta;
  inventoryMetaCategory: Array<Maybe<InventoryMetaCategory>>;
  inventoryMetaMarketingTag: Array<Maybe<InventoryMetaMarketingTag>>;
  inventoryMetaTag: Array<Maybe<InventoryMetaTag>>;
  inventoryMetaTagGroup: Array<Maybe<InventoryMetaTagGroup>>;
  pendingBrandRetailerRestrictions?: Maybe<PendingBrandRetailerRestrictionResponse>;
  pendingGlobalRetailerRestrictions?: Maybe<PendingGlobalRetailerRestrictionResponse>;
  performPreSubmissionChecks?: Maybe<PerformPreSubmissionCheckOrderPayload>;
  pinnedAccountActivity?: Maybe<Array<AccountActivity>>;
  platformAccessTokens?: Maybe<PlatformAccessTokenResponse>;
  platformApiAccessLogs?: Maybe<PlatformApiAccessLogResponse>;
  queryForm8300SubmissionDownloadLinkByDate?: Maybe<Array<BsaForm8300SubmissionDaily>>;
  queryForm8300SubmissionIndividual?: Maybe<BsaForm8300Submission>;
  retailerPricingGenerateCsv: RetailerPricingSalesRulesGenerateCsvResponse;
  retailerPricingGetConflicts: RetailerPricingSalesRuleConflictsResponse;
  retailerPricingGetItemPrices: Array<RetailerPricingItemPricesResponse>;
  retailerPricingGetItemProperties: RetailerPricingItemPropertiesResponse;
  retailerPricingGetItems: RetailerPricingItemGetManyResponse;
  retailerPricingGetRetailerProperties: RetailerPricingRetailerPropertiesResponse;
  retailerPricingGetRetailerSettings: RetailerPricingRetailerGetSettingsResponse;
  retailerPricingGetRetailers: RetailerPricingRetailerGetManyResponse;
  retailerPricingGetSalesRule: RetailerPricingSalesRuleResponse;
  retailerPricingGetSalesRules: RetailerPricingSalesRulesGetManyResponse;
  retailerPricingGetSalesRulesActiveAbbreviated: RetailerPricingSalesRuleActiveAbbreviatedMaps;
  retailerRestrictionBrandLookup?: Maybe<RetailerRestrictionBrandLookupResponse>;
  retailerRestrictionRetailerLookup?: Maybe<RetailerRestrictionRetailerLookupResponse>;
  searchMarketplaceBrands: MarketplaceBrandInfo;
  searchMarketplaceSkus: MarketplaceSkuInfo;
  subscribeToBrandSkuBatchExpiration: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuInStock: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuOutOfStock: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuStockDecrease: Array<StockSubscriptionMutationResponse>;
  subscribeToBrandSkuStockIncrease: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuBatchExpiration: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuInStock: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuOutOfStock: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuStockDecrease: Array<StockSubscriptionMutationResponse>;
  subscribeToSkuStockIncrease: Array<StockSubscriptionMutationResponse>;
  unsubscribeFromBrand: Scalars['Boolean']['output'];
  unsubscribeFromSku: Scalars['Boolean']['output'];
  userLicensedLocationRelationship?: Maybe<UserLicensedLocationRelationship>;
  verifyJwt?: Maybe<VerifyJwtResponse>;
  viewer?: Maybe<Viewer>;
};

export type QueryAccountActivityArgs = {
  input: AccountActivityInput;
};

export type QueryAccountTaskArgs = {
  input: AccountTaskInput;
};

export type QueryAdminCreditSettingsCsvArgs = {
  input?: InputMaybe<AdminCreditSettingsCsvInput>;
};

export type QueryAllPaymentsArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAllStagingAreasArgs = {
  input: AllStagingAreasInput;
};

export type QueryAllStagingAreasWithPaginationArgs = {
  input: AllStagingAreasWithPaginationInput;
};

export type QueryBccLicenseArgs = {
  licenseNumber: Scalars['String']['input'];
};

export type QueryBrandRetailerRestrictionsArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type QueryCheckConfirmationIdArgs = {
  paymentPickupConfirmationId: Scalars['ID']['input'];
};

export type QueryCheckForDuplicateRetailerGroupsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  retailerGroupLicensedLocations: Array<RetailerGroupLicensedLocationInput>;
};

export type QueryCheckForDuplicateRetailerGroupsOldArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  retailerGroupLicensedLocations: Array<RetailerGroupLicensedLocationInput>;
};

export type QueryCheckForExistingOrderFilesByTypeArgs = {
  orderNumbers: Array<Scalars['Int']['input']>;
  type: OrderFileType;
};

export type QueryCheckOrderNumberArgs = {
  orderNumber: Scalars['Int']['input'];
};

export type QueryCountEwbPrePayableOrdersArgs = {
  input?: InputMaybe<CountEwbPrePayableOrdersInput>;
};

export type QueryCountMarketplaceSkusArgs = {
  inStockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryClass: InventoryClassEnum;
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryDebugOversoldValidationArgs = {
  licensedLocationId: Scalars['ID']['input'];
  lineItems: Array<DebugLineItemInput>;
};

export type QueryDownloadProformaOrderArgs = {
  input: DownloadProformaInput;
};

export type QueryElasticSearchMarketplaceSkuArgs = {
  licensedLocationId: Scalars['ID']['input'];
  retailerOrganizationId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
};

export type QueryElasticSearchMarketplaceSkusArgs = {
  aromas?: InputMaybe<Array<AromaEnum>>;
  brandIdsExclusive?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIdsInclusive?: InputMaybe<Array<Scalars['ID']['input']>>;
  cbdPercentageMax?: InputMaybe<Scalars['Float']['input']>;
  cbdPercentageMin?: InputMaybe<Scalars['Float']['input']>;
  cbdWeightMax?: InputMaybe<Scalars['Float']['input']>;
  cbdWeightMin?: InputMaybe<Scalars['Float']['input']>;
  customTags?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedSkus?: InputMaybe<Array<Scalars['ID']['input']>>;
  inStockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryCategories?: InputMaybe<Array<InventoryCategoryEnum>>;
  inventoryCategoryTags?: InputMaybe<Array<InventoryCategoryTagEnum>>;
  inventoryClasses?: InputMaybe<Array<InventoryClassEnum>>;
  inventoryTags?: InputMaybe<Array<InventoryTagEnum>>;
  licensedLocationId: Scalars['ID']['input'];
  limitToPastPurchases?: InputMaybe<Scalars['Boolean']['input']>;
  listType?: InputMaybe<HomeListElementType>;
  order: MarketplaceSkuOrder;
  pageInfo: PageInfoInput;
  promotionsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  retailerOrganizationId: Scalars['ID']['input'];
  samplesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  strainTypes?: InputMaybe<Array<StrainTypeEnum>>;
  thcPercentageMax?: InputMaybe<Scalars['Float']['input']>;
  thcPercentageMin?: InputMaybe<Scalars['Float']['input']>;
  thcWeightMax?: InputMaybe<Scalars['Float']['input']>;
  thcWeightMin?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryFetchAsyncTasksArgs = {
  input: FetchAsyncTasksInput;
};

export type QueryFetchConfirmationUserArgs = {
  licensedLocationConfirmationUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFetchConfirmationUsersArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryFetchLicensedLocationForm8300Args = {
  input: FetchLicensedLocationForm8300Input;
};

export type QueryFindStrainsByNameArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAccountingApiBrandTransactionsDetailedPageArgs = {
  input?: InputMaybe<GetAccountingApiBrandTransactionsDetailedPageInput>;
};

export type QueryGetAccountingApiBrandTransactionsPageArgs = {
  input?: InputMaybe<GetAccountingApiBrandTransactionsPageInput>;
};

export type QueryGetAccountingApiBrandTransactionsPageCsvArgs = {
  input?: InputMaybe<GetAccountingApiBrandTransactionsPageCsvInput>;
};

export type QueryGetAccountingApiDetailedInvoiceArgs = {
  input?: InputMaybe<GetAccountingApiDetailedInvoiceInput>;
};

export type QueryGetAccountingApiDetailedInvoicesByNumberArgs = {
  input?: InputMaybe<GetAccountingApiDetailedInvoicesByNumberInput>;
};

export type QueryGetAccountingApiDetailedPaymentArgs = {
  input?: InputMaybe<GetAccountingApiDetailedPaymentInput>;
};

export type QueryGetAccountingApiDownloadReconReportArgs = {
  input?: InputMaybe<GetAccountingApiDownloadReportCsvInput>;
};

export type QueryGetAccountingApiDownloadReportCsvArgs = {
  input?: InputMaybe<GetAccountingApiDownloadReportCsvInput>;
};

export type QueryGetAccountingApiFetchJournalsForDatesArgs = {
  input?: InputMaybe<FetchJournalsForDatesInput>;
};

export type QueryGetAccountingApiFetchRemittanceReportByOrgArgs = {
  input?: InputMaybe<GetAccountingApiFetchRemittanceReportByOrgInput>;
};

export type QueryGetAccountingApiGenerateInvoicePageCsvArgs = {
  input?: InputMaybe<GetAccountingApiGenerateInvoicePageCsvInput>;
};

export type QueryGetAccountingApiGenerateTransactionsPageCsvArgs = {
  input?: InputMaybe<GetAccountingApiGenerateTransactionsPageCsvInput>;
};

export type QueryGetAccountingApiInvoicesArgs = {
  input?: InputMaybe<GetAccountingApiInvoicesInput>;
};

export type QueryGetAccountingApiPaymentTransactionsArgs = {
  input?: InputMaybe<GetAccountingApiPaymentTransactionsInput>;
};

export type QueryGetAccountingApiRetailerTransactionsAllCsvArgs = {
  input?: InputMaybe<GetAccountingApiRetailerTransactionsAllCsvInput>;
};

export type QueryGetAccountingApiRetailerTransactionsPageArgs = {
  input?: InputMaybe<GetAccountingApiRetailerTransactionsPageInput>;
};

export type QueryGetAccountingApiRetailerTransactionsPageCsvArgs = {
  input?: InputMaybe<GetAccountingApiRetailerTransactionsPageCsvInput>;
};

export type QueryGetActiveOrdersForSkuBatchArgs = {
  skuBatchId: Scalars['ID']['input'];
};

export type QueryGetAdminCreditSettingsDataArgs = {
  input?: InputMaybe<GetAdminCreditSettingsDataInput>;
};

export type QueryGetAdminFactoredInvoicesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  factorStatus?: InputMaybe<OrderFactorStatusEnum>;
  isAdvancePaid?: InputMaybe<Scalars['Boolean']['input']>;
  isReservePaid?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStatus?: InputMaybe<Array<InputMaybe<OrderPaymentStatusEnum>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryGetAllAvailableBrandsToRetailerArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetAllBatchesByCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAllBrandCreditHoldsForRetailerArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetAllCustomTagsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  type: CustomTagTypeEnum;
  usedByOrganizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetAllDriverRetailerInvoicesArgs = {
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetAllOrdersForInvoiceArgs = {
  input?: InputMaybe<GetAllOrdersForInvoiceInput>;
};

export type QueryGetAllRetailerDiscountsApplicableToLicensedLocationArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetAllSalesAssociatedBrandsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetAllSkuByCodeOrNameArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAnalyticsRetailersInTerritoriesArgs = {
  licensedLocationIds: Array<Scalars['ID']['input']>;
  territoryIds: Array<Scalars['ID']['input']>;
};

export type QueryGetApiKeyArgs = {
  clientUuid: Scalars['String']['input'];
};

export type QueryGetAvailableEmailsArgs = {
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetBankAccountInfosArgs = {
  input?: InputMaybe<GetBankAccountInfosInput>;
};

export type QueryGetBankingPageOrdersArgs = {
  input?: InputMaybe<GetBankingPageOrdersInput>;
};

export type QueryGetBatchArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetBrandCreditHoldsArgs = {
  brandOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageInfo?: InputMaybe<PageInfoInput>;
  retailerOrganizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetBrandCreditSettingsDataArgs = {
  input?: InputMaybe<GetBrandCreditSettingsDataInput>;
};

export type QueryGetBrandRetailerCreditLimitBrandArgs = {
  input: FetchMultiBrandRetailerCreditLimitsBrandUserInput;
};

export type QueryGetBrandRetailerCreditLimitRetailerArgs = {
  input: FetchMultiBrandRetailerCreditLimitsRetailerUserInput;
};

export type QueryGetBrandRetailerCreditLimitSalesArgs = {
  input: FetchMultiBrandRetailerCreditLimitsSalesUserInput;
};

export type QueryGetCcpaUsersArgs = {
  dateOfBirth: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type QueryGetColdStorageDetailsArgs = {
  skuIds: Array<Scalars['ID']['input']>;
};

export type QueryGetContainerTypesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetCreditHoldForLicensedLocationArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetCreditMemosForOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryGetCurrentFeaturedBrandsArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetCustomTagsArgs = {
  id: Scalars['ID']['input'];
  type: CustomTagTypeEnum;
};

export type QueryGetDataTableDataArgs = {
  pageInfo: PageInfoInput;
  search?: InputMaybe<Scalars['String']['input']>;
  someFilter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetDefaultSalesRepArgs = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetDraftArgs = {
  id: Scalars['ID']['input'];
  type: DraftTypeEnum;
};

export type QueryGetDriverAppSubmissionsArgs = {
  input?: InputMaybe<GetDriverAppSubmissionsInput>;
};

export type QueryGetDriverOrdersArgs = {
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetDriverRetailerInformationArgs = {
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetEwbMicroTransactionsArgs = {
  input?: InputMaybe<GetEwbMicroTransactionsInput>;
};

export type QueryGetEwbTransactionsArgs = {
  input?: InputMaybe<GetEwbTransactionsInput>;
};

export type QueryGetEwbTransactionsForOrgArgs = {
  input?: InputMaybe<GetEwbTransactionsForOrgInput>;
};

export type QueryGetEnterpriseNabisRetailerCreditHoldArgs = {
  input?: InputMaybe<GetEnterpriseNabisRetailerCreditHoldInput>;
};

export type QueryGetFactoredInvoicesArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  factorStatus: OrderFactorStatusEnum;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryGetFeatureFlagArgs = {
  key: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetFeaturedBrandArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetFeaturedBrandsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pageInfo: PageInfoInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetFeeChangesArgs = {
  groupTag: Scalars['Int']['input'];
};

export type QueryGetFeeGroupArgs = {
  groupTag: Scalars['Int']['input'];
};

export type QueryGetFeesForOrderByLineItemArgs = {
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetFeesOnOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryGetFirstShipmentArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetHasMustPayExternalBalanceArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetHighLevelFactoringDataArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetHomeListElementArgs = {
  homeListElementId: Scalars['ID']['input'];
};

export type QueryGetHomeListElementsArgs = {
  marketplacePage: MarketplacePageType;
  view: HomeListElementView;
};

export type QueryGetInventoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
  storageType?: InputMaybe<InventoryStorageType>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetInventoryItemsArgs = {
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetInventoryLedgerItemArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetInventoryQuantityArgs = {
  organizationId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
  storageType: InventoryStorageType;
  warehouseId: Scalars['ID']['input'];
};

export type QueryGetInvoiceChangelogArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryGetLastBrandOrderToLicensedLocationArgs = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetLastOrderForLicensedLocationArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetLastShipmentArgs = {
  orderId?: InputMaybe<Scalars['ID']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetLicenseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetLicensedLocationArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetLicensedLocationChangelogArgs = {
  licensedLocationId: Scalars['String']['input'];
};

export type QueryGetLicensedLocationForConfirmationUserArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetLicensedLocationHomeListElementsArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  marketplacePage?: InputMaybe<MarketplacePageType>;
  pageInfo?: InputMaybe<PageInfoInput>;
  types?: InputMaybe<Array<HomeListElementType>>;
};

export type QueryGetLicensedLocationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetLineItemArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetManufacturerOrderSubscribersArgs = {
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetMetrcTransferArgs = {
  destinationLicensedLocationId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  originLicensedLocationId: Scalars['ID']['input'];
};

export type QueryGetMetrcTransfersArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryGetOnboardingInviteDataArgs = {
  token: Scalars['String']['input'];
};

export type QueryGetOnboardingInvitesArgs = {
  callerLocation?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetOnboardingRouteByTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryGetOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  sortLikeMetrc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetOrderChangeDriverUpdatesArgs = {
  orderId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
};

export type QueryGetOrderChangelogArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOrderChangelogRetailerArgs = {
  id: Scalars['ID']['input'];
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetOrderColdStorageDetailsArgs = {
  orderIds: Array<Scalars['ID']['input']>;
};

export type QueryGetOrderExciseTaxArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryGetOrderFilesArgs = {
  orderId: Scalars['ID']['input'];
  type?: InputMaybe<OrderFileType>;
};

export type QueryGetOrderForRetailerArgs = {
  retailerConfirmLinkId: Scalars['ID']['input'];
};

export type QueryGetOrderRestrictionsForMppbArgs = {
  input: GetOrderRestrictionsForMppbInput;
};

export type QueryGetOrderRetailerArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOrdersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryGetOrdersDocsArgs = {
  input: GetOrdersDocsInput;
};

export type QueryGetOrdersForChromeExtensionArgs = {
  deliveryDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  orderNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryGetOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOrganizationByAliasArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetOrganizationContactMembersArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOrganizationFactorInformationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetOrganizationInviteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOrganizationPricingArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryGetOrganizationSalesMembersArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetOrganizationUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPaymentPermissionsArgs = {
  input?: InputMaybe<GetPaymentPermissionsInput>;
};

export type QueryGetPromotionRedemptionsArgs = {
  orderId: Scalars['ID']['input'];
};

export type QueryGetReferralByIdArgs = {
  referralId: Scalars['String']['input'];
};

export type QueryGetReorderEmailContentArgs = {
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetRetailerDiscountArgs = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetRetailerDiscountByCodeArgs = {
  code: Scalars['String']['input'];
};

export type QueryGetRetailerDiscountsArgs = {
  callerLocation?: InputMaybe<Scalars['String']['input']>;
  includePromoCodePromos?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds: Array<Scalars['ID']['input']>;
  pageInfo: PageInfoInput;
  search?: InputMaybe<Scalars['String']['input']>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetRetailerDiscountsByCodesArgs = {
  codes: Array<Scalars['String']['input']>;
};

export type QueryGetRetailerGroupSalesRulesArgs = {
  brandOrganizationIds: Array<Scalars['ID']['input']>;
  licensedLocationId: Scalars['ID']['input'];
};

export type QueryGetRetailerGroupsArgs = {
  organizationId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skuId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetRetailerMenuInfoArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetRetailerMenuProductsArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageInfo: PageInfoInput;
};

export type QueryGetRetailersFromOrganizationOrdersArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryGetRetailersFromReferralArgs = {
  brand: Scalars['String']['input'];
  user?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetRoleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSalesRulesByRetailerGroupArgs = {
  retailerGroupId: Scalars['ID']['input'];
};

export type QueryGetSampleOrderPricingArgs = {
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  orderDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryGetShipmentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetShipmentsByOrderArgs = {
  includeMetrcTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryGetShipmentsForChromeExtensionArgs = {
  shipmentNumbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryGetSimilarSkusArgs = {
  skuId: Scalars['ID']['input'];
};

export type QueryGetSiteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSkuArgs = {
  id: Scalars['ID']['input'];
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSkuBatchArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSkuBatchPairArgs = {
  batchId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
};

export type QueryGetSkuBrandNamesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSkuDetailsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSkuProductLinesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSkuSalesRuleArgs = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  skuId: Scalars['ID']['input'];
};

export type QueryGetStagingAreaArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetStrainArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSubscriptionsForBrandArgs = {
  brandId: Array<Scalars['ID']['input']>;
};

export type QueryGetSubscriptionsForSkuArgs = {
  skuId: Array<Scalars['ID']['input']>;
};

export type QueryGetTrackerShipmentsArgs = {
  input: ShipmentTrackerQueryInput;
};

export type QueryGetUnfactoredInvoicesArgs = {
  daysTillPaymentDue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  factorStatus: OrderFactorStatusEnum;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetUserByEmailArgs = {
  token: Scalars['String']['input'];
};

export type QueryGetUserCartArgs = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QueryGetUserPreferencesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type QueryGetVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetZipcodesArgs = {
  input: GetZipcodesInput;
};

export type QueryGlobalRetailerRestrictionsArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type QueryPendingBrandRetailerRestrictionsArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type QueryPendingGlobalRetailerRestrictionsArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type QueryPerformPreSubmissionChecksArgs = {
  input: PerformPreSubmissionCheckOrder;
  isV2MaxLineItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPinnedAccountActivityArgs = {
  input: UserLicensedLocationQueryInput;
};

export type QueryPlatformAccessTokensArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryPlatformApiAccessLogsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryQueryForm8300SubmissionDownloadLinkByDateArgs = {
  date: Scalars['DateTime']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type QueryQueryForm8300SubmissionIndividualArgs = {
  id: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRetailerPricingGenerateCsvArgs = {
  brandId: Scalars['String']['input'];
};

export type QueryRetailerPricingGetConflictsArgs = {
  brandId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  salesRule: RetailerPricingSalesRuleGetConflictsInput;
};

export type QueryRetailerPricingGetItemPricesArgs = {
  brandId: Scalars['String']['input'];
  retailerItems: Array<RetailerPricingRetailerItemsInput>;
};

export type QueryRetailerPricingGetItemPropertiesArgs = {
  brandId: Scalars['String']['input'];
};

export type QueryRetailerPricingGetItemsArgs = {
  brandId: Scalars['String']['input'];
  inventoryCategory?: InputMaybe<InventoryCategoryEnum>;
  inventoryClass?: InputMaybe<InventoryClassEnum>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRetailerPricingGetRetailerPropertiesArgs = {
  brandId: Scalars['String']['input'];
};

export type QueryRetailerPricingGetRetailerSettingsArgs = {
  brandId: Scalars['String']['input'];
  retailerId: Array<Scalars['String']['input']>;
};

export type QueryRetailerPricingGetRetailersArgs = {
  brandId: Scalars['String']['input'];
  creditScore?: InputMaybe<CreditRatingTrustLevels>;
  hasPreviouslyPurchasedFromBrand?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  territory?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRetailerPricingGetSalesRuleArgs = {
  brandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type QueryRetailerPricingGetSalesRulesArgs = {
  brandId: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<RetailerPricingOrderEnum>;
  orderBy?: InputMaybe<RetailerPricingSalesRuleOrderByEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  retailerId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRetailerPricingGetSalesRulesActiveAbbreviatedArgs = {
  brandId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRetailerRestrictionBrandLookupArgs = {
  brand: Scalars['String']['input'];
};

export type QueryRetailerRestrictionRetailerLookupArgs = {
  retailer: Scalars['String']['input'];
};

export type QuerySearchMarketplaceBrandsArgs = {
  licensedLocationId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
  query: Scalars['String']['input'];
};

export type QuerySearchMarketplaceSkusArgs = {
  aromas?: InputMaybe<Array<AromaEnum>>;
  brandIdsExclusive?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIdsInclusive?: InputMaybe<Array<Scalars['ID']['input']>>;
  cbdPercentageMax?: InputMaybe<Scalars['Float']['input']>;
  cbdPercentageMin?: InputMaybe<Scalars['Float']['input']>;
  cbdWeightMax?: InputMaybe<Scalars['Float']['input']>;
  cbdWeightMin?: InputMaybe<Scalars['Float']['input']>;
  customTags?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedSkus?: InputMaybe<Array<Scalars['ID']['input']>>;
  inStockOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inventoryCategories?: InputMaybe<Array<InventoryCategoryEnum>>;
  inventoryCategoryTags?: InputMaybe<Array<InventoryCategoryTagEnum>>;
  inventoryClasses?: InputMaybe<Array<InventoryClassEnum>>;
  inventoryTags?: InputMaybe<Array<InventoryTagEnum>>;
  licensedLocationId: Scalars['ID']['input'];
  limitToPastPurchases?: InputMaybe<Scalars['Boolean']['input']>;
  listType?: InputMaybe<HomeListElementType>;
  order: MarketplaceSkuOrder;
  pageInfo: PageInfoInput;
  query?: InputMaybe<Scalars['String']['input']>;
  samplesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  strainTypes?: InputMaybe<Array<StrainTypeEnum>>;
  thcPercentageMax?: InputMaybe<Scalars['Float']['input']>;
  thcPercentageMin?: InputMaybe<Scalars['Float']['input']>;
  thcWeightMax?: InputMaybe<Scalars['Float']['input']>;
  thcWeightMin?: InputMaybe<Scalars['Float']['input']>;
};

export type QuerySubscribeToBrandSkuBatchExpirationArgs = {
  brandId: Scalars['ID']['input'];
  hoursBeforeExpiration: Scalars['Int']['input'];
};

export type QuerySubscribeToBrandSkuInStockArgs = {
  brandId: Scalars['ID']['input'];
};

export type QuerySubscribeToBrandSkuOutOfStockArgs = {
  brandId: Scalars['ID']['input'];
};

export type QuerySubscribeToBrandSkuStockDecreaseArgs = {
  brandId: Scalars['ID']['input'];
  minStockThreshold: Scalars['Int']['input'];
};

export type QuerySubscribeToBrandSkuStockIncreaseArgs = {
  brandId: Scalars['ID']['input'];
  minStockThreshold: Scalars['Int']['input'];
};

export type QuerySubscribeToSkuBatchExpirationArgs = {
  hoursBeforeExpiration: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

export type QuerySubscribeToSkuInStockArgs = {
  skuId: Scalars['ID']['input'];
};

export type QuerySubscribeToSkuOutOfStockArgs = {
  skuId: Scalars['ID']['input'];
};

export type QuerySubscribeToSkuStockDecreaseArgs = {
  minStockThreshold: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

export type QuerySubscribeToSkuStockIncreaseArgs = {
  minStockThreshold: Scalars['Int']['input'];
  skuId: Scalars['ID']['input'];
};

export type QueryUnsubscribeFromBrandArgs = {
  subscriptionId: Scalars['String']['input'];
  type: StockSubscriptionEnum;
};

export type QueryUnsubscribeFromSkuArgs = {
  subscriptionId: Scalars['String']['input'];
  type: StockSubscriptionEnum;
};

export type QueryUserLicensedLocationRelationshipArgs = {
  input: UserLicensedLocationQueryInput;
};

/** Values for the QuickbooksCompanyEnum enum */
export enum QuickbooksCompanyEnum {
  Nabifive = 'NABIFIVE',
  Nabione = 'NABIONE',
  Nabitwo = 'NABITWO',
}

export type QuickbooksInvoice = {
  company: QuickbooksCompanyEnum;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  grouping?: Maybe<QuickbooksInvoiceGroupingEnum>;
  id: Scalars['ID']['output'];
  invoiceOwner: QuickbooksInvoiceOwnerEnum;
  orderId: Scalars['ID']['output'];
  qbInvoiceId?: Maybe<Scalars['String']['output']>;
  qbInvoiceSyncToken?: Maybe<Scalars['String']['output']>;
  regenerateInvoice?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Values for the QuickbooksInvoiceGroupingEnum enum */
export enum QuickbooksInvoiceGroupingEnum {
  MultiA = 'MULTI_A',
  MultiB = 'MULTI_B',
  MultiC = 'MULTI_C',
  MultiC1 = 'MULTI_C1',
  MultiC2 = 'MULTI_C2',
  Single = 'SINGLE',
}

/** Values for the QuickbooksInvoiceOwnerEnum enum */
export enum QuickbooksInvoiceOwnerEnum {
  Brand = 'BRAND',
  Nabis = 'NABIS',
  Retailer = 'RETAILER',
}

export type ReducedLicensedLocation = {
  doingBusinessAs: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReducedLineItem = {
  batchCOA?: Maybe<Scalars['String']['output']>;
  batchCode?: Maybe<Scalars['String']['output']>;
  skuCode?: Maybe<Scalars['String']['output']>;
  skuName?: Maybe<Scalars['String']['output']>;
};

export type ReducedOrganization = {
  doingBusinessAs: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Referral = {
  allowMarketplaceContactInfo: Scalars['Boolean']['output'];
  brand: Scalars['String']['output'];
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type RefreshTokenPayload = {
  token: Scalars['String']['output'];
};

export type RejectDeliveryInput = {
  retailerConfirmLinkId: Scalars['ID']['input'];
  retailerNotes: Scalars['String']['input'];
};

export type RejectDeliveryPayload = {
  success: Scalars['Boolean']['output'];
};

/** Values for the RemittanceReportStatus enum */
export enum RemittanceReportStatus {
  Accepted = 'ACCEPTED',
  Generated = 'GENERATED',
  Rejected = 'REJECTED',
}

export type RemoveAccountActivityPinInput = {
  rowId: Scalars['ID']['input'];
};

export type RequestFactorInvoiceInput = {
  factorStatus: OrderFactorStatusEnum;
  invoiceId: Scalars['ID']['input'];
  invoiceNumber: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ResetPasswordInput = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RestoreRetailerGroupPayload = {
  duplicateRetailerGroupLicensedLocations?: Maybe<Array<RetailerGroupLicensedLocation>>;
  hasDuplicates: Scalars['Boolean']['output'];
  retailerGroup?: Maybe<RetailerGroup>;
};

export type RestrictionInformation = {
  brandsNotAllowedForMarketplace: Array<Maybe<Scalars['String']['output']>>;
  creditHolds: CreditHolds;
  disableMarketplace: Scalars['Boolean']['output'];
  isFeatureFlagEnterpriseBrandCreditHoldEnabled: Scalars['Boolean']['output'];
  marketplaceOrderingRestrictions: MarketplaceOrderingRestrictions;
  orderingRestrictions: OrderingRestrictions;
  premierBrands: Array<PremierCreditHoldOrganization>;
};

export type RestrictionInformationRetailer = {
  decodedBrandOrganizationId?: Maybe<Scalars['String']['output']>;
  decodedRetailerLicensedLocationId: Scalars['String']['output'];
};

/** Values for the RestrictionStatus enum */
export enum RestrictionStatus {
  IsCodOnly = 'isCodOnly',
  IsNetTermsLimited = 'isNetTermsLimited',
  IsOnBrandCreditHold = 'isOnBrandCreditHold',
  IsOnCreditHold = 'isOnCreditHold',
  IsRetailerRestricted = 'isRetailerRestricted',
  IsRetailerRestrictedForBrand = 'isRetailerRestrictedForBrand',
}

/** Values for the RetailerConfirmationStatus enum */
export enum RetailerConfirmationStatus {
  Confirmed = 'CONFIRMED',
  NotContacted = 'NOT_CONTACTED',
  Rejected = 'REJECTED',
  Unconfirmed = 'UNCONFIRMED',
}

export type RetailerDiscount = {
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountType: RetailerDiscountType;
  distinctRedemptionCount: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  flatDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  maxCodeRedemptions?: Maybe<Scalars['Int']['output']>;
  minBrandCount?: Maybe<Scalars['Int']['output']>;
  minBrandOrderAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  percentageDiscount?: Maybe<Scalars['Float']['output']>;
  redemptions: Array<PromotionRedemption>;
  retailerGroups: Array<RetailerGroup>;
  skus: Array<Sku>;
  startDate: Scalars['DateTime']['output'];
  tiers: Array<PromotionTier>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Values for the RetailerDiscountType enum */
export enum RetailerDiscountType {
  BuyXGetY = 'BUY_X_GET_Y',
  FlatPercentage = 'FLAT_PERCENTAGE',
  FlatSum = 'FLAT_SUM',
  ProductBundling = 'PRODUCT_BUNDLING',
}

export type RetailerGroup = {
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  homeListElements: Array<HomeListElement>;
  id: Scalars['ID']['output'];
  licensedLocations: Array<LicensedLocation>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  retailerGroupLicensedLocations: Array<RetailerGroupLicensedLocation>;
  salesRules: Array<SalesRule>;
  territories: Array<Territory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RetailerGroupLicensedLocation = {
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocation?: Maybe<LicensedLocation>;
  licensedLocationId?: Maybe<Scalars['ID']['output']>;
  retailerGroup: RetailerGroup;
  retailerGroupId: Scalars['ID']['output'];
  salesHistoryType?: Maybe<RetailerGroupLicensedLocationSalesHistoryType>;
  territory?: Maybe<Territory>;
  territoryId?: Maybe<Scalars['ID']['output']>;
  trustLevel?: Maybe<CreditRatingTrustLevels>;
  type: RetailerGroupLicensedLocationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RetailerGroupLicensedLocationInput = {
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  restrictionStatus?: InputMaybe<RestrictionStatus>;
  salesHistoryType?: InputMaybe<RetailerGroupLicensedLocationSalesHistoryType>;
  territoryId?: InputMaybe<Scalars['ID']['input']>;
  trustLevel?: InputMaybe<CreditRatingTrustLevels>;
  type: RetailerGroupLicensedLocationType;
};

/** Values for the RetailerGroupLicensedLocationSalesHistoryType enum */
export enum RetailerGroupLicensedLocationSalesHistoryType {
  Existing = 'EXISTING',
  New = 'NEW',
}

/** Values for the RetailerGroupLicensedLocationType enum */
export enum RetailerGroupLicensedLocationType {
  AllRetailers = 'ALL_RETAILERS',
  SalesHistory = 'SALES_HISTORY',
  SpecificRetailer = 'SPECIFIC_RETAILER',
  Territory = 'TERRITORY',
  TrustLevel = 'TRUST_LEVEL',
}

export type RetailerInvoice = {
  ACHACRetailerUnconfirmed?: Maybe<Scalars['Float']['output']>;
  ACHAmountCollectedRetailer?: Maybe<Scalars['Float']['output']>;
  collected: Scalars['Float']['output'];
  creator: Scalars['String']['output'];
  creatorEmail: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  dispensary: Scalars['String']['output'];
  due?: Maybe<Scalars['Float']['output']>;
  exciseTaxDueDate?: Maybe<Scalars['DateTime']['output']>;
  gmv: Scalars['Float']['output'];
  gmvCollected: Scalars['Float']['output'];
  gmvDueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  irn?: Maybe<Scalars['String']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  manifestURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  orgName: Scalars['String']['output'];
  overdue: Scalars['Float']['output'];
  paymentDate: Scalars['String']['output'];
  paymentStatus: OrderPaymentStatusEnum;
  site?: Maybe<Site>;
  tax?: Maybe<Scalars['Float']['output']>;
  warehouse?: Maybe<Scalars['String']['output']>;
};

/** Values for the RetailerPayAllEnum enum */
export enum RetailerPayAllEnum {
  Outstanding = 'OUTSTANDING',
  Overdue = 'OVERDUE',
  Payable = 'PAYABLE',
}

export type RetailerPricingGroup = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  licensedLocations: Array<LicensedLocation>;
  name: Scalars['String']['output'];
  retailerPricingGroupLicensedLocations: Array<RetailerPricingGroupLicensedLocation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RetailerPricingGroupLicensedLocation = {
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  licensedLocation?: Maybe<LicensedLocation>;
  licensedLocationId: Scalars['ID']['output'];
  retailerPricingGroup: RetailerPricingGroup;
  retailerPricingGroupId: Scalars['ID']['output'];
  type: RetailerPricingGroupLicensedLocationType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Values for the RetailerPricingGroupLicensedLocationType enum */
export enum RetailerPricingGroupLicensedLocationType {
  SpecificRetailer = 'SPECIFIC_RETAILER',
}

export type RetailerPricingItemGetManyResponse = {
  data: Array<RetailerPricingItemResponse>;
  meta: RetailerPricingMeta;
};

export type RetailerPricingItemPricesResponse = {
  itemId: Scalars['String']['output'];
  itemOnMarketplace: Scalars['Boolean']['output'];
  minQuantity: Scalars['Int']['output'];
  pricePerUnit: Scalars['Float']['output'];
  retailerId: Scalars['String']['output'];
};

export type RetailerPricingItemPropertiesResponse = {
  inventoryClasses: Array<InventoryClassEnum>;
  tags: Array<Scalars['String']['output']>;
};

export type RetailerPricingItemResponse = {
  id: Scalars['String']['output'];
  inventoryCategory: InventoryCategoryEnum;
  inventoryClass: InventoryClassEnum;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pricePerUnit: Scalars['Float']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type RetailerPricingMeta = {
  currentPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

/** Values for the RetailerPricingOrderEnum enum */
export enum RetailerPricingOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type RetailerPricingRetailerGetManyResponse = {
  data: Array<RetailerPricingRetailerResponse>;
  meta: RetailerPricingMeta;
};

export type RetailerPricingRetailerGetSettingsResponse = {
  data: Array<RetailerPricingRetailerSettingsResponse>;
};

export type RetailerPricingRetailerItemsInput = {
  itemId: Scalars['String']['input'];
  retailerId: Scalars['String']['input'];
};

export type RetailerPricingRetailerPropertiesResponse = {
  creditScores: Array<CreditRatingTrustLevels>;
  territories: Array<Scalars['String']['output']>;
};

export type RetailerPricingRetailerResponse = {
  creditScore: CreditRatingTrustLevels;
  hasPreviouslyPurchasedFromBrand: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  territory: Scalars['String']['output'];
};

export type RetailerPricingRetailerSettingsResponse = {
  brandId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  retailerExcludedFromMarketplace: Scalars['Boolean']['output'];
  retailerId: Scalars['String']['output'];
};

export type RetailerPricingSalesRuleActiveAbbreviatedMaps = {
  itemRetailerMap: Scalars['JSON']['output'];
  retailerItemMap: Scalars['JSON']['output'];
};

export type RetailerPricingSalesRuleConflictingRetailerItemsResponse = {
  itemId: Scalars['String']['output'];
  retailerId: Scalars['String']['output'];
  salesRuleId: Scalars['String']['output'];
};

export type RetailerPricingSalesRuleConflictsResponse = {
  conflictingRetailerItems: Array<RetailerPricingSalesRuleConflictingRetailerItemsResponse>;
  conflictingSalesRules: Array<RetailerPricingSalesRuleResponse>;
};

export type RetailerPricingSalesRuleCreateInput = {
  brandId: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  items: Array<RetailerPricingSalesRuleItemInput>;
  name: Scalars['String']['input'];
  onMarketplace: Scalars['Boolean']['input'];
  retailerIds: Array<Scalars['String']['input']>;
};

export type RetailerPricingSalesRuleGetConflictsInput = {
  brandId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  items: Array<RetailerPricingSalesRuleItemInput>;
  name: Scalars['String']['input'];
  onMarketplace: Scalars['Boolean']['input'];
  retailerIds: Array<Scalars['String']['input']>;
};

export type RetailerPricingSalesRuleIdResponse = {
  id: Scalars['String']['output'];
};

export type RetailerPricingSalesRuleItemInput = {
  id: Scalars['String']['input'];
  minQuantity: Scalars['Int']['input'];
  pricePerUnit: Scalars['Float']['input'];
};

export type RetailerPricingSalesRuleItemResponse = {
  id: Scalars['String']['output'];
  inventoryClass: InventoryClassEnum;
  isActive: Scalars['Boolean']['output'];
  minQuantity: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pricePerUnit: Scalars['Float']['output'];
};

/** Values for the RetailerPricingSalesRuleOrderByEnum enum */
export enum RetailerPricingSalesRuleOrderByEnum {
  ItemCount = 'itemCount',
  ItemPricePerUnit = 'itemPricePerUnit',
  RetailerCount = 'retailerCount',
  SalesRuleIsActive = 'salesRuleIsActive',
  SalesRuleIsOnMarketplace = 'salesRuleIsOnMarketplace',
  SalesRuleName = 'salesRuleName',
  SalesRuleUpdatedAt = 'salesRuleUpdatedAt',
  UpdatedByName = 'updatedByName',
}

export type RetailerPricingSalesRuleResponse = {
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  itemMaxPrice: Scalars['Float']['output'];
  itemMinPrice: Scalars['Float']['output'];
  items: Array<RetailerPricingSalesRuleItemResponse>;
  name: Scalars['String']['output'];
  onMarketplace: Scalars['Boolean']['output'];
  retailerCount: Scalars['Int']['output'];
  retailers: Array<RetailerPricingSalesRuleRetailerResponse>;
  updatedAt: Scalars['String']['output'];
  updatedBy: RetailerPricingSalesRuleUpdatedByResponse;
};

export type RetailerPricingSalesRuleRetailerResponse = {
  creditScore: CreditRatingTrustLevels;
  hasPreviouslyPurchasedFromBrand: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  territory: Scalars['String']['output'];
};

export type RetailerPricingSalesRuleSummaryResponse = {
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  itemMaxPrice: Scalars['Float']['output'];
  itemMinPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  onMarketplace: Scalars['Boolean']['output'];
  retailerCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: RetailerPricingSalesRuleUpdatedByResponse;
};

export type RetailerPricingSalesRuleUpdateInput = {
  brandId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  items: Array<RetailerPricingSalesRuleItemInput>;
  name: Scalars['String']['input'];
  onMarketplace: Scalars['Boolean']['input'];
  retailerIds: Array<Scalars['String']['input']>;
};

export type RetailerPricingSalesRuleUpdatedByResponse = {
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type RetailerPricingSalesRulesGenerateCsvResponse = {
  ok: Scalars['Boolean']['output'];
};

export type RetailerPricingSalesRulesGetManyResponse = {
  data: Array<RetailerPricingSalesRuleSummaryResponse>;
  meta: RetailerPricingMeta;
};

export type RetailerPricingUpsertRetailerSettingsInput = {
  retailerExcludedFromMarketplace: Scalars['Boolean']['input'];
  retailerId: Scalars['String']['input'];
};

/** Values for the RetailerRestriction enum */
export enum RetailerRestriction {
  IsRetailerRestricted = 'isRetailerRestricted',
  IsRetailerRestrictedForBrand = 'isRetailerRestrictedForBrand',
}

export type RetailerRestrictionBrandLookup = {
  brandId: Scalars['ID']['output'];
  brandLocation?: Maybe<Scalars['String']['output']>;
  brandOrganizationName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RetailerRestrictionBrandLookupResponse = {
  results: Array<RetailerRestrictionBrandLookup>;
};

export type RetailerRestrictionRetailerLookup = {
  id: Scalars['ID']['output'];
  retailerId: Scalars['ID']['output'];
  retailerLocation: Scalars['String']['output'];
  retailerOrganizationName: Scalars['String']['output'];
};

export type RetailerRestrictionRetailerLookupResponse = {
  results: Array<RetailerRestrictionRetailerLookup>;
};

export type RetailersOnCreditHoldThatCanNotBeOverriden = {
  decodedSelectedBrandOrganizationId: Scalars['String']['output'];
  retailersThatCanNotBeOverriden: Array<RestrictionInformationRetailer>;
};

export type Role = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  permissions: Array<Scalars['String']['output']>;
};

/** Values for the RollbackReason enum */
export enum RollbackReason {
  BouncedCheck = 'BOUNCED_CHECK',
  BxChangedAllocationInstructions = 'BX_CHANGED_ALLOCATION_INSTRUCTIONS',
  BxIncorrectApplication = 'BX_INCORRECT_APPLICATION',
  BxPaymentAppliedOnRejectedOrder = 'BX_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  BxPriceChangedAfterPaymentApplication = 'BX_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  BxTypoOnPaymentInstructions = 'BX_TYPO_ON_PAYMENT_INSTRUCTIONS',
  LaChangedAllocationInstructions = 'LA_CHANGED_ALLOCATION_INSTRUCTIONS',
  LaIncorrectApplication = 'LA_INCORRECT_APPLICATION',
  LaPaymentAppliedOnRejectedOrder = 'LA_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  LaPriceChangedAfterPaymentApplication = 'LA_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  LaTypoOnPaymentInstructions = 'LA_TYPO_ON_PAYMENT_INSTRUCTIONS',
  OakChangedAllocationInstructions = 'OAK_CHANGED_ALLOCATION_INSTRUCTIONS',
  OakIncorrectApplication = 'OAK_INCORRECT_APPLICATION',
  OakPaymentAppliedOnRejectedOrder = 'OAK_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  OakPriceChangedAfterPaymentApplication = 'OAK_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  OakTypoOnPaymentInstructions = 'OAK_TYPO_ON_PAYMENT_INSTRUCTIONS',
  PaymentCreationError = 'PAYMENT_CREATION_ERROR',
  ReturnedAch = 'RETURNED_ACH',
  RocChangedAllocationInstructions = 'ROC_CHANGED_ALLOCATION_INSTRUCTIONS',
  RocIncorrectApplication = 'ROC_INCORRECT_APPLICATION',
  RocPaymentAppliedOnRejectedOrder = 'ROC_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  RocPriceChangedAfterPaymentApplication = 'ROC_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  RocTypoOnPaymentInstructions = 'ROC_TYPO_ON_PAYMENT_INSTRUCTIONS',
  SfChangedAllocationInstructions = 'SF_CHANGED_ALLOCATION_INSTRUCTIONS',
  SfIncorrectApplication = 'SF_INCORRECT_APPLICATION',
  SfPaymentAppliedOnRejectedOrder = 'SF_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  SfPriceChangedAfterPaymentApplication = 'SF_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  SfTypoOnPaymentInstructions = 'SF_TYPO_ON_PAYMENT_INSTRUCTIONS',
  WlChangedAllocationInstructions = 'WL_CHANGED_ALLOCATION_INSTRUCTIONS',
  WlIncorrectApplication = 'WL_INCORRECT_APPLICATION',
  WlPaymentAppliedOnRejectedOrder = 'WL_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  WlPriceChangedAfterPaymentApplication = 'WL_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  WlTypoOnPaymentInstructions = 'WL_TYPO_ON_PAYMENT_INSTRUCTIONS',
}

export type RunAsyncTaskInput = {
  id: Scalars['ID']['input'];
};

export type Sales = {
  day: Scalars['DateTime']['output'];
  exciseTax: Scalars['Float']['output'];
  gmv: Scalars['Float']['output'];
  month: Scalars['DateTime']['output'];
  organization: Organization;
  year: Scalars['DateTime']['output'];
};

export type SalesOrgRelationship = {
  brandOrg: Organization;
  id: Scalars['ID']['output'];
  salesOrg: Organization;
};

export type SalesOrganizationSetting = {
  id: Scalars['ID']['output'];
  minGmv: Scalars['Float']['output'];
};

export type SalesRule = {
  assigneeId?: Maybe<Scalars['ID']['output']>;
  canRequestAdditionalNetTerms: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  creatorId: Scalars['ID']['output'];
  defaultDaysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isHardMinCap: Scalars['Boolean']['output'];
  isMarketplace: Scalars['Boolean']['output'];
  isPaymentTermsBasedOnCreditRating: Scalars['Boolean']['output'];
  isSampleAllowed: Scalars['Boolean']['output'];
  isSampleDemoOrdersAllowed: Scalars['Boolean']['output'];
  maxAvailableInventory?: Maybe<Scalars['Float']['output']>;
  maxDaysTillPaymentDueForExcellent?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForFair?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForGood?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForPoor?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForWeak?: Maybe<Scalars['Int']['output']>;
  maxSamplesPerOrder?: Maybe<Scalars['Int']['output']>;
  minOrderBalance?: Maybe<Scalars['Float']['output']>;
  mustPayPreviousBalance: Scalars['Boolean']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  retailerGroup: RetailerGroup;
  retailerGroupId: Scalars['ID']['output'];
  sku?: Maybe<Sku>;
  skuId?: Maybe<Scalars['ID']['output']>;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SalesRulesPayload = {
  assigneeId?: Maybe<Scalars['ID']['output']>;
  brandId?: Maybe<Scalars['ID']['output']>;
  defaultDaysTillPaymentDue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  isPaymentTermsBasedOnCreditRating?: Maybe<Scalars['Boolean']['output']>;
  isSampleAllowed?: Maybe<Scalars['Boolean']['output']>;
  isSampleDemoOrdersAllowed?: Maybe<Scalars['Boolean']['output']>;
  maxAvailableInventory?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForExcellent?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForFair?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForGood?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForPoor?: Maybe<Scalars['Int']['output']>;
  maxDaysTillPaymentDueForWeak?: Maybe<Scalars['Int']['output']>;
  maxSamplesPerOrder?: Maybe<Scalars['Int']['output']>;
  minOrderBalance?: Maybe<Scalars['Int']['output']>;
  mustPayPreviousBalance?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  retailerGroup: RetailerGroup;
  retailerGroupId: Scalars['ID']['output'];
  salesRule: SalesRule;
  skuId?: Maybe<Scalars['ID']['output']>;
};

export type SendRetailerEmailInput = {
  attachments: Array<InputMaybe<Attachment>>;
  bcc: Array<InputMaybe<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  cc: Array<InputMaybe<Scalars['String']['input']>>;
  from: Scalars['String']['input'];
  isFromAgingReport?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  to: Array<Scalars['String']['input']>;
};

export type SendRetailerEmailPayload = {
  retailerConfirmLinkId?: Maybe<Scalars['String']['output']>;
  retailerConfirmationStatus?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SendSendGridStatusUpdateEmailPayload = {
  success: Scalars['Boolean']['output'];
};

export type SendSendGridStatusUpdateInput = {
  orderId: Scalars['ID']['input'];
};

export type Shipment = {
  arrivalTime?: Maybe<Scalars['DateTime']['output']>;
  arrivalTimeAfter?: Maybe<Scalars['DateTime']['output']>;
  arrivalTimeBefore?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  departureTime?: Maybe<Scalars['DateTime']['output']>;
  destinationLicensedLocation: LicensedLocation;
  destinationLicensedLocationId: Scalars['ID']['output'];
  driver?: Maybe<Driver>;
  driverId?: Maybe<Scalars['ID']['output']>;
  fulfillability?: Maybe<ShipmentFulfillability>;
  id: Scalars['ID']['output'];
  infoplusAsnId?: Maybe<Scalars['Int']['output']>;
  infoplusAsnInventoryStatus?: Maybe<InfoplusAsnInventoryStatus>;
  infoplusOrderId?: Maybe<Scalars['Int']['output']>;
  infoplusOrderInventoryStatus?: Maybe<InfoplusOrderInventoryStatus>;
  intaken: Scalars['Boolean']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isLoaded?: Maybe<Scalars['Boolean']['output']>;
  isPicked?: Maybe<Scalars['Boolean']['output']>;
  isPrinted?: Maybe<Scalars['Boolean']['output']>;
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isShipped?: Maybe<Scalars['Boolean']['output']>;
  isStaged?: Maybe<Scalars['Boolean']['output']>;
  isUnloaded?: Maybe<Scalars['Boolean']['output']>;
  loaderId?: Maybe<Scalars['ID']['output']>;
  metrcTransfer?: Maybe<MetrcTransfer>;
  metrcWarehouseLicenseNumber?: Maybe<Scalars['String']['output']>;
  nextShipmentId?: Maybe<Scalars['ID']['output']>;
  numberOfCartons?: Maybe<Scalars['Int']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
  originLicensedLocation: LicensedLocation;
  originLicensedLocationId: Scalars['ID']['output'];
  outtaken: Scalars['Boolean']['output'];
  pickers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  previousShipmentId?: Maybe<Scalars['ID']['output']>;
  queueOrder?: Maybe<Scalars['Int']['output']>;
  shipmentNumber: Scalars['Int']['output'];
  shipmentType: ShipmentType;
  stagingAreaId?: Maybe<Scalars['ID']['output']>;
  status: ShipmentStatus;
  unloaderId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

/** Values for the ShipmentFulfillability enum */
export enum ShipmentFulfillability {
  Fulfillable = 'FULFILLABLE',
  Manual = 'MANUAL',
  NotFulfillable = 'NOT_FULFILLABLE',
  PartiallyFulfillable = 'PARTIALLY_FULFILLABLE',
}

export type ShipmentInput = {
  arrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  departureTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationLicensedLocationId: Scalars['ID']['input'];
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fulfillability?: InputMaybe<ShipmentFulfillability>;
  id?: InputMaybe<Scalars['ID']['input']>;
  infoplusAsnId?: InputMaybe<Scalars['Int']['input']>;
  infoplusAsnInventoryStatus?: InputMaybe<InfoplusAsnInventoryStatus>;
  infoplusOrderId?: InputMaybe<Scalars['Int']['input']>;
  infoplusOrderInventoryStatus?: InputMaybe<InfoplusOrderInventoryStatus>;
  isLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  isPrinted?: InputMaybe<Scalars['Boolean']['input']>;
  isShipped?: InputMaybe<Scalars['Boolean']['input']>;
  isStaged?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloaded?: InputMaybe<Scalars['Boolean']['input']>;
  loaderId?: InputMaybe<Scalars['ID']['input']>;
  nextShipmentId?: InputMaybe<Scalars['ID']['input']>;
  numberOfCartons?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['ID']['input'];
  originLicensedLocationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
  previousShipmentId?: InputMaybe<Scalars['ID']['input']>;
  shipmentNumber?: InputMaybe<Scalars['Int']['input']>;
  stagingAreaId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ShipmentStatus>;
  unloaderId?: InputMaybe<Scalars['ID']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type ShipmentStatistics = {
  numberFulfilled: Scalars['Int']['output'];
  numberMetrcManifestSaved: Scalars['Int']['output'];
  numberMetrcStatusCompleted: Scalars['Int']['output'];
  numberMetrcTagsCompleted: Scalars['Int']['output'];
  numberOnOrder: Scalars['Int']['output'];
  numberPicked: Scalars['Int']['output'];
  numberShipped: Scalars['Int']['output'];
  numberStaged: Scalars['Int']['output'];
  totalShipments: Scalars['Int']['output'];
  totalShipmentsLinkedToInfoplus: Scalars['Int']['output'];
};

/** Values for the ShipmentStatus enum */
export enum ShipmentStatus {
  Created = 'CREATED',
  Transferring = 'TRANSFERRING',
  TransferCancelled = 'TRANSFER_CANCELLED',
  TransferComplete = 'TRANSFER_COMPLETE',
  TransferDelayed = 'TRANSFER_DELAYED',
}

export type ShipmentTrackerPayload = {
  pageInfo: PageInfo;
  results: Array<ShipmentTrackerRowPayload>;
  statistics?: Maybe<ShipmentStatistics>;
};

export type ShipmentTrackerQueryInput = {
  action?: InputMaybe<Array<OrderActionEnum>>;
  asnInventoryStatus?: InputMaybe<Array<OrderAsnInventoryStatusEnum>>;
  departureTimeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  departureTimeStart?: InputMaybe<Scalars['DateTime']['input']>;
  destination?: InputMaybe<Array<Scalars['ID']['input']>>;
  destinationCity?: InputMaybe<Scalars['String']['input']>;
  driver?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  infoplusId?: InputMaybe<Scalars['Int']['input']>;
  lastNonReturnShipmentOriginId?: InputMaybe<Array<Scalars['ID']['input']>>;
  metrcManifestCreated?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  metrcStatus?: InputMaybe<Array<MetrcOrderStatusEnum>>;
  orderInventoryStatus?: InputMaybe<Array<OrderOrderInventoryStatusEnum>>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  orderStatus?: InputMaybe<Array<OrderStatusEnum>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageInfo?: InputMaybe<PageInfoInput>;
  picked?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  restrictionStatus?: InputMaybe<Array<RetailerRestriction>>;
  shipmentNumber?: InputMaybe<Scalars['Int']['input']>;
  shipmentStatus?: InputMaybe<Array<ShipmentStatus>>;
  staged?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  stagingArea?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ShipmentTrackerRowPayload = {
  arrivalTime: Scalars['DateTime']['output'];
  arrivalTimeAfter?: Maybe<Scalars['DateTime']['output']>;
  arrivalTimeBefore?: Maybe<Scalars['DateTime']['output']>;
  confirmationName?: Maybe<Scalars['String']['output']>;
  confirmationNotes?: Maybe<Scalars['String']['output']>;
  confirmationStatus?: Maybe<RetailerConfirmationStatus>;
  confirmationTrail?: Maybe<ConfirmationTrailEnum>;
  departureTime: Scalars['DateTime']['output'];
  destinationLicensedLocation: LicensedLocation;
  driverId?: Maybe<Scalars['ID']['output']>;
  fulfillability?: Maybe<ShipmentFulfillability>;
  id: Scalars['ID']['output'];
  infoplusAsnId?: Maybe<Scalars['Int']['output']>;
  infoplusAsnInventoryStatus?: Maybe<OrderAsnInventoryStatusEnum>;
  infoplusOrderId?: Maybe<Scalars['Int']['output']>;
  infoplusOrderInventoryStatus?: Maybe<OrderOrderInventoryStatusEnum>;
  intaken?: Maybe<Scalars['Boolean']['output']>;
  isPrinted?: Maybe<Scalars['Boolean']['output']>;
  isStaged: Scalars['Boolean']['output'];
  metrcOrderAssociate?: Maybe<Scalars['ID']['output']>;
  metrcOrderNotes?: Maybe<Scalars['String']['output']>;
  metrcOrderStatus: MetrcOrderStatusEnum;
  metrcTagSequences?: Maybe<Array<Array<TagSequence>>>;
  metrcTransferId?: Maybe<Scalars['ID']['output']>;
  metrcTransferManifestId?: Maybe<Scalars['Int']['output']>;
  metrcTransferNotes?: Maybe<Scalars['String']['output']>;
  metrcWarehouseLicenseNumber?: Maybe<Scalars['String']['output']>;
  onFleetUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  order: Order;
  orderAction: OrderActionEnum;
  orderId: Scalars['ID']['output'];
  orderNumber: Scalars['Int']['output'];
  orderStatus: OrderStatusEnum;
  organization: Organization;
  originLicensedLocation: LicensedLocation;
  outtaken?: Maybe<Scalars['Boolean']['output']>;
  phoneCallStatus?: Maybe<Scalars['Boolean']['output']>;
  pickers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  queueOrder?: Maybe<Scalars['Int']['output']>;
  shipmentNumber: Scalars['Int']['output'];
  stagingAreaId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<ShipmentStatus>;
  updatedAt: Scalars['DateTime']['output'];
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

/** Values for the ShipmentType enum */
export enum ShipmentType {
  Default = 'DEFAULT',
  Return = 'RETURN',
}

export type SimplifiedDraft = {
  createdAt: Scalars['DateTime']['output'];
  errors: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Site = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inventoryItems: Array<InventoryItem>;
  lat?: Maybe<Scalars['Float']['output']>;
  licensedLocation?: Maybe<LicensedLocation>;
  licensedLocationId?: Maybe<Scalars['ID']['output']>;
  licenses: Array<License>;
  lng?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  pocEmail?: Maybe<Scalars['String']['output']>;
  pocName?: Maybe<Scalars['String']['output']>;
  pocPhoneNumber?: Maybe<Scalars['String']['output']>;
  siteCategory: SiteCategoryEnum;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

/** Values for the SiteCategoryEnum enum */
export enum SiteCategoryEnum {
  Consumer = 'CONSUMER',
  Cultivator = 'CULTIVATOR',
  Distributor = 'DISTRIBUTOR',
  Manufacturer = 'MANUFACTURER',
  Microbusiness = 'MICROBUSINESS',
  Other = 'OTHER',
  Retailer = 'RETAILER',
  Testing = 'TESTING',
}

export type SkipAsyncTaskInput = {
  id: Scalars['ID']['input'];
};

export type Sku = {
  availableInventory: Scalars['Float']['output'];
  batches?: Maybe<Array<Maybe<Batch>>>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dateAddedToMarketplace?: Maybe<Scalars['DateTime']['output']>;
  defaultPricePerUnit: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  inventoryCategory: InventoryCategoryEnum;
  inventoryCategoryTags?: Maybe<Array<InventoryCategoryTagEnum>>;
  inventoryClass: InventoryClassEnum;
  inventoryItems?: Maybe<Array<Maybe<InventoryItem>>>;
  inventoryType: InventoryTypeEnum;
  inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySampleAllowed?: Maybe<Scalars['Boolean']['output']>;
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace: Scalars['Boolean']['output'];
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isSample: Scalars['Boolean']['output'];
  isSampleAllowed: Scalars['Boolean']['output'];
  janeProductId?: Maybe<Scalars['Int']['output']>;
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplaceName?: Maybe<Scalars['String']['output']>;
  maxDaysTillPaymentDue: Scalars['Int']['output'];
  maxMarketplaceInventory?: Maybe<Scalars['Float']['output']>;
  maxSamplesPerOrder?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  netVolume?: Maybe<Scalars['Float']['output']>;
  netVolumeUnitOfMeasure?: Maybe<VolumeUnitOfMeasureEnum>;
  netWeight?: Maybe<Scalars['Float']['output']>;
  netWeightUnitOfMeasure?: Maybe<WeightUnitOfMeasureEnum>;
  nonSampleSku?: Maybe<Sku>;
  nonSampleSkuId?: Maybe<Scalars['ID']['output']>;
  organization: Organization;
  parentSku?: Maybe<ParentSku>;
  parentSkuId?: Maybe<Scalars['ID']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  productImageS3Link?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<Scalars['String']['output']>;
  promotionalNotes?: Maybe<Scalars['String']['output']>;
  quantityPerUnitOfMeasure: Scalars['Int']['output'];
  quantitySold?: Maybe<Scalars['Int']['output']>;
  relatedSkus: Array<Sku>;
  retailerDiscounts?: Maybe<Array<RetailerDiscount>>;
  salesRules: Array<SalesRule>;
  sampleSku?: Maybe<Sku>;
  secondaryImageS3Links?: Maybe<Array<Scalars['String']['output']>>;
  skuBatches?: Maybe<Array<Maybe<SkuBatch>>>;
  skuDetailsPdfLink?: Maybe<Scalars['String']['output']>;
  skuPricePerUnit?: Maybe<Scalars['Float']['output']>;
  strainId?: Maybe<Scalars['ID']['output']>;
  strainType: StrainTypeEnum;
  tags?: Maybe<Array<InventoryTagEnum>>;
  totalAvailable?: Maybe<Scalars['Int']['output']>;
  unit: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnitOfMeasure?: Maybe<WeightUnitOfMeasureEnum>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type SkuAvailableInventoryArgs = {
  licensedLocationId: Scalars['ID']['input'];
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkuIsSampleAllowedArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type SkuMaxDaysTillPaymentDueArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type SkuMaxSamplesPerOrderArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type SkuPricePerUnitArgs = {
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SkuRetailerDiscountsArgs = {
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SkuSkuBatchesArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkuBatch = {
  availableInventory?: Maybe<Array<AvailableInventory>>;
  batch?: Maybe<Batch>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  infoplus?: Maybe<Scalars['Int']['output']>;
  inventoryItems?: Maybe<Array<Maybe<InventoryItem>>>;
  inventoryValues?: Maybe<InventoryValues>;
  isArchived: Scalars['Boolean']['output'];
  isPriorNonNabisInvoice?: Maybe<Scalars['Boolean']['output']>;
  metrcSourcePackageTags?: Maybe<Scalars['JSON']['output']>;
  quarantineStatuses?: Maybe<Array<Scalars['ID']['output']>>;
  sku: Sku;
  skuBatchStatistic?: Maybe<SkuBatchStatistic>;
  titleholder: Titleholder;
  updatedAt: Scalars['DateTime']['output'];
};

export type SkuBatchAvailableInventoryArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  useInventoryBuffers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkuBatchInventoryValuesArgs = {
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
  useInventoryBuffers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SkuBatchInfo = {
  pageInfo: PageInfo;
  results: Array<SkuBatch>;
};

export type SkuBatchStatistic = {
  daysAtNabis: Scalars['Int']['output'];
  firstDropoffDate: Scalars['DateTime']['output'];
  skuBatchId: Scalars['ID']['output'];
};

export type SkuDetails = {
  brandName?: Maybe<Scalars['String']['output']>;
  cannabinoidDosageA?: Maybe<Scalars['String']['output']>;
  cannabinoidDosageB?: Maybe<Scalars['String']['output']>;
  cannabinoidTypeA?: Maybe<Scalars['String']['output']>;
  cannabinoidTypeB?: Maybe<Scalars['String']['output']>;
  containerType?: Maybe<Scalars['String']['output']>;
  eachUnitOfMeasure?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isColdStorage?: Maybe<Scalars['Boolean']['output']>;
  productLine?: Maybe<Scalars['String']['output']>;
  skuId: Scalars['ID']['output'];
  thcPotencyMeasurementType?: Maybe<Scalars['String']['output']>;
  thcPotencyPerUnit?: Maybe<Scalars['String']['output']>;
  unitsPerEach?: Maybe<Scalars['Int']['output']>;
};

export type SkuDetailsPayload = {
  brandName?: Maybe<Scalars['String']['output']>;
  cannabinoidDosageA?: Maybe<Scalars['String']['output']>;
  cannabinoidDosageB?: Maybe<Scalars['String']['output']>;
  cannabinoidTypeA?: Maybe<Scalars['String']['output']>;
  cannabinoidTypeB?: Maybe<Scalars['String']['output']>;
  containerType?: Maybe<Scalars['String']['output']>;
  eachUnitOfMeasure?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isColdStorage?: Maybe<Scalars['Boolean']['output']>;
  productLine?: Maybe<Scalars['String']['output']>;
  thcPotencyMeasurementType?: Maybe<Scalars['String']['output']>;
  thcPotencyPerUnit?: Maybe<Scalars['String']['output']>;
  unitsPerEach?: Maybe<Scalars['Int']['output']>;
};

export type SkuInfo = {
  pageInfo: PageInfo;
  results: Array<Sku>;
};

export type SnapshotAgingDates = {
  organizationId: Scalars['ID']['output'];
  snapshotDate: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

/** Values for the SourceEnvEnum enum */
export enum SourceEnvEnum {
  Demo = 'demo',
  Development = 'development',
  Indica = 'indica',
  Integration = 'integration',
  Production = 'production',
  Review = 'review',
  Sativa = 'sativa',
  Staging = 'staging',
  Testing = 'testing',
}

export type SpecialRequirementsForLocation = {
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  extraLeadTimeDays?: Maybe<Scalars['Int']['output']>;
  extraLeadTimeType?: Maybe<SpecialRequirementsForLocationExtraLeadTimeEnum>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  licensedLocationId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Values for the SpecialRequirementsForLocationExtraLeadTimeEnum enum */
export enum SpecialRequirementsForLocationExtraLeadTimeEnum {
  EarlyMetrc = 'EARLY_METRC',
  QrCodeLabeling = 'QR_CODE_LABELING',
}

export type StagingArea = {
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  creatorEmail?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  warehouseId: Scalars['ID']['output'];
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type StagingAreaPayload = {
  changedStagingArea: StagingArea;
};

export type StagingAreasPayload = {
  pageInfo?: Maybe<PageInfo>;
  stagingAreas?: Maybe<Array<StagingArea>>;
};

export type StockBrandBatchExpirationSubscription = {
  brandId: Scalars['String']['output'];
  hoursBeforeExpiration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export type StockBrandFluctuationSubscription = {
  brandId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  minStockThreshold: Scalars['Int']['output'];
};

export type StockBrandStockSubscription = {
  brandId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type StockBrandSubscription = {
  batchExpiration: Array<StockBrandBatchExpirationSubscription>;
  inStock: Array<StockBrandStockSubscription>;
  outOfStock: Array<StockBrandStockSubscription>;
  stockDecrease: Array<StockBrandFluctuationSubscription>;
  stockIncrease: Array<StockBrandFluctuationSubscription>;
};

export type StockSkuBatchExpirationSubscription = {
  hoursBeforeExpiration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
};

export type StockSkuFluctuationSubscription = {
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  minStockThreshold: Scalars['Int']['output'];
};

export type StockSkuStockSubscription = {
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
};

export type StockSkuSubscription = {
  batchExpiration: Array<StockSkuBatchExpirationSubscription>;
  inStock: Array<StockSkuStockSubscription>;
  outOfStock: Array<StockSkuStockSubscription>;
  stockDecrease: Array<StockSkuFluctuationSubscription>;
  stockIncrease: Array<StockSkuFluctuationSubscription>;
};

/** Values for the StockSubscriptionEnum enum */
export enum StockSubscriptionEnum {
  BatchExpiration = 'BATCH_EXPIRATION',
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  StockDecrease = 'STOCK_DECREASE',
  StockIncrease = 'STOCK_INCREASE',
}

export type StockSubscriptionMutationResponse = {
  id: Scalars['String']['output'];
};

export type Strain = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Values for the StrainTypeEnum enum */
export enum StrainTypeEnum {
  Hybrid = 'HYBRID',
  Indica = 'INDICA',
  IndicaDominant = 'INDICA_DOMINANT',
  Other = 'OTHER',
  Sativa = 'SATIVA',
  SativaDominant = 'SATIVA_DOMINANT',
}

export type SubOrders = {
  additionalDiscount: Scalars['Float']['input'];
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  appliedDiscounts: Array<AppliedDiscountInput>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  brandManifestNotes?: InputMaybe<Scalars['String']['input']>;
  creditMemo: Scalars['Float']['input'];
  creditMemoPayload?: InputMaybe<Array<CreditMemoPayload>>;
  daysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  discount: Scalars['Float']['input'];
  exciseTax: Scalars['Float']['input'];
  exciseTaxCollected?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentDesired?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentMin?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentNotes?: InputMaybe<Scalars['String']['input']>;
  gmv: Scalars['Float']['input'];
  gmvCollected?: InputMaybe<Scalars['Float']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  lineItems: Array<UpsertLineItemInput>;
  mppbOrders?: InputMaybe<Array<CreateMppbOrderInput>>;
  mustPayExternalBalance?: InputMaybe<Scalars['Boolean']['input']>;
  mustPayPreviousBalance?: InputMaybe<Scalars['Boolean']['input']>;
  nabisManifestNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  netGmv: Scalars['Float']['input'];
  organizationId: Scalars['ID']['input'];
  paymentStatus: OrderPaymentStatusEnum;
  promotionsDiscount: Scalars['Float']['input'];
  surcharge: Scalars['Float']['input'];
};

export type Subscription = {
  asyncOrder?: Maybe<AsyncOrderPayload>;
  csvDownload?: Maybe<PlatformCsvFileLinkResponse>;
};

export type SubscriptionAsyncOrderArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionCsvDownloadArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwapFeaturedBrandPrioritiesPayload = {
  featuredBrand1: FeaturedBrand;
  featuredBrand2: FeaturedBrand;
};

export type SwapHomeListElementPrioritiesResult = {
  homeListElement1: HomeListElement;
  homeListElement2: HomeListElement;
};

export type SyncMetrcSkuBatchItemsInput = {
  locations: Array<LocationInput>;
  skuBatchId: Scalars['String']['input'];
  unitOfMeasure: Scalars['String']['input'];
};

export type Tag = {
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  tagType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TagSequence = {
  inclusive: Scalars['Boolean']['output'];
  value: Scalars['Int']['output'];
};

export type Territory = {
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryDays: Array<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  period: Period;
  periodMultiplier: Scalars['Int']['output'];
  pickupDays?: Maybe<Array<Scalars['Int']['output']>>;
  regionNumber: Scalars['Int']['output'];
  startDate: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zipcodes?: Maybe<Array<Maybe<Zipcode>>>;
};

export type Titleholder = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  titleholderLicense?: Maybe<License>;
  titleholderOrganization?: Maybe<Organization>;
  type: TitleholderType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Values for the TitleholderType enum */
export enum TitleholderType {
  License = 'LICENSE',
  Organization = 'ORGANIZATION',
}

/** Values for the TransactionLocation enum */
export enum TransactionLocation {
  CashInBronx = 'CASH_IN_BRONX',
  CashInLa = 'CASH_IN_LA',
  CashInOak = 'CASH_IN_OAK',
  CashInRochester = 'CASH_IN_ROCHESTER',
  CashInSf = 'CASH_IN_SF',
  CashInWoodlake = 'CASH_IN_WOODLAKE',
}

/** Values for the TransactionMethod enum */
export enum TransactionMethod {
  Cash = 'CASH',
  Check = 'CHECK',
  Eft = 'EFT',
}

/** Values for the TransactionType enum */
export enum TransactionType {
  CreditMemo = 'CREDIT_MEMO',
  Discount = 'DISCOUNT',
  NabisCreditMemo = 'NABIS_CREDIT_MEMO',
  Payment = 'PAYMENT',
  SelfCollected = 'SELF_COLLECTED',
  WriteOffExternal = 'WRITE_OFF_EXTERNAL',
  WriteOffNabis = 'WRITE_OFF_NABIS',
}

/** Values for the UnappliedReason enum */
export enum UnappliedReason {
  BrandOffboarded = 'BRAND_OFFBOARDED',
  ClosedAllocatedWithOp = 'CLOSED_ALLOCATED_WITH_OP',
  ClosedPreviouslyPaid = 'CLOSED_PREVIOUSLY_PAID',
  ClosedSampleOrder = 'CLOSED_SAMPLE_ORDER',
  ClosedSelfCollected = 'CLOSED_SELF_COLLECTED',
  ClosedShortPaymentEntered = 'CLOSED_SHORT_PAYMENT_ENTERED',
  CreditMissingInstructions = 'CREDIT_MISSING_INSTRUCTIONS',
  CreditNotConfirmed = 'CREDIT_NOT_CONFIRMED',
  IncompleteBreakdown = 'INCOMPLETE_BREAKDOWN',
  InvalidOrderNumber = 'INVALID_ORDER_NUMBER',
  NabisBillpay = 'NABIS_BILLPAY',
  NoBreakdownProvided = 'NO_BREAKDOWN_PROVIDED',
  NoHistoricalDataUnknownPayer = 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderNotDeliveredYet = 'ORDER_NOT_DELIVERED_YET',
  OrderOverpaid = 'ORDER_OVERPAID',
  OrderRejected = 'ORDER_REJECTED',
  PostDeliveryAdjustments = 'POST_DELIVERY_ADJUSTMENTS',
  ReservedUnappliedPaymentsAlreadyRestricted = 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
  SiteNotFlipped = 'SITE_NOT_FLIPPED',
  UnclearBreakdown = 'UNCLEAR_BREAKDOWN',
  UnidentifiedOverpayment = 'UNIDENTIFIED_OVERPAYMENT',
  WriteOff = 'WRITE_OFF',
}

export type UnarchiveLicensePayload = {
  changedLicense: License;
};

export type UnarchiveLicensedLocationInput = {
  id: Scalars['ID']['input'];
};

export type UnencodedBatch = {
  aromas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cbdPercentage?: Maybe<Scalars['Float']['output']>;
  cbdWeight?: Maybe<Scalars['Float']['output']>;
  coaS3FileLink?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  licenseId?: Maybe<Scalars['ID']['output']>;
  manifestGDriveFileId?: Maybe<Scalars['String']['output']>;
  manufacturingDate?: Maybe<Scalars['DateTime']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  otherCannabinoidPercentage?: Maybe<Scalars['Float']['output']>;
  otherCannabinoidWeight?: Maybe<Scalars['Float']['output']>;
  skuId?: Maybe<Scalars['ID']['output']>;
  thcAPercentage?: Maybe<Scalars['Float']['output']>;
  thcAWeight?: Maybe<Scalars['Float']['output']>;
  thcPercentage?: Maybe<Scalars['Float']['output']>;
  thcWeight?: Maybe<Scalars['Float']['output']>;
};

export type UnencodedIngredient = {
  Package?: Maybe<Scalars['String']['output']>;
  Quantity?: Maybe<Scalars['String']['output']>;
  UnitOfMeasure?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UnencodedLineItem = {
  additionalDiscount?: Maybe<Scalars['Float']['output']>;
  batchId?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  destinationSkuBatchId?: Maybe<Scalars['ID']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  isSample?: Maybe<Scalars['Boolean']['output']>;
  lineItemManifestNotes?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  overrideQuantityPerUnitOfMeasure?: Maybe<Scalars['Boolean']['output']>;
  oversold?: Maybe<Scalars['Boolean']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  promotionsDiscount?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sampleType?: Maybe<LineItemSampleType>;
  skuBatch?: Maybe<UnencodedSkuBatch>;
  skuBatchId?: Maybe<Scalars['ID']['output']>;
  skuId?: Maybe<Scalars['ID']['output']>;
  standardPricePerUnit?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type UnencodedOrganization = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  bannerImageS3Link?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  doingBusinessAs?: Maybe<Scalars['String']['output']>;
  factoredStatus?: Maybe<OrganizationFactoredStatusEnum>;
  hasAnalyticsDashboard?: Maybe<Scalars['Boolean']['output']>;
  hasMustPayExternalBalance?: Maybe<Scalars['Boolean']['output']>;
  hasPlatformV2ApiAccess?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  infoplus?: Maybe<Scalars['Int']['output']>;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  licensedLocationId?: Maybe<Scalars['ID']['output']>;
  logoS3Link?: Maybe<Scalars['String']['output']>;
  manifestGDriveFolderId?: Maybe<Scalars['String']['output']>;
  marketingPDF?: Maybe<Scalars['String']['output']>;
  marketplaceContactEmail?: Maybe<Scalars['String']['output']>;
  marketplaceContactName?: Maybe<Scalars['String']['output']>;
  marketplaceContactNumber?: Maybe<Scalars['String']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  receiveReports?: Maybe<Scalars['Boolean']['output']>;
  retailerJoinedAt?: Maybe<Scalars['DateTime']['output']>;
  singleHubWarehouseId?: Maybe<Scalars['ID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OrganizationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UnencodedSku = {
  code?: Maybe<Scalars['String']['output']>;
  dateAddedToMarketplace?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inventoryCategory?: Maybe<InventoryCategoryEnum>;
  inventoryCategoryTags?: Maybe<Array<Maybe<InventoryCategoryTagEnum>>>;
  inventoryClass?: Maybe<InventoryClassEnum>;
  inventoryType?: Maybe<InventoryTypeEnum>;
  inventoryUnitOfMeasure?: Maybe<InventoryUnitOfMeasureEnum>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isExciseTaxable?: Maybe<Scalars['Boolean']['output']>;
  janeProductId?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  marketplaceDescription?: Maybe<Scalars['String']['output']>;
  marketplaceName?: Maybe<Scalars['String']['output']>;
  maxMarketplaceInventory?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonSampleSkuId?: Maybe<Scalars['ID']['output']>;
  organization?: Maybe<UnencodedOrganization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  parentSkuId?: Maybe<Scalars['ID']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  productImageS3Link?: Maybe<Scalars['String']['output']>;
  quantityPerUnitOfMeasure?: Maybe<Scalars['Int']['output']>;
  secondaryImageS3Links?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skuDetailsPdfLink?: Maybe<Scalars['String']['output']>;
  strainType?: Maybe<StrainTypeEnum>;
  tags?: Maybe<Array<Maybe<InventoryTagEnum>>>;
  unit?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnitOfMeasure?: Maybe<WeightUnitOfMeasureEnum>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type UnencodedSkuBatch = {
  batch?: Maybe<UnencodedBatch>;
  batchId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  infoplus?: Maybe<Scalars['Int']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<UnencodedSku>;
  skuId?: Maybe<Scalars['ID']['output']>;
  titleholderId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateAccountActivityInput = {
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
  secondaryNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountTaskInput = {
  dueAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isStarted?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBankAccountInfoInput = {
  achEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  approvalStatus?: InputMaybe<BankAccountInfoApprovalStatusTypeEnum>;
  autoPay?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDefaultBank?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type UpdateBatchInput = {
  aromas?: InputMaybe<Array<AromaEnum>>;
  cbdPercentage?: InputMaybe<Scalars['Float']['input']>;
  cbdWeight?: InputMaybe<Scalars['Float']['input']>;
  coaS3FileLink?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  manifestGDriveFileId?: InputMaybe<Scalars['String']['input']>;
  manufacturingDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  otherCannabinoidPercentage?: InputMaybe<Scalars['Float']['input']>;
  otherCannabinoidWeight?: InputMaybe<Scalars['Float']['input']>;
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
  thcAPercentage?: InputMaybe<Scalars['Float']['input']>;
  thcAWeight?: InputMaybe<Scalars['Float']['input']>;
  thcPercentage?: InputMaybe<Scalars['Float']['input']>;
  thcWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCartInput = {
  address?: InputMaybe<CartAddressInput>;
  brandItems?: InputMaybe<Array<InputMaybe<CartBrandItemInput>>>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  legalInformation?: InputMaybe<CartLegalInformationInput>;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  poc?: InputMaybe<CartPocInput>;
  promoCodes?: InputMaybe<Array<CartPromoCodeInput>>;
  siteLicenseNum?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDraftInput = {
  body: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateDraftPayload = {
  changedDraft: Draft;
};

export type UpdateDriverAppSubmissionInput = {
  flaggedDiscrepancy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateDriverInput = {
  driversLicense: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  onfleetWorkerId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriverPayload = {
  changedDriver: Driver;
};

export type UpdateEwbTransaction = {
  id: Scalars['ID']['input'];
  status: EwbTransactionStatusEnum;
};

export type UpdateEwbTransactionsInput = {
  transactions: Array<UpdateEwbTransaction>;
};

export type UpdateEmailTemplateInput = {
  bcc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateExternalPaymentCollectionInput = {
  externalPaymentDesired?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentMin?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentNotes: Scalars['String']['input'];
  mustPayExternalBalance: Scalars['Boolean']['input'];
  orderId: Scalars['ID']['input'];
};

export type UpdateFactorInvoiceInput = {
  factorRate?: InputMaybe<Scalars['Float']['input']>;
  factorStatus?: InputMaybe<OrderFactorStatusEnum>;
  invoiceId: Scalars['ID']['input'];
  isAdvancePaid?: InputMaybe<Scalars['Boolean']['input']>;
  isReservePaid?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type UpdateFulfillabilityFromInfoplusInput = {
  shipmentId: Scalars['ID']['input'];
};

export type UpdateFulfillabilityFromInfoplusPayload = {
  fulfillability?: Maybe<ShipmentFulfillability>;
  success: Scalars['Boolean']['output'];
};

export type UpdateHomeListElementInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  inventoryClass?: InputMaybe<InventoryClassEnum>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  marketplacePage: MarketplacePageType;
  name?: InputMaybe<Scalars['String']['input']>;
  retailerGroupId?: InputMaybe<Scalars['ID']['input']>;
  skuIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  type: HomeListElementType;
};

export type UpdateHoursInput = {
  enabled: Scalars['Boolean']['input'];
  hours?: InputMaybe<Array<InputMaybe<Array<Scalars['DateTime']['input']>>>>;
  id: Scalars['ID']['input'];
};

export type UpdateInfoplusOrderStagingAreaCustomFieldRepairPayload = {
  errors?: Maybe<Array<UpdateInfoplusOrderStagingAreaCustomFieldResponse>>;
};

export type UpdateInfoplusOrderStagingAreaCustomFieldResponse = {
  customFields?: Maybe<InfoplusOrderCustomFields>;
  error?: Maybe<Scalars['JSON']['output']>;
  infoplusOrderId?: Maybe<Scalars['Int']['output']>;
  infoplusWarehouseId?: Maybe<Scalars['Int']['output']>;
  lobId?: Maybe<Scalars['Int']['output']>;
  shipmentId?: Maybe<Scalars['ID']['output']>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type UpdateLicenseInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<LicenseCategoryEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  issuanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LicenseTypeEnum>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLicensePayload = {
  changedLicense: License;
};

export type UpdateLicensedLocationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingAddressCity?: InputMaybe<Scalars['String']['input']>;
  billingAddressState?: InputMaybe<Scalars['String']['input']>;
  billingAddressZip?: InputMaybe<Scalars['String']['input']>;
  centralizedPurchasingNotes?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  collect1PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  collect1PocEmail?: InputMaybe<Scalars['String']['input']>;
  collect1PocFirstName?: InputMaybe<Scalars['String']['input']>;
  collect1PocLastName?: InputMaybe<Scalars['String']['input']>;
  collect1PocNumber?: InputMaybe<Scalars['String']['input']>;
  collect1PocTitle?: InputMaybe<Scalars['String']['input']>;
  collect1PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  collect2PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  collect2PocEmail?: InputMaybe<Scalars['String']['input']>;
  collect2PocFirstName?: InputMaybe<Scalars['String']['input']>;
  collect2PocLastName?: InputMaybe<Scalars['String']['input']>;
  collect2PocNumber?: InputMaybe<Scalars['String']['input']>;
  collect2PocTitle?: InputMaybe<Scalars['String']['input']>;
  collect2PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  collectionNotes?: InputMaybe<Scalars['String']['input']>;
  delivery1PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  delivery1PocEmail?: InputMaybe<Scalars['String']['input']>;
  delivery1PocFirstName?: InputMaybe<Scalars['String']['input']>;
  delivery1PocLastName?: InputMaybe<Scalars['String']['input']>;
  delivery1PocNumber?: InputMaybe<Scalars['String']['input']>;
  delivery1PocTitle?: InputMaybe<Scalars['String']['input']>;
  delivery1PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  delivery2PocAllowsText?: InputMaybe<Scalars['Boolean']['input']>;
  delivery2PocEmail?: InputMaybe<Scalars['String']['input']>;
  delivery2PocFirstName?: InputMaybe<Scalars['String']['input']>;
  delivery2PocLastName?: InputMaybe<Scalars['String']['input']>;
  delivery2PocNumber?: InputMaybe<Scalars['String']['input']>;
  delivery2PocTitle?: InputMaybe<Scalars['String']['input']>;
  delivery2PreferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  deliveryByApptOnly?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  form8300ComplianceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  hoursBusiness?: InputMaybe<Scalars['String']['input']>;
  hoursDelivery?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isBillingAddressSameAsDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isDropAndGo?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  licensedLocationProposalId?: InputMaybe<Scalars['ID']['input']>;
  licenses?: InputMaybe<Array<InputMaybe<UpsertLicenseInput>>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locationNotes?: InputMaybe<Scalars['String']['input']>;
  nabisNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newSpecialRequirementsForLocation?: InputMaybe<NewSpecialRequirementsForLocation>;
  noExciseTax?: InputMaybe<Scalars['Boolean']['input']>;
  payByCheck?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  printCoas?: InputMaybe<Scalars['Boolean']['input']>;
  qualitativeRating?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  retailerPricingGroupId?: InputMaybe<Scalars['ID']['input']>;
  retailerPricingGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  schedulingSoftwareLink?: InputMaybe<Scalars['String']['input']>;
  schedulingSoftwareRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sellerPermitLink?: InputMaybe<Scalars['String']['input']>;
  siteCategory?: InputMaybe<SiteCategoryEnum>;
  specialProtocol?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  taxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  trustLevelNabis?: InputMaybe<CreditRatingTrustLevels>;
  w9Link?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLicensedLocationProposalInput = {
  body: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type UpdateLineItemInput = {
  additionalDiscount?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  destinationSkuBatchId?: InputMaybe<Scalars['ID']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemManifestNotes?: InputMaybe<Scalars['String']['input']>;
  metrcPackageTag?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overrideQuantityPerUnitOfMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  oversold?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  promotionsDiscount?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sampleType?: InputMaybe<LineItemSampleType>;
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
  standardPricePerUnit: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLineItemPayload = {
  changedLineItem: LineItem;
};

export type UpdateMetrcSkuBatchInput = {
  metrcItemIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  metrcSourcePackageTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skuBatchId: Scalars['ID']['input'];
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type UpdateMetrcWarehouseIdInput = {
  orderNumber: Scalars['Int']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type UpdateMetrcWarehouseIdPayload = {
  success: Scalars['Boolean']['output'];
};

export type UpdateMultipleFirstOrderOutput = {
  adminNotes: Scalars['String']['output'];
  firstShipmentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
};

export type UpdateMultipleFirstShipmentsOrder = {
  adminNotes: Scalars['String']['input'];
  firstShipmentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  number: Scalars['Int']['input'];
};

export type UpdateMultipleFirstShipmentsOutput = {
  arrivalTime: Scalars['DateTime']['output'];
  departureTime: Scalars['DateTime']['output'];
  destinationLicensedLocationId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  order?: Maybe<UpdateMultipleFirstOrderOutput>;
  originLicensedLocationId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateMultipleFirstShipmentsPayload = {
  newDepartureTime: Scalars['DateTime']['input'];
  order: UpdateMultipleFirstShipmentsOrder;
  shipments: Array<UpdateMultipleFirstShipmentsShipment>;
};

export type UpdateMultipleFirstShipmentsResponse = {
  failedOrders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updatedFirstShipments?: Maybe<Array<UpdateMultipleFirstShipmentsOutput>>;
};

export type UpdateMultipleFirstShipmentsShipment = {
  departureTime: Scalars['DateTime']['input'];
  destinationLicensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  originLicensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOnboardingRouteInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type UpdateOrderInput = {
  accountingNotes?: InputMaybe<Scalars['String']['input']>;
  action?: InputMaybe<OrderActionEnum>;
  additionalDiscount?: InputMaybe<Scalars['Float']['input']>;
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  appliedDiscounts?: InputMaybe<Array<AppliedDiscountInput>>;
  asnInventoryStatus?: InputMaybe<OrderAsnInventoryStatusEnum>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  autoChargeRejectionFee?: InputMaybe<Scalars['Boolean']['input']>;
  brandManifestNotes?: InputMaybe<Scalars['String']['input']>;
  confirmationPocName?: InputMaybe<Scalars['String']['input']>;
  confirmationPocNotes?: InputMaybe<Scalars['String']['input']>;
  confirmationTrail?: InputMaybe<ConfirmationTrailEnum>;
  creditMemo?: InputMaybe<Scalars['Float']['input']>;
  creditMemoPayload?: InputMaybe<Array<CreditMemoPayload>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  daysTillPaymentDue?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  editReasons?: InputMaybe<Array<InputMaybe<OrderEditReasons>>>;
  editedLineItems?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  estimatedArrivalTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedArrivalTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  exciseTax?: InputMaybe<Scalars['Float']['input']>;
  exciseTaxCollected?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentDesired?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentMin?: InputMaybe<Scalars['Float']['input']>;
  externalPaymentNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillability?: InputMaybe<OrderFulfillabilityEnum>;
  gmv?: InputMaybe<Scalars['Float']['input']>;
  gmvCollected?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  infoplus?: InputMaybe<Scalars['Int']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossHubRetailTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  isEditableByBrand?: InputMaybe<Scalars['Boolean']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isPrinted?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isReceived?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isStaged?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<OrderIssueReasons>;
  lineItems?: InputMaybe<Array<UpsertLineItemInput>>;
  manufacturerOrgId?: InputMaybe<Scalars['ID']['input']>;
  metrcWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  mppbOrders?: InputMaybe<Array<CreateMppbOrderInput>>;
  mustPayExternalBalance?: InputMaybe<Scalars['Boolean']['input']>;
  mustPayPreviousBalance?: InputMaybe<Scalars['Boolean']['input']>;
  nabisDiscount?: InputMaybe<Scalars['Float']['input']>;
  nabisManifestNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netGmv?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderInventoryStatus?: InputMaybe<OrderOrderInventoryStatusEnum>;
  orgLicenseNum?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodEnum>;
  paymentStatus?: InputMaybe<OrderPaymentStatusEnum>;
  pricingFee?: InputMaybe<Scalars['Float']['input']>;
  pricingPercentage?: InputMaybe<Scalars['Float']['input']>;
  promotionsDiscount?: InputMaybe<Scalars['Float']['input']>;
  reorderEmailDate?: InputMaybe<Scalars['DateTime']['input']>;
  returnedLineItems?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
  secondaryInfoplus?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<UpsertSiteInput>;
  siteLicenseNum?: InputMaybe<Scalars['String']['input']>;
  stagingAreaId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<OrderStatusEnum>;
  surcharge?: InputMaybe<Scalars['Float']['input']>;
  timeWindow?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  writeOffReasons?: InputMaybe<Array<WriteOffReason>>;
};

export type UpdateOrderLockdownInput = {
  id: Scalars['ID']['input'];
  isCreditMemoLocked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrderPayload = {
  changedOrder: Order;
};

export type UpdateOrganizationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  bannerImageS3Link?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  creditRatingNotificationAccess?: InputMaybe<Scalars['Boolean']['input']>;
  doingBusinessAs?: InputMaybe<Scalars['String']['input']>;
  factoredStatus?: InputMaybe<OrganizationFactoredStatusEnum>;
  hasAllowOrderCapOverride?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnalyticsDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  hasMustPayExternalBalance?: InputMaybe<Scalars['Boolean']['input']>;
  hasPlatformV2ApiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  infoplus?: InputMaybe<Scalars['Int']['input']>;
  isBrand?: InputMaybe<Scalars['Boolean']['input']>;
  isEnterpriseCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  isManufacturer?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isSalesOrg?: InputMaybe<Scalars['Boolean']['input']>;
  logoS3Link?: InputMaybe<Scalars['String']['input']>;
  manifestGDriveFolderId?: InputMaybe<Scalars['String']['input']>;
  marketplaceContactEmail?: InputMaybe<Scalars['String']['input']>;
  marketplaceContactName?: InputMaybe<Scalars['String']['input']>;
  marketplaceContactNumber?: InputMaybe<Scalars['String']['input']>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  receiveReports?: InputMaybe<Scalars['Boolean']['input']>;
  singleHubWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationType>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInviteInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  senderId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrganizationInvitePayload = {
  changedOrganizationInvite: OrganizationInvite;
};

export type UpdateOrganizationPayload = {
  changedOrganization: Organization;
};

export type UpdateOrganizationUserInput = {
  organizationId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateOrganizationUserPayload = {
  changedOrganizationUser: OrganizationUser;
};

export type UpdatePaymentPermissionsInput = {
  hasAllBankingPermissions: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateRetailerGroupPayload = {
  duplicateRetailerGroupLicensedLocations?: Maybe<Array<RetailerGroupLicensedLocation>>;
  hasDuplicates: Scalars['Boolean']['output'];
  retailerGroup?: Maybe<RetailerGroup>;
};

export type UpdateRoleInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRolePayload = {
  changedRole: Role;
};

export type UpdateSingleShipmentInput = {
  arrivalTimeAfter?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalTimeBefore?: InputMaybe<Scalars['DateTime']['input']>;
  departureTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationLicensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fulfillability?: InputMaybe<ShipmentFulfillability>;
  id: Scalars['ID']['input'];
  infoplusAsnId?: InputMaybe<Scalars['Int']['input']>;
  infoplusAsnInventoryStatus?: InputMaybe<InfoplusAsnInventoryStatus>;
  infoplusOrderId?: InputMaybe<Scalars['Int']['input']>;
  infoplusOrderInventoryStatus?: InputMaybe<InfoplusOrderInventoryStatus>;
  isLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  isPrinted?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isShipped?: InputMaybe<Scalars['Boolean']['input']>;
  isStaged?: InputMaybe<Scalars['Boolean']['input']>;
  isUnloaded?: InputMaybe<Scalars['Boolean']['input']>;
  loaderId?: InputMaybe<Scalars['ID']['input']>;
  nextShipmentId?: InputMaybe<Scalars['ID']['input']>;
  numberOfCartons?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  originLicensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  previousShipmentId?: InputMaybe<Scalars['ID']['input']>;
  shipmentNumber?: InputMaybe<Scalars['Int']['input']>;
  stagingAreaId?: InputMaybe<Scalars['ID']['input']>;
  unloaderId?: InputMaybe<Scalars['ID']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSiteInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  licenses?: InputMaybe<Array<CreateLicenseInput>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pocEmail?: InputMaybe<Scalars['String']['input']>;
  pocName?: InputMaybe<Scalars['String']['input']>;
  pocPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  siteCategory?: InputMaybe<SiteCategoryEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSitePayload = {
  changedSite: Site;
};

export type UpdateSkuDetailsInput = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  cannabinoidDosageA?: InputMaybe<Scalars['String']['input']>;
  cannabinoidDosageB?: InputMaybe<Scalars['String']['input']>;
  cannabinoidTypeA?: InputMaybe<Scalars['String']['input']>;
  cannabinoidTypeB?: InputMaybe<Scalars['String']['input']>;
  containerType?: InputMaybe<Scalars['String']['input']>;
  eachUnitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isColdStorage?: InputMaybe<Scalars['Boolean']['input']>;
  productLine?: InputMaybe<Scalars['String']['input']>;
  thcPotencyMeasurementType?: InputMaybe<Scalars['String']['input']>;
  thcPotencyPerUnit?: InputMaybe<Scalars['String']['input']>;
  unitsPerEach?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSkuDetailsPayload = {
  changedSkuDetails: SkuDetailsPayload;
};

export type UpdateSkuInput = {
  batchId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  customTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  inventoryCategory?: InputMaybe<InventoryCategoryEnum>;
  inventoryCategoryTags?: InputMaybe<Array<InventoryCategoryTagEnum>>;
  inventoryClass?: InputMaybe<InventoryClassEnum>;
  inventoryType?: InputMaybe<InventoryTypeEnum>;
  inventoryUnitOfMeasure?: InputMaybe<InventoryUnitOfMeasureEnum>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isColdStorage?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySampleAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  janeProductId?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  marketplaceDescription?: InputMaybe<Scalars['String']['input']>;
  marketplaceName?: InputMaybe<Scalars['String']['input']>;
  maxMarketplaceInventory?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netVolume?: InputMaybe<Scalars['Float']['input']>;
  netVolumeUnitOfMeasure?: InputMaybe<VolumeUnitOfMeasureEnum>;
  netWeight?: InputMaybe<Scalars['Float']['input']>;
  netWeightUnitOfMeasure?: InputMaybe<WeightUnitOfMeasureEnum>;
  nonSampleSkuId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parentSkuId?: InputMaybe<Scalars['ID']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  productImageS3Link?: InputMaybe<Scalars['String']['input']>;
  quantityPerUnitOfMeasure?: InputMaybe<Scalars['Int']['input']>;
  secondaryImageS3Links?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEnv?: InputMaybe<SourceEnvEnum>;
  strainId?: InputMaybe<Scalars['ID']['input']>;
  strainType?: InputMaybe<StrainTypeEnum>;
  tags?: InputMaybe<Array<InventoryTagEnum>>;
  unit?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnitOfMeasure?: InputMaybe<WeightUnitOfMeasureEnum>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSkuPayload = {
  changedSku: Sku;
};

export type UpdateUserInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  metrcUserApiKey?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserLicensedLocationRelationship = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<UserLicensedLocationStatusesEnum>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateUserPayload = {
  changedUser: User;
  changedUserPreference?: Maybe<UserPreference>;
};

export type UpdateVehicleInput = {
  id: Scalars['ID']['input'];
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVehiclePayload = {
  changedVehicle: Vehicle;
};

export type UploadGenericOrderFilesPayload = {
  links?: Maybe<Array<UploadGenericOrderFilesPayloadContainer>>;
};

export type UploadGenericOrderFilesPayloadContainer = {
  link: Scalars['String']['output'];
  type: GenericOrderFileUploadType;
};

export type UploadPart = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type UploadToOnfleetError = {
  error?: Maybe<OnfleetError>;
  task?: Maybe<OnfleetTask>;
};

export type UploadToOnfleetInput = {
  orders: Array<Scalars['ID']['input']>;
};

export type UploadToOnfleetPayload = {
  errors: Array<UploadToOnfleetError>;
  ok: Scalars['Boolean']['output'];
  updatedOrders?: Maybe<Array<Order>>;
};

export type UpsertLicenseInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  category: LicenseCategoryEnum;
  city: Scalars['String']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issuanceDate?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName: Scalars['String']['input'];
  licenseNumber: Scalars['String']['input'];
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  nickname: Scalars['String']['input'];
  onboardedAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  state: Scalars['String']['input'];
  type: LicenseTypeEnum;
  zip: Scalars['String']['input'];
};

export type UpsertLicensedLocationContactInput = {
  copyTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userContact?: InputMaybe<Scalars['Boolean']['input']>;
  userLicensedLocationRelationshipId: Scalars['ID']['input'];
};

export type UpsertLineItemInput = {
  additionalDiscount?: InputMaybe<Scalars['Float']['input']>;
  appliedDiscounts?: InputMaybe<Array<AppliedDiscountInput>>;
  code?: InputMaybe<Scalars['String']['input']>;
  destinationSkuBatchId?: InputMaybe<Scalars['ID']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isExciseTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemManifestNotes?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organization?: InputMaybe<UpdateOrganizationInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overrideQuantityPerUnitOfMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  oversold?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  promotionsDiscount?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sampleType?: InputMaybe<LineItemSampleType>;
  skuBatchId?: InputMaybe<Scalars['ID']['input']>;
  standardPricePerUnit: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertOrderFeeInput = {
  orderFee?: InputMaybe<OrderFeeInput>;
  orderId: Scalars['ID']['input'];
};

export type UpsertOrderFeePayload = {
  success: Scalars['Boolean']['output'];
};

export type UpsertSiteInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  licenses?: InputMaybe<Array<CreateLicenseInput>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pocEmail?: InputMaybe<Scalars['String']['input']>;
  pocName?: InputMaybe<Scalars['String']['input']>;
  pocPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  siteCategory?: InputMaybe<SiteCategoryEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  assigned: Array<Order>;
  city?: Maybe<Scalars['String']['output']>;
  drafts: Array<SimplifiedDraft>;
  driversLicense?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAccountingUser: Scalars['Boolean']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDriver: Scalars['Boolean']['output'];
  isManufacturerOnlyUser: Scalars['Boolean']['output'];
  isNabisAdminUser: Scalars['Boolean']['output'];
  isPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  isRetailerOnlyUser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  metrcUserApiKey?: Maybe<Scalars['String']['output']>;
  onfleetWorkerId?: Maybe<Scalars['String']['output']>;
  organizationCountsByType: Array<OrganizationCount>;
  organizationInvites: Array<OrganizationInvite>;
  organizationUserRole?: Maybe<Role>;
  organizations: Array<Organization>;
  paymentPermissions?: Maybe<PaymentPermissions>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  userPreferences?: Maybe<Array<UserPreference>>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserOrganizationUserRoleArgs = {
  organizationId: Scalars['ID']['input'];
};

export type UserOrganizationsArgs = {
  type?: InputMaybe<OrganizationType>;
};

export type UserPaymentPermissionsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type UserUserPreferencesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserLicensedLocationQueryInput = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UserLicensedLocationRelationship = {
  contacts?: Maybe<Array<Maybe<LicensedLocationContact>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  licensedLocationId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  status?: Maybe<UserLicensedLocationStatusesEnum>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Values for the UserLicensedLocationStatusesEnum enum */
export enum UserLicensedLocationStatusesEnum {
  BadFit = 'BAD_FIT',
  BestCustomer = 'BEST_CUSTOMER',
  Canceled = 'CANCELED',
  Customer = 'CUSTOMER',
  Interested = 'INTERESTED',
  LoyalCustomer = 'LOYAL_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  NotInterested = 'NOT_INTERESTED',
  NoStatus = 'NO_STATUS',
  Potential = 'POTENTIAL',
  Qualified = 'QUALIFIED',
}

export type UserPreference = {
  allowMarketplaceContactInfo?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  orderCSV?: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  receiveMarketplaceDealsEmails?: Maybe<Scalars['Boolean']['output']>;
  receiveMarketplaceReorderEmails?: Maybe<Scalars['Boolean']['output']>;
  receiveOrderUpdateEmails?: Maybe<Scalars['Boolean']['output']>;
  receivePaymentTermsRequestEmails?: Maybe<Scalars['Boolean']['output']>;
  receiveRetailerRequestEmails?: Maybe<Scalars['Boolean']['output']>;
  referralId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type UserPreferenceInput = {
  allowMarketplaceContactInfo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Values = {
  allocated: Scalars['Int']['output'];
  available: Scalars['Int']['output'];
  counted: Scalars['Int']['output'];
  incoming: Scalars['Int']['output'];
  outgoing: Scalars['Int']['output'];
  packed?: Maybe<Scalars['Int']['output']>;
  quarantined: Scalars['Int']['output'];
};

export type Vehicle = {
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** Values for the VerificationStatusEnum enum */
export enum VerificationStatusEnum {
  Rejected = 'REJECTED',
  Unverified = 'UNVERIFIED',
  Verfied = 'VERFIED',
}

export type VerifyEwbMicroTransactionsInput = {
  amount1: Scalars['Float']['input'];
  amount2: Scalars['Float']['input'];
  bankAccountInfoId: Scalars['ID']['input'];
};

export type VerifyJwtResponse = {
  aud: Scalars['String']['output'];
  exp: Scalars['Int']['output'];
  iat: Scalars['Int']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isDriver: Scalars['Boolean']['output'];
  iss: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
};

export type Viewer = {
  accessibleBrands?: Maybe<Array<Organization>>;
  accessibleElasticSkuBatches?: Maybe<ElasticSkuBatchInfo>;
  accessibleSkuBatches?: Maybe<SkuBatchInfo>;
  accessibleSkus?: Maybe<Array<Maybe<Sku>>>;
  activeOrdersRetailer?: Maybe<AllOrdersRetailerPayload>;
  allAccounts?: Maybe<AllAccountsPayload>;
  allAccountsGetMaximumNumberOfOrders: Scalars['Int']['output'];
  allAccountsSearchByCityState: Array<Scalars['String']['output']>;
  allAccountsSearchByLicenseNumber: Array<Scalars['String']['output']>;
  allAccountsSearchByRetailerName: Array<Scalars['String']['output']>;
  allAccountsSearchBySalesRep: Array<Scalars['String']['output']>;
  allAccountsSearchByTag: Array<Scalars['String']['output']>;
  allAdminAccountingOrders?: Maybe<AllAdminAccountingOrdersPayload>;
  allAdminAccountingOrdersWithoutPagination?: Maybe<AllAdminAccountingOrdersPayload>;
  allAdminBatches?: Maybe<BatchInfo>;
  allAdminInventoryItems?: Maybe<Array<InventoryRow>>;
  allAdminOrders?: Maybe<AllAdminOrdersPayload>;
  allAdminOrdersWithoutPagination?: Maybe<AllAdminOrdersPayload>;
  allAdminOrganizations?: Maybe<Array<Organization>>;
  allAdminOrganizationsWithRetailers: Array<MinimalOrganizationBanking>;
  allAdminSkuBatches?: Maybe<SkuBatchInfo>;
  allAdminSkus?: Maybe<SkuInfo>;
  allBatches?: Maybe<BatchInfo>;
  allBulkImportFileMappings: Array<BulkImportFileMappingResponse>;
  allBulkImportJobs: Array<BulkImportJobResponse>;
  allDateRules: Array<DateRule>;
  allDateRulesByWarehouseId: DateRulesPayload;
  allDrafts?: Maybe<AllDraftsPayload>;
  allDrivers: Array<Driver>;
  allEmailTemplates?: Maybe<AllEmailTemplatesPayload>;
  allInventory?: Maybe<Array<InventoryRow>>;
  allInventoryItems: InventoryItemInfoWithInfoplus;
  allInventoryLedgerItems?: Maybe<Array<InventoryLedgerItem>>;
  allLicensedLocationProposals?: Maybe<AllLicensedLocationProposalsPayload>;
  allLicensedLocationSimplified?: Maybe<AllLicensedLocationSimplifiedPayload>;
  allLicensedLocations?: Maybe<AllLicensedLocationsPayload>;
  allLicenses?: Maybe<AllLicensesPayload>;
  allLineItems?: Maybe<Array<LineItem>>;
  allMarketplaceBrands?: Maybe<Array<Organization>>;
  allNabisCapitalOrganizations?: Maybe<Array<Organization>>;
  allOrders?: Maybe<AllOrdersPayload>;
  allOrdersRetailer?: Maybe<AllOrdersRetailerPayload>;
  allOrganizationInvites?: Maybe<Array<OrganizationInvite>>;
  allOrganizationUsers?: Maybe<Array<OrganizationUser>>;
  allOrganizations?: Maybe<Array<Organization>>;
  allOutstandingInvoices?: Maybe<AllInvoicesPayload>;
  allOutstandingInvoicesRetailer?: Maybe<AllRetailerInvoicesPayload>;
  allOutstandingInvoicesRetailerForPayablePane?: Maybe<AllRetailerInvoicesPayload>;
  allPublicSites?: Maybe<Array<Site>>;
  allRoles?: Maybe<Array<Role>>;
  allSalesTimeSeries?: Maybe<Array<Sales>>;
  allSites?: Maybe<Array<Site>>;
  allSkuBatches?: Maybe<SkuBatchInfo>;
  allSkus?: Maybe<SkuInfo>;
  allTerritories: Array<Territory>;
  allUsers?: Maybe<Array<User>>;
  allVehicles?: Maybe<Array<Vehicle>>;
  allWarehouses?: Maybe<Array<Warehouse>>;
  backfillMPPBRestrictions: BackfillMppbStats;
  coas?: Maybe<CoaPayload>;
  countAndTotalDueForOverdueInvoices?: Maybe<CountAndTotalDueForOverdueInvoicesPayload>;
  countOverdueInvoices?: Maybe<CountOverdueInvoicesPayload>;
  csvDownloadLinks?: Maybe<PlatformCsvFileLinkResponse>;
  getAgingSnapshotDatePickerData?: Maybe<Array<Maybe<SnapshotAgingDates>>>;
  getAllBrandManufacturerLicenses?: Maybe<Array<License>>;
  getAllBrandManufacturerOrganizations?: Maybe<Array<Organization>>;
  getAllBrandNotOnboardedLicenses?: Maybe<Array<License>>;
  getAllFees?: Maybe<Array<Fee>>;
  getAllManufacturerBrandLicenses?: Maybe<Array<License>>;
  getAllManufacturerBrandOrganizations?: Maybe<Array<Organization>>;
  getAllRetailerPricingGroups?: Maybe<Array<RetailerPricingGroup>>;
  getAndSyncMetrcPackage?: Maybe<Scalars['JSON']['output']>;
  getAppSetting?: Maybe<AppSetting>;
  getAvailableEmails?: Maybe<Array<AvailableEmail>>;
  getBrandRetailerOutstandingBalanceBrand?: Maybe<Array<BrandRetailerOutstandingBalanceResponse>>;
  getBrandRetailerOutstandingBalanceRetailer?: Maybe<Array<BrandRetailerOutstandingBalanceResponse>>;
  getBrandRetailerOutstandingBalanceSales?: Maybe<Array<BrandRetailerOutstandingBalanceResponse>>;
  getDashboard?: Maybe<DashboardPayload>;
  getDashboardData?: Maybe<DashboardData>;
  getDatePickerData?: Maybe<Scalars['JSON']['output']>;
  getGMVPerBrand?: Maybe<Array<Maybe<GetGmvPerBrand>>>;
  getHours?: Maybe<Hours>;
  getMetrcItems?: Maybe<Scalars['JSON']['output']>;
  getMetrcOrders?: Maybe<GetMetrcOrdersPayload>;
  getMetrcPackages?: Maybe<Scalars['JSON']['output']>;
  getMetrcSkuBatch?: Maybe<GetMetrcSkuBatchPayload>;
  getMinutesUntilCutoffTime?: Maybe<Scalars['Int']['output']>;
  getOnFleetTask?: Maybe<Scalars['JSON']['output']>;
  getOnboardingInviteData?: Maybe<OnboardingInvitePayload>;
  getOnboardingInvites?: Maybe<Array<PendingOnboardingInvite>>;
  getOnboardingRouteByToken?: Maybe<OnboardingRoute>;
  getOnlyMetrcOrder?: Maybe<GetOnlyMetrcOrderPayload>;
  getOnlyMetrcTags?: Maybe<GetOnlyMetrcTagsPayload>;
  getOrder?: Maybe<Order>;
  getOrdersThatHaveChanged: GetOrdersThatHaveChangedPayload;
  getOrganizationInvites?: Maybe<Array<Maybe<OrganizationInvite>>>;
  getRejectionFee?: Maybe<Fee>;
  getSite?: Maybe<Site>;
  getTitleholders?: Maybe<Array<Maybe<Titleholder>>>;
  getUserByEmail?: Maybe<GetUserByEmailPayload>;
  iHeartJaneRatings: Array<IHeartJaneRating>;
  iHeartJaneReviews: IHeartJaneReviews;
  lineItemWithQr: Array<LineItemWithQr>;
  me?: Maybe<User>;
  orderCalendar?: Maybe<OrderCalendarPayload>;
  orderRepairs?: Maybe<Array<OrderRepairGroup>>;
  organizationContactTypes: Array<OrganizationContactType>;
  organizationContacts: OrganizationContactResponse;
  platformInventory?: Maybe<PlatformCsvInventoryResponse>;
  retailersOutstandingInvoicesForBrand?: Maybe<OutstandingBalanceResponse>;
};

export type ViewerAccessibleBrandsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  orgId: Scalars['ID']['input'];
};

export type ViewerAccessibleElasticSkuBatchesArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  pageInfo: PageInfoInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAccessibleSkuBatchesArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  orgId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAccessibleSkusArgs = {
  orgId: Scalars['ID']['input'];
};

export type ViewerActiveOrdersRetailerArgs = {
  licensedLocationId: Scalars['ID']['input'];
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type ViewerAllAccountsArgs = {
  input: AllAccountsInput;
};

export type ViewerAllAccountsGetMaximumNumberOfOrdersArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerAllAccountsSearchByCityStateArgs = {
  search: Scalars['String']['input'];
};

export type ViewerAllAccountsSearchByLicenseNumberArgs = {
  search: Scalars['String']['input'];
};

export type ViewerAllAccountsSearchByRetailerNameArgs = {
  search: Scalars['String']['input'];
};

export type ViewerAllAccountsSearchBySalesRepArgs = {
  organizationId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
};

export type ViewerAllAccountsSearchByTagArgs = {
  organizationId: Scalars['ID']['input'];
  search: Scalars['String']['input'];
};

export type ViewerAllAdminAccountingOrdersArgs = {
  collectionStatus?: InputMaybe<Array<InputMaybe<BrandFeesCollectionCollectionStatusEnum>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  disputeStatus?: InputMaybe<Array<OrderDisputeStatus>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  includeACHPaidOrders?: InputMaybe<Scalars['Boolean']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paidAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  paidAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  paymentProcessedAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  paymentProcessedAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  paymentSentAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  paymentSentAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  paymentStatus?: InputMaybe<Array<InputMaybe<OrderPaymentStatusEnum>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatusEnum>>>;
};

export type ViewerAllAdminAccountingOrdersWithoutPaginationArgs = {
  direction?: InputMaybe<Scalars['String']['input']>;
  disputeStatus?: InputMaybe<Array<OrderDisputeStatus>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStatus?: InputMaybe<Array<InputMaybe<OrderPaymentStatusEnum>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatusEnum>>>;
};

export type ViewerAllAdminBatchesArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewerAllAdminInventoryItemsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerAllAdminOrdersArgs = {
  action?: InputMaybe<Array<InputMaybe<OrderActionEnum>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  disputeStatus?: InputMaybe<Array<OrderDisputeStatus>>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  endCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  includeStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  isOnBrandCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  isOnCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  isRetailerRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  isRetailerRestrictedForBrand?: InputMaybe<Scalars['Boolean']['input']>;
  isStaged?: InputMaybe<Scalars['Boolean']['input']>;
  lastWarehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensedLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  metrcStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mustPayPriorBalance?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  onfleetTaskShortId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStatus?: InputMaybe<Array<InputMaybe<OrderPaymentStatusEnum>>>;
  referrer?: InputMaybe<OrderReferrer>;
  sample?: InputMaybe<OrderSampleFilterEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  stagingAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  startCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatusEnum>>>;
  transactionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ViewerAllAdminOrdersWithoutPaginationArgs = {
  action?: InputMaybe<Array<InputMaybe<OrderActionEnum>>>;
  direction?: InputMaybe<Scalars['String']['input']>;
  disputeStatus?: InputMaybe<Array<OrderDisputeStatus>>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  endCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<OnlyOrderByPageInfoInput>;
  paymentStatus?: InputMaybe<Array<InputMaybe<OrderPaymentStatusEnum>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  stagingAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  startCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatusEnum>>>;
  transactionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ViewerAllAdminSkuBatchesArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAllAdminSkusArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAllBatchesArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isInventoryTab?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overrideOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  searchBatchCode?: InputMaybe<Scalars['String']['input']>;
  searchProductName?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAllBulkImportFileMappingsArgs = {
  input: BulkImportFileMappingInput;
};

export type ViewerAllBulkImportJobsArgs = {
  input: BulkImportJobInput;
};

export type ViewerAllDateRulesArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
  warehouseId: Scalars['ID']['input'];
};

export type ViewerAllDateRulesByWarehouseIdArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  warehouseId: Scalars['ID']['input'];
};

export type ViewerAllDraftsArgs = {
  organizationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
  type: DraftTypeEnum;
};

export type ViewerAllEmailTemplatesArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewerAllInventoryArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerAllInventoryItemsArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
  skuBatchId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type ViewerAllInventoryLedgerItemsArgs = {
  inventoryItemId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerAllLicensedLocationProposalsArgs = {
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerAllLicensedLocationSimplifiedArgs = {
  pageInfo?: InputMaybe<PageInfoInput>;
};

export type ViewerAllLicensedLocationsArgs = {
  callerLocation?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOnNabisTracker?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  restrictionStatus?: InputMaybe<Array<RestrictionStatus>>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
  showArchivedLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  siteCategory?: InputMaybe<Array<SiteCategoryEnum>>;
  trustLevel?: InputMaybe<Array<CreditRatingTrustLevels>>;
};

export type ViewerAllLicensesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerAllOrdersArgs = {
  action?: InputMaybe<Array<OrderActionEnum>>;
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Scalars['ID']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  daysTillPaymentDue?: InputMaybe<Scalars['String']['input']>;
  disputeStatus?: InputMaybe<Array<OrderDisputeStatus>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  endCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endPaidAt?: InputMaybe<Scalars['DateTime']['input']>;
  endRemittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  isCodOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isNetTermsLimited?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBrandCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  isOnCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  isPriorNonNabisInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isRetailerRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  isRetailerRestrictedForBrand?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mustPayPriorBalance?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStatus?: InputMaybe<OrderPaymentStatusEnum>;
  referrer?: InputMaybe<OrderReferrer>;
  sample?: InputMaybe<OrderSampleFilterEnum>;
  site?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  startCreatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startPaidAt?: InputMaybe<Scalars['DateTime']['input']>;
  startRemittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<OrderStatusEnum>>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ViewerAllOrdersRetailerArgs = {
  creator?: InputMaybe<Scalars['String']['input']>;
  deliveryStatus?: InputMaybe<OrderRetailerDeliveryStatusEnum>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStatus?: InputMaybe<OrderPaymentStatusEnum>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<OrderStatusEnum>>>;
};

export type ViewerAllOrganizationInvitesArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerAllOutstandingInvoicesArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  creator?: InputMaybe<Scalars['String']['input']>;
  dispensary?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDueDate?: InputMaybe<Scalars['String']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  soldBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDueDate?: InputMaybe<Scalars['String']['input']>;
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAllOutstandingInvoicesRetailerArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  dispensary?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDueDate?: InputMaybe<Scalars['String']['input']>;
  irn?: InputMaybe<Scalars['String']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStatus: Array<InputMaybe<OrderPaymentStatusEnum>>;
  preNabisOrderStatus?: InputMaybe<Array<OrderStatusEnum>>;
  regularOrderStatus?: InputMaybe<Array<OrderStatusEnum>>;
  sortOption: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  startDueDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  warehouse?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAllOutstandingInvoicesRetailerForPayablePaneArgs = {
  licensedLocationId: Scalars['ID']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  paymentStage?: InputMaybe<PaymentStage>;
  sortOption: Scalars['String']['input'];
};

export type ViewerAllSalesTimeSeriesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerAllSitesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerAllSkuBatchesArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isInventoryTab?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overrideOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerAllSkusArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isInventoryTab?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isSample?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  overrideOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  quantitySold?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showAllSkus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewerAllWarehousesArgs = {
  isInUseByOps?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerCoasArgs = {
  orderId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ViewerCountAndTotalDueForOverdueInvoicesArgs = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  showExciseTaxDue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewerCountOverdueInvoicesArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type ViewerCsvDownloadLinksArgs = {
  csvFileType: CsvFileTypes;
  userId: Scalars['ID']['input'];
};

export type ViewerGetAgingSnapshotDatePickerDataArgs = {
  organizationId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ViewerGetAllBrandManufacturerLicensesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetAllBrandManufacturerOrganizationsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetAllBrandNotOnboardedLicensesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetAllFeesArgs = {
  activeDateOverride?: InputMaybe<Scalars['DateTime']['input']>;
  includeHistoricalVersions?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactiveFees: Scalars['Boolean']['input'];
  specificGroupTag?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewerGetAllManufacturerBrandLicensesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetAllManufacturerBrandOrganizationsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetAndSyncMetrcPackageArgs = {
  licenseNumber: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export type ViewerGetAvailableEmailsArgs = {
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerGetBrandRetailerOutstandingBalanceBrandArgs = {
  input: FetchMultiBrandRetailerCreditLimitsBrandUserInput;
};

export type ViewerGetBrandRetailerOutstandingBalanceRetailerArgs = {
  input: FetchMultiBrandRetailerCreditLimitsRetailerUserInput;
};

export type ViewerGetBrandRetailerOutstandingBalanceSalesArgs = {
  input: FetchMultiBrandRetailerCreditLimitsSalesUserInput;
};

export type ViewerGetDashboardArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetDashboardDataArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetDatePickerDataArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  gmv?: InputMaybe<Scalars['Float']['input']>;
  isBrandUserViewForNabisAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossHubOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['String']['input'];
  pickupDropoffWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  shouldOnlyConsiderPiggybackDates?: InputMaybe<Scalars['Boolean']['input']>;
  shouldPrioritizePiggybackDates?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUseRetailerPreferences?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseId: Scalars['ID']['input'];
};

export type ViewerGetGmvPerBrandArgs = {
  licensedLocationId: Scalars['ID']['input'];
};

export type ViewerGetHoursArgs = {
  field: Scalars['String']['input'];
  licensedLocationId: Scalars['ID']['input'];
};

export type ViewerGetMetrcItemsArgs = {
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerGetMetrcOrdersArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
  retailSourceWarehouse?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  warehouse?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerGetMetrcPackagesArgs = {
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerGetMetrcSkuBatchArgs = {
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  skuBatchId: Scalars['ID']['input'];
  warehouseId: Scalars['ID']['input'];
};

export type ViewerGetOnFleetTaskArgs = {
  orderId: Scalars['ID']['input'];
};

export type ViewerGetOnboardingInviteDataArgs = {
  token: Scalars['String']['input'];
};

export type ViewerGetOnboardingInvitesArgs = {
  callerLocation?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['ID']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerGetOnboardingRouteByTokenArgs = {
  token: Scalars['String']['input'];
};

export type ViewerGetOnlyMetrcOrderArgs = {
  orderId: Scalars['ID']['input'];
};

export type ViewerGetOnlyMetrcTagsArgs = {
  lineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ViewerGetOrderArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
};

export type ViewerGetOrdersThatHaveChangedArgs = {
  input: GetOrdersThatHaveChangedInput;
};

export type ViewerGetOrganizationInvitesArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerGetSiteArgs = {
  id: Scalars['ID']['input'];
};

export type ViewerGetTitleholdersArgs = {
  organizationId: Scalars['ID']['input'];
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
};

export type ViewerGetUserByEmailArgs = {
  token: Scalars['String']['input'];
};

export type ViewerIHeartJaneRatingsArgs = {
  skuIds: Array<Scalars['ID']['input']>;
};

export type ViewerIHeartJaneReviewsArgs = {
  pageInfo: PageInfoInput;
  skuId: Scalars['ID']['input'];
};

export type ViewerLineItemWithQrArgs = {
  orderNumber: Scalars['Int']['input'];
};

export type ViewerOrderCalendarArgs = {
  end: Scalars['DateTime']['input'];
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
};

export type ViewerOrderRepairsArgs = {
  input: OrderRepairInput;
};

export type ViewerOrganizationContactsArgs = {
  organizationId: Scalars['ID']['input'];
};

export type ViewerPlatformInventoryArgs = {
  isArchived: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ViewerRetailersOutstandingInvoicesForBrandArgs = {
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Values for the VolumeUnitOfMeasureEnum enum */
export enum VolumeUnitOfMeasureEnum {
  FlOz = 'FL_OZ',
  Gal = 'GAL',
  L = 'L',
  Ml = 'ML',
  Pt = 'PT',
  Qt = 'QT',
}

export type Warehouse = {
  id: Scalars['ID']['output'];
  infoplus?: Maybe<Scalars['Int']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isInUseByOps: Scalars['Boolean']['output'];
  isSingleHub?: Maybe<Scalars['Boolean']['output']>;
  license: License;
  region: WarehouseRegion;
  site: Site;
};

/** Values for the WarehouseRegion enum */
export enum WarehouseRegion {
  CentralCalifornia = 'CENTRAL_CALIFORNIA',
  NorthernCalifornia = 'NORTHERN_CALIFORNIA',
  SouthernCalifornia = 'SOUTHERN_CALIFORNIA',
}

/** Values for the WeightUnitOfMeasureEnum enum */
export enum WeightUnitOfMeasureEnum {
  G = 'G',
  Kg = 'KG',
  Lbs = 'LBS',
  Mg = 'MG',
  Oz = 'OZ',
}

/** Values for the WriteOffReason enum */
export enum WriteOffReason {
  DefunctBrand = 'DEFUNCT_BRAND',
  DefunctRetailer = 'DEFUNCT_RETAILER',
}

export type ZipCodeWarehouse = {
  createdAt: Scalars['DateTime']['output'];
  deliveringWarehouseId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  receivingWarehouseId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  warehouse?: Maybe<Warehouse>;
  zipcodeId: Scalars['ID']['output'];
};

export type Zipcode = {
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultWarehouseId: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['ID']['output'];
  period?: Maybe<Period>;
  periodMultiplier?: Maybe<Scalars['Int']['output']>;
  pickupDays?: Maybe<Array<Scalars['Int']['output']>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  territory?: Maybe<Territory>;
  updatedAt: Scalars['DateTime']['output'];
  zipCodeWarehouse?: Maybe<ZipCodeWarehouse>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type EncodedOrder = {
  encodedCheck: Scalars['String']['input'];
  encodedOrderNumber: Scalars['String']['input'];
};

export type VerifyJwtQueryVariables = Exact<{ [key: string]: never }>;

export type VerifyJwtQuery = { verifyJwt?: { organizationId?: string | null; scope: string } | null };

export type GetFeatureFlagQueryVariables = Exact<{
  key: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetFeatureFlagQuery = { getFeatureFlag?: { key: string; value: string } | null };

export type OrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OrganizationQuery = {
  getOrganization?: {
    id: string;
    name: string;
    doingBusinessAs?: string | null;
    alias: string;
    type: OrganizationType;
  } | null;
};

export type GetOrganizationUserRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetOrganizationUserRoleQuery = {
  getOrganization?: {
    id: string;
    organizationUserRole?: { id: string; name: string; description?: string | null; permissions: Array<string> } | null;
  } | null;
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  viewer?: {
    me?: {
      id: string;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      phone?: string | null;
      isAdmin?: boolean | null;
    } | null;
  } | null;
};

export type AllAccountSimplifiedQueryVariables = Exact<{
  input: AllAccountsInput;
}>;

export type AllAccountSimplifiedQuery = {
  viewer?: {
    allAccounts?: {
      results?: Array<{
        id: string;
        address1: string;
        address2?: string | null;
        zip: string;
        licensedLocationId: string;
        name: string;
        city: string;
        state: string;
        status?: UserLicensedLocationStatusesEnum | null;
        nextOrderDate?: string | null;
        pendingOrders?: number | null;
        nabisNotes?: string | null;
      }> | null;
    } | null;
  } | null;
};

export type GetBrandRetailerOutstandingBalanceBrandQueryVariables = Exact<{
  input: FetchMultiBrandRetailerCreditLimitsBrandUserInput;
}>;

export type GetBrandRetailerOutstandingBalanceBrandQuery = {
  viewer?: {
    getBrandRetailerOutstandingBalanceBrand?: Array<{
      brandOrganizationId: string;
      licensedLocationId: string;
      data?: { totalAmountOutstanding: number; totalAmountOverdue: number } | null;
    }> | null;
  } | null;
};

export type AccountDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  accountId: Scalars['ID']['input'];
}>;

export type AccountDetailsQuery = { userLicensedLocationRelationship?: { description?: string | null } | null };

export type GetBrandRetailerCreditLimitBrandQueryVariables = Exact<{
  input: FetchMultiBrandRetailerCreditLimitsBrandUserInput;
}>;

export type GetBrandRetailerCreditLimitBrandQuery = {
  getBrandRetailerCreditLimitBrand?: {
    data: Array<{
      brandOrganizationId: string;
      createdAt: string;
      createdById: string;
      limit?: number | null;
      retailerOrganizationId: string;
      updatedAt: string;
      updatedById: string;
      isCreditLimitEpicFeatureFlagEnabled: boolean;
    } | null>;
  } | null;
};

export type GetOutstandingAndOverdueBalancesQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  showExciseTaxDue?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOutstandingAndOverdueBalancesQuery = {
  viewer?: {
    countAndTotalDueForOverdueInvoices?: {
      overdueForAllBrands: { count: number; totalDue: number; exciseTaxDue?: number | null };
      outstandingForAllBrands: { count: number; totalDue: number; exciseTaxDue?: number | null };
      overdueForBrand: { count: number; totalDue: number; exciseTaxDue?: number | null };
      outstandingForBrand: { count: number; totalDue: number; exciseTaxDue?: number | null };
    } | null;
  } | null;
};

export type GetDeliveryHoursQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
}>;

export type GetDeliveryHoursQuery = {
  getLicensedLocation?: {
    id: string;
    deliveryHours?: { id: string; hours?: Array<Array<string> | null> | null; enabled: boolean } | null;
  } | null;
};

export type AccessibleBrandsQueryVariables = Exact<{
  orgId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AccessibleBrandsQuery = {
  viewer?: {
    accessibleBrands?: Array<{
      id: string;
      name: string;
      doingBusinessAs?: string | null;
      type: OrganizationType;
    }> | null;
  } | null;
};

export type DatePickerQueryVariables = Exact<{
  action?: InputMaybe<Scalars['String']['input']>;
  gmv?: InputMaybe<Scalars['Float']['input']>;
  warehouseId: Scalars['ID']['input'];
  organizationId: Scalars['String']['input'];
  isCrossHubOrder?: InputMaybe<Scalars['Boolean']['input']>;
  licensedLocationId: Scalars['ID']['input'];
  shouldUseRetailerPreferences?: InputMaybe<Scalars['Boolean']['input']>;
  isSampleDemo?: InputMaybe<Scalars['Boolean']['input']>;
  pickupDropoffWarehouseId?: InputMaybe<Scalars['ID']['input']>;
  shouldPrioritizePiggybackDates?: InputMaybe<Scalars['Boolean']['input']>;
  shouldOnlyConsiderPiggybackDates?: InputMaybe<Scalars['Boolean']['input']>;
  isBrandUserViewForNabisAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DatePickerQuery = { viewer?: { getDatePickerData?: unknown | null } | null };

export type GetDraftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  type: DraftTypeEnum;
}>;

export type GetDraftQuery = {
  getDraft?: {
    id: string;
    body?: unknown | null;
    createdAt: string;
    updatedAt: string;
    organization: { id: string; name: string };
  } | null;
};

export type CreateDraftMutationVariables = Exact<{
  input: CreateDraftInput;
}>;

export type CreateDraftMutation = { createDraft?: { createdDraft: { id: string } } | null };

export type UpdateDraftMutationVariables = Exact<{
  input: UpdateDraftInput;
}>;

export type UpdateDraftMutation = { updateDraft?: { changedDraft: { id: string } } | null };

export type DeleteDraftMutationVariables = Exact<{
  input: DeleteDraftInput;
}>;

export type DeleteDraftMutation = { deleteDraft?: { deletedDraft: { id: string } } | null };

export type GetLicensedLocationForDraftQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetLicensedLocationForDraftQuery = {
  getLicensedLocation?: {
    id: string;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    delivery1PocEmail?: string | null;
    delivery1PocFirstName?: string | null;
    delivery1PocLastName?: string | null;
    delivery1PocNumber?: string | null;
    isArchived?: boolean | null;
    nabisMaxTerms?: number | null;
    name?: string | null;
    siteCategory?: SiteCategoryEnum | null;
    state?: string | null;
    trustLevelInEffect: CreditRatingTrustLevels;
    zip?: string | null;
    lat?: number | null;
    lng?: number | null;
    specialRequirementsForLocation?: Array<{ id: string; isArchived: boolean }> | null;
    licenses?: Array<{ id: string; licenseNumber: string }> | null;
  } | null;
};

export type GetOrderLockdownQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetOrderLockdownQuery = {
  getOrder?: {
    id: string;
    shouldEnableOrderForm: boolean;
    orderLockdown?: {
      id: string;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      isArchived: boolean;
      orderEditLockdownTimestamp?: string | null;
      isCreditMemoLocked: boolean;
    } | null;
  } | null;
};

export type GetSiteQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  licensedLocationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetSiteQuery = {
  getSite?: {
    id: string;
    name: string;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    pocName?: string | null;
    pocPhoneNumber?: string | null;
    pocEmail?: string | null;
    siteCategory: SiteCategoryEnum;
    createdAt: string;
    licensedLocationId?: string | null;
  } | null;
};

export type GetLicensedLocationQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
}>;

export type GetLicensedLocationQuery = {
  getLicensedLocation?: {
    id: string;
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    siteCategory?: SiteCategoryEnum | null;
    warehouseId: string;
    delivery1PocFirstName?: string | null;
    delivery1PocLastName?: string | null;
    delivery1PocTitle?: string | null;
    delivery1PocNumber?: string | null;
    delivery1PocEmail?: string | null;
    delivery1PocAllowsText: boolean;
    delivery1PreferredContactMethod?: string | null;
    delivery2PocFirstName?: string | null;
    delivery2PocLastName?: string | null;
    delivery2PocTitle?: string | null;
    delivery2PocNumber?: string | null;
    delivery2PocEmail?: string | null;
    delivery2PocAllowsText: boolean;
    delivery2PreferredContactMethod?: string | null;
  } | null;
};

export type AllLicensedLocationSimplifiedQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfoInput>;
}>;

export type AllLicensedLocationSimplifiedQuery = {
  viewer?: {
    allLicensedLocationSimplified?: {
      results: Array<{
        id: string;
        address1?: string | null;
        address2?: string | null;
        city?: string | null;
        isCodOnly: boolean;
        isNetTermsLimited: boolean;
        nabisMaxTerms?: number | null;
        name?: string | null;
        noExciseTax: boolean;
        state?: string | null;
        trustLevelInEffect: CreditRatingTrustLevels;
        warehouseId: string;
        zip?: string | null;
        licenses?: Array<{
          id: string;
          nickname?: string | null;
          category: LicenseCategoryEnum;
          type: LicenseTypeEnum;
          licenseNumber: string;
          legalEntityName: string;
          expirationDate?: string | null;
        }> | null;
        warehouse: {
          id: string;
          isArchived?: boolean | null;
          infoplus?: number | null;
          region: WarehouseRegion;
          isInUseByOps: boolean;
          isSingleHub?: boolean | null;
        };
        licensedLocationOrg?: Array<{
          id: string;
          alias?: string | null;
          isMarketplace?: boolean | null;
          isRetailerRestricted: boolean;
          isRetailerRestrictedForBrand: boolean;
          isOnCreditHold: boolean;
          isOnBrandCreditHold: boolean;
          overdueExciseTaxForCreditHold?: number | null;
        } | null> | null;
        specialRequirementsForLocation?: Array<{
          id: string;
          isArchived: boolean;
          extraLeadTimeType?: SpecialRequirementsForLocationExtraLeadTimeEnum | null;
        }> | null;
      }>;
      pageInfo: { totalNumItems?: number | null; totalNumPages?: number | null };
    } | null;
  } | null;
};

export type OrganizationRestrictionInformationForRetailersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type OrganizationRestrictionInformationForRetailersQuery = {
  getOrganization?: {
    restrictions: {
      brandsNotAllowedForMarketplace: Array<string | null>;
      disableMarketplace: boolean;
      isFeatureFlagEnterpriseBrandCreditHoldEnabled: boolean;
      marketplaceOrderingRestrictions: {
        codOnly: { decodedBrandOrganizationIds: Array<string>; hasNabisMax: boolean; hasNabisStandard: boolean };
      };
      creditHolds: {
        retailersOnCreditHold: Array<{
          decodedRetailerLicensedLocationId: string;
          decodedBrandOrganizationId?: string | null;
        }>;
        canNotBeOverriden: Array<{
          decodedSelectedBrandOrganizationId: string;
          retailersThatCanNotBeOverriden: Array<{
            decodedRetailerLicensedLocationId: string;
            decodedBrandOrganizationId?: string | null;
          }>;
        }>;
      };
      orderingRestrictions: {
        codOnlyRetailers: Array<{
          decodedRetailerLicensedLocationId: string;
          decodedBrandOrganizationId?: string | null;
        }>;
        codOnlyRetailersThatCanNotBeOverriden: Array<{
          decodedSelectedBrandOrganizationId: string;
          codOnlyRetailersThatCanNotBeOverriden: Array<{
            decodedRetailerLicensedLocationId: string;
            decodedBrandOrganizationId?: string | null;
          }>;
        }>;
      };
      premierBrands: Array<{ id: string; name: string }>;
    };
  } | null;
};

export type RetailersOutstandingInvoicesForBrandQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;

export type RetailersOutstandingInvoicesForBrandQuery = {
  viewer?: {
    retailersOutstandingInvoicesForBrand?: {
      totalAmount: number;
      totalAmountCollected: number;
      totalAmountDue: number;
      totalAmountExciseTaxOutstanding: number;
      totalAmountNotYetDue: number;
      totalAmountOutstanding: number;
      totalAmountOverdue: number;
      totalAmountRequiredForDelivery: number;
      totalCountOutstanding: number;
      totalCountOverdue: number;
      orders: Array<{
        amount: number;
        amountCollected: number;
        amountDue: number;
        amountExciseTaxOutstanding: number;
        amountNotYetDue: number;
        amountOutstanding: number;
        amountOverdue: number;
        amountRequiredForDelivery: number;
        amountMustPayPriorBalanceRestriction: number;
        date: string;
        id: string;
        number: number;
        codRestriction: boolean;
        dueDate: string;
        mustPayExciseTaxRestriction: boolean;
        invoicesS3FileLink?: string | null;
        isPriorNonNabisInvoice?: boolean | null;
        orderStatus?: OrderStatusEnum | null;
        isFactoredOverdueOrder?: boolean | null;
        isPreselectedForMPPBOverridable?: boolean | null;
        isPreselectedForMPPBNonOverridable?: boolean | null;
        mustPayPriorBalanceRestrictions: Array<{ amount: number; requiredOrderId: string }>;
        creator?: { firstName?: string | null; lastName?: string | null } | null;
        assignee?: { firstName?: string | null; lastName?: string | null } | null;
      }>;
    } | null;
  } | null;
};

export type GetOrderRestrictionsForMppbQueryVariables = Exact<{
  input: GetOrderRestrictionsForMppbInput;
}>;

export type GetOrderRestrictionsForMppbQuery = {
  getOrderRestrictionsForMPPB?: {
    orderRestrictions?: Array<{
      orderRestriction: {
        id: string;
        orderId: string;
        type: OrderRestrictionTypeEnum;
        overrideStatus: OrderRestrictionOverrideStatusEnum;
        isArchived?: boolean | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        requestedBy?: string | null;
        requiredAt?: string | null;
        requestNotes?: string | null;
        adjudicatedBy?: string | null;
        adjudicatedNotes?: string | null;
        adjudicatedAt?: string | null;
        expiredAt?: string | null;
        amountToCollect?: number | null;
        requiredOrderId?: string | null;
        isPartialRequired?: boolean | null;
        isEditable?: boolean | null;
      };
      order: {
        id: string;
        gmvCollected: number;
        exciseTaxCollected: number;
        deliveryDate: string;
        orderNumber: number;
        isPriorNonNabisInvoice: boolean;
        amountOutstanding: number;
        amountOverdue: number;
        amountCollected?: number | null;
        amount: number;
        dueDate?: string | null;
        invoicesS3FileLink?: string | null;
        isFactoredOverdueOrder?: boolean | null;
        assignee?: { id: string; firstName?: string | null; lastName?: string | null } | null;
        creator: { id: string; firstName?: string | null; lastName?: string | null };
      };
    }> | null;
    outstandingOrdersForMPPB?: Array<{
      amount: number;
      amountCollected: number;
      amountDue: number;
      amountExciseTaxOutstanding: number;
      amountNotYetDue: number;
      amountOutstanding: number;
      amountOverdue: number;
      amountRequiredForDelivery: number;
      amountMustPayPriorBalanceRestriction: number;
      invoicesS3FileLink?: string | null;
      date: string;
      number: number;
      id: string;
      codRestriction: boolean;
      dueDate: string;
      isPriorNonNabisInvoice: boolean;
      isFactoredOverdueOrder?: boolean | null;
      creator?: { firstName?: string | null; lastName?: string | null } | null;
      assignee?: { firstName?: string | null; lastName?: string | null } | null;
    }> | null;
  } | null;
};

export type GetLastBrandOrderToLicensedLocationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  licensedLocationId: Scalars['ID']['input'];
  salesOrgId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetLastBrandOrderToLicensedLocationQuery = {
  getLastBrandOrderToLicensedLocation?: { daysTillPaymentDue?: number | null } | null;
};

export type GetRetailerGroupSalesRulesQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
  brandOrganizationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type GetRetailerGroupSalesRulesQuery = {
  getRetailerGroupSalesRules: Array<{
    id: string;
    brandId?: string | null;
    mustPayPreviousBalance?: boolean | null;
    isPaymentTermsBasedOnCreditRating?: boolean | null;
    maxDaysTillPaymentDueForExcellent?: number | null;
    maxDaysTillPaymentDueForGood?: number | null;
    maxDaysTillPaymentDueForFair?: number | null;
    maxDaysTillPaymentDueForWeak?: number | null;
    maxDaysTillPaymentDueForPoor?: number | null;
    defaultDaysTillPaymentDue?: number | null;
    salesRule: {
      id: string;
      isPaymentTermsBasedOnCreditRating: boolean;
      maxDaysTillPaymentDueForExcellent?: number | null;
      maxDaysTillPaymentDueForGood?: number | null;
      maxDaysTillPaymentDueForFair?: number | null;
      maxDaysTillPaymentDueForWeak?: number | null;
      maxDaysTillPaymentDueForPoor?: number | null;
      maxSamplesPerOrder?: number | null;
      isSampleAllowed: boolean;
      mustPayPreviousBalance: boolean;
      defaultDaysTillPaymentDue?: number | null;
      maxAvailableInventory?: number | null;
      minOrderBalance?: number | null;
      pricePerUnit?: number | null;
      isMarketplace: boolean;
      startDate: string;
      endDate?: string | null;
      createdAt: string;
      skuId?: string | null;
      isSampleDemoOrdersAllowed: boolean;
      isHardMinCap: boolean;
      assigneeId?: string | null;
      canRequestAdditionalNetTerms: boolean;
    };
  }>;
};

export type AccessibleSkuBatchesQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo?: InputMaybe<PageInfoInput>;
}>;

export type AccessibleSkuBatchesQuery = {
  viewer?: {
    accessibleSkuBatches?: {
      results: Array<{
        id: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        infoplus?: number | null;
        isArchived: boolean;
        sku: {
          id: string;
          code: string;
          name: string;
          unit: string;
          isArchived?: boolean | null;
          isExciseTaxable?: boolean | null;
          lastUpdate?: string | null;
          inventoryType: InventoryTypeEnum;
          inventoryClass: InventoryClassEnum;
          inventoryCategory: InventoryCategoryEnum;
          inventoryCategoryTags?: Array<InventoryCategoryTagEnum> | null;
          inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
          quantityPerUnitOfMeasure: number;
          isMarketplace: boolean;
          maxMarketplaceInventory?: number | null;
          isSample: boolean;
          janeProductId?: number | null;
          length?: number | null;
          width?: number | null;
          height?: number | null;
          weight?: number | null;
          weightUnitOfMeasure?: WeightUnitOfMeasureEnum | null;
          productImageS3Link?: string | null;
          pricePerUnit?: number | null;
          defaultPricePerUnit: number;
          skuPricePerUnit?: number | null;
        };
        batch?: {
          id: string;
          code: string;
          deletedAt?: string | null;
          expirationDate: string;
          manufacturingDate: string;
          manifestGDriveFileId?: string | null;
          coaS3FileLink?: string | null;
          createdAt: string;
          thcPercentage?: number | null;
          cbdPercentage?: number | null;
          otherCannabinoidPercentage?: number | null;
          thcAPercentage?: number | null;
          thcWeight?: number | null;
          cbdWeight?: number | null;
          otherCannabinoidWeight?: number | null;
          thcAWeight?: number | null;
          aromas: Array<AromaEnum>;
        } | null;
        availableInventory?: Array<{
          key: string;
          warehouseId: string;
          values: {
            counted: number;
            incoming: number;
            outgoing: number;
            allocated: number;
            available: number;
            quarantined: number;
            packed?: number | null;
          };
        }> | null;
      }>;
      pageInfo: {
        page?: number | null;
        numItemsPerPage?: number | null;
        totalNumItems?: number | null;
        totalNumPages?: number | null;
        orderBy: Array<{ attribute?: string | null; order?: OrderByEnum | null }>;
      };
    } | null;
  } | null;
};

export type GetRetailerDiscountsQueryVariables = Exact<{
  organizationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  skuId?: InputMaybe<Scalars['ID']['input']>;
  pageInfo: PageInfoInput;
  search?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  callerLocation?: InputMaybe<Scalars['String']['input']>;
  licensedLocationId?: InputMaybe<Scalars['ID']['input']>;
  includePromoCodePromos?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetRetailerDiscountsQuery = {
  getRetailerDiscounts?: {
    results: Array<{
      id: string;
      name: string;
      createdAt: string;
      discountType: RetailerDiscountType;
      endDate?: string | null;
      flatDiscount?: number | null;
      marketplaceDescription?: string | null;
      minBrandCount?: number | null;
      minBrandOrderAmount?: number | null;
      percentageDiscount?: number | null;
      startDate: string;
      organizationId: string;
      deletedAt?: string | null;
      distinctRedemptionCount: number;
      code?: string | null;
      maxCodeRedemptions?: number | null;
      retailerGroups: Array<{ id: string; name: string; createdAt: string; deletedAt?: string | null }>;
      skus: Array<{
        id: string;
        name: string;
        deletedAt?: string | null;
        createdAt?: string | null;
        isArchived?: boolean | null;
      }>;
      tiers: Array<{
        id: string;
        minBrandOrderAmount: number;
        percentageDiscount?: number | null;
        flatDiscount?: number | null;
      }>;
    }>;
    pageInfo: { totalNumItems?: number | null; totalNumPages?: number | null; page?: number | null };
  } | null;
};

export type GetPromotionRedemptionsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetPromotionRedemptionsQuery = {
  getPromotionRedemptions?: Array<{
    id: string;
    orderId: string;
    lineItemId?: string | null;
    retailerDiscountId: string;
    promotionsDiscount: number;
    retailerDiscountSnapshot?: unknown | null;
    createdAt: string;
    updatedAt: string;
    retailerDiscount: {
      id: string;
      organizationId: string;
      name: string;
      createdAt: string;
      discountType: RetailerDiscountType;
      endDate?: string | null;
      flatDiscount?: number | null;
      marketplaceDescription?: string | null;
      minBrandCount?: number | null;
      minBrandOrderAmount?: number | null;
      percentageDiscount?: number | null;
      startDate: string;
      deletedAt?: string | null;
      distinctRedemptionCount: number;
      code?: string | null;
      maxCodeRedemptions?: number | null;
      organization: { id: string };
      retailerGroups: Array<{ id: string; name: string; createdAt: string; deletedAt?: string | null }>;
      skus: Array<{
        id: string;
        name: string;
        deletedAt?: string | null;
        createdAt?: string | null;
        isArchived?: boolean | null;
      }>;
      tiers: Array<{
        id: string;
        minBrandOrderAmount: number;
        percentageDiscount?: number | null;
        flatDiscount?: number | null;
      }>;
    };
  }> | null;
};

export type GetOrganizationSalesRepsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetOrganizationSalesRepsQuery = {
  getOrganization?: {
    members: Array<{ id: string; firstName?: string | null; lastName?: string | null }>;
    salesOrgRelationships?: Array<{
      salesOrg: { id: string; members: Array<{ id: string; firstName?: string | null; lastName?: string | null }> };
      brandOrg: { id: string; members: Array<{ id: string; firstName?: string | null; lastName?: string | null }> };
    }> | null;
  } | null;
};

export type GetDefaultSalesRepQueryVariables = Exact<{
  licensedLocationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;

export type GetDefaultSalesRepQuery = {
  getDefaultSalesRep?: { origin: GetDefaultSalesRepOriginEnum; user?: { id: string } | null } | null;
};

export type GetIsCreditMemoLockedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetIsCreditMemoLockedQuery = {
  getOrder?: { id: string; orderLockdown?: { id: string; isCreditMemoLocked: boolean } | null } | null;
};

export type GetCreditMemoTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCreditMemoTypesQuery = { getCreditMemoTypes?: Array<{ id: string; typeName: string } | null> | null };

export type GetAllWarehousesQueryVariables = Exact<{
  isInUseByOps?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAllWarehousesQuery = {
  viewer?: {
    allWarehouses?: Array<{
      id: string;
      site: {
        id: string;
        name: string;
        state?: string | null;
        city?: string | null;
        licensedLocationId?: string | null;
      };
    }> | null;
  } | null;
};

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;

export type CreateOrderMutation = {
  createOrder?: {
    changedOrder?: {
      action: OrderActionEnum;
      accountingNotes?: string | null;
      additionalDiscount: number;
      adminNotes?: string | null;
      createdAt: string;
      date: string;
      daysTillPaymentDue?: number | null;
      paymentDueDate?: string | null;
      totalAmountDue?: number | null;
      requestedDaysTillPaymentDue?: number | null;
      discount: number;
      distroFees?: number | null;
      estimatedArrivalTimeAfter?: string | null;
      estimatedArrivalTimeBefore?: string | null;
      exciseTax: number;
      exciseTaxCollected?: number | null;
      extraFees?: number | null;
      gmv: number;
      gmvCollected: number;
      id: string;
      infoplus?: number | null;
      internalNotes?: string | null;
      irn?: string | null;
      isArchived: boolean;
      manifestGDriveFileId?: string | null;
      invoicesS3FileLink?: string | null;
      name: string;
      notes?: string | null;
      number: number;
      orgLicenseNum?: string | null;
      paymentStatus: OrderPaymentStatusEnum;
      promotionsDiscount: number;
      siteLicenseNum?: string | null;
      status: OrderStatusEnum;
      timeWindow?: string | null;
      warehouseId: string;
      surcharge: number;
      mustPayPreviousBalance?: boolean | null;
      nabisDiscount?: number | null;
      issueReason?: OrderIssueReasons | null;
      pricingFee?: number | null;
      pricingPercentage?: number | null;
      retailerConfirmationStatus: RetailerConfirmationStatus;
      retailerNotes?: string | null;
      creditMemo: number;
      netGmv?: number | null;
      secondaryInfoplus?: number | null;
      orderInventoryStatus?: OrderOrderInventoryStatusEnum | null;
      asnInventoryStatus?: OrderAsnInventoryStatusEnum | null;
      isEditableByBrand: boolean;
      isAtStartingStatus: boolean;
      shouldEnableOrderForm: boolean;
      isReceived: boolean;
      metrcWarehouseId?: string | null;
      referrer: OrderReferrer;
      isSampleDemo?: boolean | null;
      paymentTermsRequestStatus?: PaymentTermsRequestStatusEnum | null;
      brandManifestNotes?: string | null;
      nabisManifestNotes?: string | null;
      retailerManifestNotes?: string | null;
      qrcodeS3FileLink?: string | null;
      metrcManifestS3FileLink?: string | null;
      isPrinted?: boolean | null;
      isStaged?: boolean | null;
      isCrossHubRetailTransfer: boolean;
      driverConfirmedAt?: string | null;
      isSingleHubOrigin?: boolean | null;
      firstShipmentId?: string | null;
      lastShipmentId?: string | null;
      lastNonReturnShipmentId?: string | null;
      pickupDropoffWarehouseId?: string | null;
      manufacturerOrgId?: string | null;
      ACHAmountCollectedRetailer?: number | null;
      ACHACRetailerUnconfirmed?: number | null;
      ACHAmountPaidBrand?: number | null;
      isExciseTaxable?: boolean | null;
      mustPayExternalBalance: boolean;
      externalPaymentMin?: number | null;
      externalPaymentDesired?: number | null;
      externalPaymentNotes?: string | null;
      remittedAt?: string | null;
      isPriorNonNabisInvoice?: boolean | null;
    } | null;
  } | null;
};

export type CreateOrderTagMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  tagType: OrderTagType;
}>;

export type CreateOrderTagMutation = { createOrderTag?: string | null };

export type DownloadProformaOrderQueryVariables = Exact<{
  input: DownloadProformaInput;
}>;

export type DownloadProformaOrderQuery = { downloadProformaOrder?: unknown | null };

export type GetCreditMemosForOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetCreditMemosForOrderQuery = {
  getCreditMemosForOrder?: Array<{
    id: string;
    orderId: string;
    creditMemoTypeId: string;
    amount: number;
    note?: string | null;
  } | null> | null;
};

export type SkuBatchFragmentFragment = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  infoplus?: number | null;
  isArchived: boolean;
};

export type ValuesFragment = {
  counted: number;
  incoming: number;
  outgoing: number;
  allocated: number;
  available: number;
  quarantined: number;
  packed?: number | null;
};

export type BatchFragmentFragment = {
  id: string;
  code: string;
  deletedAt?: string | null;
  expirationDate: string;
  manufacturingDate: string;
  manifestGDriveFileId?: string | null;
  coaS3FileLink?: string | null;
  createdAt: string;
  thcPercentage?: number | null;
  cbdPercentage?: number | null;
  otherCannabinoidPercentage?: number | null;
  thcAPercentage?: number | null;
  thcWeight?: number | null;
  cbdWeight?: number | null;
  otherCannabinoidWeight?: number | null;
  thcAWeight?: number | null;
  aromas: Array<AromaEnum>;
};

export type SkuFragmentFragment = {
  id: string;
  code: string;
  name: string;
  unit: string;
  isArchived?: boolean | null;
  isExciseTaxable?: boolean | null;
  lastUpdate?: string | null;
  inventoryType: InventoryTypeEnum;
  inventoryClass: InventoryClassEnum;
  inventoryCategory: InventoryCategoryEnum;
  inventoryCategoryTags?: Array<InventoryCategoryTagEnum> | null;
  inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
  quantityPerUnitOfMeasure: number;
  isMarketplace: boolean;
  maxMarketplaceInventory?: number | null;
  isSample: boolean;
  janeProductId?: number | null;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  weight?: number | null;
  weightUnitOfMeasure?: WeightUnitOfMeasureEnum | null;
  productImageS3Link?: string | null;
  pricePerUnit?: number | null;
  defaultPricePerUnit: number;
};

export type GetOrderQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  orderNumber?: InputMaybe<Scalars['Int']['input']>;
  sortLikeMetrc?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  isNewOrder?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetOrderQuery = {
  getOrder?: {
    id: string;
    accountingNotes?: string | null;
    action: OrderActionEnum;
    additionalDiscount: number;
    adminNotes?: string | null;
    brandManifestNotes?: string | null;
    date: string;
    daysTillPaymentDue?: number | null;
    exciseTax: number;
    internalNotes?: string | null;
    invoicesS3FileLink?: string | null;
    irn?: string | null;
    isExciseTaxable?: boolean | null;
    isPriorNonNabisInvoice?: boolean | null;
    manufacturerOrgId?: string | null;
    metrcWarehouseId?: string | null;
    mustPayPreviousBalance?: boolean | null;
    nabisManifestNotes?: string | null;
    name: string;
    notes?: string | null;
    number: number;
    paymentStatus: OrderPaymentStatusEnum;
    pickupDropoffWarehouseId?: string | null;
    referrer: OrderReferrer;
    retailerNotes?: string | null;
    siteLicenseNum?: string | null;
    status: OrderStatusEnum;
    surcharge: number;
    timeWindow?: string | null;
    warehouseId: string;
    site: { id: string; licensedLocationId?: string | null };
    lineItems: Array<{
      id: string;
      quantity: number;
      pricePerUnit?: number | null;
      isExciseTaxable: boolean;
      isSample: boolean;
      sampleType?: LineItemSampleType | null;
      discount: number;
      skuBatchId?: string | null;
      overrideQuantityPerUnitOfMeasure: boolean;
      lineItemManifestNotes?: string | null;
      destinationSkuBatchId?: string | null;
      additionalDiscount: number;
      promotionsDiscount: number;
      organizationId?: string | null;
      destinationSkuBatch?: {
        id: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        infoplus?: number | null;
        isArchived: boolean;
        availableInventory?: Array<{
          key: string;
          warehouseId: string;
          values: {
            counted: number;
            incoming: number;
            outgoing: number;
            allocated: number;
            available: number;
            quarantined: number;
            packed?: number | null;
          };
        }> | null;
        batch?: {
          id: string;
          code: string;
          deletedAt?: string | null;
          expirationDate: string;
          manufacturingDate: string;
          manifestGDriveFileId?: string | null;
          coaS3FileLink?: string | null;
          createdAt: string;
          thcPercentage?: number | null;
          cbdPercentage?: number | null;
          otherCannabinoidPercentage?: number | null;
          thcAPercentage?: number | null;
          thcWeight?: number | null;
          cbdWeight?: number | null;
          otherCannabinoidWeight?: number | null;
          thcAWeight?: number | null;
          aromas: Array<AromaEnum>;
        } | null;
        sku: {
          id: string;
          code: string;
          name: string;
          unit: string;
          isArchived?: boolean | null;
          isExciseTaxable?: boolean | null;
          lastUpdate?: string | null;
          inventoryType: InventoryTypeEnum;
          inventoryClass: InventoryClassEnum;
          inventoryCategory: InventoryCategoryEnum;
          inventoryCategoryTags?: Array<InventoryCategoryTagEnum> | null;
          inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
          quantityPerUnitOfMeasure: number;
          isMarketplace: boolean;
          maxMarketplaceInventory?: number | null;
          isSample: boolean;
          janeProductId?: number | null;
          length?: number | null;
          width?: number | null;
          height?: number | null;
          weight?: number | null;
          weightUnitOfMeasure?: WeightUnitOfMeasureEnum | null;
          productImageS3Link?: string | null;
          pricePerUnit?: number | null;
          defaultPricePerUnit: number;
        };
      } | null;
      skuBatch?: {
        id: string;
        createdAt: string;
        updatedAt: string;
        deletedAt?: string | null;
        infoplus?: number | null;
        isArchived: boolean;
        availableInventory?: Array<{
          key: string;
          warehouseId: string;
          values: {
            counted: number;
            incoming: number;
            outgoing: number;
            allocated: number;
            available: number;
            quarantined: number;
            packed?: number | null;
          };
        }> | null;
        batch?: {
          id: string;
          code: string;
          deletedAt?: string | null;
          expirationDate: string;
          manufacturingDate: string;
          manifestGDriveFileId?: string | null;
          coaS3FileLink?: string | null;
          createdAt: string;
          thcPercentage?: number | null;
          cbdPercentage?: number | null;
          otherCannabinoidPercentage?: number | null;
          thcAPercentage?: number | null;
          thcWeight?: number | null;
          cbdWeight?: number | null;
          otherCannabinoidWeight?: number | null;
          thcAWeight?: number | null;
          aromas: Array<AromaEnum>;
        } | null;
        sku: {
          id: string;
          code: string;
          name: string;
          unit: string;
          isArchived?: boolean | null;
          isExciseTaxable?: boolean | null;
          lastUpdate?: string | null;
          inventoryType: InventoryTypeEnum;
          inventoryClass: InventoryClassEnum;
          inventoryCategory: InventoryCategoryEnum;
          inventoryCategoryTags?: Array<InventoryCategoryTagEnum> | null;
          inventoryUnitOfMeasure: InventoryUnitOfMeasureEnum;
          quantityPerUnitOfMeasure: number;
          isMarketplace: boolean;
          maxMarketplaceInventory?: number | null;
          isSample: boolean;
          janeProductId?: number | null;
          length?: number | null;
          width?: number | null;
          height?: number | null;
          weight?: number | null;
          weightUnitOfMeasure?: WeightUnitOfMeasureEnum | null;
          productImageS3Link?: string | null;
          pricePerUnit?: number | null;
          defaultPricePerUnit: number;
        };
      } | null;
    }>;
    warehouse?: {
      id: string;
      site: {
        id: string;
        name: string;
        state?: string | null;
        city?: string | null;
        licensedLocationId?: string | null;
      };
    } | null;
    assignee?: { id: string } | null;
    organization: { id: string; name: string };
  } | null;
};

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
  isFromOrderForm?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateOrderMutation = { updateOrder?: { changedOrder: { id: string; number: number } } | null };

export type GetAppSettingQueryVariables = Exact<{ [key: string]: never }>;

export type GetAppSettingQuery = { viewer?: { getAppSetting?: { canCreateOrder: boolean } | null } | null };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetOrganizationQuery = {
  getOrganization?: {
    id: string;
    name: string;
    doingBusinessAs?: string | null;
    logoS3Link?: string | null;
    singleHubWarehouseId?: string | null;
  } | null;
};

export const SkuBatchFragmentFragmentDoc = gql`
  fragment skuBatchFragment on SkuBatch {
    id
    createdAt
    updatedAt
    deletedAt
    infoplus
    isArchived
  }
`;
export const ValuesFragmentDoc = gql`
  fragment values on Values {
    counted
    incoming
    outgoing
    allocated
    available
    quarantined
    packed
  }
`;
export const BatchFragmentFragmentDoc = gql`
  fragment batchFragment on Batch {
    id
    code
    deletedAt
    expirationDate
    manufacturingDate
    manifestGDriveFileId
    coaS3FileLink
    createdAt
    thcPercentage
    cbdPercentage
    otherCannabinoidPercentage
    thcAPercentage
    thcWeight
    cbdWeight
    otherCannabinoidWeight
    thcAWeight
    aromas
  }
`;
export const SkuFragmentFragmentDoc = gql`
  fragment skuFragment on Sku {
    id
    code
    name
    unit
    isArchived
    isExciseTaxable
    lastUpdate
    inventoryType
    inventoryClass
    inventoryCategory
    inventoryCategoryTags
    inventoryUnitOfMeasure
    quantityPerUnitOfMeasure
    isMarketplace
    maxMarketplaceInventory
    isSample
    janeProductId
    length
    width
    height
    weight
    weightUnitOfMeasure
    productImageS3Link
    pricePerUnit
    defaultPricePerUnit
  }
`;
export const VerifyJwtDocument = gql`
  query VerifyJwt {
    verifyJwt {
      organizationId
      scope
    }
  }
`;
export const GetFeatureFlagDocument = gql`
  query GetFeatureFlag($key: String!, $organizationId: ID) {
    getFeatureFlag(key: $key, organizationId: $organizationId) {
      key
      value
    }
  }
`;
export const OrganizationDocument = gql`
  query Organization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      doingBusinessAs
      alias
      type
    }
  }
`;
export const GetOrganizationUserRoleDocument = gql`
  query GetOrganizationUserRole($id: ID!) {
    getOrganization(id: $id) {
      id
      organizationUserRole {
        id
        name
        description
        permissions
      }
    }
  }
`;
export const MeDocument = gql`
  query Me {
    viewer {
      me {
        id
        email
        firstName
        lastName
        phone
        isAdmin
      }
    }
  }
`;
export const AllAccountSimplifiedDocument = gql`
  query AllAccountSimplified($input: AllAccountsInput!) {
    viewer {
      allAccounts(input: $input) {
        results {
          id
          address1
          address2
          zip
          licensedLocationId
          name
          city
          state
          status
          nextOrderDate
          pendingOrders
          status
          nabisNotes
        }
      }
    }
  }
`;
export const GetBrandRetailerOutstandingBalanceBrandDocument = gql`
  query getBrandRetailerOutstandingBalanceBrand($input: FetchMultiBrandRetailerCreditLimitsBrandUserInput!) {
    viewer {
      getBrandRetailerOutstandingBalanceBrand(input: $input) {
        data {
          totalAmountOutstanding
          totalAmountOverdue
        }
        brandOrganizationId
        licensedLocationId
      }
    }
  }
`;
export const AccountDetailsDocument = gql`
  query AccountDetails($organizationId: ID!, $accountId: ID!) {
    userLicensedLocationRelationship(input: { organizationId: $organizationId, licensedLocationId: $accountId }) {
      description
    }
  }
`;
export const GetBrandRetailerCreditLimitBrandDocument = gql`
  query getBrandRetailerCreditLimitBrand($input: FetchMultiBrandRetailerCreditLimitsBrandUserInput!) {
    getBrandRetailerCreditLimitBrand(input: $input) {
      data {
        brandOrganizationId
        createdAt
        createdById
        limit
        retailerOrganizationId
        updatedAt
        updatedById
        isCreditLimitEpicFeatureFlagEnabled
      }
    }
  }
`;
export const GetOutstandingAndOverdueBalancesDocument = gql`
  query getOutstandingAndOverdueBalances($licensedLocationId: ID!, $organizationId: ID, $showExciseTaxDue: Boolean) {
    viewer {
      countAndTotalDueForOverdueInvoices(
        licensedLocationId: $licensedLocationId
        organizationId: $organizationId
        showExciseTaxDue: $showExciseTaxDue
      ) {
        overdueForAllBrands {
          count
          totalDue
          exciseTaxDue
        }
        outstandingForAllBrands {
          count
          totalDue
          exciseTaxDue
        }
        overdueForBrand {
          count
          totalDue
          exciseTaxDue
        }
        outstandingForBrand {
          count
          totalDue
          exciseTaxDue
        }
      }
    }
  }
`;
export const GetDeliveryHoursDocument = gql`
  query getDeliveryHours($licensedLocationId: ID!) {
    getLicensedLocation(licensedLocationId: $licensedLocationId) {
      id
      deliveryHours {
        id
        hours
        enabled
      }
    }
  }
`;
export const AccessibleBrandsDocument = gql`
  query AccessibleBrands($orgId: ID!, $includeArchived: Boolean) {
    viewer {
      accessibleBrands(orgId: $orgId, includeArchived: $includeArchived) {
        id
        name
        doingBusinessAs
        type
      }
    }
  }
`;
export const DatePickerDocument = gql`
  query DatePicker(
    $action: String
    $gmv: Float
    $warehouseId: ID!
    $organizationId: String!
    $isCrossHubOrder: Boolean
    $licensedLocationId: ID!
    $shouldUseRetailerPreferences: Boolean
    $isSampleDemo: Boolean
    $pickupDropoffWarehouseId: ID
    $shouldPrioritizePiggybackDates: Boolean
    $shouldOnlyConsiderPiggybackDates: Boolean
    $isBrandUserViewForNabisAdmin: Boolean
  ) {
    viewer {
      getDatePickerData(
        action: $action
        gmv: $gmv
        warehouseId: $warehouseId
        organizationId: $organizationId
        isCrossHubOrder: $isCrossHubOrder
        licensedLocationId: $licensedLocationId
        shouldUseRetailerPreferences: $shouldUseRetailerPreferences
        isSampleDemo: $isSampleDemo
        pickupDropoffWarehouseId: $pickupDropoffWarehouseId
        shouldPrioritizePiggybackDates: $shouldPrioritizePiggybackDates
        shouldOnlyConsiderPiggybackDates: $shouldOnlyConsiderPiggybackDates
        isBrandUserViewForNabisAdmin: $isBrandUserViewForNabisAdmin
      )
    }
  }
`;
export const GetDraftDocument = gql`
  query GetDraft($id: ID!, $type: DraftTypeEnum!) {
    getDraft(id: $id, type: $type) {
      id
      organization {
        id
        name
      }
      body
      createdAt
      updatedAt
    }
  }
`;
export const CreateDraftDocument = gql`
  mutation CreateDraft($input: CreateDraftInput!) {
    createDraft(input: $input) {
      createdDraft {
        id
      }
    }
  }
`;
export const UpdateDraftDocument = gql`
  mutation UpdateDraft($input: UpdateDraftInput!) {
    updateDraft(input: $input) {
      changedDraft {
        id
      }
    }
  }
`;
export const DeleteDraftDocument = gql`
  mutation DeleteDraft($input: DeleteDraftInput!) {
    deleteDraft(input: $input) {
      deletedDraft {
        id
      }
    }
  }
`;
export const GetLicensedLocationForDraftDocument = gql`
  query GetLicensedLocationForDraft($licensedLocationId: ID!, $brandId: ID) {
    getLicensedLocation(licensedLocationId: $licensedLocationId, brandId: $brandId) {
      id
      address1
      address2
      city
      delivery1PocEmail
      delivery1PocFirstName
      delivery1PocLastName
      delivery1PocNumber
      isArchived
      nabisMaxTerms
      name
      siteCategory
      state
      trustLevelInEffect
      zip
      lat
      lng
      specialRequirementsForLocation {
        id
        isArchived
      }
      licenses {
        id
        licenseNumber
      }
    }
  }
`;
export const GetOrderLockdownDocument = gql`
  query GetOrderLockdown($id: ID) {
    getOrder(id: $id) {
      id
      shouldEnableOrderForm
      orderLockdown {
        id
        createdAt
        updatedAt
        deletedAt
        isArchived
        orderEditLockdownTimestamp
        isCreditMemoLocked
      }
    }
  }
`;
export const GetSiteDocument = gql`
  query GetSite($organizationId: String, $licensedLocationId: String, $id: ID) {
    getSite(organizationId: $organizationId, licensedLocationId: $licensedLocationId, id: $id) {
      id
      name
      address1
      address2
      city
      state
      zip
      pocName
      pocPhoneNumber
      pocEmail
      siteCategory
      createdAt
      licensedLocationId
    }
  }
`;
export const GetLicensedLocationDocument = gql`
  query getLicensedLocation($licensedLocationId: ID!) {
    getLicensedLocation(licensedLocationId: $licensedLocationId) {
      id
      name
      address1
      address2
      city
      state
      zip
      siteCategory
      warehouseId
      delivery1PocFirstName
      delivery1PocLastName
      delivery1PocTitle
      delivery1PocNumber
      delivery1PocEmail
      delivery1PocAllowsText
      delivery1PreferredContactMethod
      delivery2PocFirstName
      delivery2PocLastName
      delivery2PocTitle
      delivery2PocNumber
      delivery2PocEmail
      delivery2PocAllowsText
      delivery2PreferredContactMethod
    }
  }
`;
export const AllLicensedLocationSimplifiedDocument = gql`
  query AllLicensedLocationSimplified($pageInfo: PageInfoInput) {
    viewer {
      allLicensedLocationSimplified(pageInfo: $pageInfo) {
        results {
          id
          address1
          address2
          city
          isCodOnly
          isNetTermsLimited
          nabisMaxTerms
          name
          noExciseTax
          state
          trustLevelInEffect
          warehouseId
          zip
          licenses {
            id
            nickname
            category
            type
            licenseNumber
            legalEntityName
            expirationDate
          }
          warehouse {
            id
            isArchived
            infoplus
            region
            isInUseByOps
            isSingleHub
          }
          licensedLocationOrg {
            id
            alias
            isMarketplace
            isRetailerRestricted
            isRetailerRestrictedForBrand
            isOnCreditHold
            isOnBrandCreditHold
            overdueExciseTaxForCreditHold
          }
          specialRequirementsForLocation {
            id
            isArchived
            extraLeadTimeType
          }
        }
        pageInfo {
          totalNumItems
          totalNumPages
        }
      }
    }
  }
`;
export const OrganizationRestrictionInformationForRetailersDocument = gql`
  query OrganizationRestrictionInformationForRetailers($id: ID!) {
    getOrganization(id: $id) {
      restrictions {
        brandsNotAllowedForMarketplace
        disableMarketplace
        isFeatureFlagEnterpriseBrandCreditHoldEnabled
        marketplaceOrderingRestrictions {
          codOnly {
            decodedBrandOrganizationIds
            hasNabisMax
            hasNabisStandard
          }
        }
        creditHolds {
          retailersOnCreditHold {
            decodedRetailerLicensedLocationId
            decodedBrandOrganizationId
          }
          canNotBeOverriden {
            decodedSelectedBrandOrganizationId
            retailersThatCanNotBeOverriden {
              decodedRetailerLicensedLocationId
              decodedBrandOrganizationId
            }
          }
        }
        orderingRestrictions {
          codOnlyRetailers {
            decodedRetailerLicensedLocationId
            decodedBrandOrganizationId
          }
          codOnlyRetailersThatCanNotBeOverriden {
            decodedSelectedBrandOrganizationId
            codOnlyRetailersThatCanNotBeOverriden {
              decodedRetailerLicensedLocationId
              decodedBrandOrganizationId
            }
          }
        }
        premierBrands {
          id
          name
        }
      }
    }
  }
`;
export const RetailersOutstandingInvoicesForBrandDocument = gql`
  query RetailersOutstandingInvoicesForBrand($licensedLocationId: ID!, $organizationId: ID!) {
    viewer {
      retailersOutstandingInvoicesForBrand(licensedLocationId: $licensedLocationId, organizationId: $organizationId) {
        totalAmount
        totalAmountCollected
        totalAmountDue
        totalAmountExciseTaxOutstanding
        totalAmountNotYetDue
        totalAmountOutstanding
        totalAmountOverdue
        totalAmountRequiredForDelivery
        totalCountOutstanding
        totalCountOverdue
        orders {
          amount
          amountCollected
          amountDue
          amountExciseTaxOutstanding
          amountNotYetDue
          amountOutstanding
          amountOverdue
          amountRequiredForDelivery
          amountMustPayPriorBalanceRestriction
          date
          id
          number
          codRestriction
          dueDate
          mustPayExciseTaxRestriction
          mustPayPriorBalanceRestrictions {
            amount
            requiredOrderId
          }
          creator {
            firstName
            lastName
          }
          assignee {
            firstName
            lastName
          }
          invoicesS3FileLink
          isPriorNonNabisInvoice
          orderStatus
          isFactoredOverdueOrder
          isPreselectedForMPPBOverridable
          isPreselectedForMPPBNonOverridable
        }
      }
    }
  }
`;
export const GetOrderRestrictionsForMppbDocument = gql`
  query getOrderRestrictionsForMPPB($input: GetOrderRestrictionsForMPPBInput!) {
    getOrderRestrictionsForMPPB(input: $input) {
      orderRestrictions {
        orderRestriction {
          id
          orderId
          type
          overrideStatus
          isArchived
          createdAt
          updatedAt
          requestedBy
          requiredAt
          requestNotes
          adjudicatedBy
          adjudicatedNotes
          adjudicatedAt
          expiredAt
          amountToCollect
          requiredOrderId
          isPartialRequired
          isEditable
        }
        order {
          id
          gmvCollected
          exciseTaxCollected
          assignee {
            id
            firstName
            lastName
          }
          creator {
            id
            firstName
            lastName
          }
          deliveryDate
          orderNumber
          isPriorNonNabisInvoice
          amountOutstanding
          amountOverdue
          amountCollected
          amount
          dueDate
          invoicesS3FileLink
          isFactoredOverdueOrder
        }
      }
      outstandingOrdersForMPPB {
        amount
        amountCollected
        amountDue
        amountExciseTaxOutstanding
        amountNotYetDue
        amountOutstanding
        amountOverdue
        amountRequiredForDelivery
        amountMustPayPriorBalanceRestriction
        invoicesS3FileLink
        date
        number
        id
        codRestriction
        dueDate
        isPriorNonNabisInvoice
        creator {
          firstName
          lastName
        }
        assignee {
          firstName
          lastName
        }
        isFactoredOverdueOrder
      }
    }
  }
`;
export const GetLastBrandOrderToLicensedLocationDocument = gql`
  query getLastBrandOrderToLicensedLocation($organizationId: ID!, $licensedLocationId: ID!, $salesOrgId: ID) {
    getLastBrandOrderToLicensedLocation(
      organizationId: $organizationId
      licensedLocationId: $licensedLocationId
      salesOrgId: $salesOrgId
    ) {
      daysTillPaymentDue
    }
  }
`;
export const GetRetailerGroupSalesRulesDocument = gql`
  query getRetailerGroupSalesRules($licensedLocationId: ID!, $brandOrganizationIds: [ID!]!) {
    getRetailerGroupSalesRules(licensedLocationId: $licensedLocationId, brandOrganizationIds: $brandOrganizationIds) {
      id
      brandId
      mustPayPreviousBalance
      isPaymentTermsBasedOnCreditRating
      maxDaysTillPaymentDueForExcellent
      maxDaysTillPaymentDueForGood
      maxDaysTillPaymentDueForFair
      maxDaysTillPaymentDueForWeak
      maxDaysTillPaymentDueForPoor
      defaultDaysTillPaymentDue
      salesRule {
        id
        isPaymentTermsBasedOnCreditRating
        maxDaysTillPaymentDueForExcellent
        maxDaysTillPaymentDueForGood
        maxDaysTillPaymentDueForFair
        maxDaysTillPaymentDueForWeak
        maxDaysTillPaymentDueForPoor
        maxSamplesPerOrder
        isSampleAllowed
        mustPayPreviousBalance
        defaultDaysTillPaymentDue
        maxAvailableInventory
        minOrderBalance
        pricePerUnit
        isMarketplace
        startDate
        endDate
        createdAt
        skuId
        isSampleDemoOrdersAllowed
        isHardMinCap
        assigneeId
        canRequestAdditionalNetTerms
      }
    }
  }
`;
export const AccessibleSkuBatchesDocument = gql`
  query AccessibleSkuBatches(
    $brandId: ID
    $search: String
    $organizationId: ID!
    $licensedLocationId: ID
    $pageInfo: PageInfoInput
  ) {
    viewer {
      accessibleSkuBatches(
        search: $search
        brandId: $brandId
        pageInfo: $pageInfo
        orgId: $organizationId
        licensedLocationId: $licensedLocationId
      ) {
        results {
          id
          createdAt
          updatedAt
          deletedAt
          infoplus
          isArchived
          sku {
            id
            code
            name
            unit
            isArchived
            isExciseTaxable
            lastUpdate
            inventoryType
            inventoryClass
            inventoryCategory
            inventoryCategoryTags
            inventoryUnitOfMeasure
            quantityPerUnitOfMeasure
            isMarketplace
            maxMarketplaceInventory
            isSample
            janeProductId
            length
            width
            height
            weight
            weightUnitOfMeasure
            productImageS3Link
            pricePerUnit(licensedLocationId: $licensedLocationId)
            defaultPricePerUnit
            skuPricePerUnit
          }
          batch {
            id
            code
            deletedAt
            expirationDate
            manufacturingDate
            manifestGDriveFileId
            coaS3FileLink
            createdAt
            thcPercentage
            cbdPercentage
            otherCannabinoidPercentage
            thcAPercentage
            thcWeight
            cbdWeight
            otherCannabinoidWeight
            thcAWeight
            aromas
          }
          availableInventory(organizationId: $organizationId, useInventoryBuffers: true) {
            key
            warehouseId
            values {
              counted
              incoming
              outgoing
              allocated
              available
              quarantined
              packed
            }
          }
        }
        pageInfo {
          page
          numItemsPerPage
          orderBy {
            attribute
            order
          }
          totalNumItems
          totalNumPages
        }
      }
    }
  }
`;
export const GetRetailerDiscountsDocument = gql`
  query getRetailerDiscounts(
    $organizationIds: [ID!]!
    $skuId: ID
    $pageInfo: PageInfoInput!
    $search: String
    $isActive: Boolean
    $callerLocation: String
    $licensedLocationId: ID
    $includePromoCodePromos: Boolean
  ) {
    getRetailerDiscounts(
      organizationIds: $organizationIds
      skuId: $skuId
      pageInfo: $pageInfo
      search: $search
      isActive: $isActive
      callerLocation: $callerLocation
      licensedLocationId: $licensedLocationId
      includePromoCodePromos: $includePromoCodePromos
    ) {
      results {
        id
        name
        createdAt
        discountType
        endDate
        flatDiscount
        marketplaceDescription
        minBrandCount
        minBrandOrderAmount
        percentageDiscount
        startDate
        organizationId
        deletedAt
        retailerGroups {
          id
          name
          createdAt
          deletedAt
        }
        skus {
          id
          name
          deletedAt
          createdAt
          isArchived
        }
        distinctRedemptionCount
        code
        maxCodeRedemptions
        tiers {
          id
          minBrandOrderAmount
          percentageDiscount
          flatDiscount
        }
      }
      pageInfo {
        totalNumItems
        totalNumPages
        page
      }
    }
  }
`;
export const GetPromotionRedemptionsDocument = gql`
  query getPromotionRedemptions($orderId: ID!) {
    getPromotionRedemptions(orderId: $orderId) {
      id
      orderId
      lineItemId
      retailerDiscountId
      promotionsDiscount
      retailerDiscountSnapshot
      createdAt
      updatedAt
      retailerDiscount {
        id
        organizationId
        name
        createdAt
        discountType
        endDate
        flatDiscount
        marketplaceDescription
        minBrandCount
        minBrandOrderAmount
        percentageDiscount
        startDate
        deletedAt
        organization {
          id
        }
        retailerGroups {
          id
          name
          createdAt
          deletedAt
        }
        skus {
          id
          name
          deletedAt
          createdAt
          isArchived
        }
        distinctRedemptionCount
        code
        maxCodeRedemptions
        tiers {
          id
          minBrandOrderAmount
          percentageDiscount
          flatDiscount
        }
      }
    }
  }
`;
export const GetOrganizationSalesRepsDocument = gql`
  query getOrganizationSalesReps($id: ID!) {
    getOrganization(id: $id) {
      members {
        id
        firstName
        lastName
      }
      salesOrgRelationships {
        salesOrg {
          id
          members {
            id
            firstName
            lastName
          }
        }
        brandOrg {
          id
          members {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export const GetDefaultSalesRepDocument = gql`
  query getDefaultSalesRep($licensedLocationId: ID!, $organizationId: ID!) {
    getDefaultSalesRep(licensedLocationId: $licensedLocationId, organizationId: $organizationId) {
      user {
        id
      }
      origin
    }
  }
`;
export const GetIsCreditMemoLockedDocument = gql`
  query GetIsCreditMemoLocked($id: ID) {
    getOrder(id: $id) {
      id
      orderLockdown {
        id
        isCreditMemoLocked
      }
    }
  }
`;
export const GetCreditMemoTypesDocument = gql`
  query getCreditMemoTypes {
    getCreditMemoTypes {
      id
      typeName
    }
  }
`;
export const GetAllWarehousesDocument = gql`
  query getAllWarehouses($isInUseByOps: Boolean, $organizationId: ID) {
    viewer {
      allWarehouses(isInUseByOps: $isInUseByOps, organizationId: $organizationId) {
        id
        site {
          id
          name
          state
          city
          licensedLocationId
        }
      }
    }
  }
`;
export const CreateOrderDocument = gql`
  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      changedOrder {
        action
        accountingNotes
        additionalDiscount
        adminNotes
        createdAt
        date
        daysTillPaymentDue
        paymentDueDate
        totalAmountDue
        requestedDaysTillPaymentDue
        discount
        distroFees
        estimatedArrivalTimeAfter
        estimatedArrivalTimeBefore
        exciseTax
        exciseTaxCollected
        extraFees
        gmv
        gmvCollected
        id
        infoplus
        internalNotes
        irn
        isArchived
        manifestGDriveFileId
        invoicesS3FileLink
        name
        notes
        number
        orgLicenseNum
        paymentStatus
        promotionsDiscount
        siteLicenseNum
        status
        timeWindow
        warehouseId
        surcharge
        mustPayPreviousBalance
        nabisDiscount
        issueReason
        pricingFee
        pricingPercentage
        retailerConfirmationStatus
        retailerNotes
        creditMemo
        netGmv
        secondaryInfoplus
        orderInventoryStatus
        asnInventoryStatus
        isEditableByBrand
        isAtStartingStatus
        shouldEnableOrderForm
        isReceived
        metrcWarehouseId
        referrer
        isSampleDemo
        paymentTermsRequestStatus
        brandManifestNotes
        nabisManifestNotes
        retailerManifestNotes
        qrcodeS3FileLink
        metrcManifestS3FileLink
        isPrinted
        isStaged
        isCrossHubRetailTransfer
        driverConfirmedAt
        isSingleHubOrigin
        firstShipmentId
        lastShipmentId
        lastNonReturnShipmentId
        pickupDropoffWarehouseId
        manufacturerOrgId
        ACHAmountCollectedRetailer
        ACHACRetailerUnconfirmed
        ACHAmountPaidBrand
        isExciseTaxable
        mustPayExternalBalance
        externalPaymentMin
        externalPaymentDesired
        externalPaymentNotes
        remittedAt
        isPriorNonNabisInvoice
      }
    }
  }
`;
export const CreateOrderTagDocument = gql`
  mutation createOrderTag($orderId: ID!, $tagType: OrderTagType!) {
    createOrderTag(orderId: $orderId, tagType: $tagType)
  }
`;
export const DownloadProformaOrderDocument = gql`
  query DownloadProformaOrder($input: DownloadProformaInput!) {
    downloadProformaOrder(input: $input)
  }
`;
export const GetCreditMemosForOrderDocument = gql`
  query getCreditMemosForOrder($orderId: ID!) {
    getCreditMemosForOrder(orderId: $orderId) {
      id
      orderId
      creditMemoTypeId
      amount
      note
    }
  }
`;
export const GetOrderDocument = gql`
  query GetOrder($id: ID, $orderNumber: Int, $sortLikeMetrc: Boolean, $organizationId: ID, $isNewOrder: Boolean) {
    getOrder(id: $id, orderNumber: $orderNumber) {
      id
      accountingNotes
      action
      additionalDiscount
      adminNotes
      brandManifestNotes
      date
      daysTillPaymentDue
      exciseTax
      internalNotes
      invoicesS3FileLink
      irn
      isExciseTaxable
      isPriorNonNabisInvoice
      manufacturerOrgId
      metrcWarehouseId
      mustPayPreviousBalance
      nabisManifestNotes
      name
      notes
      number
      paymentStatus
      pickupDropoffWarehouseId
      referrer
      retailerNotes
      siteLicenseNum
      status
      surcharge
      timeWindow
      warehouseId
      site {
        id
        licensedLocationId
      }
      lineItems(sortLikeMetrc: $sortLikeMetrc, organizationId: $organizationId, isNewOrder: $isNewOrder) {
        id
        quantity
        pricePerUnit
        isExciseTaxable
        isSample
        sampleType
        discount
        skuBatchId
        overrideQuantityPerUnitOfMeasure
        lineItemManifestNotes
        destinationSkuBatchId
        additionalDiscount
        promotionsDiscount
        organizationId
        destinationSkuBatch {
          ...skuBatchFragment
          availableInventory(organizationId: $organizationId, useInventoryBuffers: true) {
            key
            warehouseId
            values {
              ...values
            }
          }
          batch {
            ...batchFragment
          }
          sku {
            ...skuFragment
          }
        }
        skuBatch {
          ...skuBatchFragment
          availableInventory(organizationId: $organizationId, useInventoryBuffers: true) {
            key
            warehouseId
            values {
              ...values
            }
          }
          batch {
            ...batchFragment
          }
          sku {
            ...skuFragment
          }
        }
      }
      warehouse {
        id
        site {
          id
          name
          state
          city
          licensedLocationId
        }
      }
      assignee {
        id
      }
      organization {
        id
        name
      }
    }
  }
  ${SkuBatchFragmentFragmentDoc}
  ${ValuesFragmentDoc}
  ${BatchFragmentFragmentDoc}
  ${SkuFragmentFragmentDoc}
`;
export const UpdateOrderDocument = gql`
  mutation UpdateOrder($input: UpdateOrderInput!, $isFromOrderForm: Boolean) {
    updateOrder(input: $input, isFromOrderForm: $isFromOrderForm) {
      changedOrder {
        id
        number
      }
    }
  }
`;
export const GetAppSettingDocument = gql`
  query GetAppSetting {
    viewer {
      getAppSetting {
        canCreateOrder
      }
    }
  }
`;
export const GetOrganizationDocument = gql`
  query getOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      doingBusinessAs
      logoS3Link
      singleHubWarehouseId
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    VerifyJwt(
      variables?: VerifyJwtQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<VerifyJwtQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<VerifyJwtQuery>(VerifyJwtDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }),
        'VerifyJwt',
        'query',
        variables,
      );
    },
    GetFeatureFlag(
      variables: GetFeatureFlagQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetFeatureFlagQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeatureFlagQuery>(GetFeatureFlagDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetFeatureFlag',
        'query',
        variables,
      );
    },
    Organization(
      variables: OrganizationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<OrganizationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OrganizationQuery>(OrganizationDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'Organization',
        'query',
        variables,
      );
    },
    GetOrganizationUserRole(
      variables: GetOrganizationUserRoleQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOrganizationUserRoleQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrganizationUserRoleQuery>(GetOrganizationUserRoleDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetOrganizationUserRole',
        'query',
        variables,
      );
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<MeQuery>(MeDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }),
        'Me',
        'query',
        variables,
      );
    },
    AllAccountSimplified(
      variables: AllAccountSimplifiedQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<AllAccountSimplifiedQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AllAccountSimplifiedQuery>(AllAccountSimplifiedDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'AllAccountSimplified',
        'query',
        variables,
      );
    },
    getBrandRetailerOutstandingBalanceBrand(
      variables: GetBrandRetailerOutstandingBalanceBrandQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetBrandRetailerOutstandingBalanceBrandQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetBrandRetailerOutstandingBalanceBrandQuery>(
            GetBrandRetailerOutstandingBalanceBrandDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'getBrandRetailerOutstandingBalanceBrand',
        'query',
        variables,
      );
    },
    AccountDetails(
      variables: AccountDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<AccountDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AccountDetailsQuery>(AccountDetailsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'AccountDetails',
        'query',
        variables,
      );
    },
    getBrandRetailerCreditLimitBrand(
      variables: GetBrandRetailerCreditLimitBrandQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetBrandRetailerCreditLimitBrandQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetBrandRetailerCreditLimitBrandQuery>(GetBrandRetailerCreditLimitBrandDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getBrandRetailerCreditLimitBrand',
        'query',
        variables,
      );
    },
    getOutstandingAndOverdueBalances(
      variables: GetOutstandingAndOverdueBalancesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOutstandingAndOverdueBalancesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOutstandingAndOverdueBalancesQuery>(GetOutstandingAndOverdueBalancesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getOutstandingAndOverdueBalances',
        'query',
        variables,
      );
    },
    getDeliveryHours(
      variables: GetDeliveryHoursQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetDeliveryHoursQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDeliveryHoursQuery>(GetDeliveryHoursDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getDeliveryHours',
        'query',
        variables,
      );
    },
    AccessibleBrands(
      variables: AccessibleBrandsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<AccessibleBrandsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AccessibleBrandsQuery>(AccessibleBrandsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'AccessibleBrands',
        'query',
        variables,
      );
    },
    DatePicker(
      variables: DatePickerQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<DatePickerQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DatePickerQuery>(DatePickerDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'DatePicker',
        'query',
        variables,
      );
    },
    GetDraft(variables: GetDraftQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDraftQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDraftQuery>(GetDraftDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }),
        'GetDraft',
        'query',
        variables,
      );
    },
    CreateDraft(
      variables: CreateDraftMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CreateDraftMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateDraftMutation>(CreateDraftDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'CreateDraft',
        'mutation',
        variables,
      );
    },
    UpdateDraft(
      variables: UpdateDraftMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<UpdateDraftMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateDraftMutation>(UpdateDraftDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'UpdateDraft',
        'mutation',
        variables,
      );
    },
    DeleteDraft(
      variables: DeleteDraftMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<DeleteDraftMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DeleteDraftMutation>(DeleteDraftDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'DeleteDraft',
        'mutation',
        variables,
      );
    },
    GetLicensedLocationForDraft(
      variables: GetLicensedLocationForDraftQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLicensedLocationForDraftQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLicensedLocationForDraftQuery>(GetLicensedLocationForDraftDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetLicensedLocationForDraft',
        'query',
        variables,
      );
    },
    GetOrderLockdown(
      variables?: GetOrderLockdownQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOrderLockdownQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrderLockdownQuery>(GetOrderLockdownDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetOrderLockdown',
        'query',
        variables,
      );
    },
    GetSite(variables?: GetSiteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSiteQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetSiteQuery>(GetSiteDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }),
        'GetSite',
        'query',
        variables,
      );
    },
    getLicensedLocation(
      variables: GetLicensedLocationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLicensedLocationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLicensedLocationQuery>(GetLicensedLocationDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getLicensedLocation',
        'query',
        variables,
      );
    },
    AllLicensedLocationSimplified(
      variables?: AllLicensedLocationSimplifiedQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<AllLicensedLocationSimplifiedQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AllLicensedLocationSimplifiedQuery>(AllLicensedLocationSimplifiedDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'AllLicensedLocationSimplified',
        'query',
        variables,
      );
    },
    OrganizationRestrictionInformationForRetailers(
      variables: OrganizationRestrictionInformationForRetailersQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<OrganizationRestrictionInformationForRetailersQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OrganizationRestrictionInformationForRetailersQuery>(
            OrganizationRestrictionInformationForRetailersDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'OrganizationRestrictionInformationForRetailers',
        'query',
        variables,
      );
    },
    RetailersOutstandingInvoicesForBrand(
      variables: RetailersOutstandingInvoicesForBrandQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<RetailersOutstandingInvoicesForBrandQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RetailersOutstandingInvoicesForBrandQuery>(
            RetailersOutstandingInvoicesForBrandDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'RetailersOutstandingInvoicesForBrand',
        'query',
        variables,
      );
    },
    getOrderRestrictionsForMPPB(
      variables: GetOrderRestrictionsForMppbQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOrderRestrictionsForMppbQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrderRestrictionsForMppbQuery>(GetOrderRestrictionsForMppbDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getOrderRestrictionsForMPPB',
        'query',
        variables,
      );
    },
    getLastBrandOrderToLicensedLocation(
      variables: GetLastBrandOrderToLicensedLocationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLastBrandOrderToLicensedLocationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLastBrandOrderToLicensedLocationQuery>(
            GetLastBrandOrderToLicensedLocationDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'getLastBrandOrderToLicensedLocation',
        'query',
        variables,
      );
    },
    getRetailerGroupSalesRules(
      variables: GetRetailerGroupSalesRulesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetRetailerGroupSalesRulesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRetailerGroupSalesRulesQuery>(GetRetailerGroupSalesRulesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getRetailerGroupSalesRules',
        'query',
        variables,
      );
    },
    AccessibleSkuBatches(
      variables: AccessibleSkuBatchesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<AccessibleSkuBatchesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AccessibleSkuBatchesQuery>(AccessibleSkuBatchesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'AccessibleSkuBatches',
        'query',
        variables,
      );
    },
    getRetailerDiscounts(
      variables: GetRetailerDiscountsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetRetailerDiscountsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRetailerDiscountsQuery>(GetRetailerDiscountsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getRetailerDiscounts',
        'query',
        variables,
      );
    },
    getPromotionRedemptions(
      variables: GetPromotionRedemptionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetPromotionRedemptionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPromotionRedemptionsQuery>(GetPromotionRedemptionsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getPromotionRedemptions',
        'query',
        variables,
      );
    },
    getOrganizationSalesReps(
      variables: GetOrganizationSalesRepsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOrganizationSalesRepsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrganizationSalesRepsQuery>(GetOrganizationSalesRepsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getOrganizationSalesReps',
        'query',
        variables,
      );
    },
    getDefaultSalesRep(
      variables: GetDefaultSalesRepQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetDefaultSalesRepQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetDefaultSalesRepQuery>(GetDefaultSalesRepDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getDefaultSalesRep',
        'query',
        variables,
      );
    },
    GetIsCreditMemoLocked(
      variables?: GetIsCreditMemoLockedQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetIsCreditMemoLockedQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetIsCreditMemoLockedQuery>(GetIsCreditMemoLockedDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetIsCreditMemoLocked',
        'query',
        variables,
      );
    },
    getCreditMemoTypes(
      variables?: GetCreditMemoTypesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetCreditMemoTypesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCreditMemoTypesQuery>(GetCreditMemoTypesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getCreditMemoTypes',
        'query',
        variables,
      );
    },
    getAllWarehouses(
      variables?: GetAllWarehousesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetAllWarehousesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAllWarehousesQuery>(GetAllWarehousesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getAllWarehouses',
        'query',
        variables,
      );
    },
    CreateOrder(
      variables: CreateOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CreateOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateOrderMutation>(CreateOrderDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'CreateOrder',
        'mutation',
        variables,
      );
    },
    createOrderTag(
      variables: CreateOrderTagMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CreateOrderTagMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateOrderTagMutation>(CreateOrderTagDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'createOrderTag',
        'mutation',
        variables,
      );
    },
    DownloadProformaOrder(
      variables: DownloadProformaOrderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<DownloadProformaOrderQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DownloadProformaOrderQuery>(DownloadProformaOrderDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'DownloadProformaOrder',
        'query',
        variables,
      );
    },
    getCreditMemosForOrder(
      variables: GetCreditMemosForOrderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetCreditMemosForOrderQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCreditMemosForOrderQuery>(GetCreditMemosForOrderDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getCreditMemosForOrder',
        'query',
        variables,
      );
    },
    GetOrder(variables?: GetOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrderQuery>(GetOrderDocument, variables, { ...requestHeaders, ...wrappedRequestHeaders }),
        'GetOrder',
        'query',
        variables,
      );
    },
    UpdateOrder(
      variables: UpdateOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<UpdateOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateOrderMutation>(UpdateOrderDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'UpdateOrder',
        'mutation',
        variables,
      );
    },
    GetAppSetting(
      variables?: GetAppSettingQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetAppSettingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAppSettingQuery>(GetAppSettingDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'GetAppSetting',
        'query',
        variables,
      );
    },
    getOrganization(
      variables: GetOrganizationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOrganizationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrganizationQuery>(GetOrganizationDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'getOrganization',
        'query',
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
export function getSdkWithHooks(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  const sdk = getSdk(client, withWrapper);
  return {
    ...sdk,
    useVerifyJwt(
      key: SWRKeyInterface,
      variables?: VerifyJwtQueryVariables,
      config?: SWRConfigInterface<VerifyJwtQuery, ClientError>,
    ) {
      return useSWR<VerifyJwtQuery, ClientError>(key, () => sdk.VerifyJwt(variables), config);
    },
    useGetFeatureFlag(
      key: SWRKeyInterface,
      variables: GetFeatureFlagQueryVariables,
      config?: SWRConfigInterface<GetFeatureFlagQuery, ClientError>,
    ) {
      return useSWR<GetFeatureFlagQuery, ClientError>(key, () => sdk.GetFeatureFlag(variables), config);
    },
    useOrganization(
      key: SWRKeyInterface,
      variables: OrganizationQueryVariables,
      config?: SWRConfigInterface<OrganizationQuery, ClientError>,
    ) {
      return useSWR<OrganizationQuery, ClientError>(key, () => sdk.Organization(variables), config);
    },
    useGetOrganizationUserRole(
      key: SWRKeyInterface,
      variables: GetOrganizationUserRoleQueryVariables,
      config?: SWRConfigInterface<GetOrganizationUserRoleQuery, ClientError>,
    ) {
      return useSWR<GetOrganizationUserRoleQuery, ClientError>(
        key,
        () => sdk.GetOrganizationUserRole(variables),
        config,
      );
    },
    useMe(key: SWRKeyInterface, variables?: MeQueryVariables, config?: SWRConfigInterface<MeQuery, ClientError>) {
      return useSWR<MeQuery, ClientError>(key, () => sdk.Me(variables), config);
    },
    useAllAccountSimplified(
      key: SWRKeyInterface,
      variables: AllAccountSimplifiedQueryVariables,
      config?: SWRConfigInterface<AllAccountSimplifiedQuery, ClientError>,
    ) {
      return useSWR<AllAccountSimplifiedQuery, ClientError>(key, () => sdk.AllAccountSimplified(variables), config);
    },
    useGetBrandRetailerOutstandingBalanceBrand(
      key: SWRKeyInterface,
      variables: GetBrandRetailerOutstandingBalanceBrandQueryVariables,
      config?: SWRConfigInterface<GetBrandRetailerOutstandingBalanceBrandQuery, ClientError>,
    ) {
      return useSWR<GetBrandRetailerOutstandingBalanceBrandQuery, ClientError>(
        key,
        () => sdk.getBrandRetailerOutstandingBalanceBrand(variables),
        config,
      );
    },
    useAccountDetails(
      key: SWRKeyInterface,
      variables: AccountDetailsQueryVariables,
      config?: SWRConfigInterface<AccountDetailsQuery, ClientError>,
    ) {
      return useSWR<AccountDetailsQuery, ClientError>(key, () => sdk.AccountDetails(variables), config);
    },
    useGetBrandRetailerCreditLimitBrand(
      key: SWRKeyInterface,
      variables: GetBrandRetailerCreditLimitBrandQueryVariables,
      config?: SWRConfigInterface<GetBrandRetailerCreditLimitBrandQuery, ClientError>,
    ) {
      return useSWR<GetBrandRetailerCreditLimitBrandQuery, ClientError>(
        key,
        () => sdk.getBrandRetailerCreditLimitBrand(variables),
        config,
      );
    },
    useGetOutstandingAndOverdueBalances(
      key: SWRKeyInterface,
      variables: GetOutstandingAndOverdueBalancesQueryVariables,
      config?: SWRConfigInterface<GetOutstandingAndOverdueBalancesQuery, ClientError>,
    ) {
      return useSWR<GetOutstandingAndOverdueBalancesQuery, ClientError>(
        key,
        () => sdk.getOutstandingAndOverdueBalances(variables),
        config,
      );
    },
    useGetDeliveryHours(
      key: SWRKeyInterface,
      variables: GetDeliveryHoursQueryVariables,
      config?: SWRConfigInterface<GetDeliveryHoursQuery, ClientError>,
    ) {
      return useSWR<GetDeliveryHoursQuery, ClientError>(key, () => sdk.getDeliveryHours(variables), config);
    },
    useAccessibleBrands(
      key: SWRKeyInterface,
      variables: AccessibleBrandsQueryVariables,
      config?: SWRConfigInterface<AccessibleBrandsQuery, ClientError>,
    ) {
      return useSWR<AccessibleBrandsQuery, ClientError>(key, () => sdk.AccessibleBrands(variables), config);
    },
    useDatePicker(
      key: SWRKeyInterface,
      variables: DatePickerQueryVariables,
      config?: SWRConfigInterface<DatePickerQuery, ClientError>,
    ) {
      return useSWR<DatePickerQuery, ClientError>(key, () => sdk.DatePicker(variables), config);
    },
    useGetDraft(
      key: SWRKeyInterface,
      variables: GetDraftQueryVariables,
      config?: SWRConfigInterface<GetDraftQuery, ClientError>,
    ) {
      return useSWR<GetDraftQuery, ClientError>(key, () => sdk.GetDraft(variables), config);
    },
    useGetLicensedLocationForDraft(
      key: SWRKeyInterface,
      variables: GetLicensedLocationForDraftQueryVariables,
      config?: SWRConfigInterface<GetLicensedLocationForDraftQuery, ClientError>,
    ) {
      return useSWR<GetLicensedLocationForDraftQuery, ClientError>(
        key,
        () => sdk.GetLicensedLocationForDraft(variables),
        config,
      );
    },
    useGetOrderLockdown(
      key: SWRKeyInterface,
      variables?: GetOrderLockdownQueryVariables,
      config?: SWRConfigInterface<GetOrderLockdownQuery, ClientError>,
    ) {
      return useSWR<GetOrderLockdownQuery, ClientError>(key, () => sdk.GetOrderLockdown(variables), config);
    },
    useGetSite(
      key: SWRKeyInterface,
      variables?: GetSiteQueryVariables,
      config?: SWRConfigInterface<GetSiteQuery, ClientError>,
    ) {
      return useSWR<GetSiteQuery, ClientError>(key, () => sdk.GetSite(variables), config);
    },
    useGetLicensedLocation(
      key: SWRKeyInterface,
      variables: GetLicensedLocationQueryVariables,
      config?: SWRConfigInterface<GetLicensedLocationQuery, ClientError>,
    ) {
      return useSWR<GetLicensedLocationQuery, ClientError>(key, () => sdk.getLicensedLocation(variables), config);
    },
    useAllLicensedLocationSimplified(
      key: SWRKeyInterface,
      variables?: AllLicensedLocationSimplifiedQueryVariables,
      config?: SWRConfigInterface<AllLicensedLocationSimplifiedQuery, ClientError>,
    ) {
      return useSWR<AllLicensedLocationSimplifiedQuery, ClientError>(
        key,
        () => sdk.AllLicensedLocationSimplified(variables),
        config,
      );
    },
    useOrganizationRestrictionInformationForRetailers(
      key: SWRKeyInterface,
      variables: OrganizationRestrictionInformationForRetailersQueryVariables,
      config?: SWRConfigInterface<OrganizationRestrictionInformationForRetailersQuery, ClientError>,
    ) {
      return useSWR<OrganizationRestrictionInformationForRetailersQuery, ClientError>(
        key,
        () => sdk.OrganizationRestrictionInformationForRetailers(variables),
        config,
      );
    },
    useRetailersOutstandingInvoicesForBrand(
      key: SWRKeyInterface,
      variables: RetailersOutstandingInvoicesForBrandQueryVariables,
      config?: SWRConfigInterface<RetailersOutstandingInvoicesForBrandQuery, ClientError>,
    ) {
      return useSWR<RetailersOutstandingInvoicesForBrandQuery, ClientError>(
        key,
        () => sdk.RetailersOutstandingInvoicesForBrand(variables),
        config,
      );
    },
    useGetOrderRestrictionsForMppb(
      key: SWRKeyInterface,
      variables: GetOrderRestrictionsForMppbQueryVariables,
      config?: SWRConfigInterface<GetOrderRestrictionsForMppbQuery, ClientError>,
    ) {
      return useSWR<GetOrderRestrictionsForMppbQuery, ClientError>(
        key,
        () => sdk.getOrderRestrictionsForMPPB(variables),
        config,
      );
    },
    useGetLastBrandOrderToLicensedLocation(
      key: SWRKeyInterface,
      variables: GetLastBrandOrderToLicensedLocationQueryVariables,
      config?: SWRConfigInterface<GetLastBrandOrderToLicensedLocationQuery, ClientError>,
    ) {
      return useSWR<GetLastBrandOrderToLicensedLocationQuery, ClientError>(
        key,
        () => sdk.getLastBrandOrderToLicensedLocation(variables),
        config,
      );
    },
    useGetRetailerGroupSalesRules(
      key: SWRKeyInterface,
      variables: GetRetailerGroupSalesRulesQueryVariables,
      config?: SWRConfigInterface<GetRetailerGroupSalesRulesQuery, ClientError>,
    ) {
      return useSWR<GetRetailerGroupSalesRulesQuery, ClientError>(
        key,
        () => sdk.getRetailerGroupSalesRules(variables),
        config,
      );
    },
    useAccessibleSkuBatches(
      key: SWRKeyInterface,
      variables: AccessibleSkuBatchesQueryVariables,
      config?: SWRConfigInterface<AccessibleSkuBatchesQuery, ClientError>,
    ) {
      return useSWR<AccessibleSkuBatchesQuery, ClientError>(key, () => sdk.AccessibleSkuBatches(variables), config);
    },
    useGetRetailerDiscounts(
      key: SWRKeyInterface,
      variables: GetRetailerDiscountsQueryVariables,
      config?: SWRConfigInterface<GetRetailerDiscountsQuery, ClientError>,
    ) {
      return useSWR<GetRetailerDiscountsQuery, ClientError>(key, () => sdk.getRetailerDiscounts(variables), config);
    },
    useGetPromotionRedemptions(
      key: SWRKeyInterface,
      variables: GetPromotionRedemptionsQueryVariables,
      config?: SWRConfigInterface<GetPromotionRedemptionsQuery, ClientError>,
    ) {
      return useSWR<GetPromotionRedemptionsQuery, ClientError>(
        key,
        () => sdk.getPromotionRedemptions(variables),
        config,
      );
    },
    useGetOrganizationSalesReps(
      key: SWRKeyInterface,
      variables: GetOrganizationSalesRepsQueryVariables,
      config?: SWRConfigInterface<GetOrganizationSalesRepsQuery, ClientError>,
    ) {
      return useSWR<GetOrganizationSalesRepsQuery, ClientError>(
        key,
        () => sdk.getOrganizationSalesReps(variables),
        config,
      );
    },
    useGetDefaultSalesRep(
      key: SWRKeyInterface,
      variables: GetDefaultSalesRepQueryVariables,
      config?: SWRConfigInterface<GetDefaultSalesRepQuery, ClientError>,
    ) {
      return useSWR<GetDefaultSalesRepQuery, ClientError>(key, () => sdk.getDefaultSalesRep(variables), config);
    },
    useGetIsCreditMemoLocked(
      key: SWRKeyInterface,
      variables?: GetIsCreditMemoLockedQueryVariables,
      config?: SWRConfigInterface<GetIsCreditMemoLockedQuery, ClientError>,
    ) {
      return useSWR<GetIsCreditMemoLockedQuery, ClientError>(key, () => sdk.GetIsCreditMemoLocked(variables), config);
    },
    useGetCreditMemoTypes(
      key: SWRKeyInterface,
      variables?: GetCreditMemoTypesQueryVariables,
      config?: SWRConfigInterface<GetCreditMemoTypesQuery, ClientError>,
    ) {
      return useSWR<GetCreditMemoTypesQuery, ClientError>(key, () => sdk.getCreditMemoTypes(variables), config);
    },
    useGetAllWarehouses(
      key: SWRKeyInterface,
      variables?: GetAllWarehousesQueryVariables,
      config?: SWRConfigInterface<GetAllWarehousesQuery, ClientError>,
    ) {
      return useSWR<GetAllWarehousesQuery, ClientError>(key, () => sdk.getAllWarehouses(variables), config);
    },
    useDownloadProformaOrder(
      key: SWRKeyInterface,
      variables: DownloadProformaOrderQueryVariables,
      config?: SWRConfigInterface<DownloadProformaOrderQuery, ClientError>,
    ) {
      return useSWR<DownloadProformaOrderQuery, ClientError>(key, () => sdk.DownloadProformaOrder(variables), config);
    },
    useGetCreditMemosForOrder(
      key: SWRKeyInterface,
      variables: GetCreditMemosForOrderQueryVariables,
      config?: SWRConfigInterface<GetCreditMemosForOrderQuery, ClientError>,
    ) {
      return useSWR<GetCreditMemosForOrderQuery, ClientError>(key, () => sdk.getCreditMemosForOrder(variables), config);
    },
    useGetOrder(
      key: SWRKeyInterface,
      variables?: GetOrderQueryVariables,
      config?: SWRConfigInterface<GetOrderQuery, ClientError>,
    ) {
      return useSWR<GetOrderQuery, ClientError>(key, () => sdk.GetOrder(variables), config);
    },
    useGetAppSetting(
      key: SWRKeyInterface,
      variables?: GetAppSettingQueryVariables,
      config?: SWRConfigInterface<GetAppSettingQuery, ClientError>,
    ) {
      return useSWR<GetAppSettingQuery, ClientError>(key, () => sdk.GetAppSetting(variables), config);
    },
    useGetOrganization(
      key: SWRKeyInterface,
      variables: GetOrganizationQueryVariables,
      config?: SWRConfigInterface<GetOrganizationQuery, ClientError>,
    ) {
      return useSWR<GetOrganizationQuery, ClientError>(key, () => sdk.getOrganization(variables), config);
    },
  };
}
export type SdkWithHooks = ReturnType<typeof getSdkWithHooks>;
